import React, { useEffect, useMemo, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";

export const StarIcon = ({ className }) => {
  return (
    <svg
      role="img"
      aria-labelledby="starRating-hb17sh9rio5"
      viewBox="0 0 251 46"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title id="starRating-hb17sh9rio5" lang="en">
        4.6 out of five star rating on Trustpilot
      </title>
      <g className="tp-star">
        <path
          className="tp-star__canvas"
          fill="#00b67a"
          d="M0 46.330002h46.375586V0H0z"
        ></path>
        <path
          className="tp-star__shape"
          d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
          fill="#FFF"
        ></path>
      </g>
      <g className="tp-star">
        <path
          className="tp-star__canvas"
          fill="#00b67a"
          d="M51.24816 46.330002h46.375587V0H51.248161z"
        ></path>
        <path
          className="tp-star__canvas--half"
          fill="#00b67a"
          d="M51.24816 46.330002h23.187793V0H51.248161z"
        ></path>
        <path
          className="tp-star__shape"
          d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
          fill="#FFF"
        ></path>
      </g>
      <g className="tp-star">
        <path
          className="tp-star__canvas"
          fill="#00b67a"
          d="M102.532209 46.330002h46.375586V0h-46.375586z"
        ></path>
        <path
          className="tp-star__canvas--half"
          fill="#00b67a"
          d="M102.532209 46.330002h23.187793V0h-23.187793z"
        ></path>
        <path
          className="tp-star__shape"
          d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
          fill="#FFF"
        ></path>
      </g>
      <g className="tp-star">
        <path
          className="tp-star__canvas"
          fill="#00b67a"
          d="M153.815458 46.330002h46.375586V0h-46.375586z"
        ></path>
        <path
          className="tp-star__canvas--half"
          fill="#00b67a"
          d="M153.815458 46.330002h23.187793V0h-23.187793z"
        ></path>
        <path
          className="tp-star__shape"
          d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
          fill="#FFF"
        ></path>
      </g>
      <g className="tp-star">
        <path
          className="tp-star__canvas"
          fill="#dcdce6"
          d="M205.064416 46.330002h46.375587V0h-46.375587z"
        ></path>
        <path
          className="tp-star__canvas--half"
          fill="#00b67a"
          d="M205.064416 46.330002h23.187793V0h-23.187793z"
        ></path>
        <path
          className="tp-star__shape"
          d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
          fill="#FFF"
        ></path>
      </g>
    </svg>
  );
};

export const TrustpilotIcon = ({ className }) => {
  return (
    <svg
      role="img"
      aria-labelledby="trustpilotLogo-61jr1fv7j43"
      viewBox="0 0 126 31"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title id="trustpilotLogo-61jr1fv7j43">Trustpilot</title>
      <path
        className="tp-logo__text"
        d="M33.074774 11.07005H45.81806v2.364196h-5.010656v13.290316h-2.755306V13.434246h-4.988435V11.07005h.01111zm12.198892 4.319629h2.355341v2.187433h.04444c.077771-.309334.222203-.60762.433295-.894859.211092-.287239.466624-.56343.766597-.79543.299972-.243048.633276-.430858.999909-.585525.366633-.14362.744377-.220953 1.12212-.220953.288863 0 .499955.011047.611056.022095.1111.011048.222202.033143.344413.04419v2.408387c-.177762-.033143-.355523-.055238-.544395-.077333-.188872-.022096-.366633-.033143-.544395-.033143-.422184 0-.822148.08838-1.199891.254096-.377744.165714-.699936.41981-.977689.740192-.277753.331429-.499955.729144-.666606 1.21524-.166652.486097-.244422 1.03848-.244422 1.668195v5.39125h-2.510883V15.38968h.01111zm18.220567 11.334883H61.02779v-1.579813h-.04444c-.311083.574477-.766597 1.02743-1.377653 1.369908-.611055.342477-1.233221.51924-1.866497.51924-1.499864 0-2.588654-.364573-3.25526-1.104765-.666606-.740193-.999909-1.856005-.999909-3.347437V15.38968h2.510883v6.948968c0 .994288.188872 1.701337.577725 2.1101.377744.408763.922139.618668 1.610965.618668.533285 0 .96658-.077333 1.322102-.243048.355524-.165714.644386-.37562.855478-.65181.222202-.265144.377744-.596574.477735-.972194.09999-.37562.144431-.784382.144431-1.226288v-6.573349h2.510883v11.323836zm4.27739-3.634675c.07777.729144.355522 1.237336.833257 1.535623.488844.287238 1.06657.441905 1.744286.441905.233312 0 .499954-.022095.799927-.055238.299973-.033143.588836-.110476.844368-.209905.266642-.099429.477734-.254096.655496-.452954.166652-.198857.244422-.452953.233312-.773335-.01111-.320381-.133321-.585525-.355523-.784382-.222202-.209906-.499955-.364573-.844368-.497144-.344413-.121525-.733267-.232-1.17767-.320382-.444405-.088381-.888809-.18781-1.344323-.287239-.466624-.099429-.922138-.232-1.355432-.37562-.433294-.14362-.822148-.342477-1.166561-.596573-.344413-.243048-.622166-.56343-.822148-.950097-.211092-.386668-.311083-.861716-.311083-1.436194 0-.618668.155542-1.12686.455515-1.54667.299972-.41981.688826-.75124 1.14434-1.005336.466624-.254095.97769-.430858 1.544304-.541334.566615-.099429 1.11101-.154667 1.622075-.154667.588836 0 1.15545.066286 1.688736.18781.533285.121524 1.02213.320381 1.455423.60762.433294.276191.788817.640764 1.07768 1.08267.288863.441905.466624.98324.544395 1.612955h-2.621984c-.122211-.596572-.388854-1.005335-.822148-1.204193-.433294-.209905-.933248-.309334-1.488753-.309334-.177762 0-.388854.011048-.633276.04419-.244422.033144-.466624.088382-.688826.165715-.211092.077334-.388854.198858-.544395.353525-.144432.154667-.222203.353525-.222203.60762 0 .309335.111101.552383.322193.740193.211092.18781.488845.342477.833258.475048.344413.121524.733267.232 1.177671.320382.444404.088381.899918.18781 1.366542.287239.455515.099429.899919.232 1.344323.37562.444404.14362.833257.342477 1.17767.596573.344414.254095.622166.56343.833258.93905.211092.37562.322193.850668.322193 1.40305 0 .673906-.155541 1.237336-.466624 1.712385-.311083.464001-.711047.850669-1.199891 1.137907-.488845.28724-1.04435.508192-1.644295.640764-.599946.132572-1.199891.198857-1.788727.198857-.722156 0-1.388762-.077333-1.999818-.243048-.611056-.165714-1.14434-.408763-1.588745-.729144-.444404-.33143-.799927-.740192-1.05546-1.226289-.255532-.486096-.388853-1.071621-.411073-1.745528h2.533103v-.022095zm8.288135-7.700208h1.899828v-3.402675h2.510883v3.402675h2.26646v1.867052h-2.26646v6.054109c0 .265143.01111.486096.03333.684954.02222.18781.07777.353524.155542.486096.07777.132572.199981.232.366633.298287.166651.066285.377743.099428.666606.099428.177762 0 .355523 0 .533285-.011047.177762-.011048.355523-.033143.533285-.077334v1.933338c-.277753.033143-.555505.055238-.811038.088381-.266642.033143-.533285.04419-.811037.04419-.666606 0-1.199891-.066285-1.599855-.18781-.399963-.121523-.722156-.309333-.944358-.552381-.233313-.243049-.377744-.541335-.466625-.905907-.07777-.364573-.13332-.784383-.144431-1.248384v-6.683825h-1.899827v-1.889147h-.02222zm8.454788 0h2.377562V16.9253h.04444c.355523-.662858.844368-1.12686 1.477644-1.414098.633276-.287239 1.310992-.430858 2.055369-.430858.899918 0 1.677625.154667 2.344231.475048.666606.309335 1.222111.740193 1.666515 1.292575.444405.552382.766597 1.193145.9888 1.92229.222202.729145.333303 1.513527.333303 2.3421 0 .762288-.099991 1.50248-.299973 2.20953-.199982.718096-.499955 1.347812-.899918 1.900194-.399964.552383-.911029.98324-1.533194 1.31467-.622166.33143-1.344323.497144-2.18869.497144-.366634 0-.733267-.033143-1.0999-.099429-.366634-.066286-.722157-.176762-1.05546-.320381-.333303-.14362-.655496-.33143-.933249-.56343-.288863-.232-.522175-.497144-.722157-.79543h-.04444v5.656393h-2.510883V15.38968zm8.77698 5.67849c0-.508193-.06666-1.005337-.199981-1.491433-.133321-.486096-.333303-.905907-.599946-1.281527-.266642-.37562-.599945-.673906-.988799-.894859-.399963-.220953-.855478-.342477-1.366542-.342477-1.05546 0-1.855387.364572-2.388672 1.093717-.533285.729144-.799928 1.701337-.799928 2.916578 0 .574478.066661 1.104764.211092 1.59086.144432.486097.344414.905908.633276 1.259432.277753.353525.611056.629716.99991.828574.388853.209905.844367.309334 1.355432.309334.577725 0 1.05546-.121524 1.455423-.353525.399964-.232.722157-.541335.97769-.905907.255531-.37562.444403-.79543.555504-1.270479.099991-.475049.155542-.961145.155542-1.458289zm4.432931-9.99812h2.510883v2.364197h-2.510883V11.07005zm0 4.31963h2.510883v11.334883h-2.510883V15.389679zm4.755124-4.31963h2.510883v15.654513h-2.510883V11.07005zm10.210184 15.963847c-.911029 0-1.722066-.154667-2.433113-.452953-.711046-.298287-1.310992-.718097-1.810946-1.237337-.488845-.530287-.866588-1.160002-1.12212-1.889147-.255533-.729144-.388854-1.535622-.388854-2.408386 0-.861716.133321-1.657147.388853-2.386291.255533-.729145.633276-1.35886 1.12212-1.889148.488845-.530287 1.0999-.93905 1.810947-1.237336.711047-.298286 1.522084-.452953 2.433113-.452953.911028 0 1.722066.154667 2.433112.452953.711047.298287 1.310992.718097 1.810947 1.237336.488844.530287.866588 1.160003 1.12212 1.889148.255532.729144.388854 1.524575.388854 2.38629 0 .872765-.133322 1.679243-.388854 2.408387-.255532.729145-.633276 1.35886-1.12212 1.889147-.488845.530287-1.0999.93905-1.810947 1.237337-.711046.298286-1.522084.452953-2.433112.452953zm0-1.977528c.555505 0 1.04435-.121524 1.455423-.353525.411074-.232.744377-.541335 1.01102-.916954.266642-.37562.455513-.806478.588835-1.281527.12221-.475049.188872-.961145.188872-1.45829 0-.486096-.066661-.961144-.188872-1.44724-.122211-.486097-.322193-.905907-.588836-1.281527-.266642-.37562-.599945-.673907-1.011019-.905907-.411074-.232-.899918-.353525-1.455423-.353525-.555505 0-1.04435.121524-1.455424.353525-.411073.232-.744376.541334-1.011019.905907-.266642.37562-.455514.79543-.588835 1.281526-.122211.486097-.188872.961145-.188872 1.447242 0 .497144.06666.98324.188872 1.458289.12221.475049.322193.905907.588835 1.281527.266643.37562.599946.684954 1.01102.916954.411073.243048.899918.353525 1.455423.353525zm6.4883-9.66669h1.899827v-3.402674h2.510883v3.402675h2.26646v1.867052h-2.26646v6.054109c0 .265143.01111.486096.03333.684954.02222.18781.07777.353524.155541.486096.077771.132572.199982.232.366634.298287.166651.066285.377743.099428.666606.099428.177762 0 .355523 0 .533285-.011047.177762-.011048.355523-.033143.533285-.077334v1.933338c-.277753.033143-.555505.055238-.811038.088381-.266642.033143-.533285.04419-.811037.04419-.666606 0-1.199891-.066285-1.599855-.18781-.399963-.121523-.722156-.309333-.944358-.552381-.233313-.243049-.377744-.541335-.466625-.905907-.07777-.364573-.133321-.784383-.144431-1.248384v-6.683825h-1.899827v-1.889147h-.02222z"
        fill="#191919"
      ></path>
      <path
        className="tp-logo__star"
        fill="#00B67A"
        d="M30.141707 11.07005H18.63164L15.076408.177071l-3.566342 10.892977L0 11.059002l9.321376 6.739063-3.566343 10.88193 9.321375-6.728016 9.310266 6.728016-3.555233-10.88193 9.310266-6.728016z"
      ></path>
      <path
        className="tp-logo__star-notch"
        fill="#005128"
        d="M21.631369 20.26169l-.799928-2.463625-5.755033 4.153914z"
      ></path>
    </svg>
  );
};

export const Card1 = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      role="img"
      className={className} // Apply className if passed as a prop
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#D1E5FA" cx="44" cy="44" r="44"></circle>
        <g transform="translate(1 12)">
          <rect
            stroke="#0A335C"
            strokeWidth="2"
            fill="#F6FAFE"
            width="64"
            height="64"
            rx="2"
          ></rect>
          <g transform="translate(8 8)" fill="#197FE6">
            <rect width="8" height="8" rx="2"></rect>
            <rect x="12" width="8" height="8" rx="2"></rect>
            <rect y="12" width="8" height="8" rx="2"></rect>
            <rect x="12" y="12" width="8" height="8" rx="2"></rect>
            <rect x="6" y="6" width="8" height="8" rx="2"></rect>
          </g>
          <rect
            fill="#0A335C"
            x="12"
            y="40"
            width="12"
            height="12"
            rx="2"
          ></rect>
          <rect
            fill="#0A335C"
            x="40"
            y="12"
            width="12"
            height="12"
            rx="2"
          ></rect>
          <rect
            stroke="#0A335C"
            strokeWidth="2"
            x="8"
            y="36"
            width="20"
            height="20"
            rx="2"
          ></rect>
          <rect
            stroke="#0A335C"
            strokeWidth="2"
            x="36"
            y="8"
            width="20"
            height="20"
            rx="2"
          ></rect>
          <g fill="#FACF51" fillRule="nonzero">
            <path d="M47.38 46.282c-.745-.742-2.031-.37-2.268.641L42.27 59.571c-.237.978.71 1.855 1.692 1.586l2.979-.877c.27-.068.575.067.643.337l2.166 7.42a1.34 1.34 0 0 0 1.66.91l2.538-.741a1.334 1.334 0 0 0 .914-1.653l-2.167-7.42c-.067-.27.068-.573.339-.64l2.979-.878c.981-.27 1.286-1.518.575-2.226l-9.207-9.107zM43.42 40.324c.169.54.643.877 1.185.877.101 0 .237 0 .338-.034a1.263 1.263 0 0 0 .846-1.517l-.812-2.766a1.27 1.27 0 0 0-1.523-.843 1.263 1.263 0 0 0-.846 1.517l.812 2.766zM41.152 42.146l-2.539-1.383a1.213 1.213 0 0 0-1.658.472c-.305.573-.102 1.349.474 1.653l2.538 1.383a1.253 1.253 0 0 0 1.659-.506 1.147 1.147 0 0 0-.474-1.62zM39.663 47.171l-2.776.81a1.263 1.263 0 0 0-.846 1.517c.17.54.643.877 1.185.877.101 0 .237 0 .338-.033l2.776-.81a1.263 1.263 0 0 0 .846-1.518c-.203-.674-.88-1.045-1.523-.843zM51.814 44.911c.17.54.643.877 1.185.877.101 0 .237 0 .338-.033l2.776-.81a1.263 1.263 0 0 0 .846-1.518 1.27 1.27 0 0 0-1.523-.843l-2.776.81c-.643.168-1.015.843-.846 1.517zM49.174 41.606a1.253 1.253 0 0 0 1.659-.506l1.387-2.53a1.204 1.204 0 0 0-.474-1.652 1.213 1.213 0 0 0-1.658.472L48.7 39.92a1.223 1.223 0 0 0 .474 1.686z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Card2 = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      className="injected-svg"
      data-src="/svg/design.svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      role="img"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#D1E5FA" cx="44" cy="44" r="44"></circle>
        <rect
          stroke="#0A335C"
          strokeWidth="2"
          fill="#F6FAFE"
          x="1"
          y="12"
          width="77"
          height="64"
          rx="2"
        ></rect>
        <rect fill="#FACF51" x="9" y="58" width="22" height="2" rx="1"></rect>
        <g transform="translate(9 30)">
          <rect
            stroke="#0A335C"
            strokeWidth="2"
            width="22"
            height="22"
            rx="2"
          ></rect>
          <g fill="#0A335C">
            <path d="m2.121.707 19.817 19.817a1 1 0 1 1-1.414 1.414L.707 2.12A1 1 0 0 1 2.121.707z"></path>
            <path d="M.707 20.524 20.524.707a1 1 0 1 1 1.414 1.414L2.12 21.938a1 1 0 0 1-1.414-1.414z"></path>
          </g>
        </g>
        <rect fill="#FACF51" x="9" y="62" width="22" height="2" rx="1"></rect>
        <rect fill="#FACF51" x="9" y="66" width="14" height="2" rx="1"></rect>
        <rect
          stroke="#197FE6"
          strokeWidth="2"
          x="40"
          y="30"
          width="8"
          height="8"
          rx="2"
        ></rect>
        <rect
          stroke="#197FE6"
          strokeWidth="2"
          x="40"
          y="58"
          width="8"
          height="8"
          rx="2"
        ></rect>
        <rect
          stroke="#197FE6"
          strokeWidth="2"
          x="62"
          y="30"
          width="8"
          height="8"
          rx="2"
        ></rect>
        <rect
          stroke="#197FE6"
          strokeWidth="2"
          x="62"
          y="58"
          width="8"
          height="8"
          rx="2"
        ></rect>
        <rect fill="#197FE6" x="48" y="33" width="14" height="2" rx="1"></rect>
        <rect fill="#197FE6" x="48" y="61" width="14" height="2" rx="1"></rect>
        <rect
          fill="#197FE6"
          transform="rotate(90 44 48)"
          x="34"
          y="47"
          width="20"
          height="2"
          rx="1"
        ></rect>
        <rect
          fill="#197FE6"
          transform="rotate(90 66 48)"
          x="56"
          y="47"
          width="20"
          height="2"
          rx="1"
        ></rect>
        <path
          d="M3 12h73a2 2 0 0 1 2 2v8H1v-8a2 2 0 0 1 2-2z"
          stroke="#0A335C"
          strokeWidth="2"
          fill="#F6FAFE"
        ></path>
        <rect fill="#197FE6" x="7" y="16" width="8" height="2" rx="1"></rect>
        <rect fill="#197FE6" x="19" y="16" width="8" height="2" rx="1"></rect>
        <rect fill="#197FE6" x="62" y="16" width="8" height="2" rx="1"></rect>
        <g fill="#197FE6" fillRule="nonzero">
          <path d="M53.639 48.817h-3.083l-.31.751h.31c.306 0 .523.058.653.172.13.114.195.264.195.448 0 .18-.065.328-.195.442-.13.114-.347.172-.653.172h-1.708c-.305 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.185.068-.335.204-.451.136-.116.361-.17.675-.163l1.993-4.824h-.83c-.305 0-.522-.057-.652-.171a.568.568 0 0 1-.195-.448c0-.185.065-.334.195-.448.13-.115.347-.172.653-.172l2.742.006 2.525 6.057c.297 0 .493.033.588.097a.61.61 0 0 1 .285.523c0 .18-.064.328-.192.442-.128.114-.345.172-.65.172h-1.708c-.306 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.18.065-.328.195-.442.13-.114.347-.172.653-.172h.31l-.304-.751zm-.526-1.234-1.022-2.442-1.027 2.442h2.049z"></path>
          <path d="M57.937 43v2.767c.31-.197.624-.344.944-.442.32-.098.642-.148.968-.148.88 0 1.624.295 2.235.885.61.59.916 1.3.916 2.135 0 .798-.29 1.465-.873 2-.582.535-1.35.803-2.302.803a3.755 3.755 0 0 1-1.888-.5v.302H56.45c-.305 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.18.066-.328.198-.442.132-.114.35-.172.65-.172h.217v-5.335h-.217c-.305 0-.523-.057-.653-.171a.568.568 0 0 1-.195-.448c0-.18.065-.328.195-.443.13-.114.348-.171.653-.171h1.486zm3.794 5.233c0-.51-.184-.94-.55-1.293a1.874 1.874 0 0 0-1.35-.53c-.528 0-.976.177-1.343.53-.368.353-.551.778-.551 1.275 0 .453.165.825.495 1.116.33.29.796.436 1.399.436.602 0 1.07-.145 1.402-.436.332-.29.498-.657.498-1.098z"></path>
        </g>
      </g>
    </svg>
  );
};

export const Logo = ({ className, color }) => (
  <svg
    width="189"
    height="28"
    viewBox="0 0 189 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={color} fillRule="nonzero">
        <path d="m53.62 28.4-2.912-3.484c-.806.2-1.63.301-2.473.301-1.795 0-3.443-.42-4.945-1.262a9.429 9.429 0 0 1-3.571-3.498c-.88-1.49-1.319-3.178-1.319-5.062 0-1.866.44-3.544 1.319-5.035a9.429 9.429 0 0 1 3.571-3.498c1.502-.841 3.15-1.262 4.945-1.262 1.813 0 3.466.42 4.959 1.262a9.357 9.357 0 0 1 3.544 3.498c.87 1.491 1.305 3.17 1.305 5.035 0 1.701-.362 3.251-1.085 4.65-.724 1.4-1.708 2.538-2.954 3.416L58.4 28.4h-4.78zM42.4 15.572c0 1.288.244 2.419.733 3.394.49.974 1.173 1.724 2.052 2.248.878.524 1.888.786 3.029.786 1.14 0 2.146-.262 3.015-.786.87-.524 1.549-1.274 2.038-2.248.489-.975.733-2.106.733-3.394 0-1.287-.244-2.413-.733-3.379-.49-.965-1.169-1.706-2.038-2.22-.87-.516-1.874-.773-3.015-.773s-2.151.257-3.03.772c-.878.515-1.562 1.256-2.05 2.221-.49.966-.734 2.092-.734 3.38zM70.836 25.6l-4.312-7.616h-1.848V25.6h-3.92V6.056h7.336c1.512 0 2.8.266 3.864.798s1.862 1.25 2.394 2.156c.532.905.798 1.918.798 3.038a5.82 5.82 0 0 1-1.12 3.486c-.746 1.036-1.857 1.75-3.332 2.142l4.676 7.924h-4.536zm-6.16-10.556h3.276c1.064 0 1.858-.257 2.38-.77.523-.513.784-1.227.784-2.142 0-.896-.261-1.591-.784-2.086-.522-.495-1.316-.742-2.38-.742h-3.276v5.74zM83.593 15.8c0-1.923.434-3.645 1.302-5.166a9.297 9.297 0 0 1 3.556-3.556c1.502-.85 3.187-1.274 5.054-1.274 2.184 0 4.097.56 5.74 1.68 1.642 1.12 2.79 2.67 3.444 4.648H98.18c-.448-.933-1.078-1.633-1.89-2.1-.812-.467-1.75-.7-2.814-.7-1.139 0-2.152.266-3.038.798-.887.532-1.578 1.283-2.072 2.254-.495.97-.742 2.11-.742 3.416 0 1.288.247 2.422.742 3.402.494.98 1.185 1.736 2.072 2.268.886.532 1.899.798 3.038.798 1.064 0 2.002-.238 2.814-.714.812-.476 1.442-1.18 1.89-2.114h4.508c-.654 1.997-1.797 3.551-3.43 4.662-1.634 1.11-3.552 1.666-5.754 1.666-1.867 0-3.552-.425-5.054-1.274a9.325 9.325 0 0 1-3.556-3.542c-.868-1.512-1.302-3.23-1.302-5.152zM109.557 12.496a5.511 5.511 0 0 1 1.974-1.932c.812-.467 1.74-.7 2.786-.7v4.116h-1.036c-1.232 0-2.16.29-2.786.868-.625.579-.938 1.587-.938 3.024V25.6h-3.92V10.088h3.92v2.408zM130.957 17.508c0 .56-.037 1.064-.112 1.512h-11.34c.094 1.12.486 1.997 1.176 2.632s1.54.952 2.548.952c1.456 0 2.492-.625 3.108-1.876h4.228c-.448 1.493-1.306 2.72-2.576 3.682-1.27.961-2.828 1.442-4.676 1.442-1.493 0-2.832-.331-4.018-.994a6.996 6.996 0 0 1-2.772-2.814c-.662-1.213-.994-2.613-.994-4.2 0-1.605.327-3.015.98-4.228.654-1.213 1.568-2.147 2.744-2.8 1.176-.653 2.53-.98 4.06-.98 1.475 0 2.796.317 3.962.952a6.7 6.7 0 0 1 2.716 2.702c.644 1.167.966 2.506.966 4.018zm-4.06-1.12c-.018-1.008-.382-1.815-1.092-2.422-.71-.607-1.577-.91-2.604-.91-.97 0-1.787.294-2.45.882-.662.588-1.068 1.405-1.218 2.45h7.364zM132.393 17.788c0-1.568.313-2.959.938-4.172.626-1.213 1.475-2.147 2.548-2.8 1.074-.653 2.273-.98 3.598-.98 1.158 0 2.17.233 3.038.7.868.467 1.564 1.055 2.086 1.764v-2.212h3.948V25.6h-3.948v-2.268c-.504.728-1.199 1.33-2.086 1.806-.886.476-1.908.714-3.066.714-1.306 0-2.496-.336-3.57-1.008-1.073-.672-1.922-1.62-2.548-2.842-.625-1.223-.938-2.627-.938-4.214zm12.208.056c0-.952-.186-1.769-.56-2.45a3.948 3.948 0 0 0-1.512-1.568 4.041 4.041 0 0 0-2.044-.546c-.728 0-1.4.177-2.016.532-.616.355-1.115.873-1.498 1.554-.382.681-.574 1.489-.574 2.422s.192 1.75.574 2.45c.383.7.887 1.237 1.512 1.61a3.84 3.84 0 0 0 2.002.56c.728 0 1.41-.182 2.044-.546a3.948 3.948 0 0 0 1.512-1.568c.374-.681.56-1.498.56-2.45zM156.538 13.308v7.504c0 .523.126.9.378 1.134.252.233.676.35 1.274.35h1.82V25.6h-2.464c-3.304 0-4.956-1.605-4.956-4.816v-7.476h-1.848v-3.22h1.848V6.252h3.948v3.836h3.472v3.22h-3.472zM169.314 25.852c-1.493 0-2.837-.331-4.032-.994a7.158 7.158 0 0 1-2.814-2.814c-.681-1.213-1.022-2.613-1.022-4.2 0-1.587.35-2.987 1.05-4.2a7.297 7.297 0 0 1 2.87-2.814c1.213-.663 2.567-.994 4.06-.994 1.493 0 2.847.331 4.06.994a7.297 7.297 0 0 1 2.87 2.814c.7 1.213 1.05 2.613 1.05 4.2 0 1.587-.36 2.987-1.078 4.2a7.465 7.465 0 0 1-2.912 2.814c-1.223.663-2.59.994-4.102.994zm0-3.416c.71 0 1.377-.173 2.002-.518.625-.345 1.125-.863 1.498-1.554.373-.69.56-1.53.56-2.52 0-1.475-.387-2.609-1.162-3.402-.775-.793-1.722-1.19-2.842-1.19s-2.058.397-2.814 1.19c-.756.793-1.134 1.927-1.134 3.402s.369 2.609 1.106 3.402c.737.793 1.666 1.19 2.786 1.19zM183.798 12.496a5.511 5.511 0 0 1 1.974-1.932c.812-.467 1.74-.7 2.786-.7v4.116h-1.036c-1.232 0-2.16.29-2.786.868-.625.579-.938 1.587-.938 3.024V25.6h-3.92V10.088h3.92v2.408z" />
      </g>
      <path fill="#197FE6" d="M12.8 12.8h12.8v12.8H12.8z" />
      <path
        d="M6.399 25.6H12.8V32H0V0h32v12.8h-6.4V6.4H6.399v19.2zM25.568 25.568h6.4v6.4h-6.4z"
        fill="#197FE6"
      />
    </g>
  </svg>
);

//SIDEBAR ICONS
export const SideBarQrCodeSVG = ({ className }) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z"></path>
  </svg>
);
export const SidebarAnalytics = ({ className }) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58l-3.12-3.11zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18l-4.69 7.4z"></path>
  </svg>
);
export const SidebarAccount = ({ className }) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2H4zM10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
  </svg>
);
export const SidebarBilling = ({ className }) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"></path>
  </svg>
);
export const SidebarCompany = ({}) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM14 19H20V5H8V7.12729C8.23444 7.12729 8.46888 7.20938 8.65718 7.37355L13.6572 11.733C13.875 11.9229 14 12.1978 14 12.4868V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"></path>
  </svg>
);
export const SidebarHelp = ({}) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"></path>
  </svg>
);
export const SidebarLogout = ({}) => (
  <svg
    stroke="currentColor"
    fill="#fff"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"></path>
  </svg>
);

// QR CODE-FRAMES
export const NotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-none.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.5 1.125H4.5C2.63604 1.125 1.125 2.63604 1.125 4.5V67.5C1.125 69.364 2.63604 70.875 4.5 70.875H49.5C51.364 70.875 52.875 69.364 52.875 67.5V4.5C52.875 2.63604 51.364 1.125 49.5 1.125ZM4.5 0C2.01472 0 0 2.01472 0 4.5V67.5C0 69.9853 2.01472 72 4.5 72H49.5C51.9853 72 54 69.9853 54 67.5V4.5C54 2.01472 51.9853 0 49.5 0H4.5Z"
      fill="#404040"
    />
    <path
      d="M27.571 43.4483C29.3558 43.4494 31.0856 42.853 32.4662 41.7606C33.8465 40.6683 34.7919 39.1475 35.1412 37.4577C35.4905 35.7676 35.2221 34.0132 34.3818 32.4928C33.5413 30.9726 32.181 29.7807 30.5323 29.1203C28.8838 28.46 27.0492 28.372 25.3409 28.8712C23.6326 29.3706 22.1567 30.4263 21.1641 31.8587C20.1718 33.2911 19.7245 35.0113 19.8986 36.7263C20.0726 38.4413 20.8572 40.0451 22.1186 41.2642C22.8332 41.9576 23.6828 42.5076 24.6185 42.8825C25.5543 43.2573 26.5576 43.4496 27.5707 43.4483L27.571 43.4483ZM31.9404 40.2187C30.8775 41.2423 29.4641 41.8564 27.9657 41.9457C26.4672 42.0351 24.9864 41.5937 23.801 40.7041L32.4431 32.3411C33.3657 33.4887 33.8235 34.9215 33.731 36.3716C33.6385 37.8215 33.002 39.1893 31.9404 40.2188L31.9404 40.2187ZM23.2016 31.781C24.2646 30.7573 25.678 30.1432 27.1764 30.0539C28.6749 29.9646 30.1556 30.406 31.3411 31.2955L22.699 39.6586C21.7777 38.5138 21.3205 37.0842 21.4131 35.6374C21.5056 34.1906 22.1416 32.826 23.2017 31.7995L23.2016 31.781Z"
      fill="#404040"
    />
  </svg>
);

export const Frame1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-mobile.svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 0C2.01472 0 0 2.01472 0 4.5V67.5C0 69.9853 2.01472 72 4.5 72H49.5C51.9853 72 54 69.9853 54 67.5V4.5C54 2.01472 51.9853 0 49.5 0H4.5ZM31.0501 66.15C31.0501 68.3868 29.2368 70.2 27.0001 70.2C24.7633 70.2 22.9501 68.3868 22.9501 66.15C22.9501 63.9132 24.7633 62.1 27.0001 62.1C29.2368 62.1 31.0501 63.9132 31.0501 66.15ZM29.9248 66.15C29.9248 67.7654 28.6152 69.075 26.9998 69.075C25.3843 69.075 24.0748 67.7654 24.0748 66.15C24.0748 64.5346 25.3843 63.225 26.9998 63.225C28.6152 63.225 29.9248 64.5346 29.9248 66.15Z"
      fill="#404040"
    />
    <rect x={3.59961} y={13.5} width={46.8} height={46.8} fill="white" />
    <rect
      x={6.30029}
      y={16.2}
      width={41.4}
      height={41.4}
      fill="url(#pattern0-105)"
    />
    <path
      d="M10.9131 9.96076C10.5486 9.96076 10.2066 9.91126 9.88715 9.81226C9.56765 9.71326 9.29765 9.57376 9.07715 9.39376L9.3674 8.75926C9.5969 8.93476 9.83765 9.06301 10.0896 9.14401C10.3461 9.22501 10.6229 9.26551 10.9199 9.26551C11.2484 9.26551 11.5004 9.20926 11.6759 9.09676C11.8559 8.97976 11.9459 8.81776 11.9459 8.61076C11.9459 8.43076 11.8626 8.29351 11.6961 8.19901C11.5341 8.10451 11.2619 8.01451 10.8794 7.92901C10.4834 7.84351 10.1616 7.74451 9.91415 7.63201C9.66665 7.51951 9.4799 7.37551 9.3539 7.20001C9.2279 7.02451 9.1649 6.80176 9.1649 6.53176C9.1649 6.25276 9.2414 6.00301 9.3944 5.78251C9.5474 5.56201 9.7634 5.39101 10.0424 5.26951C10.3214 5.14351 10.6431 5.08051 11.0076 5.08051C11.3406 5.08051 11.6579 5.13226 11.9594 5.23576C12.2609 5.33476 12.5084 5.47201 12.7019 5.64751L12.4116 6.28201C11.9886 5.94451 11.5206 5.77576 11.0076 5.77576C10.7016 5.77576 10.4586 5.83876 10.2786 5.96476C10.1031 6.08626 10.0154 6.25726 10.0154 6.47776C10.0154 6.66226 10.0941 6.80401 10.2516 6.90301C10.4091 7.00201 10.6769 7.09426 11.0549 7.17976C11.4554 7.26976 11.7794 7.37101 12.0269 7.48351C12.2789 7.59151 12.4701 7.73101 12.6006 7.90201C12.7356 8.07301 12.8031 8.28901 12.8031 8.55001C12.8031 8.83351 12.7266 9.08326 12.5736 9.29926C12.4251 9.51076 12.2069 9.675 11.9189 9.79201C11.6354 9.90451 11.3001 9.96076 10.9131 9.96076Z"
      fill="white"
    />
    <path
      d="M15.3893 9.96076C14.9213 9.96076 14.5118 9.86176 14.1608 9.66376C13.8143 9.46126 13.5466 9.17551 13.3576 8.80651C13.1731 8.43751 13.0808 8.00776 13.0808 7.51726C13.0808 7.02676 13.1731 6.59926 13.3576 6.23476C13.5466 5.86576 13.8143 5.58226 14.1608 5.38426C14.5118 5.18176 14.9213 5.08051 15.3893 5.08051C15.7088 5.08051 16.0103 5.13001 16.2938 5.22901C16.5773 5.32801 16.8158 5.46751 17.0093 5.64751L16.7191 6.28201C16.5031 6.11101 16.2893 5.98726 16.0778 5.91076C15.8663 5.82976 15.6413 5.78926 15.4028 5.78926C14.9438 5.78926 14.5883 5.93776 14.3363 6.23476C14.0888 6.53176 13.9651 6.95926 13.9651 7.51726C13.9651 8.07976 14.0888 8.50951 14.3363 8.80651C14.5883 9.10351 14.9438 9.25201 15.4028 9.25201C15.6413 9.25201 15.8663 9.21376 16.0778 9.13726C16.2893 9.05626 16.5031 8.93026 16.7191 8.75926L17.0093 9.39376C16.8158 9.57376 16.5773 9.71326 16.2938 9.81226C16.0103 9.91126 15.7088 9.96076 15.3893 9.96076Z"
      fill="white"
    />
    <path
      d="M20.9816 9.90001L20.5024 8.78626H18.1871L17.7079 9.90001H16.8304L18.9836 5.14126H19.6924L21.8456 9.90001H20.9816ZM18.4706 8.11126H20.2121L19.3414 6.08626L18.4706 8.11126Z"
      fill="white"
    />
    <path
      d="M25.1776 5.14126H25.9944V9.90001H25.3396L22.7881 6.57901V9.90001H21.9781V5.14126H22.6261L25.1776 8.45551V5.14126Z"
      fill="white"
    />
    <path
      d="M32.0656 5.14126H32.7474V9.90001H31.9779V6.75451L30.7224 9.13051H30.1419L28.8796 6.78826L28.8864 9.90001H28.1169V5.14126H28.8054L30.4389 8.25301L32.0656 5.14126Z"
      fill="white"
    />
    <path
      d="M33.4039 9.90001V5.14126H36.5899V5.82976H34.2544V7.13926H36.4549V7.82101H34.2544V9.2115H36.5899V9.90001H33.4039Z"
      fill="white"
    />
    <path
      d="M37.0038 9.90001V5.14126H40.1898V5.82976H37.8543V7.13926H40.0548V7.82101H37.8543V9.2115H40.1898V9.90001H37.0038Z"
      fill="white"
    />
    <path
      d="M40.6036 9.90001V5.14126H43.7896V5.82976H41.4541V7.13926H43.6546V7.82101H41.4541V9.2115H43.7896V9.90001H40.6036Z"
      fill="white"
    />
    <path
      d="M44.271 8.46901L44.0077 5.13451L45.0472 5.14126L44.784 8.46901H44.271ZM44.055 8.96851H45V9.90001H44.055V8.96851Z"
      fill="white"
    />
    <defs>
      <pattern
        id="pattern0-105"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_815"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_815"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame2 = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-black.svg"
    role="img"
    // {...props}
  >
    <rect width={54} height={72} rx={3} fill="#404040" />
    <rect x={3.375} y={3.375} width={46.8} height={46.8} fill="white" />
    <rect
      x={6.1875}
      y={6.1875}
      width={41.4}
      height={41.4}
      fill="url(#pattern0-106)"
    />
    <path
      d="M10.8375 63.0608C10.473 63.0608 10.131 63.0113 9.81146 62.9123C9.49196 62.8133 9.22196 62.6738 9.00146 62.4938L9.29171 61.8593C9.52121 62.0348 9.76196 62.163 10.014 62.244C10.2705 62.325 10.5472 62.3655 10.8442 62.3655C11.1727 62.3655 11.4247 62.3093 11.6002 62.1968C11.7802 62.0798 11.8702 61.9178 11.8702 61.7108C11.8702 61.5308 11.787 61.3935 11.6205 61.299C11.4585 61.2045 11.1862 61.1145 10.8037 61.029C10.4077 60.9435 10.086 60.8445 9.83847 60.732C9.59096 60.6195 9.40421 60.4755 9.27821 60.3C9.15221 60.1245 9.08921 59.9018 9.08921 59.6318C9.08921 59.3528 9.16571 59.103 9.31871 58.8825C9.47171 58.662 9.68771 58.491 9.96671 58.3695C10.2457 58.2435 10.5675 58.1805 10.932 58.1805C11.265 58.1805 11.5822 58.2323 11.8837 58.3358C12.1852 58.4348 12.4327 58.572 12.6262 58.7475L12.336 59.382C11.913 59.0445 11.445 58.8758 10.932 58.8758C10.626 58.8758 10.383 58.9388 10.203 59.0648C10.0275 59.1863 9.93972 59.3573 9.93972 59.5778C9.93972 59.7623 10.0185 59.904 10.176 60.003C10.3335 60.102 10.6012 60.1943 10.9792 60.2798C11.3797 60.3698 11.7037 60.471 11.9512 60.5835C12.2032 60.6915 12.3945 60.831 12.525 61.002C12.66 61.173 12.7275 61.389 12.7275 61.65C12.7275 61.9335 12.651 62.1833 12.498 62.3993C12.3495 62.6108 12.1312 62.775 11.8432 62.892C11.5597 63.0045 11.2245 63.0608 10.8375 63.0608Z"
      fill="white"
    />
    <path
      d="M15.3137 63.0608C14.8457 63.0608 14.4362 62.9618 14.0852 62.7638C13.7387 62.5613 13.4709 62.2755 13.2819 61.9065C13.0974 61.5375 13.0052 61.1078 13.0052 60.6173C13.0052 60.1268 13.0974 59.6993 13.2819 59.3348C13.4709 58.9658 13.7387 58.6823 14.0852 58.4843C14.4362 58.2818 14.8457 58.1805 15.3137 58.1805C15.6332 58.1805 15.9347 58.23 16.2182 58.329C16.5017 58.428 16.7402 58.5675 16.9337 58.7475L16.6434 59.382C16.4274 59.211 16.2137 59.0873 16.0022 59.0108C15.7907 58.9298 15.5657 58.8893 15.3272 58.8893C14.8682 58.8893 14.5127 59.0378 14.2607 59.3348C14.0132 59.6318 13.8894 60.0593 13.8894 60.6173C13.8894 61.1798 14.0132 61.6095 14.2607 61.9065C14.5127 62.2035 14.8682 62.352 15.3272 62.352C15.5657 62.352 15.7907 62.3138 16.0022 62.2373C16.2137 62.1563 16.4274 62.0303 16.6434 61.8593L16.9337 62.4938C16.7402 62.6738 16.5017 62.8133 16.2182 62.9123C15.9347 63.0113 15.6332 63.0608 15.3137 63.0608Z"
      fill="white"
    />
    <path
      d="M20.9059 63L20.4267 61.8863H18.1114L17.6322 63H16.7547L18.9079 58.2413H19.6167L21.7699 63H20.9059ZM18.3949 61.2113H20.1364L19.2657 59.1863L18.3949 61.2113Z"
      fill="white"
    />
    <path
      d="M25.1019 58.2413H25.9187V63H25.2639L22.7124 59.679V63H21.9024V58.2413H22.5504L25.1019 61.5555V58.2413Z"
      fill="white"
    />
    <path
      d="M31.9899 58.2413H32.6717V63H31.9022V59.8545L30.6467 62.2305H30.0662L28.8039 59.8883L28.8107 63H28.0412V58.2413H28.7297L30.3632 61.353L31.9899 58.2413Z"
      fill="white"
    />
    <path
      d="M33.3282 63V58.2413H36.5142V58.9298H34.1787V60.2393H36.3792V60.921H34.1787V62.3115H36.5142V63H33.3282Z"
      fill="white"
    />
    <path
      d="M36.9281 63V58.2413H40.1141V58.9298H37.7786V60.2393H39.9791V60.921H37.7786V62.3115H40.1141V63H36.9281Z"
      fill="white"
    />
    <path
      d="M40.5279 63V58.2413H43.7139V58.9298H41.3784V60.2393H43.5789V60.921H41.3784V62.3115H43.7139V63H40.5279Z"
      fill="white"
    />
    <path
      d="M44.1953 61.569L43.932 58.2345L44.9715 58.2413L44.7083 61.569H44.1953ZM43.9793 62.0685H44.9243V63H43.9793V62.0685Z"
      fill="white"
    />
    <defs>
      <pattern
        id="pattern0-106"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_997"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_997"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-white.svg"
    role="img"
    {...props}
  >
    <rect width={54} height={72} rx={3} fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.75 1.125H2.25C1.62868 1.125 1.125 1.62868 1.125 2.25V51.75C1.125 52.3713 1.62868 52.875 2.25 52.875H51.75C52.3713 52.875 52.875 52.3713 52.875 51.75V2.25C52.875 1.62868 52.3713 1.125 51.75 1.125ZM2.25 0C1.00736 0 0 1.00736 0 2.25V51.75C0 52.9926 1.00736 54 2.25 54H51.75C52.9926 54 54 52.9926 54 51.75V2.25C54 1.00736 52.9926 0 51.75 0H2.25Z"
      fill="#404040"
    />
    <rect x={3.375} y={3.375} width={46.8} height={46.8} fill="white" />
    <rect
      x={6.1875}
      y={6.1875}
      width={41.4}
      height={41.4}
      fill="url(#pattern0-107)"
    />
    <path
      d="M10.6124 65.3108C10.2479 65.3108 9.90587 65.2613 9.58637 65.1623C9.26687 65.0633 8.99687 64.9238 8.77637 64.7438L9.06662 64.1093C9.29612 64.2848 9.53687 64.413 9.78887 64.494C10.0454 64.575 10.3221 64.6155 10.6191 64.6155C10.9476 64.6155 11.1996 64.5593 11.3751 64.4468C11.5551 64.3298 11.6451 64.1678 11.6451 63.9608C11.6451 63.7808 11.5619 63.6435 11.3954 63.549C11.2334 63.4545 10.9611 63.3645 10.5786 63.279C10.1826 63.1935 9.86087 63.0945 9.61337 62.982C9.36587 62.8695 9.17912 62.7255 9.05312 62.55C8.92712 62.3745 8.86412 62.1518 8.86412 61.8818C8.86412 61.6028 8.94062 61.353 9.09362 61.1325C9.24662 60.912 9.46262 60.741 9.74162 60.6195C10.0206 60.4935 10.3424 60.4305 10.7069 60.4305C11.0399 60.4305 11.3571 60.4823 11.6586 60.5858C11.9601 60.6848 12.2076 60.822 12.4011 60.9975L12.1109 61.632C11.6879 61.2945 11.2199 61.1258 10.7069 61.1258C10.4009 61.1258 10.1579 61.1888 9.97787 61.3148C9.80237 61.4363 9.71462 61.6073 9.71462 61.8278C9.71462 62.0123 9.79337 62.154 9.95087 62.253C10.1084 62.352 10.3761 62.4443 10.7541 62.5298C11.1546 62.6198 11.4786 62.721 11.7261 62.8335C11.9781 62.9415 12.1694 63.081 12.2999 63.252C12.4349 63.423 12.5024 63.639 12.5024 63.9C12.5024 64.1835 12.4259 64.4333 12.2729 64.6493C12.1244 64.8608 11.9061 65.025 11.6181 65.142C11.3346 65.2545 10.9994 65.3108 10.6124 65.3108Z"
      fill="#404040"
    />
    <path
      d="M15.0886 65.3108C14.6206 65.3108 14.2111 65.2118 13.8601 65.0138C13.5136 64.8113 13.2458 64.5255 13.0568 64.1565C12.8723 63.7875 12.7801 63.3578 12.7801 62.8673C12.7801 62.3768 12.8723 61.9493 13.0568 61.5848C13.2458 61.2158 13.5136 60.9323 13.8601 60.7343C14.2111 60.5318 14.6206 60.4305 15.0886 60.4305C15.4081 60.4305 15.7096 60.48 15.9931 60.579C16.2766 60.678 16.5151 60.8175 16.7086 60.9975L16.4183 61.632C16.2023 61.461 15.9886 61.3373 15.7771 61.2608C15.5656 61.1798 15.3406 61.1393 15.1021 61.1393C14.6431 61.1393 14.2876 61.2878 14.0356 61.5848C13.7881 61.8818 13.6643 62.3093 13.6643 62.8673C13.6643 63.4298 13.7881 63.8595 14.0356 64.1565C14.2876 64.4535 14.6431 64.602 15.1021 64.602C15.3406 64.602 15.5656 64.5638 15.7771 64.4873C15.9886 64.4063 16.2023 64.2803 16.4183 64.1093L16.7086 64.7438C16.5151 64.9238 16.2766 65.0633 15.9931 65.1623C15.7096 65.2613 15.4081 65.3108 15.0886 65.3108Z"
      fill="#404040"
    />
    <path
      d="M20.6808 65.25L20.2016 64.1363H17.8863L17.4071 65.25H16.5296L18.6828 60.4913H19.3916L21.5448 65.25H20.6808ZM18.1698 63.4613H19.9113L19.0406 61.4363L18.1698 63.4613Z"
      fill="#404040"
    />
    <path
      d="M24.8768 60.4913H25.6936V65.25H25.0388L22.4873 61.929V65.25H21.6773V60.4913H22.3253L24.8768 63.8055V60.4913Z"
      fill="#404040"
    />
    <path
      d="M31.7648 60.4913H32.4466V65.25H31.6771V62.1045L30.4216 64.4805H29.8411L28.5788 62.1383L28.5856 65.25H27.8161V60.4913H28.5046L30.1381 63.603L31.7648 60.4913Z"
      fill="#404040"
    />
    <path
      d="M33.1031 65.25V60.4913H36.2891V61.1798H33.9536V62.4893H36.1541V63.171H33.9536V64.5615H36.2891V65.25H33.1031Z"
      fill="#404040"
    />
    <path
      d="M36.703 65.25V60.4913H39.889V61.1798H37.5535V62.4893H39.754V63.171H37.5535V64.5615H39.889V65.25H36.703Z"
      fill="#404040"
    />
    <path
      d="M40.3028 65.25V60.4913H43.4888V61.1798H41.1533V62.4893H43.3538V63.171H41.1533V64.5615H43.4888V65.25H40.3028Z"
      fill="#404040"
    />
    <path
      d="M43.9702 63.819L43.7069 60.4845L44.7464 60.4913L44.4832 63.819H43.9702ZM43.7542 64.3185H44.6992V65.25H43.7542V64.3185Z"
      fill="#404040"
    />
    <defs>
      <pattern
        id="pattern0-107"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_866"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_866"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-button.svg"
    role="img"
    {...props}
  >
    <rect width={54} height={54} rx={3} fill="#404040" />
    <rect y={56.25} width={54} height={15.75} rx={3} fill="#404040" />
    <rect x={3.375} y={3.375} width={46.8} height={46.8} fill="white" />
    <rect
      x={6.1875}
      y={6.1875}
      width={41.4}
      height={41.4}
      fill="url(#pattern0-108)"
    />
    <path
      d="M10.8375 66.4358C10.473 66.4358 10.131 66.3863 9.81146 66.2873C9.49196 66.1883 9.22196 66.0488 9.00146 65.8688L9.29171 65.2343C9.52121 65.4098 9.76196 65.538 10.014 65.619C10.2705 65.7 10.5472 65.7405 10.8442 65.7405C11.1727 65.7405 11.4247 65.6843 11.6002 65.5718C11.7802 65.4548 11.8702 65.2928 11.8702 65.0858C11.8702 64.9058 11.787 64.7685 11.6205 64.674C11.4585 64.5795 11.1862 64.4895 10.8037 64.404C10.4077 64.3185 10.086 64.2195 9.83847 64.107C9.59096 63.9945 9.40421 63.8505 9.27821 63.675C9.15221 63.4995 9.08921 63.2768 9.08921 63.0068C9.08921 62.7278 9.16571 62.478 9.31871 62.2575C9.47171 62.037 9.68771 61.866 9.96671 61.7445C10.2457 61.6185 10.5675 61.5555 10.932 61.5555C11.265 61.5555 11.5822 61.6073 11.8837 61.7108C12.1852 61.8098 12.4327 61.947 12.6262 62.1225L12.336 62.757C11.913 62.4195 11.445 62.2508 10.932 62.2508C10.626 62.2508 10.383 62.3138 10.203 62.4398C10.0275 62.5613 9.93972 62.7323 9.93972 62.9528C9.93972 63.1373 10.0185 63.279 10.176 63.378C10.3335 63.477 10.6012 63.5693 10.9792 63.6548C11.3797 63.7448 11.7037 63.846 11.9512 63.9585C12.2032 64.0665 12.3945 64.206 12.525 64.377C12.66 64.548 12.7275 64.764 12.7275 65.025C12.7275 65.3085 12.651 65.5583 12.498 65.7743C12.3495 65.9858 12.1312 66.15 11.8432 66.267C11.5597 66.3795 11.2245 66.4358 10.8375 66.4358Z"
      fill="white"
    />
    <path
      d="M15.3137 66.4358C14.8457 66.4358 14.4362 66.3368 14.0852 66.1388C13.7387 65.9363 13.4709 65.6505 13.2819 65.2815C13.0974 64.9125 13.0052 64.4828 13.0052 63.9923C13.0052 63.5018 13.0974 63.0743 13.2819 62.7098C13.4709 62.3408 13.7387 62.0573 14.0852 61.8593C14.4362 61.6568 14.8457 61.5555 15.3137 61.5555C15.6332 61.5555 15.9347 61.605 16.2182 61.704C16.5017 61.803 16.7402 61.9425 16.9337 62.1225L16.6434 62.757C16.4274 62.586 16.2137 62.4623 16.0022 62.3858C15.7907 62.3048 15.5657 62.2643 15.3272 62.2643C14.8682 62.2643 14.5127 62.4128 14.2607 62.7098C14.0132 63.0068 13.8894 63.4343 13.8894 63.9923C13.8894 64.5548 14.0132 64.9845 14.2607 65.2815C14.5127 65.5785 14.8682 65.727 15.3272 65.727C15.5657 65.727 15.7907 65.6888 16.0022 65.6123C16.2137 65.5313 16.4274 65.4053 16.6434 65.2343L16.9337 65.8688C16.7402 66.0488 16.5017 66.1883 16.2182 66.2873C15.9347 66.3863 15.6332 66.4358 15.3137 66.4358Z"
      fill="white"
    />
    <path
      d="M20.9059 66.375L20.4267 65.2613H18.1114L17.6322 66.375H16.7547L18.9079 61.6163H19.6167L21.7699 66.375H20.9059ZM18.3949 64.5863H20.1364L19.2657 62.5613L18.3949 64.5863Z"
      fill="white"
    />
    <path
      d="M25.1019 61.6163H25.9187V66.375H25.2639L22.7124 63.054V66.375H21.9024V61.6163H22.5504L25.1019 64.9305V61.6163Z"
      fill="white"
    />
    <path
      d="M31.9899 61.6163H32.6717V66.375H31.9022V63.2295L30.6467 65.6055H30.0662L28.8039 63.2633L28.8107 66.375H28.0412V61.6163H28.7297L30.3632 64.728L31.9899 61.6163Z"
      fill="white"
    />
    <path
      d="M33.3282 66.375V61.6163H36.5142V62.3048H34.1787V63.6143H36.3792V64.296H34.1787V65.6865H36.5142V66.375H33.3282Z"
      fill="white"
    />
    <path
      d="M36.9281 66.375V61.6163H40.1141V62.3048H37.7786V63.6143H39.9791V64.296H37.7786V65.6865H40.1141V66.375H36.9281Z"
      fill="white"
    />
    <path
      d="M40.5279 66.375V61.6163H43.7139V62.3048H41.3784V63.6143H43.5789V64.296H41.3784V65.6865H43.7139V66.375H40.5279Z"
      fill="white"
    />
    <path
      d="M44.1953 64.944L43.932 61.6095L44.9715 61.6163L44.7083 64.944H44.1953ZM43.9793 65.4435H44.9243V66.375H43.9793V65.4435Z"
      fill="white"
    />
    <defs>
      <pattern
        id="pattern0-108"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_858"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_858"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-ticket.svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 0H6C6 3.31371 3.31371 6 0 6V66C3.31371 66 6 68.6863 6 72H48C48 68.6863 50.6863 66 54 66V6C50.6863 6 48 3.31371 48 0Z"
      fill="#404040"
    />
    <rect x={3.6001} y={16.2} width={46.8} height={46.8} fill="white" />
    <rect
      x={6.30029}
      y={18.9}
      width={41.4}
      height={41.4}
      fill="url(#pattern0-109)"
    />
    <path
      d="M10.8375 10.6357C10.473 10.6357 10.131 10.5862 9.81146 10.4872C9.49196 10.3882 9.22196 10.2487 9.00146 10.0687L9.29171 9.43424C9.52121 9.60974 9.76196 9.73799 10.014 9.81899C10.2705 9.89999 10.5472 9.94049 10.8442 9.94049C11.1727 9.94049 11.4247 9.88424 11.6002 9.77174C11.7802 9.65474 11.8702 9.49274 11.8702 9.28574C11.8702 9.10574 11.787 8.96849 11.6205 8.87399C11.4585 8.77949 11.1862 8.68949 10.8037 8.60399C10.4077 8.51849 10.086 8.41949 9.83847 8.30699C9.59096 8.19449 9.40421 8.05049 9.27821 7.87499C9.15221 7.69949 9.08921 7.47674 9.08921 7.20674C9.08921 6.92774 9.16571 6.67799 9.31871 6.45749C9.47171 6.23699 9.68771 6.06599 9.96671 5.94449C10.2457 5.81849 10.5675 5.75549 10.932 5.75549C11.265 5.75549 11.5822 5.80724 11.8837 5.91074C12.1852 6.00974 12.4327 6.14699 12.6262 6.32249L12.336 6.95699C11.913 6.61949 11.445 6.45074 10.932 6.45074C10.626 6.45074 10.383 6.51374 10.203 6.63974C10.0275 6.76124 9.93972 6.93224 9.93972 7.15274C9.93972 7.33724 10.0185 7.47899 10.176 7.57799C10.3335 7.67699 10.6012 7.76924 10.9792 7.85474C11.3797 7.94474 11.7037 8.04599 11.9512 8.15849C12.2032 8.26649 12.3945 8.40599 12.525 8.57699C12.66 8.74799 12.7275 8.96399 12.7275 9.22499C12.7275 9.50849 12.651 9.75824 12.498 9.97424C12.3495 10.1857 12.1312 10.35 11.8432 10.467C11.5597 10.5795 11.2245 10.6357 10.8375 10.6357Z"
      fill="white"
    />
    <path
      d="M15.3137 10.6357C14.8457 10.6357 14.4362 10.5367 14.0852 10.3387C13.7387 10.1362 13.4709 9.85049 13.2819 9.48149C13.0974 9.11249 13.0052 8.68274 13.0052 8.19224C13.0052 7.70174 13.0974 7.27424 13.2819 6.90974C13.4709 6.54074 13.7387 6.25724 14.0852 6.05924C14.4362 5.85674 14.8457 5.75549 15.3137 5.75549C15.6332 5.75549 15.9347 5.80499 16.2182 5.90399C16.5017 6.00299 16.7402 6.14249 16.9337 6.32249L16.6434 6.95699C16.4274 6.78599 16.2137 6.66224 16.0022 6.58574C15.7907 6.50474 15.5657 6.46424 15.3272 6.46424C14.8682 6.46424 14.5127 6.61274 14.2607 6.90974C14.0132 7.20674 13.8894 7.63424 13.8894 8.19224C13.8894 8.75474 14.0132 9.18449 14.2607 9.48149C14.5127 9.77849 14.8682 9.92699 15.3272 9.92699C15.5657 9.92699 15.7907 9.88874 16.0022 9.81224C16.2137 9.73124 16.4274 9.60524 16.6434 9.43424L16.9337 10.0687C16.7402 10.2487 16.5017 10.3882 16.2182 10.4872C15.9347 10.5862 15.6332 10.6357 15.3137 10.6357Z"
      fill="white"
    />
    <path
      d="M20.9059 10.575L20.4267 9.46124H18.1114L17.6322 10.575H16.7547L18.9079 5.81624H19.6167L21.7699 10.575H20.9059ZM18.3949 8.78624H20.1364L19.2657 6.76124L18.3949 8.78624Z"
      fill="white"
    />
    <path
      d="M25.1019 5.81624H25.9187V10.575H25.2639L22.7124 7.25399V10.575H21.9024V5.81624H22.5504L25.1019 9.13049V5.81624Z"
      fill="white"
    />
    <path
      d="M31.9899 5.81624H32.6717V10.575H31.9022V7.42949L30.6467 9.80549H30.0662L28.8039 7.46324L28.8107 10.575H28.0412V5.81624H28.7297L30.3632 8.92799L31.9899 5.81624Z"
      fill="white"
    />
    <path
      d="M33.3282 10.575V5.81624H36.5142V6.50474H34.1787V7.81424H36.3792V8.49599H34.1787V9.88649H36.5142V10.575H33.3282Z"
      fill="white"
    />
    <path
      d="M36.9281 10.575V5.81624H40.1141V6.50474H37.7786V7.81424H39.9791V8.49599H37.7786V9.88649H40.1141V10.575H36.9281Z"
      fill="white"
    />
    <path
      d="M40.5279 10.575V5.81624H43.7139V6.50474H41.3784V7.81424H43.5789V8.49599H41.3784V9.88649H43.7139V10.575H40.5279Z"
      fill="white"
    />
    <path
      d="M44.1953 9.14399L43.932 5.80949L44.9715 5.81624L44.7083 9.14399H44.1953ZM43.9793 9.64349H44.9243V10.575H43.9793V9.64349Z"
      fill="white"
    />
    <defs>
      <pattern
        id="pattern0-109"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_904"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_904"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={72}
    height={96}
    viewBox="0 0 54 72"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-museum.svg"
    role="img"
    {...props}
  >
    <rect x={3.375} y={3.42859} width={47.25} height={47.5429} fill="white" />
    <rect
      x={6.1875}
      y={6.28571}
      width={41.4}
      height={42.0571}
      fill="url(#pattern0-110)"
    />
    <path
      d="M7.66178 63.1229C7.67865 63.14 7.68709 63.1686 7.68709 63.2086C7.68709 63.26 7.6674 63.3172 7.62803 63.38C7.59428 63.4429 7.54928 63.4914 7.49303 63.5257C7.50428 63.5372 7.5099 63.5714 7.5099 63.6286C7.5099 63.6857 7.50428 63.74 7.49303 63.7914C7.4874 63.8372 7.48178 63.8686 7.47615 63.8857C7.49303 63.9029 7.5099 63.94 7.52678 63.9972C7.54365 64.0543 7.5549 64.1 7.56053 64.1343C7.61115 64.1343 7.65896 64.1514 7.70396 64.1857C7.74896 64.22 7.78271 64.2686 7.80521 64.3314C7.81084 64.3257 7.8249 64.3229 7.8474 64.3229C7.88115 64.3229 7.92053 64.3286 7.96553 64.34C8.01053 64.3514 8.04709 64.3629 8.07521 64.3743C8.09209 64.3572 8.12865 64.3486 8.1849 64.3486C8.28053 64.3486 8.3424 64.3714 8.37053 64.4172C8.39865 64.4 8.43521 64.3914 8.48021 64.3914C8.57021 64.3914 8.63771 64.4143 8.68271 64.46C8.71084 64.4372 8.7699 64.4257 8.8599 64.4257C8.92178 64.4257 8.98365 64.4343 9.04553 64.4514C9.1074 64.4686 9.14678 64.4914 9.16365 64.52C9.18053 64.5143 9.20584 64.5114 9.23959 64.5114C9.33521 64.5114 9.42521 64.5372 9.50959 64.5886C9.59959 64.6343 9.64459 64.6857 9.64459 64.7429C9.71771 64.7314 9.78521 64.7486 9.84709 64.7943C9.90896 64.84 9.95959 64.8972 9.99896 64.9657C10.1002 64.9829 10.1958 65.0772 10.2858 65.2486C10.3758 65.42 10.4208 65.58 10.4208 65.7286C10.4208 65.7972 10.4068 65.8543 10.3787 65.9C10.463 65.9572 10.5052 66.0629 10.5052 66.2172C10.5052 66.3257 10.4827 66.4257 10.4377 66.5172C10.449 66.5629 10.4546 66.5972 10.4546 66.62C10.4546 66.7172 10.4265 66.8143 10.3702 66.9114C10.3196 67.0029 10.2577 67.06 10.1846 67.0829C10.1677 67.18 10.1171 67.2714 10.0327 67.3572C9.94834 67.4372 9.86115 67.4972 9.77115 67.5372C9.7599 67.6114 9.70646 67.6857 9.61084 67.76C9.51521 67.8286 9.4224 67.8514 9.3324 67.8286C9.29303 67.88 9.2199 67.9229 9.11303 67.9572C9.01178 67.9857 8.90209 68 8.78396 68C8.67146 68 8.5674 67.9857 8.47178 67.9572C8.38178 67.9286 8.3199 67.8857 8.28615 67.8286C8.23553 67.8514 8.17928 67.8629 8.1174 67.8629C8.03865 67.8629 7.96271 67.8429 7.88959 67.8029C7.82209 67.7629 7.77428 67.7086 7.74615 67.64C7.67865 67.6572 7.60553 67.6429 7.52678 67.5972C7.45365 67.5457 7.40021 67.4686 7.36646 67.3657C7.27646 67.3657 7.18365 67.3343 7.08803 67.2714C6.99803 67.2086 6.9474 67.1457 6.93615 67.0829C6.84615 67.0657 6.77584 67.0257 6.72521 66.9629C6.68021 66.9 6.65771 66.8286 6.65771 66.7486C6.65771 66.6572 6.68584 66.5743 6.74209 66.5C6.80396 66.4257 6.88271 66.3886 6.97834 66.3886C7.02896 66.3886 7.06834 66.3943 7.09646 66.4057C7.14146 66.3943 7.1724 66.3886 7.18928 66.3886C7.27365 66.3886 7.34959 66.4172 7.41709 66.4743C7.49021 66.5314 7.52959 66.6029 7.53521 66.6886C7.56896 66.6772 7.59709 66.6714 7.61959 66.6714C7.69834 66.6714 7.76865 66.7086 7.83053 66.7829C7.89803 66.8514 7.9374 66.9314 7.94865 67.0229C7.9824 67.0057 8.01896 66.9972 8.05834 66.9972C8.12021 66.9972 8.17928 67.0143 8.23553 67.0486C8.29178 67.0829 8.32271 67.1229 8.32834 67.1686C8.37896 67.1514 8.42959 67.1429 8.48021 67.1429C8.57021 67.1429 8.64334 67.18 8.69959 67.2543C8.75021 67.22 8.80365 67.2029 8.8599 67.2029C8.88803 67.2029 8.93584 67.2143 9.00334 67.2372C9.07646 67.1286 9.14959 67.0857 9.22271 67.1086C9.26771 67.0457 9.31834 66.9914 9.37459 66.9457C9.43084 66.8943 9.48709 66.8657 9.54334 66.86C9.56584 66.7972 9.59115 66.7514 9.61928 66.7229C9.6474 66.6886 9.6924 66.6543 9.75428 66.62C9.74303 66.5972 9.7374 66.5686 9.7374 66.5343C9.7374 66.4772 9.74865 66.4172 9.77115 66.3543C9.79365 66.2914 9.81896 66.2514 9.84709 66.2343C9.80209 66.1829 9.77959 66.1229 9.77959 66.0543C9.77959 65.9972 9.79928 65.9314 9.83865 65.8572C9.7374 65.7943 9.68678 65.7029 9.68678 65.5829C9.6024 65.5543 9.54053 65.5143 9.50115 65.4629C9.40553 65.4686 9.32678 65.4543 9.2649 65.42C9.20303 65.38 9.16365 65.3229 9.14678 65.2486C9.10178 65.26 9.07084 65.2657 9.05396 65.2657C8.99771 65.2657 8.94428 65.2543 8.89365 65.2314C8.84303 65.2029 8.80084 65.1657 8.76709 65.12C8.73334 65.1486 8.68834 65.1629 8.63209 65.1629C8.55896 65.1629 8.48021 65.1343 8.39584 65.0772C8.33959 65.1057 8.28615 65.12 8.23553 65.12C8.1624 65.12 8.10334 65.1057 8.05834 65.0772C8.02459 65.0886 7.99646 65.0943 7.97396 65.0943C7.92334 65.0943 7.87553 65.0857 7.83053 65.0686C7.79115 65.0457 7.76865 65.02 7.76303 64.9914C7.56053 64.9914 7.45084 64.9543 7.43396 64.88C7.36646 64.8686 7.30178 64.8457 7.2399 64.8114C7.17803 64.7714 7.14428 64.7257 7.13865 64.6743C7.0824 64.6629 7.03459 64.6314 6.99521 64.58C6.95584 64.5229 6.93615 64.4543 6.93615 64.3743C6.88553 64.3343 6.84334 64.2629 6.80959 64.16C6.77584 64.0572 6.75896 63.9486 6.75896 63.8343C6.75896 63.6514 6.79553 63.5257 6.86865 63.4572C6.8574 63.4229 6.85178 63.3886 6.85178 63.3543C6.85178 63.2743 6.86584 63.1914 6.89396 63.1057C6.92771 63.02 6.96146 62.9686 6.99521 62.9514C6.99521 62.8772 7.0149 62.7914 7.05428 62.6943C7.1049 62.6257 7.16396 62.5686 7.23146 62.5229C7.29896 62.4714 7.37209 62.4457 7.45084 62.4457C7.46209 62.3829 7.49584 62.3286 7.55209 62.2829C7.61396 62.2372 7.68428 62.2143 7.76303 62.2143C7.78553 62.1457 7.83334 62.0914 7.90646 62.0514C7.97959 62.0114 8.06115 61.9914 8.15115 61.9914C8.21865 61.9914 8.27771 62 8.32834 62.0172C8.34521 61.9886 8.37615 61.9657 8.42115 61.9486C8.46615 61.9314 8.51396 61.9229 8.56459 61.9229C8.59271 61.9229 8.62365 61.9286 8.6574 61.94C8.70803 61.8886 8.79803 61.8629 8.9274 61.8629C9.06803 61.8629 9.1749 61.8886 9.24803 61.94C9.27053 61.9343 9.30146 61.9314 9.34084 61.9314C9.50959 61.9314 9.65303 62.0314 9.77115 62.2314C9.83303 62.22 9.90053 62.2372 9.97365 62.2829C10.0524 62.3286 10.1143 62.3914 10.1593 62.4714C10.2099 62.5457 10.2324 62.6172 10.2268 62.6857C10.3224 62.7543 10.3899 62.8257 10.4293 62.9C10.4687 62.9743 10.4996 63.0857 10.5221 63.2343C10.5277 63.3372 10.4968 63.42 10.4293 63.4829C10.3618 63.5457 10.283 63.5772 10.193 63.5772C10.1087 63.5772 10.0355 63.5457 9.97365 63.4829C9.90615 63.4714 9.84709 63.4372 9.79646 63.38C9.74584 63.3229 9.72334 63.2657 9.72896 63.2086C9.57146 63.1 9.50115 62.98 9.51803 62.8486C9.45053 62.86 9.36615 62.8429 9.2649 62.7972C9.16928 62.7457 9.09615 62.68 9.04553 62.6C9.00615 62.6572 8.9274 62.6857 8.80928 62.6857C8.7249 62.6857 8.65459 62.6714 8.59834 62.6429C8.55896 62.6943 8.48865 62.72 8.3874 62.72C8.33678 62.72 8.28896 62.7114 8.24396 62.6943C8.22146 62.7572 8.18209 62.8114 8.12584 62.8572C8.07521 62.8972 8.01615 62.9229 7.94865 62.9343C7.9149 62.9857 7.87271 63.0314 7.82209 63.0714C7.77146 63.1057 7.71803 63.1229 7.66178 63.1229Z"
      fill="#404040"
    />
    <path
      d="M14.7878 65.7629C14.8103 65.7 14.8553 65.6486 14.9228 65.6086C14.9903 65.5629 15.0606 65.54 15.1337 65.54C15.1562 65.54 15.19 65.5457 15.235 65.5572C15.3981 65.6029 15.4797 65.7 15.4797 65.8486C15.4797 65.98 15.4234 66.1143 15.3109 66.2514C15.3222 66.2972 15.3278 66.3372 15.3278 66.3714C15.3278 66.4457 15.3109 66.52 15.2772 66.5943C15.249 66.6686 15.2068 66.7372 15.1506 66.8C15.1337 66.8914 15.1084 66.9714 15.0747 67.04C15.0465 67.1029 15.0015 67.1772 14.9397 67.2629C14.8722 67.3543 14.8047 67.42 14.7372 67.46C14.6753 67.4943 14.5881 67.5286 14.4756 67.5629C14.4475 67.6429 14.4025 67.7172 14.3406 67.7857C14.2787 67.8486 14.2028 67.88 14.1128 67.88C14.0678 67.88 14.02 67.8714 13.9693 67.8543C13.93 67.9 13.8737 67.9372 13.8006 67.9657C13.7331 67.9886 13.6628 68 13.5897 68C13.494 68 13.4181 67.98 13.3618 67.94C13.2943 67.9686 13.2072 67.9829 13.1003 67.9829C12.9597 67.9829 12.8247 67.96 12.6953 67.9143C12.5659 67.8686 12.4647 67.7972 12.3915 67.7C12.2565 67.7114 12.144 67.68 12.054 67.6057C11.9753 67.56 11.9247 67.5086 11.9022 67.4514C11.694 67.3486 11.5928 67.16 11.5984 66.8857C11.4972 66.8172 11.4212 66.74 11.3706 66.6543C11.32 66.5629 11.2806 66.4486 11.2525 66.3114C11.2075 66.2657 11.185 66.2057 11.185 66.1314C11.185 66.0972 11.1878 66.0686 11.1934 66.0457C11.1428 65.9943 11.1175 65.9257 11.1175 65.84C11.1175 65.8 11.1259 65.76 11.1428 65.72C11.064 65.6343 11.0247 65.5114 11.0247 65.3514C11.0247 65.2086 11.0556 65.0972 11.1175 65.0172C11.0781 64.96 11.0584 64.8972 11.0584 64.8286C11.0584 64.7772 11.0725 64.7229 11.1006 64.6657C11.0725 64.6314 11.0584 64.5629 11.0584 64.46C11.0584 64.3457 11.0753 64.2314 11.109 64.1172C11.1428 63.9972 11.185 63.9172 11.2356 63.8772C11.2187 63.8429 11.2103 63.7943 11.2103 63.7314C11.2103 63.64 11.2243 63.5543 11.2525 63.4743C11.2862 63.3943 11.3312 63.3514 11.3875 63.3457C11.3875 63.2257 11.4353 63.1314 11.5309 63.0629C11.5253 62.9829 11.5534 62.8943 11.6153 62.7972C11.6828 62.7 11.7587 62.6343 11.8431 62.6C11.86 62.4743 11.9106 62.3686 11.995 62.2829C12.0793 62.1972 12.1722 62.1486 12.2734 62.1372C12.3015 62.0857 12.3522 62.0429 12.4253 62.0086C12.504 61.9686 12.58 61.9486 12.6531 61.9486C12.7093 61.9486 12.7572 61.96 12.7965 61.9829C12.8809 61.9029 12.9765 61.8629 13.0834 61.8629C13.1734 61.8629 13.2325 61.8857 13.2606 61.9314C13.3056 61.92 13.345 61.9143 13.3787 61.9143C13.48 61.9143 13.5559 61.9514 13.6065 62.0257C13.629 62.0086 13.6628 62 13.7078 62C13.7865 62 13.8737 62.0229 13.9693 62.0686C14.0706 62.1086 14.1297 62.1486 14.1465 62.1886C14.2647 62.2114 14.3715 62.2714 14.4672 62.3686C14.5628 62.46 14.6022 62.5543 14.5853 62.6514C14.664 62.6914 14.7203 62.7486 14.754 62.8229C14.7878 62.8914 14.799 62.9572 14.7878 63.02C14.8384 63.06 14.8722 63.1114 14.889 63.1743C14.9059 63.2314 14.9172 63.2657 14.9228 63.2772C15.0353 63.3743 15.0915 63.4972 15.0915 63.6457C15.0915 63.6743 15.0859 63.7114 15.0747 63.7572C15.0803 63.78 15.0831 63.8086 15.0831 63.8429C15.0831 63.94 15.0465 64.0229 14.9734 64.0914C14.9059 64.1543 14.8272 64.1857 14.7372 64.1857C14.6472 64.1857 14.5684 64.1514 14.5009 64.0829C14.3434 63.9114 14.2562 63.74 14.2393 63.5686C14.1718 63.5457 14.1184 63.5029 14.079 63.44C14.0397 63.3714 14.0228 63.2972 14.0284 63.2172C13.9778 63.1829 13.9384 63.14 13.9103 63.0886C13.8878 63.0314 13.8793 62.9743 13.885 62.9172C13.7837 62.9172 13.705 62.8857 13.6487 62.8229C13.6318 62.8286 13.6009 62.8314 13.5559 62.8314C13.494 62.8314 13.4265 62.8229 13.3534 62.8057C13.2803 62.7829 13.224 62.7572 13.1847 62.7286C13.1622 62.7343 13.1284 62.7372 13.0834 62.7372C13.0215 62.7372 12.9793 62.7314 12.9568 62.72C12.8837 62.7657 12.8134 62.7886 12.7459 62.7886C12.7234 62.7886 12.684 62.7829 12.6278 62.7714C12.5659 62.8229 12.5068 62.8514 12.4506 62.8572C12.4393 62.9486 12.414 63.0314 12.3747 63.1057C12.3409 63.18 12.2959 63.2229 12.2397 63.2343C12.2509 63.3029 12.2397 63.3714 12.2059 63.44C12.1722 63.5029 12.1243 63.5543 12.0625 63.5943C12.0568 63.64 12.0428 63.6857 12.0203 63.7314C11.9978 63.7714 11.9697 63.8029 11.9359 63.8257C11.9415 63.8543 11.9472 63.8886 11.9528 63.9286C11.9584 63.9629 11.9612 64.0057 11.9612 64.0572C11.9612 64.1772 11.9106 64.2714 11.8093 64.34C11.8093 64.4143 11.7953 64.4743 11.7672 64.52C11.7953 64.5772 11.8093 64.6343 11.8093 64.6914C11.8093 64.7486 11.7981 64.8 11.7756 64.8457C11.8093 64.9029 11.8262 64.9572 11.8262 65.0086C11.8262 65.06 11.8122 65.12 11.784 65.1886C11.7559 65.2629 11.739 65.3314 11.7334 65.3943C11.784 65.4229 11.8234 65.4629 11.8515 65.5143C11.8797 65.5657 11.8937 65.62 11.8937 65.6772C11.8937 65.74 11.8768 65.7972 11.8431 65.8486C11.8881 65.8714 11.9218 65.9114 11.9443 65.9686C11.9668 66.0257 11.9781 66.0857 11.9781 66.1486C11.9781 66.2114 11.9668 66.2629 11.9443 66.3029C12.0681 66.3714 12.1525 66.4429 12.1975 66.5172C12.2481 66.5857 12.2847 66.6972 12.3072 66.8514C12.3465 66.8686 12.3915 66.8972 12.4422 66.9372C12.4984 66.9772 12.535 67.0114 12.5518 67.04C12.6475 67.0343 12.7459 67.0572 12.8472 67.1086C12.954 67.1543 13.0272 67.2172 13.0665 67.2972C13.1003 67.2686 13.1537 67.2457 13.2268 67.2286C13.3056 67.2057 13.3815 67.1943 13.4547 67.1943C13.5334 67.1943 13.5868 67.2057 13.615 67.2286C13.6937 67.1314 13.7893 67.0829 13.9018 67.0829C13.9356 67.0829 13.9609 67.0857 13.9778 67.0914C14.0678 67.0172 14.1381 66.9657 14.1887 66.9372C14.2393 66.9029 14.2984 66.8772 14.3659 66.86C14.3715 66.7743 14.4053 66.6914 14.4672 66.6114C14.4728 66.5657 14.4897 66.5114 14.5178 66.4486C14.5459 66.38 14.574 66.3286 14.6022 66.2943C14.5965 66.2772 14.5937 66.2486 14.5937 66.2086C14.5937 66.1343 14.6134 66.0543 14.6528 65.9686C14.6922 65.8772 14.7372 65.8086 14.7878 65.7629Z"
      fill="#404040"
    />
    <path
      d="M20.3628 67.0743C20.3628 67.0743 20.4106 67.0943 20.5062 67.1343C20.6075 67.1743 20.6469 67.3086 20.6244 67.5372C20.6469 67.5829 20.6581 67.6343 20.6581 67.6914C20.6581 67.7829 20.6215 67.8572 20.5484 67.9143C20.4753 67.9714 20.3909 68 20.2953 68C20.2109 68 20.1378 67.9743 20.0759 67.9229C20.0197 67.8657 19.9915 67.7857 19.9915 67.6829C19.9297 67.6714 19.865 67.6229 19.7975 67.5372C19.7356 67.4457 19.7047 67.3543 19.7047 67.2629C19.7047 67.24 19.7103 67.2057 19.7215 67.16C19.6653 67.1314 19.6147 67.0743 19.5697 66.9886C19.5303 66.8972 19.5022 66.8029 19.4853 66.7057C19.4684 66.6086 19.4628 66.54 19.4684 66.5C19.3953 66.4657 19.3362 66.3829 19.2912 66.2514C19.2519 66.1143 19.2378 65.9972 19.249 65.9C19.2097 65.9172 19.1619 65.9257 19.1056 65.9257C18.9931 65.9257 18.889 65.8914 18.7934 65.8229C18.7203 65.8972 18.6106 65.9343 18.4644 65.9343C18.3294 65.9343 18.2337 65.9 18.1775 65.8314C18.1044 65.8943 18.0256 65.9257 17.9412 65.9257C17.8737 65.9257 17.8203 65.9114 17.7809 65.8829C17.7415 65.9114 17.6825 65.9257 17.6037 65.9257C17.5362 65.9257 17.4687 65.9143 17.4012 65.8914C17.3337 65.8686 17.2803 65.8372 17.2409 65.7972C17.2353 65.7972 17.2212 65.8029 17.1987 65.8143C17.2325 65.9229 17.2494 66.02 17.2494 66.1057C17.2494 66.2372 17.1847 66.3514 17.0553 66.4486C17.0778 66.4943 17.089 66.5486 17.089 66.6114C17.089 66.7372 17.0469 66.8572 16.9625 66.9714C16.8781 67.0857 16.7965 67.1486 16.7178 67.16C16.7403 67.2114 16.7515 67.2714 16.7515 67.34C16.7515 67.4943 16.7009 67.6372 16.5997 67.7686C16.4984 67.8943 16.3747 67.9572 16.2284 67.9572C16.189 67.9572 16.1581 67.9543 16.1356 67.9486C16.0625 67.9486 16.0062 67.9257 15.9669 67.88C15.9275 67.8343 15.9078 67.7743 15.9078 67.7C15.9078 67.6486 15.9219 67.5886 15.95 67.52C15.9444 67.4972 15.9415 67.4629 15.9415 67.4172C15.9415 67.3029 15.9978 67.2029 16.1103 67.1172C16.1047 67.1 16.1019 67.0743 16.1019 67.04C16.1019 66.9543 16.1215 66.8686 16.1609 66.7829C16.2059 66.6914 16.2622 66.6314 16.3297 66.6029C16.324 66.5914 16.3212 66.5657 16.3212 66.5257C16.3212 66.4286 16.3437 66.3172 16.3887 66.1914C16.4337 66.06 16.4844 65.9857 16.5406 65.9686C16.5294 65.7172 16.6109 65.4629 16.7853 65.2057C16.7853 65.0743 16.805 64.9514 16.8444 64.8372C16.8837 64.7172 16.954 64.6314 17.0553 64.58C17.0609 64.4714 17.0862 64.3629 17.1312 64.2543C17.1762 64.1457 17.2269 64.0543 17.2831 63.98C17.2662 63.9172 17.2578 63.86 17.2578 63.8086C17.2578 63.7286 17.2719 63.6657 17.3 63.62C17.3337 63.5686 17.3703 63.5372 17.4097 63.5257C17.404 63.5029 17.4012 63.4686 17.4012 63.4229C17.4012 63.2972 17.4462 63.1972 17.5362 63.1229L17.5278 63.0714C17.5278 62.9857 17.5615 62.9086 17.629 62.84C17.6234 62.8172 17.6206 62.7857 17.6206 62.7457C17.6206 62.6429 17.6459 62.54 17.6965 62.4372C17.7472 62.3343 17.8034 62.2657 17.8653 62.2314C17.9665 62.0886 18.0734 62.0172 18.1859 62.0172C18.2365 62.0172 18.3012 62.0343 18.38 62.0686C18.5431 62.0743 18.6612 62.2029 18.7344 62.4543C18.785 62.5172 18.8215 62.5914 18.844 62.6772C18.8665 62.7572 18.875 62.8314 18.8694 62.9C18.92 62.9343 18.9565 62.98 18.979 63.0372C19.0072 63.0943 19.0184 63.1543 19.0128 63.2172C19.069 63.2686 19.1169 63.3486 19.1562 63.4572C19.2012 63.5657 19.2237 63.6686 19.2237 63.7657C19.2237 63.8114 19.2209 63.8429 19.2153 63.86C19.2547 63.9 19.2884 63.9572 19.3165 64.0314C19.3503 64.1057 19.3672 64.1743 19.3672 64.2372C19.3672 64.2714 19.3644 64.2972 19.3587 64.3143C19.4319 64.3657 19.4909 64.4457 19.5359 64.5543C19.5865 64.6629 19.6203 64.7714 19.6372 64.88C19.6597 64.9829 19.6653 65.0543 19.654 65.0943C19.6653 65.1114 19.6962 65.1543 19.7469 65.2229C19.7975 65.2857 19.8369 65.3514 19.865 65.42C19.8931 65.4829 19.9072 65.5429 19.9072 65.6C19.9072 65.6514 19.9015 65.6886 19.8903 65.7114C19.9128 65.74 19.9381 65.7743 19.9662 65.8143C19.9944 65.8486 20.0169 65.88 20.0337 65.9086C20.0506 65.9372 20.059 65.9714 20.059 66.0114C20.059 66.0514 20.0562 66.08 20.0506 66.0972C20.0956 66.1429 20.135 66.2029 20.1687 66.2772C20.2025 66.3514 20.2194 66.4229 20.2194 66.4914C20.2194 66.5486 20.2081 66.5914 20.1856 66.62C20.2475 66.6657 20.2953 66.7314 20.329 66.8172C20.3628 66.9029 20.374 66.9886 20.3628 67.0743ZM18.8103 65.2143C18.8215 65.18 18.8469 65.16 18.8862 65.1543C18.9256 65.1429 18.9594 65.1457 18.9875 65.1629C18.9762 65.1286 18.9706 65.1029 18.9706 65.0857C18.9706 65.04 18.9819 65.0057 19.0044 64.9829C18.9537 64.9429 18.9115 64.8914 18.8778 64.8286C18.8497 64.7657 18.8384 64.7029 18.844 64.64C18.8047 64.6286 18.7681 64.6 18.7344 64.5543C18.7062 64.5029 18.6922 64.4486 18.6922 64.3914C18.6922 64.3743 18.6978 64.3429 18.709 64.2972C18.5909 64.2229 18.5319 64.1114 18.5319 63.9629C18.5319 63.9057 18.5403 63.84 18.5572 63.7657C18.5515 63.76 18.5375 63.7486 18.515 63.7314C18.4925 63.7086 18.484 63.6743 18.4897 63.6286C18.3772 63.5943 18.3237 63.5029 18.3294 63.3543C18.2844 63.3314 18.2478 63.2886 18.2197 63.2257C18.2309 63.3572 18.1803 63.46 18.0678 63.5343C18.0734 63.5972 18.0622 63.6686 18.034 63.7486C18.0059 63.8286 17.9722 63.8886 17.9328 63.9286C17.9384 63.9514 17.9412 63.9886 17.9412 64.04C17.9412 64.1714 17.8878 64.3457 17.7809 64.5629C17.7528 64.6257 17.7303 64.6829 17.7134 64.7343C17.6909 64.7914 17.6656 64.8486 17.6375 64.9057C17.615 64.9629 17.584 65.0057 17.5447 65.0343C17.5447 65.0914 17.5334 65.1429 17.5109 65.1886L17.5784 65.18C17.6347 65.18 17.6769 65.1943 17.705 65.2229C17.7219 65.1943 17.7556 65.18 17.8062 65.18C17.84 65.18 17.8653 65.1886 17.8822 65.2057C17.9497 65.1543 18.034 65.1286 18.1353 65.1286C18.2084 65.1286 18.2759 65.14 18.3378 65.1629C18.3997 65.1857 18.4503 65.2172 18.4897 65.2572C18.5459 65.1943 18.605 65.1629 18.6669 65.1629C18.7062 65.1629 18.754 65.18 18.8103 65.2143Z"
      fill="#404040"
    />
    <path
      d="M25.7372 67.0486C25.771 67.0829 25.7879 67.1257 25.7879 67.1772C25.7879 67.2172 25.7738 67.2514 25.7457 67.28C25.7738 67.3314 25.7879 67.3829 25.7879 67.4343C25.7879 67.48 25.7766 67.5257 25.7541 67.5714C25.7654 67.64 25.771 67.6829 25.771 67.7C25.771 67.78 25.726 67.8543 25.636 67.9229C25.5685 67.9743 25.4925 68 25.4082 68C25.3013 68 25.2057 67.9629 25.1213 67.8886C25.0425 67.8772 24.975 67.8343 24.9188 67.76C24.8682 67.68 24.8513 67.5914 24.8682 67.4943C24.84 67.4714 24.8063 67.4486 24.7669 67.4257C24.7275 67.3972 24.6938 67.3686 24.6657 67.34C24.6432 67.3057 24.6263 67.2657 24.615 67.22C24.5475 67.1972 24.4941 67.1572 24.4547 67.1C24.4154 67.0372 24.3957 66.9686 24.3957 66.8943C24.3957 66.8657 24.3985 66.8429 24.4041 66.8257C24.331 66.8143 24.2691 66.78 24.2185 66.7229C24.1735 66.66 24.1482 66.5914 24.1425 66.5172C24.03 66.46 23.9485 66.4114 23.8979 66.3714C23.8472 66.3314 23.8163 66.2686 23.805 66.1829C23.7488 66.1543 23.6925 66.0972 23.6363 66.0114C23.58 65.9257 23.5463 65.8486 23.535 65.78C23.4338 65.7286 23.3747 65.6429 23.3579 65.5229C23.3072 65.5 23.251 65.4457 23.1891 65.36C23.1272 65.2686 23.0935 65.1886 23.0879 65.12C23.0091 65.0914 22.9332 65.0257 22.86 64.9229C22.7869 64.8143 22.7447 64.7057 22.7335 64.5972C22.6885 64.5743 22.635 64.5172 22.5732 64.4257C22.5113 64.3286 22.4719 64.2486 22.455 64.1857C22.41 64.14 22.3594 64.0657 22.3032 63.9629C22.2469 63.8543 22.2104 63.76 22.1935 63.68C22.1485 63.6457 22.1007 63.5829 22.05 63.4914C21.9994 63.4 21.9657 63.32 21.9488 63.2514C21.96 63.2857 21.9657 63.3343 21.9657 63.3972C21.9657 63.4714 21.9572 63.5172 21.9404 63.5343C21.9741 63.6714 21.991 63.7857 21.991 63.8772C21.991 63.9114 21.9854 63.9514 21.9741 63.9972C21.9966 64.0486 22.0079 64.1257 22.0079 64.2286C22.0079 64.32 21.9994 64.3914 21.9825 64.4429C22.0163 64.4829 22.0332 64.5514 22.0332 64.6486C22.0332 64.7343 22.0191 64.8057 21.991 64.8629C22.0247 64.92 22.0416 64.9772 22.0416 65.0343C22.0416 65.0972 22.0247 65.1629 21.991 65.2314C21.9629 65.3 21.946 65.3429 21.9404 65.36C21.991 65.4343 22.0163 65.56 22.0163 65.7372C22.0163 65.84 22.0022 65.9286 21.9741 66.0029C22.0191 66.0772 22.0416 66.1514 22.0416 66.2257C22.0416 66.3057 22.0107 66.42 21.9488 66.5686C22.005 66.6257 22.0332 66.7057 22.0332 66.8086C22.0332 66.9229 22.0022 67.0372 21.9404 67.1514C21.946 67.2029 21.9544 67.2743 21.9657 67.3657C21.9825 67.4572 21.991 67.5314 21.991 67.5886C21.991 67.8343 21.8785 67.9572 21.6535 67.9572C21.5635 67.9572 21.4875 67.9257 21.4257 67.8629C21.3694 67.8 21.3357 67.7229 21.3244 67.6314C21.2907 67.5514 21.2738 67.4657 21.2738 67.3743C21.2738 67.2829 21.2879 67.2 21.316 67.1257C21.2879 67.0229 21.2738 66.9257 21.2738 66.8343C21.2738 66.76 21.2822 66.6972 21.2991 66.6457C21.2822 66.5829 21.2738 66.5286 21.2738 66.4829C21.2738 66.3972 21.2907 66.3114 21.3244 66.2257C21.2794 66.1514 21.2569 66.0572 21.2569 65.9429C21.2569 65.8172 21.285 65.72 21.3413 65.6514C21.2963 65.5429 21.2738 65.44 21.2738 65.3429C21.2738 65.2286 21.2991 65.1257 21.3497 65.0343C21.3272 64.9772 21.316 64.9314 21.316 64.8972C21.316 64.88 21.3216 64.8486 21.3329 64.8029C21.2597 64.7286 21.2232 64.6086 21.2232 64.4429C21.2232 64.3572 21.2316 64.2743 21.2485 64.1943C21.271 64.1143 21.2963 64.0572 21.3244 64.0229C21.2625 63.9086 21.2316 63.7629 21.2316 63.5857C21.2316 63.4714 21.2485 63.38 21.2822 63.3114C21.2485 63.2486 21.2316 63.1686 21.2316 63.0714C21.2316 62.9514 21.2541 62.8543 21.2991 62.78C21.2822 62.7343 21.2738 62.6686 21.2738 62.5829C21.2738 62.5029 21.2822 62.4486 21.2991 62.42C21.2991 62.2772 21.3441 62.1657 21.4341 62.0857C21.5241 62.0057 21.631 61.9657 21.7547 61.9657C21.8785 61.9657 21.9825 62.0086 22.0669 62.0943C22.1569 62.18 22.1963 62.2943 22.185 62.4372C22.3144 62.4543 22.4354 62.5343 22.5479 62.6772C22.6604 62.82 22.7138 62.9743 22.7082 63.14C22.7813 63.1914 22.8516 63.2686 22.9191 63.3714C22.9922 63.4743 23.0316 63.5686 23.0372 63.6543C23.1104 63.7114 23.1891 63.8143 23.2735 63.9629C23.3579 64.1114 23.4029 64.2429 23.4085 64.3572C23.476 64.3629 23.5463 64.4286 23.6194 64.5543C23.6982 64.68 23.7432 64.7857 23.7544 64.8714C23.8107 64.8943 23.8669 64.9514 23.9232 65.0429C23.9794 65.1343 24.0075 65.2143 24.0075 65.2829C24.0525 65.2943 24.0919 65.34 24.1257 65.42C24.165 65.5 24.1791 65.5629 24.1679 65.6086C24.3085 65.6657 24.3929 65.7657 24.421 65.9086C24.4829 65.9029 24.5504 65.94 24.6235 66.02C24.6966 66.1 24.7416 66.18 24.7585 66.26C24.8147 66.2829 24.8738 66.3343 24.9357 66.4143C25.0032 66.4886 25.0454 66.56 25.0622 66.6286C25.0454 66.5429 25.0369 66.48 25.0369 66.44C25.0369 66.4 25.051 66.3657 25.0791 66.3372C25.0229 66.2743 24.9947 66.1829 24.9947 66.0629C24.9947 66 25.0032 65.9486 25.02 65.9086C24.9807 65.84 24.961 65.7772 24.961 65.72C24.961 65.6686 24.975 65.6143 25.0032 65.5572C24.9469 65.5057 24.9188 65.4172 24.9188 65.2914C24.9188 65.2343 24.9272 65.1886 24.9441 65.1543C24.8991 65.0629 24.8766 64.96 24.8766 64.8457C24.8766 64.8114 24.8822 64.76 24.8935 64.6914C24.8316 64.6172 24.8007 64.4972 24.8007 64.3314C24.8007 64.1943 24.8232 64.0943 24.8682 64.0314C24.84 63.9914 24.8147 63.9372 24.7922 63.8686C24.7754 63.7943 24.7669 63.7257 24.7669 63.6629C24.7669 63.5543 24.7894 63.4714 24.8344 63.4143C24.7838 63.3629 24.7585 63.2914 24.7585 63.2C24.7585 63.1372 24.7725 63.0572 24.8007 62.96C24.7444 62.8743 24.7163 62.7714 24.7163 62.6514C24.7163 62.56 24.7332 62.4886 24.7669 62.4372C24.7388 62.3629 24.7247 62.2972 24.7247 62.24C24.7247 62.1257 24.781 62.0457 24.8935 62C24.9554 61.9772 25.0116 61.9657 25.0622 61.9657C25.1579 61.9657 25.2254 62.0029 25.2647 62.0772C25.3097 62.1514 25.3322 62.24 25.3322 62.3429C25.3322 62.4 25.3294 62.44 25.3238 62.4629C25.3688 62.4972 25.4054 62.56 25.4335 62.6514C25.4616 62.7429 25.4757 62.8372 25.4757 62.9343C25.4757 63.02 25.4644 63.0829 25.4419 63.1229C25.4813 63.2143 25.501 63.3343 25.501 63.4829C25.501 63.6086 25.4869 63.6972 25.4588 63.7486C25.4925 63.8172 25.5094 63.9172 25.5094 64.0486C25.5094 64.1514 25.4982 64.2257 25.4757 64.2714C25.5038 64.3172 25.5263 64.38 25.5432 64.46C25.5657 64.5343 25.5769 64.6057 25.5769 64.6743C25.5769 64.7714 25.5572 64.84 25.5179 64.88C25.5572 64.9143 25.5882 64.9714 25.6107 65.0514C25.6332 65.1314 25.6444 65.2143 25.6444 65.3C25.6444 65.3743 25.636 65.4372 25.6191 65.4886C25.6641 65.5629 25.6866 65.6514 25.6866 65.7543C25.6866 65.84 25.6725 65.9 25.6444 65.9343C25.6613 65.9686 25.6754 66.0257 25.6866 66.1057C25.6979 66.1857 25.6979 66.2429 25.6866 66.2772C25.7429 66.3172 25.771 66.4 25.771 66.5257C25.771 66.6229 25.7513 66.7 25.7119 66.7572C25.74 66.8314 25.7541 66.8914 25.7541 66.9372C25.7541 66.9543 25.7485 66.9914 25.7372 67.0486Z"
      fill="#404040"
    />
    <path
      d="M32.8812 65.0857C32.9037 65.1486 32.9149 65.22 32.9149 65.3C32.9149 65.3914 32.9009 65.4829 32.8727 65.5743C32.8502 65.66 32.8193 65.7257 32.7799 65.7714C32.8305 65.8229 32.8559 65.9372 32.8559 66.1143C32.8559 66.2857 32.8305 66.4057 32.7799 66.4743C32.808 66.5029 32.8305 66.5543 32.8474 66.6286C32.8643 66.7029 32.8727 66.7857 32.8727 66.8772C32.8727 67.0486 32.8418 67.1829 32.7799 67.28C32.8137 67.3886 32.8305 67.4857 32.8305 67.5714C32.8305 67.7029 32.7968 67.8029 32.7293 67.8714C32.6618 67.94 32.583 67.9743 32.493 67.9743C32.4143 67.9743 32.344 67.9457 32.2821 67.8886C32.2202 67.8314 32.1893 67.7543 32.1893 67.6572C32.1893 67.6057 32.1977 67.5543 32.2146 67.5029C32.1415 67.3714 32.1049 67.2229 32.1049 67.0572C32.1049 66.8914 32.1415 66.7714 32.2146 66.6972C32.1584 66.64 32.1302 66.56 32.1302 66.4572C32.1302 66.36 32.1584 66.2829 32.2146 66.2257C32.1584 66.1114 32.1302 65.9829 32.1302 65.84C32.1302 65.6972 32.1584 65.6 32.2146 65.5486C32.1584 65.4343 32.1302 65.2829 32.1302 65.0943C32.1302 64.9057 32.1584 64.7857 32.2146 64.7343C32.1359 64.6257 32.0965 64.4972 32.0965 64.3486C32.0965 64.2172 32.1359 64.1143 32.2146 64.04C32.1921 64.0114 32.1809 63.9714 32.1809 63.92C32.1809 63.88 32.1865 63.8286 32.1977 63.7657C32.209 63.6972 32.2146 63.6343 32.2146 63.5772C32.2146 63.7257 32.1809 63.92 32.1134 64.16C32.0459 64.3943 31.953 64.5543 31.8349 64.64C31.8349 65.0172 31.7646 65.2372 31.624 65.3C31.624 65.4257 31.6015 65.5743 31.5565 65.7457C31.5115 65.9114 31.4665 65.9943 31.4215 65.9943C31.4215 66.0629 31.3934 66.14 31.3371 66.2257C31.2865 66.3057 31.2359 66.3457 31.1852 66.3457C31.2021 66.4029 31.2105 66.4657 31.2105 66.5343C31.2105 66.6143 31.1965 66.6914 31.1684 66.7657C31.1459 66.8343 31.1149 66.8886 31.0755 66.9286C31.0755 67.0314 31.0559 67.1172 31.0165 67.1857C30.9771 67.2543 30.9237 67.32 30.8562 67.3829C30.8562 67.4914 30.8196 67.5772 30.7465 67.64C30.6734 67.7029 30.589 67.7343 30.4934 67.7343C30.4034 67.7343 30.3246 67.7057 30.2571 67.6486C30.1896 67.5857 30.1559 67.5 30.1559 67.3914C30.1559 67.34 30.1587 67.3029 30.1643 67.28C30.108 67.28 30.0546 67.2314 30.004 67.1343C29.959 67.0314 29.9365 66.9229 29.9365 66.8086C29.8859 66.8086 29.8324 66.7657 29.7762 66.68C29.7199 66.5886 29.6749 66.4886 29.6412 66.38C29.6074 66.2657 29.599 66.18 29.6159 66.1229C29.5709 66.0886 29.5259 66.0229 29.4809 65.9257C29.4415 65.8286 29.4218 65.7257 29.4218 65.6172C29.4218 65.5029 29.4443 65.4029 29.4893 65.3172C29.4162 65.3114 29.3515 65.26 29.2952 65.1629C29.2446 65.06 29.2193 64.96 29.2193 64.8629C29.2193 64.8057 29.2334 64.7629 29.2615 64.7343C29.2052 64.6886 29.1518 64.6143 29.1012 64.5114C29.0562 64.4086 29.0337 64.3257 29.0337 64.2629C28.9605 64.1886 28.924 64.0372 28.924 63.8086C28.8452 63.8086 28.7777 63.7372 28.7215 63.5943C28.7327 63.7029 28.7215 63.8114 28.6877 63.92C28.6596 64.0229 28.6202 64.1 28.5696 64.1514C28.6202 64.1972 28.6596 64.2857 28.6877 64.4172C28.7159 64.5429 28.7299 64.6714 28.7299 64.8029C28.7299 64.9229 28.7187 65.0086 28.6962 65.06C28.7524 65.1514 28.7805 65.2914 28.7805 65.48C28.7805 65.6914 28.7524 65.8629 28.6962 65.9943C28.7412 66.0914 28.7637 66.1886 28.7637 66.2857C28.7637 66.3714 28.7412 66.4686 28.6962 66.5772C28.7187 66.6 28.7384 66.6572 28.7552 66.7486C28.7721 66.8343 28.7805 66.9286 28.7805 67.0314C28.7805 67.2257 28.7524 67.3429 28.6962 67.3829C28.7018 67.4172 28.7046 67.4629 28.7046 67.52C28.7046 67.6686 28.668 67.7829 28.5949 67.8629C28.5274 67.9429 28.443 67.9829 28.3418 67.9829C28.2405 67.9829 28.1505 67.9429 28.0718 67.8629C27.993 67.7829 27.9537 67.6772 27.9537 67.5457C27.9537 67.4486 27.979 67.34 28.0296 67.22C27.9621 66.9857 27.9284 66.7657 27.9284 66.56C27.9284 66.3714 27.9537 66.2257 28.0043 66.1229C27.948 66.0486 27.9199 65.9314 27.9199 65.7714C27.9199 65.6972 27.9284 65.6286 27.9452 65.5657C27.9621 65.4972 27.9818 65.4486 28.0043 65.42C27.948 65.2886 27.9199 65.1572 27.9199 65.0257C27.9199 64.8886 27.948 64.7914 28.0043 64.7343C27.9762 64.6943 27.9537 64.6429 27.9368 64.58C27.9199 64.5172 27.9115 64.4514 27.9115 64.3829C27.9115 64.28 27.9284 64.2029 27.9621 64.1514C27.9059 64.0543 27.8777 63.9286 27.8777 63.7743C27.8777 63.5743 27.9199 63.4314 28.0043 63.3457C27.9255 63.2657 27.8862 63.1029 27.8862 62.8572C27.8862 62.7429 27.8974 62.6343 27.9199 62.5314C27.9424 62.4229 27.9705 62.3514 28.0043 62.3172C28.0043 62.2086 28.0437 62.12 28.1224 62.0514C28.2012 61.9829 28.2912 61.9486 28.3924 61.9486C28.5105 61.9486 28.6118 61.9914 28.6962 62.0772C28.8087 62.0772 28.9099 62.1286 28.9999 62.2314C29.0955 62.3343 29.1434 62.44 29.1434 62.5486C29.1827 62.5829 29.2165 62.6314 29.2446 62.6943C29.2727 62.7514 29.2868 62.8114 29.2868 62.8743C29.2868 62.92 29.2784 62.9657 29.2615 63.0114C29.329 63.0172 29.3824 63.0572 29.4218 63.1314C29.4668 63.2057 29.4893 63.2772 29.4893 63.3457C29.5343 63.3857 29.5709 63.4429 29.599 63.5172C29.6327 63.5857 29.6496 63.6572 29.6496 63.7314C29.6496 63.8 29.6384 63.8657 29.6159 63.9286C29.644 63.9286 29.6693 63.9543 29.6918 64.0057C29.7199 64.0514 29.734 64.1029 29.734 64.16C29.734 64.2057 29.7227 64.24 29.7002 64.2629C29.7621 64.2972 29.8155 64.3686 29.8605 64.4772C29.9112 64.58 29.9365 64.6657 29.9365 64.7343C29.9759 64.7743 30.0068 64.84 30.0293 64.9314C30.0574 65.0229 30.0715 65.1172 30.0715 65.2143C30.0715 65.2886 30.063 65.3572 30.0462 65.42C30.1024 65.46 30.1559 65.5429 30.2065 65.6686C30.2571 65.7886 30.2824 65.9057 30.2824 66.02C30.2824 66.0657 30.2796 66.1 30.274 66.1229C30.3415 66.1743 30.3893 66.2229 30.4174 66.2686C30.4512 66.3143 30.4793 66.3829 30.5018 66.4743C30.513 66.2229 30.5665 66.0714 30.6621 66.02C30.6509 65.9743 30.6452 65.94 30.6452 65.9172C30.6452 65.8314 30.6649 65.7486 30.7043 65.6686C30.7493 65.5886 30.7999 65.5486 30.8562 65.5486C30.828 65.4914 30.814 65.4429 30.814 65.4029C30.814 65.2772 30.9012 65.1172 31.0755 64.9229C31.0587 64.8886 31.0502 64.8429 31.0502 64.7857C31.0502 64.6886 31.0699 64.5886 31.1093 64.4857C31.1543 64.3829 31.2162 64.3086 31.2949 64.2629C31.2949 64.0914 31.3062 63.9486 31.3287 63.8343C31.3568 63.7143 31.4215 63.6286 31.5227 63.5772C31.5227 63.4743 31.5452 63.3914 31.5902 63.3286C31.6409 63.26 31.6999 63.2257 31.7674 63.2257C31.7393 63.18 31.7252 63.12 31.7252 63.0457C31.7252 62.9257 31.7505 62.8029 31.8012 62.6772C31.8574 62.5514 31.9221 62.4657 31.9952 62.42C31.9952 62.2943 32.029 62.1857 32.0965 62.0943C32.1696 62.0029 32.2821 61.9572 32.434 61.9572C32.4621 61.9457 32.5015 61.94 32.5521 61.94C32.6646 61.94 32.7462 61.9914 32.7968 62.0943C32.853 62.1914 32.8812 62.28 32.8812 62.36C32.9318 62.5372 32.9571 62.6714 32.9571 62.7629C32.9571 62.8486 32.9318 62.9829 32.8812 63.1657C32.9318 63.2229 32.9571 63.3057 32.9571 63.4143C32.9571 63.5172 32.9318 63.6286 32.8812 63.7486C32.9318 63.8057 32.9571 63.9 32.9571 64.0314C32.9571 64.1686 32.929 64.2714 32.8727 64.34C32.9459 64.4372 32.9824 64.56 32.9824 64.7086C32.9824 64.8572 32.9487 64.9829 32.8812 65.0857Z"
      fill="#404040"
    />
    <path
      d="M36.3851 61.9829C36.4414 61.9429 36.5145 61.9229 36.6045 61.9229C36.7339 61.9229 36.8632 61.9657 36.9926 62.0514C37.0545 62.0514 37.1051 62.0772 37.1445 62.1286C37.1839 62.18 37.2035 62.2429 37.2035 62.3172C37.2035 62.4143 37.1754 62.5 37.1192 62.5743C37.0629 62.6486 36.9842 62.6857 36.8829 62.6857C36.8098 62.6857 36.7311 62.6629 36.6467 62.6172C36.6017 62.6629 36.5426 62.6857 36.4695 62.6857C36.3907 62.6857 36.3092 62.6572 36.2248 62.6C36.1685 62.6286 36.0842 62.6429 35.9717 62.6429C35.8085 62.6429 35.682 62.6172 35.592 62.5657C35.5076 62.6057 35.4204 62.6257 35.3304 62.6257C35.2573 62.6257 35.187 62.6143 35.1195 62.5914C35.0464 62.62 34.976 62.6343 34.9085 62.6343C34.8185 62.6343 34.7285 62.6086 34.6385 62.5572C34.5373 62.6143 34.4473 62.6486 34.3685 62.66C34.4079 62.7572 34.4276 62.8629 34.4276 62.9772C34.4276 63.12 34.3967 63.2343 34.3348 63.32C34.4023 63.4286 34.4361 63.5486 34.4361 63.68C34.4361 63.7829 34.4107 63.8857 34.3601 63.9886C34.4107 64.0457 34.4361 64.1172 34.4361 64.2029C34.4361 64.26 34.4164 64.3286 34.377 64.4086C34.4276 64.38 34.4895 64.3657 34.5626 64.3657C34.6189 64.3657 34.6582 64.3714 34.6807 64.3829C34.7426 64.3372 34.8101 64.3143 34.8832 64.3143C34.9564 64.3143 35.0295 64.3457 35.1026 64.4086C35.1701 64.3914 35.2264 64.3829 35.2714 64.3829C35.2995 64.3829 35.3473 64.3886 35.4148 64.4C35.4823 64.3886 35.5301 64.3829 35.5582 64.3829C35.6539 64.3829 35.7242 64.4057 35.7692 64.4514C35.8142 64.4229 35.8648 64.4086 35.921 64.4086C35.9886 64.4086 36.0307 64.4229 36.0476 64.4514C36.0982 64.4343 36.1376 64.4257 36.1657 64.4257C36.2051 64.4257 36.2585 64.4372 36.326 64.46C36.3992 64.42 36.4695 64.4 36.537 64.4C36.6326 64.4 36.7142 64.4372 36.7817 64.5114C36.8492 64.58 36.8829 64.6572 36.8829 64.7429C36.8829 64.8172 36.8576 64.88 36.807 64.9314C36.7564 64.9829 36.6776 65.0114 36.5707 65.0172C36.5201 65.0857 36.4357 65.12 36.3176 65.12C36.2107 65.12 36.1151 65.0914 36.0307 65.0343C35.9745 65.0914 35.8929 65.12 35.786 65.12C35.6904 65.12 35.6117 65.0972 35.5498 65.0514C35.5048 65.0857 35.457 65.1029 35.4064 65.1029C35.3726 65.1029 35.3445 65.0914 35.322 65.0686C35.2601 65.1257 35.1757 65.1543 35.0689 65.1543C34.9901 65.1543 34.917 65.1372 34.8495 65.1029C34.7932 65.1314 34.7454 65.1457 34.7061 65.1457C34.6498 65.1457 34.5935 65.1257 34.5373 65.0857C34.4979 65.1086 34.467 65.1229 34.4445 65.1286C34.422 65.1343 34.3911 65.1343 34.3517 65.1286C34.4023 65.2314 34.4276 65.3114 34.4276 65.3686C34.4276 65.42 34.4107 65.48 34.377 65.5486C34.4164 65.5943 34.4361 65.6514 34.4361 65.72C34.4361 65.7714 34.422 65.8257 34.3939 65.8829C34.4332 65.9286 34.4529 65.9886 34.4529 66.0629C34.4529 66.1314 34.4332 66.1886 34.3939 66.2343C34.4276 66.3029 34.4445 66.3572 34.4445 66.3972C34.4445 66.4314 34.422 66.4886 34.377 66.5686C34.3995 66.5914 34.4107 66.6229 34.4107 66.6629C34.4107 66.7143 34.3939 66.7486 34.3601 66.7657C34.4164 66.8172 34.4445 66.8829 34.4445 66.9629C34.4445 66.9914 34.4389 67.04 34.4276 67.1086L34.4782 67.1C34.5401 67.1 34.6048 67.1286 34.6723 67.1857C34.7567 67.1229 34.8664 67.0914 35.0014 67.0914C35.052 67.0914 35.1054 67.0972 35.1617 67.1086C35.1954 67.0686 35.2432 67.0372 35.3051 67.0143C35.367 66.9914 35.4345 66.98 35.5076 66.98C35.6257 66.98 35.7157 67.0057 35.7776 67.0572C35.8114 67 35.8704 66.9543 35.9548 66.92C36.0392 66.8857 36.1235 66.8686 36.2079 66.8686C36.2698 66.8686 36.3204 66.8772 36.3598 66.8943C36.4217 66.86 36.4779 66.8429 36.5285 66.8429C36.6185 66.8429 36.6973 66.88 36.7648 66.9543C36.8323 67.0286 36.8661 67.1143 36.8661 67.2114C36.8661 67.3314 36.8126 67.4257 36.7057 67.4943C36.6832 67.54 36.6382 67.58 36.5707 67.6143C36.5032 67.6429 36.4301 67.6572 36.3514 67.6572C36.2726 67.6572 36.2107 67.6429 36.1657 67.6143C36.1207 67.66 36.0617 67.7 35.9885 67.7343C35.9154 67.7629 35.8423 67.7772 35.7692 67.7772C35.6567 67.7772 35.5695 67.7457 35.5076 67.6829C35.412 67.7857 35.2882 67.8372 35.1364 67.8372C35.1082 67.8372 35.0604 67.8314 34.9929 67.82C34.8804 67.8886 34.7707 67.9229 34.6639 67.9229C34.5795 67.9229 34.5064 67.9 34.4445 67.8543C34.3826 67.9514 34.2926 68 34.1745 68C34.0732 68 33.9832 67.96 33.9045 67.88C33.8314 67.8 33.806 67.7057 33.8285 67.5972C33.7948 67.5629 33.7695 67.5114 33.7526 67.4429C33.7357 67.3743 33.7273 67.3057 33.7273 67.2372C33.7273 67.1857 33.7301 67.1486 33.7357 67.1257C33.6626 67.0514 33.626 66.9257 33.626 66.7486C33.626 66.6743 33.6345 66.6057 33.6514 66.5429C33.6682 66.4743 33.6879 66.4257 33.7104 66.3972C33.6823 66.34 33.6682 66.28 33.6682 66.2172C33.6682 66.1886 33.6739 66.1514 33.6851 66.1057C33.6345 66.0543 33.6092 65.9857 33.6092 65.9C33.6092 65.82 33.6289 65.7572 33.6682 65.7114C33.6401 65.6543 33.626 65.6029 33.626 65.5572C33.626 65.4943 33.6457 65.4343 33.6851 65.3772C33.6401 65.2743 33.6176 65.1743 33.6176 65.0772C33.6176 64.9572 33.6542 64.8429 33.7273 64.7343C33.6936 64.66 33.6626 64.5686 33.6345 64.46C33.612 64.3514 33.6007 64.2486 33.6007 64.1514C33.6007 63.9686 33.6429 63.8429 33.7273 63.7743C33.6992 63.6486 33.6851 63.5829 33.6851 63.5772C33.6514 63.44 33.6345 63.3429 33.6345 63.2857C33.6345 63.2 33.6542 63.0972 33.6935 62.9772C33.6654 62.9372 33.6429 62.8714 33.626 62.78C33.6092 62.6886 33.6035 62.6229 33.6092 62.5829C33.5417 62.5143 33.5079 62.4314 33.5079 62.3343C33.5079 62.26 33.5304 62.1914 33.5754 62.1286C33.626 62.06 33.6907 62.0143 33.7695 61.9914C33.8089 61.9514 33.8623 61.92 33.9298 61.8972C33.9973 61.8686 34.0676 61.8543 34.1407 61.8543C34.2364 61.8543 34.3179 61.88 34.3854 61.9314C34.4811 61.9029 34.5767 61.8886 34.6723 61.8886C34.8073 61.8886 34.917 61.92 35.0014 61.9829C35.052 61.96 35.111 61.9486 35.1786 61.9486C35.2404 61.9486 35.2882 61.9629 35.322 61.9914C35.3557 61.9629 35.4373 61.9486 35.5667 61.9486C35.7354 61.9486 35.8676 61.9772 35.9632 62.0343C36.0251 61.9714 36.101 61.94 36.191 61.94C36.2473 61.94 36.312 61.9543 36.3851 61.9829Z"
      fill="#404040"
    />
    <path
      d="M40.3937 61.9829C40.4499 61.9429 40.523 61.9229 40.613 61.9229C40.7424 61.9229 40.8718 61.9657 41.0012 62.0514C41.063 62.0514 41.1137 62.0772 41.153 62.1286C41.1924 62.18 41.2121 62.2429 41.2121 62.3172C41.2121 62.4143 41.184 62.5 41.1277 62.5743C41.0715 62.6486 40.9927 62.6857 40.8915 62.6857C40.8183 62.6857 40.7396 62.6629 40.6552 62.6172C40.6102 62.6629 40.5512 62.6857 40.478 62.6857C40.3993 62.6857 40.3177 62.6572 40.2333 62.6C40.1771 62.6286 40.0927 62.6429 39.9802 62.6429C39.8171 62.6429 39.6905 62.6172 39.6005 62.5657C39.5162 62.6057 39.429 62.6257 39.339 62.6257C39.2658 62.6257 39.1955 62.6143 39.128 62.5914C39.0549 62.62 38.9846 62.6343 38.9171 62.6343C38.8271 62.6343 38.7371 62.6086 38.6471 62.5572C38.5458 62.6143 38.4558 62.6486 38.3771 62.66C38.4165 62.7572 38.4362 62.8629 38.4362 62.9772C38.4362 63.12 38.4052 63.2343 38.3433 63.32C38.4108 63.4286 38.4446 63.5486 38.4446 63.68C38.4446 63.7829 38.4193 63.8857 38.3687 63.9886C38.4193 64.0457 38.4446 64.1172 38.4446 64.2029C38.4446 64.26 38.4249 64.3286 38.3855 64.4086C38.4362 64.38 38.498 64.3657 38.5712 64.3657C38.6274 64.3657 38.6668 64.3714 38.6893 64.3829C38.7512 64.3372 38.8187 64.3143 38.8918 64.3143C38.9649 64.3143 39.038 64.3457 39.1112 64.4086C39.1787 64.3914 39.2349 64.3829 39.2799 64.3829C39.308 64.3829 39.3558 64.3886 39.4233 64.4C39.4908 64.3886 39.5387 64.3829 39.5668 64.3829C39.6624 64.3829 39.7327 64.4057 39.7777 64.4514C39.8227 64.4229 39.8733 64.4086 39.9296 64.4086C39.9971 64.4086 40.0393 64.4229 40.0562 64.4514C40.1068 64.4343 40.1462 64.4257 40.1743 64.4257C40.2137 64.4257 40.2671 64.4372 40.3346 64.46C40.4077 64.42 40.478 64.4 40.5455 64.4C40.6412 64.4 40.7227 64.4372 40.7902 64.5114C40.8577 64.58 40.8915 64.6572 40.8915 64.7429C40.8915 64.8172 40.8662 64.88 40.8155 64.9314C40.7649 64.9829 40.6862 65.0114 40.5793 65.0172C40.5287 65.0857 40.4443 65.12 40.3262 65.12C40.2193 65.12 40.1237 65.0914 40.0393 65.0343C39.983 65.0914 39.9015 65.12 39.7946 65.12C39.699 65.12 39.6202 65.0972 39.5583 65.0514C39.5133 65.0857 39.4655 65.1029 39.4149 65.1029C39.3812 65.1029 39.353 65.0914 39.3305 65.0686C39.2687 65.1257 39.1843 65.1543 39.0774 65.1543C38.9987 65.1543 38.9255 65.1372 38.858 65.1029C38.8018 65.1314 38.754 65.1457 38.7146 65.1457C38.6583 65.1457 38.6021 65.1257 38.5458 65.0857C38.5065 65.1086 38.4755 65.1229 38.453 65.1286C38.4305 65.1343 38.3996 65.1343 38.3602 65.1286C38.4108 65.2314 38.4362 65.3114 38.4362 65.3686C38.4362 65.42 38.4193 65.48 38.3855 65.5486C38.4249 65.5943 38.4446 65.6514 38.4446 65.72C38.4446 65.7714 38.4305 65.8257 38.4024 65.8829C38.4418 65.9286 38.4615 65.9886 38.4615 66.0629C38.4615 66.1314 38.4418 66.1886 38.4024 66.2343C38.4362 66.3029 38.453 66.3572 38.453 66.3972C38.453 66.4314 38.4305 66.4886 38.3855 66.5686C38.408 66.5914 38.4193 66.6229 38.4193 66.6629C38.4193 66.7143 38.4024 66.7486 38.3687 66.7657C38.4249 66.8172 38.453 66.8829 38.453 66.9629C38.453 66.9914 38.4474 67.04 38.4362 67.1086L38.4868 67.1C38.5487 67.1 38.6133 67.1286 38.6808 67.1857C38.7652 67.1229 38.8749 67.0914 39.0099 67.0914C39.0605 67.0914 39.114 67.0972 39.1702 67.1086C39.204 67.0686 39.2518 67.0372 39.3137 67.0143C39.3755 66.9914 39.443 66.98 39.5162 66.98C39.6343 66.98 39.7243 67.0057 39.7862 67.0572C39.8199 67 39.879 66.9543 39.9633 66.92C40.0477 66.8857 40.1321 66.8686 40.2165 66.8686C40.2783 66.8686 40.329 66.8772 40.3683 66.8943C40.4302 66.86 40.4865 66.8429 40.5371 66.8429C40.6271 66.8429 40.7058 66.88 40.7733 66.9543C40.8408 67.0286 40.8746 67.1143 40.8746 67.2114C40.8746 67.3314 40.8212 67.4257 40.7143 67.4943C40.6918 67.54 40.6468 67.58 40.5793 67.6143C40.5118 67.6429 40.4387 67.6572 40.3599 67.6572C40.2812 67.6572 40.2193 67.6429 40.1743 67.6143C40.1293 67.66 40.0702 67.7 39.9971 67.7343C39.924 67.7629 39.8508 67.7772 39.7777 67.7772C39.6652 67.7772 39.578 67.7457 39.5162 67.6829C39.4205 67.7857 39.2968 67.8372 39.1449 67.8372C39.1168 67.8372 39.069 67.8314 39.0015 67.82C38.889 67.8886 38.7793 67.9229 38.6724 67.9229C38.588 67.9229 38.5149 67.9 38.453 67.8543C38.3912 67.9514 38.3012 68 38.183 68C38.0818 68 37.9918 67.96 37.913 67.88C37.8399 67.8 37.8146 67.7057 37.8371 67.5972C37.8033 67.5629 37.778 67.5114 37.7612 67.4429C37.7443 67.3743 37.7358 67.3057 37.7358 67.2372C37.7358 67.1857 37.7387 67.1486 37.7443 67.1257C37.6712 67.0514 37.6346 66.9257 37.6346 66.7486C37.6346 66.6743 37.643 66.6057 37.6599 66.5429C37.6768 66.4743 37.6965 66.4257 37.719 66.3972C37.6908 66.34 37.6768 66.28 37.6768 66.2172C37.6768 66.1886 37.6824 66.1514 37.6937 66.1057C37.643 66.0543 37.6177 65.9857 37.6177 65.9C37.6177 65.82 37.6374 65.7572 37.6768 65.7114C37.6487 65.6543 37.6346 65.6029 37.6346 65.5572C37.6346 65.4943 37.6543 65.4343 37.6937 65.3772C37.6487 65.2743 37.6262 65.1743 37.6262 65.0772C37.6262 64.9572 37.6627 64.8429 37.7358 64.7343C37.7021 64.66 37.6712 64.5686 37.643 64.46C37.6205 64.3514 37.6093 64.2486 37.6093 64.1514C37.6093 63.9686 37.6515 63.8429 37.7358 63.7743C37.7077 63.6486 37.6937 63.5829 37.6937 63.5772C37.6599 63.44 37.643 63.3429 37.643 63.2857C37.643 63.2 37.6627 63.0972 37.7021 62.9772C37.674 62.9372 37.6515 62.8714 37.6346 62.78C37.6177 62.6886 37.6121 62.6229 37.6177 62.5829C37.5502 62.5143 37.5165 62.4314 37.5165 62.3343C37.5165 62.26 37.539 62.1914 37.584 62.1286C37.6346 62.06 37.6993 62.0143 37.778 61.9914C37.8174 61.9514 37.8708 61.92 37.9383 61.8972C38.0058 61.8686 38.0762 61.8543 38.1493 61.8543C38.2449 61.8543 38.3265 61.88 38.394 61.9314C38.4896 61.9029 38.5852 61.8886 38.6808 61.8886C38.8158 61.8886 38.9255 61.92 39.0099 61.9829C39.0605 61.96 39.1196 61.9486 39.1871 61.9486C39.249 61.9486 39.2968 61.9629 39.3305 61.9914C39.3643 61.9629 39.4458 61.9486 39.5752 61.9486C39.744 61.9486 39.8762 61.9772 39.9718 62.0343C40.0337 61.9714 40.1096 61.94 40.1996 61.94C40.2558 61.94 40.3205 61.9543 40.3937 61.9829Z"
      fill="#404040"
    />
    <path
      d="M44.4022 61.9829C44.4585 61.9429 44.5316 61.9229 44.6216 61.9229C44.751 61.9229 44.8803 61.9657 45.0097 62.0514C45.0716 62.0514 45.1222 62.0772 45.1616 62.1286C45.201 62.18 45.2206 62.2429 45.2206 62.3172C45.2206 62.4143 45.1925 62.5 45.1363 62.5743C45.08 62.6486 45.0013 62.6857 44.9 62.6857C44.8269 62.6857 44.7481 62.6629 44.6638 62.6172C44.6188 62.6629 44.5597 62.6857 44.4866 62.6857C44.4078 62.6857 44.3263 62.6572 44.2419 62.6C44.1856 62.6286 44.1013 62.6429 43.9888 62.6429C43.8256 62.6429 43.6991 62.6172 43.6091 62.5657C43.5247 62.6057 43.4375 62.6257 43.3475 62.6257C43.2744 62.6257 43.2041 62.6143 43.1366 62.5914C43.0635 62.62 42.9931 62.6343 42.9256 62.6343C42.8356 62.6343 42.7456 62.6086 42.6556 62.5572C42.5544 62.6143 42.4644 62.6486 42.3856 62.66C42.425 62.7572 42.4447 62.8629 42.4447 62.9772C42.4447 63.12 42.4138 63.2343 42.3519 63.32C42.4194 63.4286 42.4531 63.5486 42.4531 63.68C42.4531 63.7829 42.4278 63.8857 42.3772 63.9886C42.4278 64.0457 42.4531 64.1172 42.4531 64.2029C42.4531 64.26 42.4334 64.3286 42.3941 64.4086C42.4447 64.38 42.5066 64.3657 42.5797 64.3657C42.636 64.3657 42.6753 64.3714 42.6978 64.3829C42.7597 64.3372 42.8272 64.3143 42.9003 64.3143C42.9735 64.3143 43.0466 64.3457 43.1197 64.4086C43.1872 64.3914 43.2435 64.3829 43.2885 64.3829C43.3166 64.3829 43.3644 64.3886 43.4319 64.4C43.4994 64.3886 43.5472 64.3829 43.5753 64.3829C43.671 64.3829 43.7413 64.4057 43.7863 64.4514C43.8313 64.4229 43.8819 64.4086 43.9381 64.4086C44.0056 64.4086 44.0478 64.4229 44.0647 64.4514C44.1153 64.4343 44.1547 64.4257 44.1828 64.4257C44.2222 64.4257 44.2756 64.4372 44.3431 64.46C44.4163 64.42 44.4866 64.4 44.5541 64.4C44.6497 64.4 44.7313 64.4372 44.7988 64.5114C44.8663 64.58 44.9 64.6572 44.9 64.7429C44.9 64.8172 44.8747 64.88 44.8241 64.9314C44.7735 64.9829 44.6947 65.0114 44.5878 65.0172C44.5372 65.0857 44.4528 65.12 44.3347 65.12C44.2278 65.12 44.1322 65.0914 44.0478 65.0343C43.9916 65.0914 43.91 65.12 43.8031 65.12C43.7075 65.12 43.6288 65.0972 43.5669 65.0514C43.5219 65.0857 43.4741 65.1029 43.4235 65.1029C43.3897 65.1029 43.3616 65.0914 43.3391 65.0686C43.2772 65.1257 43.1928 65.1543 43.0859 65.1543C43.0072 65.1543 42.9341 65.1372 42.8666 65.1029C42.8103 65.1314 42.7625 65.1457 42.7231 65.1457C42.6669 65.1457 42.6106 65.1257 42.5544 65.0857C42.515 65.1086 42.4841 65.1229 42.4616 65.1286C42.4391 65.1343 42.4081 65.1343 42.3688 65.1286C42.4194 65.2314 42.4447 65.3114 42.4447 65.3686C42.4447 65.42 42.4278 65.48 42.3941 65.5486C42.4334 65.5943 42.4531 65.6514 42.4531 65.72C42.4531 65.7714 42.4391 65.8257 42.411 65.8829C42.4503 65.9286 42.47 65.9886 42.47 66.0629C42.47 66.1314 42.4503 66.1886 42.411 66.2343C42.4447 66.3029 42.4616 66.3572 42.4616 66.3972C42.4616 66.4314 42.4391 66.4886 42.3941 66.5686C42.4166 66.5914 42.4278 66.6229 42.4278 66.6629C42.4278 66.7143 42.4109 66.7486 42.3772 66.7657C42.4335 66.8172 42.4616 66.8829 42.4616 66.9629C42.4616 66.9914 42.456 67.04 42.4447 67.1086L42.4953 67.1C42.5572 67.1 42.6219 67.1286 42.6894 67.1857C42.7738 67.1229 42.8835 67.0914 43.0185 67.0914C43.0691 67.0914 43.1225 67.0972 43.1788 67.1086C43.2125 67.0686 43.2603 67.0372 43.3222 67.0143C43.3841 66.9914 43.4516 66.98 43.5247 66.98C43.6428 66.98 43.7328 67.0057 43.7947 67.0572C43.8285 67 43.8875 66.9543 43.9719 66.92C44.0563 66.8857 44.1406 66.8686 44.225 66.8686C44.2869 66.8686 44.3375 66.8772 44.3769 66.8943C44.4388 66.86 44.495 66.8429 44.5456 66.8429C44.6356 66.8429 44.7144 66.88 44.7819 66.9543C44.8494 67.0286 44.8831 67.1143 44.8831 67.2114C44.8831 67.3314 44.8297 67.4257 44.7228 67.4943C44.7003 67.54 44.6553 67.58 44.5878 67.6143C44.5203 67.6429 44.4472 67.6572 44.3685 67.6572C44.2897 67.6572 44.2278 67.6429 44.1828 67.6143C44.1378 67.66 44.0788 67.7 44.0056 67.7343C43.9325 67.7629 43.8594 67.7772 43.7863 67.7772C43.6738 67.7772 43.5866 67.7457 43.5247 67.6829C43.4291 67.7857 43.3053 67.8372 43.1535 67.8372C43.1253 67.8372 43.0775 67.8314 43.01 67.82C42.8975 67.8886 42.7878 67.9229 42.681 67.9229C42.5966 67.9229 42.5235 67.9 42.4616 67.8543C42.3997 67.9514 42.3097 68 42.1916 68C42.0903 68 42.0003 67.96 41.9216 67.88C41.8484 67.8 41.8231 67.7057 41.8456 67.5972C41.8119 67.5629 41.7866 67.5114 41.7697 67.4429C41.7528 67.3743 41.7444 67.3057 41.7444 67.2372C41.7444 67.1857 41.7472 67.1486 41.7528 67.1257C41.6797 67.0514 41.6431 66.9257 41.6431 66.7486C41.6431 66.6743 41.6516 66.6057 41.6685 66.5429C41.6853 66.4743 41.705 66.4257 41.7275 66.3972C41.6994 66.34 41.6853 66.28 41.6853 66.2172C41.6853 66.1886 41.691 66.1514 41.7022 66.1057C41.6516 66.0543 41.6263 65.9857 41.6263 65.9C41.6263 65.82 41.646 65.7572 41.6853 65.7114C41.6572 65.6543 41.6431 65.6029 41.6431 65.5572C41.6431 65.4943 41.6628 65.4343 41.7022 65.3772C41.6572 65.2743 41.6347 65.1743 41.6347 65.0772C41.6347 64.9572 41.6713 64.8429 41.7444 64.7343C41.7106 64.66 41.6797 64.5686 41.6516 64.46C41.6291 64.3514 41.6178 64.2486 41.6178 64.1514C41.6178 63.9686 41.66 63.8429 41.7444 63.7743C41.7163 63.6486 41.7022 63.5829 41.7022 63.5772C41.6684 63.44 41.6516 63.3429 41.6516 63.2857C41.6516 63.2 41.6713 63.0972 41.7106 62.9772C41.6825 62.9372 41.66 62.8714 41.6431 62.78C41.6263 62.6886 41.6206 62.6229 41.6263 62.5829C41.5588 62.5143 41.525 62.4314 41.525 62.3343C41.525 62.26 41.5475 62.1914 41.5925 62.1286C41.6431 62.06 41.7078 62.0143 41.7866 61.9914C41.826 61.9514 41.8794 61.92 41.9469 61.8972C42.0144 61.8686 42.0847 61.8543 42.1578 61.8543C42.2535 61.8543 42.335 61.88 42.4025 61.9314C42.4981 61.9029 42.5938 61.8886 42.6894 61.8886C42.8244 61.8886 42.9341 61.92 43.0185 61.9829C43.0691 61.96 43.1281 61.9486 43.1956 61.9486C43.2575 61.9486 43.3053 61.9629 43.3391 61.9914C43.3728 61.9629 43.4544 61.9486 43.5838 61.9486C43.7525 61.9486 43.8847 61.9772 43.9803 62.0343C44.0422 61.9714 44.1181 61.94 44.2081 61.94C44.2644 61.94 44.3291 61.9543 44.4022 61.9829Z"
      fill="#404040"
    />
    <path
      d="M45.8795 65.6343C45.8514 65.5772 45.8373 65.5057 45.8373 65.42C45.8373 65.34 45.8514 65.28 45.8795 65.24C45.8682 65.2114 45.8626 65.1629 45.8626 65.0943C45.8626 65.0143 45.8739 64.9343 45.8964 64.8543C45.9189 64.7743 45.9442 64.7229 45.9723 64.7C45.9217 64.6543 45.8964 64.5543 45.8964 64.4C45.8964 64.3314 45.902 64.2714 45.9132 64.22C45.9245 64.1629 45.9414 64.1286 45.9639 64.1172C45.9357 64.06 45.9217 63.9686 45.9217 63.8429C45.9217 63.7514 45.9301 63.6686 45.947 63.5943C45.9639 63.5143 45.9864 63.4543 46.0145 63.4143C45.947 63.3457 45.9132 63.2514 45.9132 63.1314C45.9132 63.0572 45.9245 62.9886 45.947 62.9257C45.9751 62.8572 46.0089 62.8057 46.0482 62.7714C45.9976 62.6972 45.9723 62.6057 45.9723 62.4972C45.9723 62.4286 45.9864 62.3457 46.0145 62.2486C45.9582 62.1743 45.9301 62.1029 45.9301 62.0343C45.9301 61.9429 45.9695 61.8657 46.0482 61.8029C46.127 61.7343 46.2142 61.7 46.3098 61.7C46.3773 61.7 46.4364 61.7229 46.487 61.7686C46.5433 61.8086 46.5826 61.8714 46.6051 61.9572C46.667 62.0314 46.6979 62.1114 46.6979 62.1972C46.6979 62.2543 46.6867 62.3029 46.6642 62.3429C46.6811 62.36 46.6895 62.5 46.6895 62.7629C46.7007 62.8086 46.7064 62.8457 46.7064 62.8743C46.7064 62.9886 46.6811 63.1114 46.6304 63.2429C46.6642 63.2886 46.6811 63.3657 46.6811 63.4743C46.6811 63.5486 46.6698 63.6229 46.6473 63.6972C46.6304 63.7657 46.6107 63.8172 46.5882 63.8514C46.5939 63.8686 46.6023 63.9 46.6136 63.9457C46.6248 63.9914 46.6304 64.0343 46.6304 64.0743C46.6304 64.1372 46.6164 64.1914 46.5882 64.2372C46.6276 64.2943 46.6473 64.4086 46.6473 64.58C46.6473 64.6429 46.6417 64.6972 46.6304 64.7429C46.6529 64.7714 46.6642 64.8314 46.6642 64.9229C46.6642 64.9972 46.6529 65.0714 46.6304 65.1457C46.6136 65.2143 46.5854 65.2629 46.5461 65.2914C46.5854 65.3372 46.6051 65.4 46.6051 65.48C46.6051 65.5543 46.5911 65.6143 46.5629 65.66C46.5911 65.6714 46.6051 65.7114 46.6051 65.78C46.6051 65.82 46.5995 65.8629 46.5882 65.9086C46.577 65.9486 46.5629 65.9714 46.5461 65.9772C46.5573 66.0229 46.5629 66.06 46.5629 66.0886C46.5629 66.18 46.5292 66.2629 46.4617 66.3372C46.3998 66.4057 46.3211 66.44 46.2254 66.44C46.1242 66.44 46.0398 66.4029 45.9723 66.3286C45.9048 66.2486 45.8795 66.1572 45.8964 66.0543C45.8682 65.9857 45.8542 65.8943 45.8542 65.78C45.8542 65.7172 45.8626 65.6686 45.8795 65.6343ZM45.9301 67.7257C45.9301 67.8286 45.9611 67.9114 46.0229 67.9743C46.0904 68.0314 46.1692 68.06 46.2592 68.06C46.3379 68.06 46.4082 68.0372 46.4701 67.9914C46.532 67.94 46.5714 67.8686 46.5882 67.7772C46.6389 67.7086 46.6642 67.6286 46.6642 67.5372L46.6557 67.3743C46.6445 67.22 46.577 67.1172 46.4532 67.0657C46.4139 67.0486 46.3717 67.04 46.3267 67.04C46.2367 67.04 46.1579 67.0743 46.0904 67.1429C46.0229 67.2057 45.9892 67.2857 45.9892 67.3829C45.9892 67.4114 45.9948 67.4486 46.0061 67.4943C45.9554 67.5686 45.9301 67.6457 45.9301 67.7257Z"
      fill="#404040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 54.8571V0H54V54.8571H0ZM1.85222 1.14286H52.1478L50.0585 3.42857H3.94151L1.85222 1.14286ZM1.85222 53.7143L3.94151 51.4286H50.0585L52.1478 53.7143H1.85222ZM49.5 4.57143H4.5V50.2857H49.5V4.57143Z"
      fill="#404040"
    />
    <defs>
      <pattern
        id="pattern0-110"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1647_873"
          transform="translate(-0.0555556 -0.0555556) scale(0.000478927)"
        />
      </pattern>
      <image
        id="image0_1647_873"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame7 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={76}
    height={96}
    viewBox="0 0 76 84"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-cafe.svg"
    role="img"
    {...props}
  >
    <path
      d="M71.6772 33.6772C69.9122 35.4421 67.6023 36.5366 65.1429 36.7969L65.1429 15.2031C67.6023 15.4634 69.9122 16.5579 71.6772 18.3228C73.7133 20.359 74.8571 23.1205 74.8571 26C74.8571 28.8795 73.7133 31.641 71.6772 33.6772Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2.28571}
    />
    <path
      d="M9 4C9 2.34315 10.3431 1 12 1H62C63.6569 1 65 2.34315 65 4V44C65 50.0751 60.0751 55 54 55H20C13.9249 55 9 50.0751 9 44V4Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2}
    />
    <path
      d="M0 52.6667C0 52.2985 0.298477 52 0.666667 52H74.3333C74.7015 52 75 52.2985 75 52.6667C75 56.7168 71.7168 60 67.6667 60H7.33333C3.28325 60 0 56.7168 0 52.6667Z"
      fill="#404040"
    />
    <path
      d="M10.785 74.49C10.815 74.52 10.83 74.57 10.83 74.64C10.83 74.73 10.795 74.83 10.725 74.94C10.665 75.05 10.585 75.135 10.485 75.195C10.505 75.215 10.515 75.275 10.515 75.375C10.515 75.475 10.505 75.57 10.485 75.66C10.475 75.74 10.465 75.795 10.455 75.825C10.485 75.855 10.515 75.92 10.545 76.02C10.575 76.12 10.595 76.2 10.605 76.26C10.695 76.26 10.78 76.29 10.86 76.35C10.94 76.41 11 76.495 11.04 76.605C11.05 76.595 11.075 76.59 11.115 76.59C11.175 76.59 11.245 76.6 11.325 76.62C11.405 76.64 11.47 76.66 11.52 76.68C11.55 76.65 11.615 76.635 11.715 76.635C11.885 76.635 11.995 76.675 12.045 76.755C12.095 76.725 12.16 76.71 12.24 76.71C12.4 76.71 12.52 76.75 12.6 76.83C12.65 76.79 12.755 76.77 12.915 76.77C13.025 76.77 13.135 76.785 13.245 76.815C13.355 76.845 13.425 76.885 13.455 76.935C13.485 76.925 13.53 76.92 13.59 76.92C13.76 76.92 13.92 76.965 14.07 77.055C14.23 77.135 14.31 77.225 14.31 77.325C14.44 77.305 14.56 77.335 14.67 77.415C14.78 77.495 14.87 77.595 14.94 77.715C15.12 77.745 15.29 77.91 15.45 78.21C15.61 78.51 15.69 78.79 15.69 79.05C15.69 79.17 15.665 79.27 15.615 79.35C15.765 79.45 15.84 79.635 15.84 79.905C15.84 80.095 15.8 80.27 15.72 80.43C15.74 80.51 15.75 80.57 15.75 80.61C15.75 80.78 15.7 80.95 15.6 81.12C15.51 81.28 15.4 81.38 15.27 81.42C15.24 81.59 15.15 81.75 15 81.9C14.85 82.04 14.695 82.145 14.535 82.215C14.515 82.345 14.42 82.475 14.25 82.605C14.08 82.725 13.915 82.765 13.755 82.725C13.685 82.815 13.555 82.89 13.365 82.95C13.185 83 12.99 83.025 12.78 83.025C12.58 83.025 12.395 83 12.225 82.95C12.065 82.9 11.955 82.825 11.895 82.725C11.805 82.765 11.705 82.785 11.595 82.785C11.455 82.785 11.32 82.75 11.19 82.68C11.07 82.61 10.985 82.515 10.935 82.395C10.815 82.425 10.685 82.4 10.545 82.32C10.415 82.23 10.32 82.095 10.26 81.915C10.1 81.915 9.935 81.86 9.765 81.75C9.605 81.64 9.515 81.53 9.495 81.42C9.335 81.39 9.21 81.32 9.12 81.21C9.04 81.1 9 80.975 9 80.835C9 80.675 9.05 80.53 9.15 80.4C9.26 80.27 9.4 80.205 9.57 80.205C9.66 80.205 9.73 80.215 9.78 80.235C9.86 80.215 9.915 80.205 9.945 80.205C10.095 80.205 10.23 80.255 10.35 80.355C10.48 80.455 10.55 80.58 10.56 80.73C10.62 80.71 10.67 80.7 10.71 80.7C10.85 80.7 10.975 80.765 11.085 80.895C11.205 81.015 11.275 81.155 11.295 81.315C11.355 81.285 11.42 81.27 11.49 81.27C11.6 81.27 11.705 81.3 11.805 81.36C11.905 81.42 11.96 81.49 11.97 81.57C12.06 81.54 12.15 81.525 12.24 81.525C12.4 81.525 12.53 81.59 12.63 81.72C12.72 81.66 12.815 81.63 12.915 81.63C12.965 81.63 13.05 81.65 13.17 81.69C13.3 81.5 13.43 81.425 13.56 81.465C13.64 81.355 13.73 81.26 13.83 81.18C13.93 81.09 14.03 81.04 14.13 81.03C14.17 80.92 14.215 80.84 14.265 80.79C14.315 80.73 14.395 80.67 14.505 80.61C14.485 80.57 14.475 80.52 14.475 80.46C14.475 80.36 14.495 80.255 14.535 80.145C14.575 80.035 14.62 79.965 14.67 79.935C14.59 79.845 14.55 79.74 14.55 79.62C14.55 79.52 14.585 79.405 14.655 79.275C14.475 79.165 14.385 79.005 14.385 78.795C14.235 78.745 14.125 78.675 14.055 78.585C13.885 78.595 13.745 78.57 13.635 78.51C13.525 78.44 13.455 78.34 13.425 78.21C13.345 78.23 13.29 78.24 13.26 78.24C13.16 78.24 13.065 78.22 12.975 78.18C12.885 78.13 12.81 78.065 12.75 77.985C12.69 78.035 12.61 78.06 12.51 78.06C12.38 78.06 12.24 78.01 12.09 77.91C11.99 77.96 11.895 77.985 11.805 77.985C11.675 77.985 11.57 77.96 11.49 77.91C11.43 77.93 11.38 77.94 11.34 77.94C11.25 77.94 11.165 77.925 11.085 77.895C11.015 77.855 10.975 77.81 10.965 77.76C10.605 77.76 10.41 77.695 10.38 77.565C10.26 77.545 10.145 77.505 10.035 77.445C9.925 77.375 9.865 77.295 9.855 77.205C9.755 77.185 9.67 77.13 9.6 77.04C9.53 76.94 9.495 76.82 9.495 76.68C9.405 76.61 9.33 76.485 9.27 76.305C9.21 76.125 9.18 75.935 9.18 75.735C9.18 75.415 9.245 75.195 9.375 75.075C9.355 75.015 9.345 74.955 9.345 74.895C9.345 74.755 9.37 74.61 9.42 74.46C9.48 74.31 9.54 74.22 9.6 74.19C9.6 74.06 9.635 73.91 9.705 73.74C9.795 73.62 9.9 73.52 10.02 73.44C10.14 73.35 10.27 73.305 10.41 73.305C10.43 73.195 10.49 73.1 10.59 73.02C10.7 72.94 10.825 72.9 10.965 72.9C11.005 72.78 11.09 72.685 11.22 72.615C11.35 72.545 11.495 72.51 11.655 72.51C11.775 72.51 11.88 72.525 11.97 72.555C12 72.505 12.055 72.465 12.135 72.435C12.215 72.405 12.3 72.39 12.39 72.39C12.44 72.39 12.495 72.4 12.555 72.42C12.645 72.33 12.805 72.285 13.035 72.285C13.285 72.285 13.475 72.33 13.605 72.42C13.645 72.41 13.7 72.405 13.77 72.405C14.07 72.405 14.325 72.58 14.535 72.93C14.645 72.91 14.765 72.94 14.895 73.02C15.035 73.1 15.145 73.21 15.225 73.35C15.315 73.48 15.355 73.605 15.345 73.725C15.515 73.845 15.635 73.97 15.705 74.1C15.775 74.23 15.83 74.425 15.87 74.685C15.88 74.865 15.825 75.01 15.705 75.12C15.585 75.23 15.445 75.285 15.285 75.285C15.135 75.285 15.005 75.23 14.895 75.12C14.775 75.1 14.67 75.04 14.58 74.94C14.49 74.84 14.45 74.74 14.46 74.64C14.18 74.45 14.055 74.24 14.085 74.01C13.965 74.03 13.815 74 13.635 73.92C13.465 73.83 13.335 73.715 13.245 73.575C13.175 73.675 13.035 73.725 12.825 73.725C12.675 73.725 12.55 73.7 12.45 73.65C12.38 73.74 12.255 73.785 12.075 73.785C11.985 73.785 11.9 73.77 11.82 73.74C11.78 73.85 11.71 73.945 11.61 74.025C11.52 74.095 11.415 74.14 11.295 74.16C11.235 74.25 11.16 74.33 11.07 74.4C10.98 74.46 10.885 74.49 10.785 74.49Z"
      fill="#404040"
    />
    <path
      d="M23.4535 79.11C23.4935 79 23.5735 78.91 23.6935 78.84C23.8135 78.76 23.9384 78.72 24.0684 78.72C24.1084 78.72 24.1685 78.73 24.2485 78.75C24.5385 78.83 24.6835 79 24.6835 79.26C24.6835 79.49 24.5835 79.725 24.3835 79.965C24.4035 80.045 24.4135 80.115 24.4135 80.175C24.4135 80.305 24.3835 80.435 24.3235 80.565C24.2735 80.695 24.1985 80.815 24.0985 80.925C24.0685 81.085 24.0234 81.225 23.9635 81.345C23.9135 81.455 23.8335 81.585 23.7235 81.735C23.6035 81.895 23.4835 82.01 23.3635 82.08C23.2535 82.14 23.0985 82.2 22.8985 82.26C22.8485 82.4 22.7685 82.53 22.6585 82.65C22.5485 82.76 22.4135 82.815 22.2535 82.815C22.1735 82.815 22.0885 82.8 21.9985 82.77C21.9285 82.85 21.8285 82.915 21.6985 82.965C21.5785 83.005 21.4535 83.025 21.3235 83.025C21.1535 83.025 21.0185 82.99 20.9185 82.92C20.7985 82.97 20.6434 82.995 20.4535 82.995C20.2035 82.995 19.9634 82.955 19.7334 82.875C19.5035 82.795 19.3235 82.67 19.1934 82.5C18.9535 82.52 18.7535 82.465 18.5935 82.335C18.4535 82.255 18.3635 82.165 18.3235 82.065C17.9535 81.885 17.7734 81.555 17.7835 81.075C17.6034 80.955 17.4685 80.82 17.3785 80.67C17.2885 80.51 17.2185 80.31 17.1685 80.07C17.0885 79.99 17.0485 79.885 17.0485 79.755C17.0485 79.695 17.0534 79.645 17.0634 79.605C16.9734 79.515 16.9285 79.395 16.9285 79.245C16.9285 79.175 16.9434 79.105 16.9735 79.035C16.8335 78.885 16.7635 78.67 16.7635 78.39C16.7635 78.14 16.8184 77.945 16.9285 77.805C16.8584 77.705 16.8235 77.595 16.8235 77.475C16.8235 77.385 16.8485 77.29 16.8985 77.19C16.8485 77.13 16.8235 77.01 16.8235 76.83C16.8235 76.63 16.8535 76.43 16.9135 76.23C16.9735 76.02 17.0485 75.88 17.1385 75.81C17.1085 75.75 17.0935 75.665 17.0935 75.555C17.0935 75.395 17.1185 75.245 17.1685 75.105C17.2285 74.965 17.3084 74.89 17.4085 74.88C17.4085 74.67 17.4935 74.505 17.6635 74.385C17.6535 74.245 17.7035 74.09 17.8134 73.92C17.9334 73.75 18.0685 73.635 18.2185 73.575C18.2485 73.355 18.3385 73.17 18.4885 73.02C18.6384 72.87 18.8034 72.785 18.9834 72.765C19.0335 72.675 19.1235 72.6 19.2535 72.54C19.3935 72.47 19.5285 72.435 19.6585 72.435C19.7584 72.435 19.8435 72.455 19.9135 72.495C20.0635 72.355 20.2335 72.285 20.4235 72.285C20.5835 72.285 20.6884 72.325 20.7385 72.405C20.8184 72.385 20.8885 72.375 20.9485 72.375C21.1285 72.375 21.2635 72.44 21.3535 72.57C21.3935 72.54 21.4535 72.525 21.5335 72.525C21.6735 72.525 21.8285 72.565 21.9985 72.645C22.1784 72.715 22.2835 72.785 22.3135 72.855C22.5235 72.895 22.7135 73 22.8835 73.17C23.0535 73.33 23.1235 73.495 23.0935 73.665C23.2335 73.735 23.3335 73.835 23.3935 73.965C23.4535 74.085 23.4735 74.2 23.4535 74.31C23.5435 74.38 23.6035 74.47 23.6335 74.58C23.6635 74.68 23.6835 74.74 23.6935 74.76C23.8935 74.93 23.9935 75.145 23.9935 75.405C23.9935 75.455 23.9834 75.52 23.9635 75.6C23.9735 75.64 23.9785 75.69 23.9785 75.75C23.9785 75.92 23.9135 76.065 23.7835 76.185C23.6635 76.295 23.5235 76.35 23.3635 76.35C23.2035 76.35 23.0635 76.29 22.9435 76.17C22.6635 75.87 22.5085 75.57 22.4785 75.27C22.3585 75.23 22.2634 75.155 22.1934 75.045C22.1235 74.925 22.0935 74.795 22.1035 74.655C22.0135 74.595 21.9435 74.52 21.8935 74.43C21.8535 74.33 21.8385 74.23 21.8485 74.13C21.6685 74.13 21.5285 74.075 21.4285 73.965C21.3985 73.975 21.3435 73.98 21.2635 73.98C21.1535 73.98 21.0335 73.965 20.9035 73.935C20.7734 73.895 20.6735 73.85 20.6035 73.8C20.5635 73.81 20.5035 73.815 20.4235 73.815C20.3135 73.815 20.2385 73.805 20.1985 73.785C20.0685 73.865 19.9434 73.905 19.8235 73.905C19.7835 73.905 19.7135 73.895 19.6135 73.875C19.5035 73.965 19.3985 74.015 19.2985 74.025C19.2785 74.185 19.2334 74.33 19.1635 74.46C19.1034 74.59 19.0235 74.665 18.9235 74.685C18.9435 74.805 18.9235 74.925 18.8635 75.045C18.8034 75.155 18.7184 75.245 18.6084 75.315C18.5984 75.395 18.5735 75.475 18.5335 75.555C18.4935 75.625 18.4435 75.68 18.3835 75.72C18.3935 75.77 18.4035 75.83 18.4135 75.9C18.4235 75.96 18.4285 76.035 18.4285 76.125C18.4285 76.335 18.3385 76.5 18.1585 76.62C18.1585 76.75 18.1335 76.855 18.0835 76.935C18.1335 77.035 18.1585 77.135 18.1585 77.235C18.1585 77.335 18.1385 77.425 18.0985 77.505C18.1585 77.605 18.1884 77.7 18.1884 77.79C18.1884 77.88 18.1635 77.985 18.1135 78.105C18.0634 78.235 18.0335 78.355 18.0234 78.465C18.1135 78.515 18.1834 78.585 18.2334 78.675C18.2835 78.765 18.3085 78.86 18.3085 78.96C18.3085 79.07 18.2785 79.17 18.2185 79.26C18.2985 79.3 18.3584 79.37 18.3984 79.47C18.4384 79.57 18.4585 79.675 18.4585 79.785C18.4585 79.895 18.4384 79.985 18.3984 80.055C18.6185 80.175 18.7685 80.3 18.8485 80.43C18.9385 80.55 19.0035 80.745 19.0435 81.015C19.1135 81.045 19.1934 81.095 19.2835 81.165C19.3835 81.235 19.4485 81.295 19.4784 81.345C19.6484 81.335 19.8235 81.375 20.0035 81.465C20.1934 81.545 20.3235 81.655 20.3935 81.795C20.4535 81.745 20.5485 81.705 20.6785 81.675C20.8185 81.635 20.9535 81.615 21.0835 81.615C21.2235 81.615 21.3184 81.635 21.3685 81.675C21.5085 81.505 21.6785 81.42 21.8785 81.42C21.9385 81.42 21.9835 81.425 22.0135 81.435C22.1735 81.305 22.2985 81.215 22.3885 81.165C22.4785 81.105 22.5835 81.06 22.7035 81.03C22.7135 80.88 22.7735 80.735 22.8835 80.595C22.8935 80.515 22.9235 80.42 22.9735 80.31C23.0235 80.19 23.0735 80.1 23.1235 80.04C23.1135 80.01 23.1085 79.96 23.1085 79.89C23.1085 79.76 23.1435 79.62 23.2135 79.47C23.2835 79.31 23.3635 79.19 23.4535 79.11Z"
      fill="#404040"
    />
    <path
      d="M33.3646 81.405C33.3646 81.405 33.4496 81.44 33.6196 81.51C33.7996 81.58 33.8696 81.815 33.8296 82.215C33.8696 82.295 33.8896 82.385 33.8896 82.485C33.8896 82.645 33.8246 82.775 33.6946 82.875C33.5646 82.975 33.4146 83.025 33.2446 83.025C33.0946 83.025 32.9646 82.98 32.8546 82.89C32.7546 82.79 32.7046 82.65 32.7046 82.47C32.5946 82.45 32.4796 82.365 32.3596 82.215C32.2496 82.055 32.1946 81.895 32.1946 81.735C32.1946 81.695 32.2046 81.635 32.2246 81.555C32.1246 81.505 32.0346 81.405 31.9546 81.255C31.8846 81.095 31.8346 80.93 31.8046 80.76C31.7746 80.59 31.7646 80.47 31.7746 80.4C31.6446 80.34 31.5396 80.195 31.4596 79.965C31.3896 79.725 31.3646 79.52 31.3846 79.35C31.3146 79.38 31.2296 79.395 31.1296 79.395C30.9296 79.395 30.7446 79.335 30.5746 79.215C30.4446 79.345 30.2496 79.41 29.9896 79.41C29.7496 79.41 29.5796 79.35 29.4796 79.23C29.3496 79.34 29.2096 79.395 29.0596 79.395C28.9396 79.395 28.8446 79.37 28.7746 79.32C28.7046 79.37 28.5996 79.395 28.4596 79.395C28.3396 79.395 28.2196 79.375 28.0996 79.335C27.9796 79.295 27.8846 79.24 27.8146 79.17C27.8046 79.17 27.7796 79.18 27.7396 79.2C27.7996 79.39 27.8296 79.56 27.8296 79.71C27.8296 79.94 27.7146 80.14 27.4846 80.31C27.5246 80.39 27.5446 80.485 27.5446 80.595C27.5446 80.815 27.4696 81.025 27.3196 81.225C27.1696 81.425 27.0246 81.535 26.8846 81.555C26.9246 81.645 26.9446 81.75 26.9446 81.87C26.9446 82.14 26.8546 82.39 26.6746 82.62C26.4946 82.84 26.2746 82.95 26.0146 82.95C25.9446 82.95 25.8896 82.945 25.8496 82.935C25.7196 82.935 25.6196 82.895 25.5496 82.815C25.4796 82.735 25.4446 82.63 25.4446 82.5C25.4446 82.41 25.4696 82.305 25.5196 82.185C25.5096 82.145 25.5046 82.085 25.5046 82.005C25.5046 81.805 25.6046 81.63 25.8046 81.48C25.7946 81.45 25.7896 81.405 25.7896 81.345C25.7896 81.195 25.8246 81.045 25.8946 80.895C25.9746 80.735 26.0746 80.63 26.1946 80.58C26.1846 80.56 26.1796 80.515 26.1796 80.445C26.1796 80.275 26.2196 80.08 26.2996 79.86C26.3796 79.63 26.4696 79.5 26.5696 79.47C26.5496 79.03 26.6946 78.585 27.0046 78.135C27.0046 77.905 27.0396 77.69 27.1096 77.49C27.1796 77.28 27.3046 77.13 27.4846 77.04C27.4946 76.85 27.5396 76.66 27.6196 76.47C27.6996 76.28 27.7896 76.12 27.8896 75.99C27.8596 75.88 27.8446 75.78 27.8446 75.69C27.8446 75.55 27.8696 75.44 27.9196 75.36C27.9796 75.27 28.0446 75.215 28.1146 75.195C28.1046 75.155 28.0996 75.095 28.0996 75.015C28.0996 74.795 28.1796 74.62 28.3396 74.49L28.3246 74.4C28.3246 74.25 28.3846 74.115 28.5046 73.995C28.4946 73.955 28.4896 73.9 28.4896 73.83C28.4896 73.65 28.5346 73.47 28.6246 73.29C28.7146 73.11 28.8146 72.99 28.9246 72.93C29.1046 72.68 29.2946 72.555 29.4946 72.555C29.5846 72.555 29.6996 72.585 29.8396 72.645C30.1296 72.655 30.3396 72.88 30.4696 73.32C30.5596 73.43 30.6246 73.56 30.6646 73.71C30.7046 73.85 30.7196 73.98 30.7096 74.1C30.7996 74.16 30.8646 74.24 30.9046 74.34C30.9546 74.44 30.9746 74.545 30.9646 74.655C31.0646 74.745 31.1496 74.885 31.2196 75.075C31.2996 75.265 31.3396 75.445 31.3396 75.615C31.3396 75.695 31.3346 75.75 31.3246 75.78C31.3946 75.85 31.4546 75.95 31.5046 76.08C31.5646 76.21 31.5946 76.33 31.5946 76.44C31.5946 76.5 31.5896 76.545 31.5796 76.575C31.7096 76.665 31.8146 76.805 31.8946 76.995C31.9846 77.185 32.0446 77.375 32.0746 77.565C32.1146 77.745 32.1246 77.87 32.1046 77.94C32.1246 77.97 32.1796 78.045 32.2696 78.165C32.3596 78.275 32.4296 78.39 32.4796 78.51C32.5296 78.62 32.5546 78.725 32.5546 78.825C32.5546 78.915 32.5446 78.98 32.5246 79.02C32.5646 79.07 32.6096 79.13 32.6596 79.2C32.7096 79.26 32.7496 79.315 32.7796 79.365C32.8096 79.415 32.8246 79.475 32.8246 79.545C32.8246 79.615 32.8196 79.665 32.8096 79.695C32.8896 79.775 32.9596 79.88 33.0196 80.01C33.0796 80.14 33.1096 80.265 33.1096 80.385C33.1096 80.485 33.0896 80.56 33.0496 80.61C33.1596 80.69 33.2446 80.805 33.3046 80.955C33.3646 81.105 33.3846 81.255 33.3646 81.405ZM30.6046 78.15C30.6246 78.09 30.6696 78.055 30.7396 78.045C30.8096 78.025 30.8696 78.03 30.9196 78.06C30.8996 78 30.8896 77.955 30.8896 77.925C30.8896 77.845 30.9096 77.785 30.9496 77.745C30.8596 77.675 30.7846 77.585 30.7246 77.475C30.6746 77.365 30.6546 77.255 30.6646 77.145C30.5946 77.125 30.5296 77.075 30.4696 76.995C30.4196 76.905 30.3946 76.81 30.3946 76.71C30.3946 76.68 30.4046 76.625 30.4246 76.545C30.2146 76.415 30.1096 76.22 30.1096 75.96C30.1096 75.86 30.1246 75.745 30.1546 75.615C30.1446 75.605 30.1196 75.585 30.0796 75.555C30.0396 75.515 30.0246 75.455 30.0346 75.375C29.8346 75.315 29.7396 75.155 29.7496 74.895C29.6696 74.855 29.6046 74.78 29.5546 74.67C29.5746 74.9 29.4846 75.08 29.2846 75.21C29.2946 75.32 29.2746 75.445 29.2246 75.585C29.1746 75.725 29.1146 75.83 29.0446 75.9C29.0546 75.94 29.0596 76.005 29.0596 76.095C29.0596 76.325 28.9646 76.63 28.7746 77.01C28.7246 77.12 28.6846 77.22 28.6546 77.31C28.6146 77.41 28.5696 77.51 28.5196 77.61C28.4796 77.71 28.4246 77.785 28.3546 77.835C28.3546 77.935 28.3346 78.025 28.2946 78.105L28.4146 78.09C28.5146 78.09 28.5896 78.115 28.6396 78.165C28.6696 78.115 28.7296 78.09 28.8196 78.09C28.8796 78.09 28.9246 78.105 28.9546 78.135C29.0746 78.045 29.2246 78 29.4046 78C29.5346 78 29.6546 78.02 29.7646 78.06C29.8746 78.1 29.9646 78.155 30.0346 78.225C30.1346 78.115 30.2396 78.06 30.3496 78.06C30.4196 78.06 30.5046 78.09 30.6046 78.15Z"
      fill="#404040"
    />
    <path
      d="M42.9191 81.36C42.9791 81.42 43.0091 81.495 43.0091 81.585C43.0091 81.655 42.9841 81.715 42.9341 81.765C42.9841 81.855 43.0091 81.945 43.0091 82.035C43.0091 82.115 42.9891 82.195 42.9491 82.275C42.9691 82.395 42.9791 82.47 42.9791 82.5C42.9791 82.64 42.8991 82.77 42.7391 82.89C42.6191 82.98 42.4841 83.025 42.3341 83.025C42.1441 83.025 41.9741 82.96 41.8241 82.83C41.6841 82.81 41.5641 82.735 41.4641 82.605C41.3741 82.465 41.3441 82.31 41.3741 82.14C41.3241 82.1 41.2641 82.06 41.1941 82.02C41.1241 81.97 41.0641 81.92 41.0141 81.87C40.9741 81.81 40.9441 81.74 40.9241 81.66C40.8041 81.62 40.7091 81.55 40.6391 81.45C40.5691 81.34 40.5341 81.22 40.5341 81.09C40.5341 81.04 40.5391 81 40.5491 80.97C40.4191 80.95 40.3091 80.89 40.2191 80.79C40.1391 80.68 40.0941 80.56 40.0841 80.43C39.8841 80.33 39.7391 80.245 39.6491 80.175C39.5591 80.105 39.5041 79.995 39.4841 79.845C39.3841 79.795 39.2841 79.695 39.1841 79.545C39.0841 79.395 39.0241 79.26 39.0041 79.14C38.8241 79.05 38.7191 78.9 38.6891 78.69C38.5991 78.65 38.4991 78.555 38.3891 78.405C38.2791 78.245 38.2191 78.105 38.2091 77.985C38.0691 77.935 37.9341 77.82 37.8041 77.64C37.6741 77.45 37.5991 77.26 37.5791 77.07C37.4991 77.03 37.4041 76.93 37.2941 76.77C37.1841 76.6 37.1141 76.46 37.0841 76.35C37.0041 76.27 36.9141 76.14 36.8141 75.96C36.7141 75.77 36.6491 75.605 36.6191 75.465C36.5391 75.405 36.4541 75.295 36.3641 75.135C36.2741 74.975 36.2141 74.835 36.1841 74.715C36.2041 74.775 36.2141 74.86 36.2141 74.97C36.2141 75.1 36.1991 75.18 36.1691 75.21C36.2291 75.45 36.2591 75.65 36.2591 75.81C36.2591 75.87 36.2491 75.94 36.2291 76.02C36.2691 76.11 36.2891 76.245 36.2891 76.425C36.2891 76.585 36.2741 76.71 36.2441 76.8C36.3041 76.87 36.3341 76.99 36.3341 77.16C36.3341 77.31 36.3091 77.435 36.2591 77.535C36.3191 77.635 36.3491 77.735 36.3491 77.835C36.3491 77.945 36.3191 78.06 36.2591 78.18C36.2091 78.3 36.1791 78.375 36.1691 78.405C36.2591 78.535 36.3041 78.755 36.3041 79.065C36.3041 79.245 36.2791 79.4 36.2291 79.53C36.3091 79.66 36.3491 79.79 36.3491 79.92C36.3491 80.06 36.2941 80.26 36.1841 80.52C36.2841 80.62 36.3341 80.76 36.3341 80.94C36.3341 81.14 36.2791 81.34 36.1691 81.54C36.1791 81.63 36.1941 81.755 36.2141 81.915C36.2441 82.075 36.2591 82.205 36.2591 82.305C36.2591 82.735 36.0591 82.95 35.6591 82.95C35.4991 82.95 35.3641 82.895 35.2541 82.785C35.1541 82.675 35.0941 82.54 35.0741 82.38C35.0141 82.24 34.9841 82.09 34.9841 81.93C34.9841 81.77 35.0091 81.625 35.0591 81.495C35.0091 81.315 34.9841 81.145 34.9841 80.985C34.9841 80.855 34.9991 80.745 35.0291 80.655C34.9991 80.545 34.9841 80.45 34.9841 80.37C34.9841 80.22 35.0141 80.07 35.0741 79.92C34.9941 79.79 34.9541 79.625 34.9541 79.425C34.9541 79.205 35.0041 79.035 35.1041 78.915C35.0241 78.725 34.9841 78.545 34.9841 78.375C34.9841 78.175 35.0291 77.995 35.1191 77.835C35.0791 77.735 35.0591 77.655 35.0591 77.595C35.0591 77.565 35.0691 77.51 35.0891 77.43C34.9591 77.3 34.8941 77.09 34.8941 76.8C34.8941 76.65 34.9091 76.505 34.9391 76.365C34.9791 76.225 35.0241 76.125 35.0741 76.065C34.9641 75.865 34.9091 75.61 34.9091 75.3C34.9091 75.1 34.9391 74.94 34.9991 74.82C34.9391 74.71 34.9091 74.57 34.9091 74.4C34.9091 74.19 34.9491 74.02 35.0291 73.89C34.9991 73.81 34.9841 73.695 34.9841 73.545C34.9841 73.405 34.9991 73.31 35.0291 73.26C35.0291 73.01 35.1091 72.815 35.2691 72.675C35.4291 72.535 35.6191 72.465 35.8391 72.465C36.0591 72.465 36.2441 72.54 36.3941 72.69C36.5541 72.84 36.6241 73.04 36.6041 73.29C36.8341 73.32 37.0491 73.46 37.2491 73.71C37.4491 73.96 37.5441 74.23 37.5341 74.52C37.6641 74.61 37.7891 74.745 37.9091 74.925C38.0391 75.105 38.1091 75.27 38.1191 75.42C38.2491 75.52 38.3891 75.7 38.5391 75.96C38.6891 76.22 38.7691 76.45 38.7791 76.65C38.8991 76.66 39.0241 76.775 39.1541 76.995C39.2941 77.215 39.3741 77.4 39.3941 77.55C39.4941 77.59 39.5941 77.69 39.6941 77.85C39.7941 78.01 39.8441 78.15 39.8441 78.27C39.9241 78.29 39.9941 78.37 40.0541 78.51C40.1241 78.65 40.1491 78.76 40.1291 78.84C40.3791 78.94 40.5291 79.115 40.5791 79.365C40.6891 79.355 40.8091 79.42 40.9391 79.56C41.0691 79.7 41.1491 79.84 41.1791 79.98C41.2791 80.02 41.3841 80.11 41.4941 80.25C41.6141 80.38 41.6891 80.505 41.7191 80.625C41.6891 80.475 41.6741 80.365 41.6741 80.295C41.6741 80.225 41.6991 80.165 41.7491 80.115C41.6491 80.005 41.5991 79.845 41.5991 79.635C41.5991 79.525 41.6141 79.435 41.6441 79.365C41.5741 79.245 41.5391 79.135 41.5391 79.035C41.5391 78.945 41.5641 78.85 41.6141 78.75C41.5141 78.66 41.4641 78.505 41.4641 78.285C41.4641 78.185 41.4791 78.105 41.5091 78.045C41.4291 77.885 41.3891 77.705 41.3891 77.505C41.3891 77.445 41.3991 77.355 41.4191 77.235C41.3091 77.105 41.2541 76.895 41.2541 76.605C41.2541 76.365 41.2941 76.19 41.3741 76.08C41.3241 76.01 41.2791 75.915 41.2391 75.795C41.2091 75.665 41.1941 75.545 41.1941 75.435C41.1941 75.245 41.2341 75.1 41.3141 75C41.2241 74.91 41.1791 74.785 41.1791 74.625C41.1791 74.515 41.2041 74.375 41.2541 74.205C41.1541 74.055 41.1041 73.875 41.1041 73.665C41.1041 73.505 41.1341 73.38 41.1941 73.29C41.1441 73.16 41.1191 73.045 41.1191 72.945C41.1191 72.745 41.2191 72.605 41.4191 72.525C41.5291 72.485 41.6291 72.465 41.7191 72.465C41.8891 72.465 42.0091 72.53 42.0791 72.66C42.1591 72.79 42.1991 72.945 42.1991 73.125C42.1991 73.225 42.1941 73.295 42.1841 73.335C42.2641 73.395 42.3291 73.505 42.3791 73.665C42.4291 73.825 42.4541 73.99 42.4541 74.16C42.4541 74.31 42.4341 74.42 42.3941 74.49C42.4641 74.65 42.4991 74.86 42.4991 75.12C42.4991 75.34 42.4741 75.495 42.4241 75.585C42.4841 75.705 42.5141 75.88 42.5141 76.11C42.5141 76.29 42.4941 76.42 42.4541 76.5C42.5041 76.58 42.5441 76.69 42.5741 76.83C42.6141 76.96 42.6341 77.085 42.6341 77.205C42.6341 77.375 42.5991 77.495 42.5291 77.565C42.5991 77.625 42.6541 77.725 42.6941 77.865C42.7341 78.005 42.7541 78.15 42.7541 78.3C42.7541 78.43 42.7391 78.54 42.7091 78.63C42.7891 78.76 42.8291 78.915 42.8291 79.095C42.8291 79.245 42.8041 79.35 42.7541 79.41C42.7841 79.47 42.8091 79.57 42.8291 79.71C42.8491 79.85 42.8491 79.95 42.8291 80.01C42.9291 80.08 42.9791 80.225 42.9791 80.445C42.9791 80.615 42.9441 80.75 42.8741 80.85C42.9241 80.98 42.9491 81.085 42.9491 81.165C42.9491 81.195 42.9391 81.26 42.9191 81.36Z"
      fill="#404040"
    />
    <path
      d="M55.6195 77.925C55.6595 78.035 55.6795 78.16 55.6795 78.3C55.6795 78.46 55.6545 78.62 55.6045 78.78C55.5645 78.93 55.5095 79.045 55.4395 79.125C55.5295 79.215 55.5745 79.415 55.5745 79.725C55.5745 80.025 55.5295 80.235 55.4395 80.355C55.4895 80.405 55.5295 80.495 55.5595 80.625C55.5895 80.755 55.6045 80.9 55.6045 81.06C55.6045 81.36 55.5495 81.595 55.4395 81.765C55.4995 81.955 55.5295 82.125 55.5295 82.275C55.5295 82.505 55.4695 82.68 55.3495 82.8C55.2295 82.92 55.0895 82.98 54.9295 82.98C54.7895 82.98 54.6645 82.93 54.5545 82.83C54.4445 82.73 54.3895 82.595 54.3895 82.425C54.3895 82.335 54.4045 82.245 54.4345 82.155C54.3045 81.925 54.2395 81.665 54.2395 81.375C54.2395 81.085 54.3045 80.875 54.4345 80.745C54.3345 80.645 54.2845 80.505 54.2845 80.325C54.2845 80.155 54.3345 80.02 54.4345 79.92C54.3345 79.72 54.2845 79.495 54.2845 79.245C54.2845 78.995 54.3345 78.825 54.4345 78.735C54.3345 78.535 54.2845 78.27 54.2845 77.94C54.2845 77.61 54.3345 77.4 54.4345 77.31C54.2945 77.12 54.2245 76.895 54.2245 76.635C54.2245 76.405 54.2945 76.225 54.4345 76.095C54.3945 76.045 54.3745 75.975 54.3745 75.885C54.3745 75.815 54.3845 75.725 54.4045 75.615C54.4245 75.495 54.4345 75.385 54.4345 75.285C54.4345 75.545 54.3745 75.885 54.2545 76.305C54.1345 76.715 53.9695 76.995 53.7595 77.145C53.7595 77.805 53.6345 78.19 53.3845 78.3C53.3845 78.52 53.3445 78.78 53.2645 79.08C53.1845 79.37 53.1045 79.515 53.0245 79.515C53.0245 79.635 52.9745 79.77 52.8745 79.92C52.7845 80.06 52.6945 80.13 52.6045 80.13C52.6345 80.23 52.6495 80.34 52.6495 80.46C52.6495 80.6 52.6245 80.735 52.5745 80.865C52.5345 80.985 52.4795 81.08 52.4095 81.15C52.4095 81.33 52.3745 81.48 52.3045 81.6C52.2345 81.72 52.1395 81.835 52.0195 81.945C52.0195 82.135 51.9545 82.285 51.8245 82.395C51.6945 82.505 51.5445 82.56 51.3745 82.56C51.2145 82.56 51.0745 82.51 50.9545 82.41C50.8345 82.3 50.7745 82.15 50.7745 81.96C50.7745 81.87 50.7795 81.805 50.7895 81.765C50.6895 81.765 50.5945 81.68 50.5045 81.51C50.4245 81.33 50.3845 81.14 50.3845 80.94C50.2945 80.94 50.1995 80.865 50.0995 80.715C49.9995 80.555 49.9195 80.38 49.8595 80.19C49.7995 79.99 49.7845 79.84 49.8145 79.74C49.7345 79.68 49.6545 79.565 49.5745 79.395C49.5045 79.225 49.4695 79.045 49.4695 78.855C49.4695 78.655 49.5095 78.48 49.5895 78.33C49.4595 78.32 49.3445 78.23 49.2445 78.06C49.1545 77.88 49.1095 77.705 49.1095 77.535C49.1095 77.435 49.1345 77.36 49.1845 77.31C49.0845 77.23 48.9895 77.1 48.8995 76.92C48.8195 76.74 48.7795 76.595 48.7795 76.485C48.6495 76.355 48.5845 76.09 48.5845 75.69C48.4445 75.69 48.3245 75.565 48.2245 75.315C48.2445 75.505 48.2245 75.695 48.1645 75.885C48.1145 76.065 48.0445 76.2 47.9545 76.29C48.0445 76.37 48.1145 76.525 48.1645 76.755C48.2145 76.975 48.2395 77.2 48.2395 77.43C48.2395 77.64 48.2195 77.79 48.1795 77.88C48.2795 78.04 48.3295 78.285 48.3295 78.615C48.3295 78.985 48.2795 79.285 48.1795 79.515C48.2595 79.685 48.2995 79.855 48.2995 80.025C48.2995 80.175 48.2595 80.345 48.1795 80.535C48.2195 80.575 48.2545 80.675 48.2845 80.835C48.3145 80.985 48.3295 81.15 48.3295 81.33C48.3295 81.67 48.2795 81.875 48.1795 81.945C48.1895 82.005 48.1945 82.085 48.1945 82.185C48.1945 82.445 48.1295 82.645 47.9995 82.785C47.8795 82.925 47.7295 82.995 47.5495 82.995C47.3695 82.995 47.2095 82.925 47.0695 82.785C46.9295 82.645 46.8595 82.46 46.8595 82.23C46.8595 82.06 46.9045 81.87 46.9945 81.66C46.8745 81.25 46.8145 80.865 46.8145 80.505C46.8145 80.175 46.8595 79.92 46.9495 79.74C46.8495 79.61 46.7995 79.405 46.7995 79.125C46.7995 78.995 46.8145 78.875 46.8445 78.765C46.8745 78.645 46.9095 78.56 46.9495 78.51C46.8495 78.28 46.7995 78.05 46.7995 77.82C46.7995 77.58 46.8495 77.41 46.9495 77.31C46.8995 77.24 46.8595 77.15 46.8295 77.04C46.7995 76.93 46.7845 76.815 46.7845 76.695C46.7845 76.515 46.8145 76.38 46.8745 76.29C46.7745 76.12 46.7245 75.9 46.7245 75.63C46.7245 75.28 46.7995 75.03 46.9495 74.88C46.8095 74.74 46.7395 74.455 46.7395 74.025C46.7395 73.825 46.7595 73.635 46.7995 73.455C46.8395 73.265 46.8895 73.14 46.9495 73.08C46.9495 72.89 47.0195 72.735 47.1595 72.615C47.2995 72.495 47.4595 72.435 47.6395 72.435C47.8495 72.435 48.0295 72.51 48.1795 72.66C48.3795 72.66 48.5595 72.75 48.7195 72.93C48.8895 73.11 48.9745 73.295 48.9745 73.485C49.0445 73.545 49.1045 73.63 49.1545 73.74C49.2045 73.84 49.2295 73.945 49.2295 74.055C49.2295 74.135 49.2145 74.215 49.1845 74.295C49.3045 74.305 49.3995 74.375 49.4695 74.505C49.5495 74.635 49.5895 74.76 49.5895 74.88C49.6695 74.95 49.7345 75.05 49.7845 75.18C49.8445 75.3 49.8745 75.425 49.8745 75.555C49.8745 75.675 49.8545 75.79 49.8145 75.9C49.8645 75.9 49.9095 75.945 49.9495 76.035C49.9995 76.115 50.0245 76.205 50.0245 76.305C50.0245 76.385 50.0045 76.445 49.9645 76.485C50.0745 76.545 50.1695 76.67 50.2495 76.86C50.3395 77.04 50.3845 77.19 50.3845 77.31C50.4545 77.38 50.5095 77.495 50.5495 77.655C50.5995 77.815 50.6245 77.98 50.6245 78.15C50.6245 78.28 50.6095 78.4 50.5795 78.51C50.6795 78.58 50.7745 78.725 50.8645 78.945C50.9545 79.155 50.9995 79.36 50.9995 79.56C50.9995 79.64 50.9945 79.7 50.9845 79.74C51.1045 79.83 51.1895 79.915 51.2395 79.995C51.2995 80.075 51.3495 80.195 51.3895 80.355C51.4095 79.915 51.5045 79.65 51.6745 79.56C51.6545 79.48 51.6445 79.42 51.6445 79.38C51.6445 79.23 51.6795 79.085 51.7495 78.945C51.8295 78.805 51.9195 78.735 52.0195 78.735C51.9695 78.635 51.9445 78.55 51.9445 78.48C51.9445 78.26 52.0995 77.98 52.4095 77.64C52.3795 77.58 52.3645 77.5 52.3645 77.4C52.3645 77.23 52.3995 77.055 52.4695 76.875C52.5495 76.695 52.6595 76.565 52.7995 76.485C52.7995 76.185 52.8195 75.935 52.8595 75.735C52.9095 75.525 53.0245 75.375 53.2045 75.285C53.2045 75.105 53.2445 74.96 53.3245 74.85C53.4145 74.73 53.5195 74.67 53.6395 74.67C53.5895 74.59 53.5645 74.485 53.5645 74.355C53.5645 74.145 53.6095 73.93 53.6995 73.71C53.7995 73.49 53.9145 73.34 54.0445 73.26C54.0445 73.04 54.1045 72.85 54.2245 72.69C54.3545 72.53 54.5545 72.45 54.8245 72.45C54.8745 72.43 54.9445 72.42 55.0345 72.42C55.2345 72.42 55.3795 72.51 55.4695 72.69C55.5695 72.86 55.6195 73.015 55.6195 73.155C55.7095 73.465 55.7545 73.7 55.7545 73.86C55.7545 74.01 55.7095 74.245 55.6195 74.565C55.7095 74.665 55.7545 74.81 55.7545 75C55.7545 75.18 55.7095 75.375 55.6195 75.585C55.7095 75.685 55.7545 75.85 55.7545 76.08C55.7545 76.32 55.7045 76.5 55.6045 76.62C55.7345 76.79 55.7995 77.005 55.7995 77.265C55.7995 77.525 55.7395 77.745 55.6195 77.925Z"
      fill="#404040"
    />
    <path
      d="M62.115 72.495C62.215 72.425 62.345 72.39 62.505 72.39C62.735 72.39 62.965 72.465 63.195 72.615C63.305 72.615 63.395 72.66 63.465 72.75C63.535 72.84 63.57 72.95 63.57 73.08C63.57 73.25 63.52 73.4 63.42 73.53C63.32 73.66 63.18 73.725 63 73.725C62.87 73.725 62.73 73.685 62.58 73.605C62.5 73.685 62.395 73.725 62.265 73.725C62.125 73.725 61.98 73.675 61.83 73.575C61.73 73.625 61.58 73.65 61.38 73.65C61.09 73.65 60.865 73.605 60.705 73.515C60.555 73.585 60.4 73.62 60.24 73.62C60.11 73.62 59.985 73.6 59.865 73.56C59.735 73.61 59.61 73.635 59.49 73.635C59.33 73.635 59.17 73.59 59.01 73.5C58.83 73.6 58.67 73.66 58.53 73.68C58.6 73.85 58.635 74.035 58.635 74.235C58.635 74.485 58.58 74.685 58.47 74.835C58.59 75.025 58.65 75.235 58.65 75.465C58.65 75.645 58.605 75.825 58.515 76.005C58.605 76.105 58.65 76.23 58.65 76.38C58.65 76.48 58.615 76.6 58.545 76.74C58.635 76.69 58.745 76.665 58.875 76.665C58.975 76.665 59.045 76.675 59.085 76.695C59.195 76.615 59.315 76.575 59.445 76.575C59.575 76.575 59.705 76.63 59.835 76.74C59.955 76.71 60.055 76.695 60.135 76.695C60.185 76.695 60.27 76.705 60.39 76.725C60.51 76.705 60.595 76.695 60.645 76.695C60.815 76.695 60.94 76.735 61.02 76.815C61.1 76.765 61.19 76.74 61.29 76.74C61.41 76.74 61.485 76.765 61.515 76.815C61.605 76.785 61.675 76.77 61.725 76.77C61.795 76.77 61.89 76.79 62.01 76.83C62.14 76.76 62.265 76.725 62.385 76.725C62.555 76.725 62.7 76.79 62.82 76.92C62.94 77.04 63 77.175 63 77.325C63 77.455 62.955 77.565 62.865 77.655C62.775 77.745 62.635 77.795 62.445 77.805C62.355 77.925 62.205 77.985 61.995 77.985C61.805 77.985 61.635 77.935 61.485 77.835C61.385 77.935 61.24 77.985 61.05 77.985C60.88 77.985 60.74 77.945 60.63 77.865C60.55 77.925 60.465 77.955 60.375 77.955C60.315 77.955 60.265 77.935 60.225 77.895C60.115 77.995 59.965 78.045 59.775 78.045C59.635 78.045 59.505 78.015 59.385 77.955C59.285 78.005 59.2 78.03 59.13 78.03C59.03 78.03 58.93 77.995 58.83 77.925C58.76 77.965 58.705 77.99 58.665 78C58.625 78.01 58.57 78.01 58.5 78C58.59 78.18 58.635 78.32 58.635 78.42C58.635 78.51 58.605 78.615 58.545 78.735C58.615 78.815 58.65 78.915 58.65 79.035C58.65 79.125 58.625 79.22 58.575 79.32C58.645 79.4 58.68 79.505 58.68 79.635C58.68 79.755 58.645 79.855 58.575 79.935C58.635 80.055 58.665 80.15 58.665 80.22C58.665 80.28 58.625 80.38 58.545 80.52C58.585 80.56 58.605 80.615 58.605 80.685C58.605 80.775 58.575 80.835 58.515 80.865C58.615 80.955 58.665 81.07 58.665 81.21C58.665 81.26 58.655 81.345 58.635 81.465L58.725 81.45C58.835 81.45 58.95 81.5 59.07 81.6C59.22 81.49 59.415 81.435 59.655 81.435C59.745 81.435 59.84 81.445 59.94 81.465C60 81.395 60.085 81.34 60.195 81.3C60.305 81.26 60.425 81.24 60.555 81.24C60.765 81.24 60.925 81.285 61.035 81.375C61.095 81.275 61.2 81.195 61.35 81.135C61.5 81.075 61.65 81.045 61.8 81.045C61.91 81.045 62 81.06 62.07 81.09C62.18 81.03 62.28 81 62.37 81C62.53 81 62.67 81.065 62.79 81.195C62.91 81.325 62.97 81.475 62.97 81.645C62.97 81.855 62.875 82.02 62.685 82.14C62.645 82.22 62.565 82.29 62.445 82.35C62.325 82.4 62.195 82.425 62.055 82.425C61.915 82.425 61.805 82.4 61.725 82.35C61.645 82.43 61.54 82.5 61.41 82.56C61.28 82.61 61.15 82.635 61.02 82.635C60.82 82.635 60.665 82.58 60.555 82.47C60.385 82.65 60.165 82.74 59.895 82.74C59.845 82.74 59.76 82.73 59.64 82.71C59.44 82.83 59.245 82.89 59.055 82.89C58.905 82.89 58.775 82.85 58.665 82.77C58.555 82.94 58.395 83.025 58.185 83.025C58.005 83.025 57.845 82.955 57.705 82.815C57.575 82.675 57.53 82.51 57.57 82.32C57.51 82.26 57.465 82.17 57.435 82.05C57.405 81.93 57.39 81.81 57.39 81.69C57.39 81.6 57.395 81.535 57.405 81.495C57.275 81.365 57.21 81.145 57.21 80.835C57.21 80.705 57.225 80.585 57.255 80.475C57.285 80.355 57.32 80.27 57.36 80.22C57.31 80.12 57.285 80.015 57.285 79.905C57.285 79.855 57.295 79.79 57.315 79.71C57.225 79.62 57.18 79.5 57.18 79.35C57.18 79.21 57.215 79.1 57.285 79.02C57.235 78.92 57.21 78.83 57.21 78.75C57.21 78.64 57.245 78.535 57.315 78.435C57.235 78.255 57.195 78.08 57.195 77.91C57.195 77.7 57.26 77.5 57.39 77.31C57.33 77.18 57.275 77.02 57.225 76.83C57.185 76.64 57.165 76.46 57.165 76.29C57.165 75.97 57.24 75.75 57.39 75.63C57.34 75.41 57.315 75.295 57.315 75.285C57.255 75.045 57.225 74.875 57.225 74.775C57.225 74.625 57.26 74.445 57.33 74.235C57.28 74.165 57.24 74.05 57.21 73.89C57.18 73.73 57.17 73.615 57.18 73.545C57.06 73.425 57 73.28 57 73.11C57 72.98 57.04 72.86 57.12 72.75C57.21 72.63 57.325 72.55 57.465 72.51C57.535 72.44 57.63 72.385 57.75 72.345C57.87 72.295 57.995 72.27 58.125 72.27C58.295 72.27 58.44 72.315 58.56 72.405C58.73 72.355 58.9 72.33 59.07 72.33C59.31 72.33 59.505 72.385 59.655 72.495C59.745 72.455 59.85 72.435 59.97 72.435C60.08 72.435 60.165 72.46 60.225 72.51C60.285 72.46 60.43 72.435 60.66 72.435C60.96 72.435 61.195 72.485 61.365 72.585C61.475 72.475 61.61 72.42 61.77 72.42C61.87 72.42 61.985 72.445 62.115 72.495Z"
      fill="#404040"
    />
    <path
      d="M64.7413 78.885C64.6913 78.785 64.6663 78.66 64.6663 78.51C64.6663 78.37 64.6913 78.265 64.7413 78.195C64.7213 78.145 64.7113 78.06 64.7113 77.94C64.7113 77.8 64.7313 77.66 64.7713 77.52C64.8113 77.38 64.8563 77.29 64.9063 77.25C64.8163 77.17 64.7713 76.995 64.7713 76.725C64.7713 76.605 64.7813 76.5 64.8013 76.41C64.8213 76.31 64.8513 76.25 64.8913 76.23C64.8413 76.13 64.8163 75.97 64.8163 75.75C64.8163 75.59 64.8313 75.445 64.8613 75.315C64.8913 75.175 64.9313 75.07 64.9813 75C64.8613 74.88 64.8013 74.715 64.8013 74.505C64.8013 74.375 64.8213 74.255 64.8613 74.145C64.9113 74.025 64.9713 73.935 65.0413 73.875C64.9513 73.745 64.9063 73.585 64.9063 73.395C64.9063 73.275 64.9313 73.13 64.9813 72.96C64.8813 72.83 64.8313 72.705 64.8313 72.585C64.8313 72.425 64.9013 72.29 65.0413 72.18C65.1813 72.06 65.3363 72 65.5063 72C65.6263 72 65.7313 72.04 65.8213 72.12C65.9213 72.19 65.9913 72.3 66.0313 72.45C66.1413 72.58 66.1963 72.72 66.1963 72.87C66.1963 72.97 66.1763 73.055 66.1363 73.125C66.1663 73.155 66.1813 73.4 66.1813 73.86C66.2013 73.94 66.2113 74.005 66.2113 74.055C66.2113 74.255 66.1663 74.47 66.0763 74.7C66.1363 74.78 66.1663 74.915 66.1663 75.105C66.1663 75.235 66.1463 75.365 66.1063 75.495C66.0763 75.615 66.0413 75.705 66.0013 75.765C66.0113 75.795 66.0263 75.85 66.0463 75.93C66.0663 76.01 66.0763 76.085 66.0763 76.155C66.0763 76.265 66.0513 76.36 66.0013 76.44C66.0713 76.54 66.1063 76.74 66.1063 77.04C66.1063 77.15 66.0963 77.245 66.0763 77.325C66.1163 77.375 66.1363 77.48 66.1363 77.64C66.1363 77.77 66.1163 77.9 66.0763 78.03C66.0463 78.15 65.9963 78.235 65.9263 78.285C65.9963 78.365 66.0313 78.475 66.0313 78.615C66.0313 78.745 66.0063 78.85 65.9563 78.93C66.0063 78.95 66.0313 79.02 66.0313 79.14C66.0313 79.21 66.0213 79.285 66.0013 79.365C65.9813 79.435 65.9563 79.475 65.9263 79.485C65.9463 79.565 65.9563 79.63 65.9563 79.68C65.9563 79.84 65.8963 79.985 65.7763 80.115C65.6663 80.235 65.5263 80.295 65.3563 80.295C65.1763 80.295 65.0263 80.23 64.9063 80.1C64.7863 79.96 64.7413 79.8 64.7713 79.62C64.7213 79.5 64.6963 79.34 64.6963 79.14C64.6963 79.03 64.7113 78.945 64.7413 78.885ZM64.8313 82.545C64.8313 82.725 64.8863 82.87 64.9963 82.98C65.1163 83.08 65.2563 83.13 65.4163 83.13C65.5563 83.13 65.6813 83.09 65.7913 83.01C65.9013 82.92 65.9713 82.795 66.0013 82.635C66.0913 82.515 66.1363 82.375 66.1363 82.215L66.1213 81.93C66.1013 81.66 65.9813 81.48 65.7613 81.39C65.6913 81.36 65.6163 81.345 65.5363 81.345C65.3763 81.345 65.2363 81.405 65.1163 81.525C64.9963 81.635 64.9363 81.775 64.9363 81.945C64.9363 81.995 64.9463 82.06 64.9663 82.14C64.8763 82.27 64.8313 82.405 64.8313 82.545Z"
      fill="#404040"
    />
    <rect x={15} y={4} width={44} height={44} fill="url(#pattern0-111)" />
    <defs>
      <pattern
        id="pattern0-111"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_1278_40815" transform="scale(0.000431034)" />
      </pattern>
      <image
        id="image0_1278_40815"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame8 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={83}
    height={96}
    viewBox="0 0 83 114"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-shopping.svg"
    role="img"
    {...props}
  >
    <path
      d="M0.0129935 25.5044C-0.275576 19.7907 4.2793 15 10.0003 15H72.9115C78.6523 15 83.2145 19.8227 82.8961 25.5547L78.5072 104.555C78.2128 109.854 73.8299 114 68.5226 114H13.9902C8.66337 114 4.27158 109.824 4.00289 104.504L0.0129935 25.5044Z"
      fill="#404040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.882 30C54.6932 30 59.2806 25.0635 58.8552 19.2678L58.121 9.26785C57.7375 4.04312 53.3867 1.66943e-06 48.1479 1.21144e-06L34.2907 0C29.0799 -4.55536e-07 24.7425 4.00126 24.3231 9.19508L23.5156 19.1951C23.0455 25.0163 27.6429 30 33.4831 30L48.882 30ZM47.18 25C50.6691 25 53.4224 22.0343 53.1635 18.5548L52.5682 10.5548C52.3352 7.42246 49.7258 5 46.5848 5L35.8089 5C32.685 5 30.0837 7.39703 29.8289 10.5106L29.1742 18.5106C28.8881 22.0056 31.6474 25 35.1542 25L47.18 25Z"
      fill="#404040"
    />
    <path
      d="M19.7464 103.676C19.0984 103.676 18.4904 103.588 17.9224 103.412C17.3544 103.236 16.8744 102.988 16.4824 102.668L16.9984 101.54C17.4064 101.852 17.8344 102.08 18.2824 102.224C18.7384 102.368 19.2304 102.44 19.7584 102.44C20.3424 102.44 20.7904 102.34 21.1024 102.14C21.4224 101.932 21.5824 101.644 21.5824 101.276C21.5824 100.956 21.4344 100.712 21.1384 100.544C20.8504 100.376 20.3664 100.216 19.6864 100.064C18.9824 99.912 18.4104 99.736 17.9704 99.536C17.5304 99.336 17.1984 99.08 16.9744 98.768C16.7504 98.456 16.6384 98.06 16.6384 97.58C16.6384 97.084 16.7744 96.64 17.0464 96.248C17.3184 95.856 17.7024 95.552 18.1984 95.336C18.6944 95.112 19.2664 95 19.9144 95C20.5064 95 21.0704 95.092 21.6064 95.276C22.1424 95.452 22.5824 95.696 22.9264 96.008L22.4104 97.136C21.6584 96.536 20.8264 96.236 19.9144 96.236C19.3704 96.236 18.9384 96.348 18.6184 96.572C18.3064 96.788 18.1504 97.092 18.1504 97.484C18.1504 97.812 18.2904 98.064 18.5704 98.24C18.8504 98.416 19.3264 98.58 19.9984 98.732C20.7104 98.892 21.2864 99.072 21.7264 99.272C22.1744 99.464 22.5144 99.712 22.7464 100.016C22.9864 100.32 23.1064 100.704 23.1064 101.168C23.1064 101.672 22.9704 102.116 22.6984 102.5C22.4344 102.876 22.0464 103.168 21.5344 103.376C21.0304 103.576 20.4344 103.676 19.7464 103.676Z"
      fill="white"
    />
    <path
      d="M27.7041 103.676C26.8721 103.676 26.1441 103.5 25.5201 103.148C24.9041 102.788 24.4281 102.28 24.0921 101.624C23.7641 100.968 23.6001 100.204 23.6001 99.332C23.6001 98.46 23.7641 97.7 24.0921 97.052C24.4281 96.396 24.9041 95.892 25.5201 95.54C26.1441 95.18 26.8721 95 27.7041 95C28.2721 95 28.8081 95.088 29.3121 95.264C29.8161 95.44 30.2401 95.688 30.5841 96.008L30.0681 97.136C29.6841 96.832 29.3041 96.612 28.9281 96.476C28.5521 96.332 28.1521 96.26 27.7281 96.26C26.9121 96.26 26.2801 96.524 25.8321 97.052C25.3921 97.58 25.1721 98.34 25.1721 99.332C25.1721 100.332 25.3921 101.096 25.8321 101.624C26.2801 102.152 26.9121 102.416 27.7281 102.416C28.1521 102.416 28.5521 102.348 28.9281 102.212C29.3041 102.068 29.6841 101.844 30.0681 101.54L30.5841 102.668C30.2401 102.988 29.8161 103.236 29.3121 103.412C28.8081 103.588 28.2721 103.676 27.7041 103.676Z"
      fill="white"
    />
    <path
      d="M37.6459 103.568L36.7939 101.588H32.6779L31.8259 103.568H30.2659L34.0939 95.108H35.3539L39.1819 103.568H37.6459ZM33.1819 100.388H36.2779L34.7299 96.788L33.1819 100.388Z"
      fill="white"
    />
    <path
      d="M45.1055 95.108H46.5575V103.568H45.3935L40.8575 97.664V103.568H39.4175V95.108H40.5695L45.1055 101V95.108Z"
      fill="white"
    />
    <path
      d="M57.3508 95.108H58.5628V103.568H57.1948V97.976L54.9628 102.2H53.9308L51.6868 98.036L51.6988 103.568H50.3308V95.108H51.5548L54.4588 100.64L57.3508 95.108Z"
      fill="white"
    />
    <path
      d="M59.73 103.568V95.108H65.394V96.332H61.242V98.66H65.154V99.872H61.242V102.344H65.394V103.568H59.73Z"
      fill="white"
    />
    <path
      d="M66.2497 101.024L65.7817 95.096L67.6297 95.108L67.1617 101.024H66.2497ZM65.8657 101.912H67.5457V103.568H65.8657V101.912Z"
      fill="white"
    />
    <rect
      width={64}
      height={64}
      transform="translate(9.48242 23)"
      fill="#404040"
    />
    <rect x={9.48242} y={23} width={64} height={64} fill="url(#pattern0-112)" />
    <defs>
      <pattern
        id="pattern0-112"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_1280_27412" transform="scale(0.000431034)" />
      </pattern>
      <image
        id="image0_1280_27412"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame9 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={80}
    height={96}
    viewBox="0 0 80 109"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-board.svg"
    role="img"
    {...props}
  >
    <path
      d="M1.25 13C1.25 11.4812 2.48122 10.25 4 10.25H76C77.5188 10.25 78.75 11.4812 78.75 13V105C78.75 106.519 77.5188 107.75 76 107.75H4C2.48122 107.75 1.25 106.519 1.25 105V13Z"
      fill="#FCFCFC"
      stroke="#404040"
      strokeWidth={2.5}
    />
    <rect x={8} y={20} width={64} height={64} fill="url(#pattern0-113)" />
    <path
      d="M17.264 100.676C16.616 100.676 16.008 100.588 15.44 100.412C14.872 100.236 14.392 99.988 14 99.668L14.516 98.54C14.924 98.852 15.352 99.08 15.8 99.224C16.256 99.368 16.748 99.44 17.276 99.44C17.86 99.44 18.308 99.34 18.62 99.14C18.94 98.932 19.1 98.644 19.1 98.276C19.1 97.956 18.952 97.712 18.656 97.544C18.368 97.376 17.884 97.216 17.204 97.064C16.5 96.912 15.928 96.736 15.488 96.536C15.048 96.336 14.716 96.08 14.492 95.768C14.268 95.456 14.156 95.06 14.156 94.58C14.156 94.084 14.292 93.64 14.564 93.248C14.836 92.856 15.22 92.552 15.716 92.336C16.212 92.112 16.784 92 17.432 92C18.024 92 18.588 92.092 19.124 92.276C19.66 92.452 20.1 92.696 20.444 93.008L19.928 94.136C19.176 93.536 18.344 93.236 17.432 93.236C16.888 93.236 16.456 93.348 16.136 93.572C15.824 93.788 15.668 94.092 15.668 94.484C15.668 94.812 15.808 95.064 16.088 95.24C16.368 95.416 16.844 95.58 17.516 95.732C18.228 95.892 18.804 96.072 19.244 96.272C19.692 96.464 20.032 96.712 20.264 97.016C20.504 97.32 20.624 97.704 20.624 98.168C20.624 98.672 20.488 99.116 20.216 99.5C19.952 99.876 19.564 100.168 19.052 100.376C18.548 100.576 17.952 100.676 17.264 100.676Z"
      fill="#404040"
    />
    <path
      d="M25.2217 100.676C24.3897 100.676 23.6617 100.5 23.0377 100.148C22.4217 99.788 21.9457 99.28 21.6097 98.624C21.2817 97.968 21.1177 97.204 21.1177 96.332C21.1177 95.46 21.2817 94.7 21.6097 94.052C21.9457 93.396 22.4217 92.892 23.0377 92.54C23.6617 92.18 24.3897 92 25.2217 92C25.7897 92 26.3257 92.088 26.8297 92.264C27.3337 92.44 27.7577 92.688 28.1017 93.008L27.5857 94.136C27.2017 93.832 26.8217 93.612 26.4457 93.476C26.0697 93.332 25.6697 93.26 25.2457 93.26C24.4297 93.26 23.7977 93.524 23.3497 94.052C22.9097 94.58 22.6897 95.34 22.6897 96.332C22.6897 97.332 22.9097 98.096 23.3497 98.624C23.7977 99.152 24.4297 99.416 25.2457 99.416C25.6697 99.416 26.0697 99.348 26.4457 99.212C26.8217 99.068 27.2017 98.844 27.5857 98.54L28.1017 99.668C27.7577 99.988 27.3337 100.236 26.8297 100.412C26.3257 100.588 25.7897 100.676 25.2217 100.676Z"
      fill="#404040"
    />
    <path
      d="M35.1635 100.568L34.3115 98.588H30.1955L29.3435 100.568H27.7835L31.6115 92.108H32.8715L36.6995 100.568H35.1635ZM30.6995 97.388H33.7955L32.2475 93.788L30.6995 97.388Z"
      fill="#404040"
    />
    <path
      d="M42.6231 92.108H44.0751V100.568H42.9111L38.3751 94.664V100.568H36.9351V92.108H38.0871L42.6231 98V92.108Z"
      fill="#404040"
    />
    <path
      d="M54.8684 92.108H56.0804V100.568H54.7124V94.976L52.4804 99.2H51.4484L49.2044 95.036L49.2164 100.568H47.8484V92.108H49.0724L51.9764 97.64L54.8684 92.108Z"
      fill="#404040"
    />
    <path
      d="M57.2476 100.568V92.108H62.9116V93.332H58.7596V95.66H62.6716V96.872H58.7596V99.344H62.9116V100.568H57.2476Z"
      fill="#404040"
    />
    <path
      d="M63.7673 98.024L63.2993 92.096L65.1473 92.108L64.6793 98.024H63.7673ZM63.3833 98.912H65.0633V100.568H63.3833V98.912Z"
      fill="#404040"
    />
    <path
      d="M21 10.25C21 7.62665 23.1266 5.5 25.75 5.5H54.25C56.8734 5.5 59 7.62665 59 10.25C59 12.8734 56.8734 15 54.25 15H25.75C23.1266 15 21 12.8734 21 10.25Z"
      fill="#404040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 10.25C42.6232 10.25 44.75 8.12335 44.75 5.5C44.75 2.87665 42.6232 0.75 40 0.75C37.3768 0.75 35.25 2.87665 35.25 5.5C35.25 8.12335 37.3768 10.25 40 10.25ZM40 7.875C41.3116 7.875 42.375 6.81169 42.375 5.5C42.375 4.18831 41.3116 3.125 40 3.125C38.6884 3.125 37.625 4.18831 37.625 5.5C37.625 6.81169 38.6884 7.875 40 7.875Z"
      fill="#404040"
    />
    <defs>
      <pattern
        id="pattern0-113"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_1278_40945" transform="scale(0.000431034)" />
      </pattern>
      <image
        id="image0_1278_40945"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame10 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={76}
    height={96}
    viewBox="0 0 76 100"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-envelope.svg"
    role="img"
    {...props}
  >
    <path
      d="M2 95.5667V51.394C2 50.6683 2.32395 49.9804 2.88345 49.5181L35.8757 22.2594C36.7638 21.5257 38.0447 21.5152 38.9447 22.2344L73.0857 49.5175C73.6636 49.9792 74 50.6787 74 51.4184V95.5667C74 96.9106 72.9106 98 71.5667 98H4.43333C3.08944 98 2 96.9106 2 95.5667Z"
      fill="#404040"
      stroke="#404040"
      strokeWidth={2.43333}
    />
    <path
      d="M7.215 4C7.215 2.46189 8.46189 1.215 10 1.215H66C67.5381 1.215 68.785 2.46189 68.785 4V80C68.785 81.5381 67.5381 82.785 66 82.785H10C8.46189 82.785 7.215 81.5381 7.215 80V4Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2.43}
    />
    <rect x={10} y={4} width={56} height={55} fill="url(#pattern0-114)" />
    <path
      d="M71.8348 96.0938L44.4898 75.5046C43.8177 74.9986 43.8497 73.9795 44.5523 73.5167L71.8973 55.5011C72.7063 54.9681 73.7833 55.5484 73.7833 56.5171V95.1219C73.7833 96.1255 72.6366 96.6975 71.8348 96.0938ZM4.16516 55.9062L31.5102 76.4954C32.1823 77.0014 32.1503 78.0205 31.4477 78.4834L4.1027 96.4989C3.29373 97.0319 2.21667 96.4517 2.21667 95.4829L2.21667 56.8781C2.21667 55.8745 3.36338 55.3025 4.16516 55.9062Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2.43333}
    />
    <path
      d="M2 95.5182V91.7332C2 90.9999 2.318 90.3041 2.86868 89.8325L35.8612 61.5811C36.7545 60.8162 38.0543 60.8053 38.9598 61.5552L73.1006 89.8315C73.6696 90.3028 74 91.0105 74 91.7581V95.5182C74 96.8889 72.9106 98 71.5667 98H4.43333C3.08944 98 2 96.8889 2 95.5182Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2.43333}
    />
    <path
      d="M19.6803 90C19.1481 90 18.6489 89.929 18.1825 89.787C17.716 89.645 17.3219 89.4449 17 89.1867L17.4237 88.2766C17.7587 88.5284 18.1102 88.7123 18.4781 88.8285C18.8525 88.9447 19.2565 89.0028 19.6901 89.0028C20.1697 89.0028 20.5375 88.9221 20.7937 88.7607C21.0565 88.5929 21.1879 88.3605 21.1879 88.0636C21.1879 87.8054 21.0664 87.6086 20.8233 87.473C20.5868 87.3375 20.1894 87.2084 19.631 87.0858C19.0529 86.9631 18.5832 86.8211 18.2219 86.6598C17.8606 86.4984 17.5879 86.2918 17.404 86.0401C17.2201 85.7884 17.1281 85.4689 17.1281 85.0816C17.1281 84.6814 17.2398 84.3232 17.4631 84.0069C17.6865 83.6906 18.0018 83.4454 18.4091 83.2711C18.8164 83.0904 19.2861 83 19.8182 83C20.3043 83 20.7675 83.0742 21.2076 83.2227C21.6478 83.3647 22.0091 83.5615 22.2915 83.8133L21.8678 84.7234C21.2503 84.2393 20.5671 83.9972 19.8182 83.9972C19.3715 83.9972 19.0168 84.0876 18.754 84.2683C18.4978 84.4426 18.3697 84.6879 18.3697 85.0041C18.3697 85.2688 18.4847 85.4721 18.7146 85.6141C18.9445 85.7561 19.3354 85.8884 19.8872 86.0111C20.4719 86.1402 20.9448 86.2854 21.3062 86.4467C21.674 86.6017 21.9532 86.8018 22.1437 87.047C22.3408 87.2923 22.4393 87.6021 22.4393 87.9765C22.4393 88.3831 22.3277 88.7414 22.1043 89.0512C21.8875 89.3545 21.5689 89.5901 21.1485 89.758C20.7346 89.9193 20.2452 90 19.6803 90Z"
      fill="#404040"
    />
    <path
      d="M26.2148 90C25.5316 90 24.9338 89.858 24.4214 89.574C23.9155 89.2835 23.5247 88.8737 23.2487 88.3444C22.9794 87.8151 22.8447 87.1987 22.8447 86.4952C22.8447 85.7916 22.9794 85.1784 23.2487 84.6556C23.5247 84.1263 23.9155 83.7197 24.4214 83.4357C24.9338 83.1452 25.5316 83 26.2148 83C26.6812 83 27.1213 83.071 27.5352 83.213C27.9491 83.355 28.2972 83.5551 28.5797 83.8133L28.156 84.7234C27.8407 84.4781 27.5286 84.3006 27.2199 84.1909C26.9111 84.0747 26.5826 84.0166 26.2345 84.0166C25.5644 84.0166 25.0454 84.2296 24.6776 84.6556C24.3163 85.0816 24.1356 85.6948 24.1356 86.4952C24.1356 87.302 24.3163 87.9184 24.6776 88.3444C25.0454 88.7704 25.5644 88.9834 26.2345 88.9834C26.5826 88.9834 26.9111 88.9285 27.2199 88.8188C27.5286 88.7026 27.8407 88.5219 28.156 88.2766L28.5797 89.1867C28.2972 89.4449 27.9491 89.645 27.5352 89.787C27.1213 89.929 26.6812 90 26.2148 90Z"
      fill="#404040"
    />
    <path
      d="M34.3786 89.9129L33.6789 88.3154H30.299L29.5994 89.9129H28.3184L31.4618 83.0871H32.4965L35.6399 89.9129H34.3786ZM30.7129 87.3472H33.2552L31.9841 84.4426L30.7129 87.3472Z"
      fill="#404040"
    />
    <path
      d="M40.504 83.0871H41.6964V89.9129H40.7405L37.0158 85.1494V89.9129H35.8333V83.0871H36.7793L40.504 87.8409V83.0871Z"
      fill="#404040"
    />
    <path
      d="M50.5594 83.0871H51.5546V89.9129H50.4313V85.4011L48.5985 88.8091H47.751L45.9083 85.4495L45.9182 89.9129H44.7949V83.0871H45.8L48.1846 87.5505L50.5594 83.0871Z"
      fill="#404040"
    />
    <path
      d="M52.5131 89.9129V83.0871H57.1641V84.0747H53.7547V85.953H56.967V86.9308H53.7547V88.9253H57.1641V89.9129H52.5131Z"
      fill="#404040"
    />
    <path
      d="M57.8668 87.8603L57.4825 83.0775L59 83.0871L58.6157 87.8603H57.8668ZM57.5515 88.5768H58.931V89.9129H57.5515V88.5768Z"
      fill="#404040"
    />
    <defs>
      <pattern
        id="pattern0-114"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1283_27443"
          transform="matrix(0.000431034 0 0 0.000438871 0 -0.00909087)"
        />
      </pattern>
      <image
        id="image0_1283_27443"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const Frame11 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={80}
    height={96}
    viewBox="0 0 80 111"
    fill="none"
    className="injected-svg"
    data-src="/svg/frame-receipt.svg"
    role="img"
    {...props}
  >
    <path
      d="M6.81755 104.903L1.215 108.707V4C1.215 2.46189 2.46189 1.215 4 1.215H76C77.5381 1.215 78.785 2.46189 78.785 4V108.614L73.7147 104.926L72.9073 104.338L72.1746 105.017L67.5 109.344L62.8254 105.017L62.1379 104.38L61.3476 104.883L54.0727 109.514L48.2493 104.952L47.5 104.365L46.7507 104.952L41.0307 109.433L35.7862 104.982L35.0307 104.341L34.2507 104.952L28.4729 109.478L22.2147 104.926L21.5 104.406L20.7853 104.926L14.5 109.498L8.21471 104.926L7.5241 104.423L6.81755 104.903Z"
      fill="white"
      stroke="#404040"
      strokeWidth={2.43}
    />
    <path
      d="M12.785 82.49C12.815 82.52 12.83 82.57 12.83 82.64C12.83 82.73 12.795 82.83 12.725 82.94C12.665 83.05 12.585 83.135 12.485 83.195C12.505 83.215 12.515 83.275 12.515 83.375C12.515 83.475 12.505 83.57 12.485 83.66C12.475 83.74 12.465 83.795 12.455 83.825C12.485 83.855 12.515 83.92 12.545 84.02C12.575 84.12 12.595 84.2 12.605 84.26C12.695 84.26 12.78 84.29 12.86 84.35C12.94 84.41 13 84.495 13.04 84.605C13.05 84.595 13.075 84.59 13.115 84.59C13.175 84.59 13.245 84.6 13.325 84.62C13.405 84.64 13.47 84.66 13.52 84.68C13.55 84.65 13.615 84.635 13.715 84.635C13.885 84.635 13.995 84.675 14.045 84.755C14.095 84.725 14.16 84.71 14.24 84.71C14.4 84.71 14.52 84.75 14.6 84.83C14.65 84.79 14.755 84.77 14.915 84.77C15.025 84.77 15.135 84.785 15.245 84.815C15.355 84.845 15.425 84.885 15.455 84.935C15.485 84.925 15.53 84.92 15.59 84.92C15.76 84.92 15.92 84.965 16.07 85.055C16.23 85.135 16.31 85.225 16.31 85.325C16.44 85.305 16.56 85.335 16.67 85.415C16.78 85.495 16.87 85.595 16.94 85.715C17.12 85.745 17.29 85.91 17.45 86.21C17.61 86.51 17.69 86.79 17.69 87.05C17.69 87.17 17.665 87.27 17.615 87.35C17.765 87.45 17.84 87.635 17.84 87.905C17.84 88.095 17.8 88.27 17.72 88.43C17.74 88.51 17.75 88.57 17.75 88.61C17.75 88.78 17.7 88.95 17.6 89.12C17.51 89.28 17.4 89.38 17.27 89.42C17.24 89.59 17.15 89.75 17 89.9C16.85 90.04 16.695 90.145 16.535 90.215C16.515 90.345 16.42 90.475 16.25 90.605C16.08 90.725 15.915 90.765 15.755 90.725C15.685 90.815 15.555 90.89 15.365 90.95C15.185 91 14.99 91.025 14.78 91.025C14.58 91.025 14.395 91 14.225 90.95C14.065 90.9 13.955 90.825 13.895 90.725C13.805 90.765 13.705 90.785 13.595 90.785C13.455 90.785 13.32 90.75 13.19 90.68C13.07 90.61 12.985 90.515 12.935 90.395C12.815 90.425 12.685 90.4 12.545 90.32C12.415 90.23 12.32 90.095 12.26 89.915C12.1 89.915 11.935 89.86 11.765 89.75C11.605 89.64 11.515 89.53 11.495 89.42C11.335 89.39 11.21 89.32 11.12 89.21C11.04 89.1 11 88.975 11 88.835C11 88.675 11.05 88.53 11.15 88.4C11.26 88.27 11.4 88.205 11.57 88.205C11.66 88.205 11.73 88.215 11.78 88.235C11.86 88.215 11.915 88.205 11.945 88.205C12.095 88.205 12.23 88.255 12.35 88.355C12.48 88.455 12.55 88.58 12.56 88.73C12.62 88.71 12.67 88.7 12.71 88.7C12.85 88.7 12.975 88.765 13.085 88.895C13.205 89.015 13.275 89.155 13.295 89.315C13.355 89.285 13.42 89.27 13.49 89.27C13.6 89.27 13.705 89.3 13.805 89.36C13.905 89.42 13.96 89.49 13.97 89.57C14.06 89.54 14.15 89.525 14.24 89.525C14.4 89.525 14.53 89.59 14.63 89.72C14.72 89.66 14.815 89.63 14.915 89.63C14.965 89.63 15.05 89.65 15.17 89.69C15.3 89.5 15.43 89.425 15.56 89.465C15.64 89.355 15.73 89.26 15.83 89.18C15.93 89.09 16.03 89.04 16.13 89.03C16.17 88.92 16.215 88.84 16.265 88.79C16.315 88.73 16.395 88.67 16.505 88.61C16.485 88.57 16.475 88.52 16.475 88.46C16.475 88.36 16.495 88.255 16.535 88.145C16.575 88.035 16.62 87.965 16.67 87.935C16.59 87.845 16.55 87.74 16.55 87.62C16.55 87.52 16.585 87.405 16.655 87.275C16.475 87.165 16.385 87.005 16.385 86.795C16.235 86.745 16.125 86.675 16.055 86.585C15.885 86.595 15.745 86.57 15.635 86.51C15.525 86.44 15.455 86.34 15.425 86.21C15.345 86.23 15.29 86.24 15.26 86.24C15.16 86.24 15.065 86.22 14.975 86.18C14.885 86.13 14.81 86.065 14.75 85.985C14.69 86.035 14.61 86.06 14.51 86.06C14.38 86.06 14.24 86.01 14.09 85.91C13.99 85.96 13.895 85.985 13.805 85.985C13.675 85.985 13.57 85.96 13.49 85.91C13.43 85.93 13.38 85.94 13.34 85.94C13.25 85.94 13.165 85.925 13.085 85.895C13.015 85.855 12.975 85.81 12.965 85.76C12.605 85.76 12.41 85.695 12.38 85.565C12.26 85.545 12.145 85.505 12.035 85.445C11.925 85.375 11.865 85.295 11.855 85.205C11.755 85.185 11.67 85.13 11.6 85.04C11.53 84.94 11.495 84.82 11.495 84.68C11.405 84.61 11.33 84.485 11.27 84.305C11.21 84.125 11.18 83.935 11.18 83.735C11.18 83.415 11.245 83.195 11.375 83.075C11.355 83.015 11.345 82.955 11.345 82.895C11.345 82.755 11.37 82.61 11.42 82.46C11.48 82.31 11.54 82.22 11.6 82.19C11.6 82.06 11.635 81.91 11.705 81.74C11.795 81.62 11.9 81.52 12.02 81.44C12.14 81.35 12.27 81.305 12.41 81.305C12.43 81.195 12.49 81.1 12.59 81.02C12.7 80.94 12.825 80.9 12.965 80.9C13.005 80.78 13.09 80.685 13.22 80.615C13.35 80.545 13.495 80.51 13.655 80.51C13.775 80.51 13.88 80.525 13.97 80.555C14 80.505 14.055 80.465 14.135 80.435C14.215 80.405 14.3 80.39 14.39 80.39C14.44 80.39 14.495 80.4 14.555 80.42C14.645 80.33 14.805 80.285 15.035 80.285C15.285 80.285 15.475 80.33 15.605 80.42C15.645 80.41 15.7 80.405 15.77 80.405C16.07 80.405 16.325 80.58 16.535 80.93C16.645 80.91 16.765 80.94 16.895 81.02C17.035 81.1 17.145 81.21 17.225 81.35C17.315 81.48 17.355 81.605 17.345 81.725C17.515 81.845 17.635 81.97 17.705 82.1C17.775 82.23 17.83 82.425 17.87 82.685C17.88 82.865 17.825 83.01 17.705 83.12C17.585 83.23 17.445 83.285 17.285 83.285C17.135 83.285 17.005 83.23 16.895 83.12C16.775 83.1 16.67 83.04 16.58 82.94C16.49 82.84 16.45 82.74 16.46 82.64C16.18 82.45 16.055 82.24 16.085 82.01C15.965 82.03 15.815 82 15.635 81.92C15.465 81.83 15.335 81.715 15.245 81.575C15.175 81.675 15.035 81.725 14.825 81.725C14.675 81.725 14.55 81.7 14.45 81.65C14.38 81.74 14.255 81.785 14.075 81.785C13.985 81.785 13.9 81.77 13.82 81.74C13.78 81.85 13.71 81.945 13.61 82.025C13.52 82.095 13.415 82.14 13.295 82.16C13.235 82.25 13.16 82.33 13.07 82.4C12.98 82.46 12.885 82.49 12.785 82.49Z"
      fill="#404040"
    />
    <path
      d="M25.4535 87.11C25.4935 87 25.5735 86.91 25.6935 86.84C25.8135 86.76 25.9384 86.72 26.0684 86.72C26.1084 86.72 26.1685 86.73 26.2485 86.75C26.5385 86.83 26.6835 87 26.6835 87.26C26.6835 87.49 26.5835 87.725 26.3835 87.965C26.4035 88.045 26.4135 88.115 26.4135 88.175C26.4135 88.305 26.3835 88.435 26.3235 88.565C26.2735 88.695 26.1985 88.815 26.0985 88.925C26.0685 89.085 26.0234 89.225 25.9635 89.345C25.9135 89.455 25.8335 89.585 25.7235 89.735C25.6035 89.895 25.4835 90.01 25.3635 90.08C25.2535 90.14 25.0985 90.2 24.8985 90.26C24.8485 90.4 24.7685 90.53 24.6585 90.65C24.5485 90.76 24.4135 90.815 24.2535 90.815C24.1735 90.815 24.0885 90.8 23.9985 90.77C23.9285 90.85 23.8285 90.915 23.6985 90.965C23.5785 91.005 23.4535 91.025 23.3235 91.025C23.1535 91.025 23.0185 90.99 22.9185 90.92C22.7985 90.97 22.6434 90.995 22.4535 90.995C22.2035 90.995 21.9634 90.955 21.7334 90.875C21.5035 90.795 21.3235 90.67 21.1934 90.5C20.9535 90.52 20.7535 90.465 20.5935 90.335C20.4535 90.255 20.3635 90.165 20.3235 90.065C19.9535 89.885 19.7734 89.555 19.7835 89.075C19.6034 88.955 19.4685 88.82 19.3785 88.67C19.2885 88.51 19.2185 88.31 19.1685 88.07C19.0885 87.99 19.0485 87.885 19.0485 87.755C19.0485 87.695 19.0534 87.645 19.0634 87.605C18.9734 87.515 18.9285 87.395 18.9285 87.245C18.9285 87.175 18.9434 87.105 18.9735 87.035C18.8335 86.885 18.7635 86.67 18.7635 86.39C18.7635 86.14 18.8184 85.945 18.9285 85.805C18.8584 85.705 18.8235 85.595 18.8235 85.475C18.8235 85.385 18.8485 85.29 18.8985 85.19C18.8485 85.13 18.8235 85.01 18.8235 84.83C18.8235 84.63 18.8535 84.43 18.9135 84.23C18.9735 84.02 19.0485 83.88 19.1385 83.81C19.1085 83.75 19.0935 83.665 19.0935 83.555C19.0935 83.395 19.1185 83.245 19.1685 83.105C19.2285 82.965 19.3084 82.89 19.4085 82.88C19.4085 82.67 19.4935 82.505 19.6635 82.385C19.6535 82.245 19.7035 82.09 19.8134 81.92C19.9334 81.75 20.0685 81.635 20.2185 81.575C20.2485 81.355 20.3385 81.17 20.4885 81.02C20.6384 80.87 20.8034 80.785 20.9834 80.765C21.0335 80.675 21.1235 80.6 21.2535 80.54C21.3935 80.47 21.5285 80.435 21.6585 80.435C21.7584 80.435 21.8435 80.455 21.9135 80.495C22.0635 80.355 22.2335 80.285 22.4235 80.285C22.5835 80.285 22.6884 80.325 22.7385 80.405C22.8184 80.385 22.8885 80.375 22.9485 80.375C23.1285 80.375 23.2635 80.44 23.3535 80.57C23.3935 80.54 23.4535 80.525 23.5335 80.525C23.6735 80.525 23.8285 80.565 23.9985 80.645C24.1784 80.715 24.2835 80.785 24.3135 80.855C24.5235 80.895 24.7135 81 24.8835 81.17C25.0535 81.33 25.1235 81.495 25.0935 81.665C25.2335 81.735 25.3335 81.835 25.3935 81.965C25.4535 82.085 25.4735 82.2 25.4535 82.31C25.5435 82.38 25.6035 82.47 25.6335 82.58C25.6635 82.68 25.6835 82.74 25.6935 82.76C25.8935 82.93 25.9935 83.145 25.9935 83.405C25.9935 83.455 25.9834 83.52 25.9635 83.6C25.9735 83.64 25.9785 83.69 25.9785 83.75C25.9785 83.92 25.9135 84.065 25.7835 84.185C25.6635 84.295 25.5235 84.35 25.3635 84.35C25.2035 84.35 25.0635 84.29 24.9435 84.17C24.6635 83.87 24.5085 83.57 24.4785 83.27C24.3585 83.23 24.2634 83.155 24.1934 83.045C24.1235 82.925 24.0935 82.795 24.1035 82.655C24.0135 82.595 23.9435 82.52 23.8935 82.43C23.8535 82.33 23.8385 82.23 23.8485 82.13C23.6685 82.13 23.5285 82.075 23.4285 81.965C23.3985 81.975 23.3435 81.98 23.2635 81.98C23.1535 81.98 23.0335 81.965 22.9035 81.935C22.7734 81.895 22.6735 81.85 22.6035 81.8C22.5635 81.81 22.5035 81.815 22.4235 81.815C22.3135 81.815 22.2385 81.805 22.1985 81.785C22.0685 81.865 21.9434 81.905 21.8235 81.905C21.7835 81.905 21.7135 81.895 21.6135 81.875C21.5035 81.965 21.3985 82.015 21.2985 82.025C21.2785 82.185 21.2334 82.33 21.1635 82.46C21.1034 82.59 21.0235 82.665 20.9235 82.685C20.9435 82.805 20.9235 82.925 20.8635 83.045C20.8034 83.155 20.7184 83.245 20.6084 83.315C20.5984 83.395 20.5735 83.475 20.5335 83.555C20.4935 83.625 20.4435 83.68 20.3835 83.72C20.3935 83.77 20.4035 83.83 20.4135 83.9C20.4235 83.96 20.4285 84.035 20.4285 84.125C20.4285 84.335 20.3385 84.5 20.1585 84.62C20.1585 84.75 20.1335 84.855 20.0835 84.935C20.1335 85.035 20.1585 85.135 20.1585 85.235C20.1585 85.335 20.1385 85.425 20.0985 85.505C20.1585 85.605 20.1884 85.7 20.1884 85.79C20.1884 85.88 20.1635 85.985 20.1135 86.105C20.0634 86.235 20.0335 86.355 20.0234 86.465C20.1135 86.515 20.1834 86.585 20.2334 86.675C20.2835 86.765 20.3085 86.86 20.3085 86.96C20.3085 87.07 20.2785 87.17 20.2185 87.26C20.2985 87.3 20.3584 87.37 20.3984 87.47C20.4384 87.57 20.4585 87.675 20.4585 87.785C20.4585 87.895 20.4384 87.985 20.3984 88.055C20.6185 88.175 20.7685 88.3 20.8485 88.43C20.9385 88.55 21.0035 88.745 21.0435 89.015C21.1135 89.045 21.1934 89.095 21.2835 89.165C21.3835 89.235 21.4485 89.295 21.4784 89.345C21.6484 89.335 21.8235 89.375 22.0035 89.465C22.1934 89.545 22.3235 89.655 22.3935 89.795C22.4535 89.745 22.5485 89.705 22.6785 89.675C22.8185 89.635 22.9535 89.615 23.0835 89.615C23.2235 89.615 23.3184 89.635 23.3685 89.675C23.5085 89.505 23.6785 89.42 23.8785 89.42C23.9385 89.42 23.9835 89.425 24.0135 89.435C24.1735 89.305 24.2985 89.215 24.3885 89.165C24.4785 89.105 24.5835 89.06 24.7035 89.03C24.7135 88.88 24.7735 88.735 24.8835 88.595C24.8935 88.515 24.9235 88.42 24.9735 88.31C25.0235 88.19 25.0735 88.1 25.1235 88.04C25.1135 88.01 25.1085 87.96 25.1085 87.89C25.1085 87.76 25.1435 87.62 25.2135 87.47C25.2835 87.31 25.3635 87.19 25.4535 87.11Z"
      fill="#404040"
    />
    <path
      d="M35.3646 89.405C35.3646 89.405 35.4496 89.44 35.6196 89.51C35.7996 89.58 35.8696 89.815 35.8296 90.215C35.8696 90.295 35.8896 90.385 35.8896 90.485C35.8896 90.645 35.8246 90.775 35.6946 90.875C35.5646 90.975 35.4146 91.025 35.2446 91.025C35.0946 91.025 34.9646 90.98 34.8546 90.89C34.7546 90.79 34.7046 90.65 34.7046 90.47C34.5946 90.45 34.4796 90.365 34.3596 90.215C34.2496 90.055 34.1946 89.895 34.1946 89.735C34.1946 89.695 34.2046 89.635 34.2246 89.555C34.1246 89.505 34.0346 89.405 33.9546 89.255C33.8846 89.095 33.8346 88.93 33.8046 88.76C33.7746 88.59 33.7646 88.47 33.7746 88.4C33.6446 88.34 33.5396 88.195 33.4596 87.965C33.3896 87.725 33.3646 87.52 33.3846 87.35C33.3146 87.38 33.2296 87.395 33.1296 87.395C32.9296 87.395 32.7446 87.335 32.5746 87.215C32.4446 87.345 32.2496 87.41 31.9896 87.41C31.7496 87.41 31.5796 87.35 31.4796 87.23C31.3496 87.34 31.2096 87.395 31.0596 87.395C30.9396 87.395 30.8446 87.37 30.7746 87.32C30.7046 87.37 30.5996 87.395 30.4596 87.395C30.3396 87.395 30.2196 87.375 30.0996 87.335C29.9796 87.295 29.8846 87.24 29.8146 87.17C29.8046 87.17 29.7796 87.18 29.7396 87.2C29.7996 87.39 29.8296 87.56 29.8296 87.71C29.8296 87.94 29.7146 88.14 29.4846 88.31C29.5246 88.39 29.5446 88.485 29.5446 88.595C29.5446 88.815 29.4696 89.025 29.3196 89.225C29.1696 89.425 29.0246 89.535 28.8846 89.555C28.9246 89.645 28.9446 89.75 28.9446 89.87C28.9446 90.14 28.8546 90.39 28.6746 90.62C28.4946 90.84 28.2746 90.95 28.0146 90.95C27.9446 90.95 27.8896 90.945 27.8496 90.935C27.7196 90.935 27.6196 90.895 27.5496 90.815C27.4796 90.735 27.4446 90.63 27.4446 90.5C27.4446 90.41 27.4696 90.305 27.5196 90.185C27.5096 90.145 27.5046 90.085 27.5046 90.005C27.5046 89.805 27.6046 89.63 27.8046 89.48C27.7946 89.45 27.7896 89.405 27.7896 89.345C27.7896 89.195 27.8246 89.045 27.8946 88.895C27.9746 88.735 28.0746 88.63 28.1946 88.58C28.1846 88.56 28.1796 88.515 28.1796 88.445C28.1796 88.275 28.2196 88.08 28.2996 87.86C28.3796 87.63 28.4696 87.5 28.5696 87.47C28.5496 87.03 28.6946 86.585 29.0046 86.135C29.0046 85.905 29.0396 85.69 29.1096 85.49C29.1796 85.28 29.3046 85.13 29.4846 85.04C29.4946 84.85 29.5396 84.66 29.6196 84.47C29.6996 84.28 29.7896 84.12 29.8896 83.99C29.8596 83.88 29.8446 83.78 29.8446 83.69C29.8446 83.55 29.8696 83.44 29.9196 83.36C29.9796 83.27 30.0446 83.215 30.1146 83.195C30.1046 83.155 30.0996 83.095 30.0996 83.015C30.0996 82.795 30.1796 82.62 30.3396 82.49L30.3246 82.4C30.3246 82.25 30.3846 82.115 30.5046 81.995C30.4946 81.955 30.4896 81.9 30.4896 81.83C30.4896 81.65 30.5346 81.47 30.6246 81.29C30.7146 81.11 30.8146 80.99 30.9246 80.93C31.1046 80.68 31.2946 80.555 31.4946 80.555C31.5846 80.555 31.6996 80.585 31.8396 80.645C32.1296 80.655 32.3396 80.88 32.4696 81.32C32.5596 81.43 32.6246 81.56 32.6646 81.71C32.7046 81.85 32.7196 81.98 32.7096 82.1C32.7996 82.16 32.8646 82.24 32.9046 82.34C32.9546 82.44 32.9746 82.545 32.9646 82.655C33.0646 82.745 33.1496 82.885 33.2196 83.075C33.2996 83.265 33.3396 83.445 33.3396 83.615C33.3396 83.695 33.3346 83.75 33.3246 83.78C33.3946 83.85 33.4546 83.95 33.5046 84.08C33.5646 84.21 33.5946 84.33 33.5946 84.44C33.5946 84.5 33.5896 84.545 33.5796 84.575C33.7096 84.665 33.8146 84.805 33.8946 84.995C33.9846 85.185 34.0446 85.375 34.0746 85.565C34.1146 85.745 34.1246 85.87 34.1046 85.94C34.1246 85.97 34.1796 86.045 34.2696 86.165C34.3596 86.275 34.4296 86.39 34.4796 86.51C34.5296 86.62 34.5546 86.725 34.5546 86.825C34.5546 86.915 34.5446 86.98 34.5246 87.02C34.5646 87.07 34.6096 87.13 34.6596 87.2C34.7096 87.26 34.7496 87.315 34.7796 87.365C34.8096 87.415 34.8246 87.475 34.8246 87.545C34.8246 87.615 34.8196 87.665 34.8096 87.695C34.8896 87.775 34.9596 87.88 35.0196 88.01C35.0796 88.14 35.1096 88.265 35.1096 88.385C35.1096 88.485 35.0896 88.56 35.0496 88.61C35.1596 88.69 35.2446 88.805 35.3046 88.955C35.3646 89.105 35.3846 89.255 35.3646 89.405ZM32.6046 86.15C32.6246 86.09 32.6696 86.055 32.7396 86.045C32.8096 86.025 32.8696 86.03 32.9196 86.06C32.8996 86 32.8896 85.955 32.8896 85.925C32.8896 85.845 32.9096 85.785 32.9496 85.745C32.8596 85.675 32.7846 85.585 32.7246 85.475C32.6746 85.365 32.6546 85.255 32.6646 85.145C32.5946 85.125 32.5296 85.075 32.4696 84.995C32.4196 84.905 32.3946 84.81 32.3946 84.71C32.3946 84.68 32.4046 84.625 32.4246 84.545C32.2146 84.415 32.1096 84.22 32.1096 83.96C32.1096 83.86 32.1246 83.745 32.1546 83.615C32.1446 83.605 32.1196 83.585 32.0796 83.555C32.0396 83.515 32.0246 83.455 32.0346 83.375C31.8346 83.315 31.7396 83.155 31.7496 82.895C31.6696 82.855 31.6046 82.78 31.5546 82.67C31.5746 82.9 31.4846 83.08 31.2846 83.21C31.2946 83.32 31.2746 83.445 31.2246 83.585C31.1746 83.725 31.1146 83.83 31.0446 83.9C31.0546 83.94 31.0596 84.005 31.0596 84.095C31.0596 84.325 30.9646 84.63 30.7746 85.01C30.7246 85.12 30.6846 85.22 30.6546 85.31C30.6146 85.41 30.5696 85.51 30.5196 85.61C30.4796 85.71 30.4246 85.785 30.3546 85.835C30.3546 85.935 30.3346 86.025 30.2946 86.105L30.4146 86.09C30.5146 86.09 30.5896 86.115 30.6396 86.165C30.6696 86.115 30.7296 86.09 30.8196 86.09C30.8796 86.09 30.9246 86.105 30.9546 86.135C31.0746 86.045 31.2246 86 31.4046 86C31.5346 86 31.6546 86.02 31.7646 86.06C31.8746 86.1 31.9646 86.155 32.0346 86.225C32.1346 86.115 32.2396 86.06 32.3496 86.06C32.4196 86.06 32.5046 86.09 32.6046 86.15Z"
      fill="#404040"
    />
    <path
      d="M44.9191 89.36C44.9791 89.42 45.0091 89.495 45.0091 89.585C45.0091 89.655 44.9841 89.715 44.9341 89.765C44.9841 89.855 45.0091 89.945 45.0091 90.035C45.0091 90.115 44.9891 90.195 44.9491 90.275C44.9691 90.395 44.9791 90.47 44.9791 90.5C44.9791 90.64 44.8991 90.77 44.7391 90.89C44.6191 90.98 44.4841 91.025 44.3341 91.025C44.1441 91.025 43.9741 90.96 43.8241 90.83C43.6841 90.81 43.5641 90.735 43.4641 90.605C43.3741 90.465 43.3441 90.31 43.3741 90.14C43.3241 90.1 43.2641 90.06 43.1941 90.02C43.1241 89.97 43.0641 89.92 43.0141 89.87C42.9741 89.81 42.9441 89.74 42.9241 89.66C42.8041 89.62 42.7091 89.55 42.6391 89.45C42.5691 89.34 42.5341 89.22 42.5341 89.09C42.5341 89.04 42.5391 89 42.5491 88.97C42.4191 88.95 42.3091 88.89 42.2191 88.79C42.1391 88.68 42.0941 88.56 42.0841 88.43C41.8841 88.33 41.7391 88.245 41.6491 88.175C41.5591 88.105 41.5041 87.995 41.4841 87.845C41.3841 87.795 41.2841 87.695 41.1841 87.545C41.0841 87.395 41.0241 87.26 41.0041 87.14C40.8241 87.05 40.7191 86.9 40.6891 86.69C40.5991 86.65 40.4991 86.555 40.3891 86.405C40.2791 86.245 40.2191 86.105 40.2091 85.985C40.0691 85.935 39.9341 85.82 39.8041 85.64C39.6741 85.45 39.5991 85.26 39.5791 85.07C39.4991 85.03 39.4041 84.93 39.2941 84.77C39.1841 84.6 39.1141 84.46 39.0841 84.35C39.0041 84.27 38.9141 84.14 38.8141 83.96C38.7141 83.77 38.6491 83.605 38.6191 83.465C38.5391 83.405 38.4541 83.295 38.3641 83.135C38.2741 82.975 38.2141 82.835 38.1841 82.715C38.2041 82.775 38.2141 82.86 38.2141 82.97C38.2141 83.1 38.1991 83.18 38.1691 83.21C38.2291 83.45 38.2591 83.65 38.2591 83.81C38.2591 83.87 38.2491 83.94 38.2291 84.02C38.2691 84.11 38.2891 84.245 38.2891 84.425C38.2891 84.585 38.2741 84.71 38.2441 84.8C38.3041 84.87 38.3341 84.99 38.3341 85.16C38.3341 85.31 38.3091 85.435 38.2591 85.535C38.3191 85.635 38.3491 85.735 38.3491 85.835C38.3491 85.945 38.3191 86.06 38.2591 86.18C38.2091 86.3 38.1791 86.375 38.1691 86.405C38.2591 86.535 38.3041 86.755 38.3041 87.065C38.3041 87.245 38.2791 87.4 38.2291 87.53C38.3091 87.66 38.3491 87.79 38.3491 87.92C38.3491 88.06 38.2941 88.26 38.1841 88.52C38.2841 88.62 38.3341 88.76 38.3341 88.94C38.3341 89.14 38.2791 89.34 38.1691 89.54C38.1791 89.63 38.1941 89.755 38.2141 89.915C38.2441 90.075 38.2591 90.205 38.2591 90.305C38.2591 90.735 38.0591 90.95 37.6591 90.95C37.4991 90.95 37.3641 90.895 37.2541 90.785C37.1541 90.675 37.0941 90.54 37.0741 90.38C37.0141 90.24 36.9841 90.09 36.9841 89.93C36.9841 89.77 37.0091 89.625 37.0591 89.495C37.0091 89.315 36.9841 89.145 36.9841 88.985C36.9841 88.855 36.9991 88.745 37.0291 88.655C36.9991 88.545 36.9841 88.45 36.9841 88.37C36.9841 88.22 37.0141 88.07 37.0741 87.92C36.9941 87.79 36.9541 87.625 36.9541 87.425C36.9541 87.205 37.0041 87.035 37.1041 86.915C37.0241 86.725 36.9841 86.545 36.9841 86.375C36.9841 86.175 37.0291 85.995 37.1191 85.835C37.0791 85.735 37.0591 85.655 37.0591 85.595C37.0591 85.565 37.0691 85.51 37.0891 85.43C36.9591 85.3 36.8941 85.09 36.8941 84.8C36.8941 84.65 36.9091 84.505 36.9391 84.365C36.9791 84.225 37.0241 84.125 37.0741 84.065C36.9641 83.865 36.9091 83.61 36.9091 83.3C36.9091 83.1 36.9391 82.94 36.9991 82.82C36.9391 82.71 36.9091 82.57 36.9091 82.4C36.9091 82.19 36.9491 82.02 37.0291 81.89C36.9991 81.81 36.9841 81.695 36.9841 81.545C36.9841 81.405 36.9991 81.31 37.0291 81.26C37.0291 81.01 37.1091 80.815 37.2691 80.675C37.4291 80.535 37.6191 80.465 37.8391 80.465C38.0591 80.465 38.2441 80.54 38.3941 80.69C38.5541 80.84 38.6241 81.04 38.6041 81.29C38.8341 81.32 39.0491 81.46 39.2491 81.71C39.4491 81.96 39.5441 82.23 39.5341 82.52C39.6641 82.61 39.7891 82.745 39.9091 82.925C40.0391 83.105 40.1091 83.27 40.1191 83.42C40.2491 83.52 40.3891 83.7 40.5391 83.96C40.6891 84.22 40.7691 84.45 40.7791 84.65C40.8991 84.66 41.0241 84.775 41.1541 84.995C41.2941 85.215 41.3741 85.4 41.3941 85.55C41.4941 85.59 41.5941 85.69 41.6941 85.85C41.7941 86.01 41.8441 86.15 41.8441 86.27C41.9241 86.29 41.9941 86.37 42.0541 86.51C42.1241 86.65 42.1491 86.76 42.1291 86.84C42.3791 86.94 42.5291 87.115 42.5791 87.365C42.6891 87.355 42.8091 87.42 42.9391 87.56C43.0691 87.7 43.1491 87.84 43.1791 87.98C43.2791 88.02 43.3841 88.11 43.4941 88.25C43.6141 88.38 43.6891 88.505 43.7191 88.625C43.6891 88.475 43.6741 88.365 43.6741 88.295C43.6741 88.225 43.6991 88.165 43.7491 88.115C43.6491 88.005 43.5991 87.845 43.5991 87.635C43.5991 87.525 43.6141 87.435 43.6441 87.365C43.5741 87.245 43.5391 87.135 43.5391 87.035C43.5391 86.945 43.5641 86.85 43.6141 86.75C43.5141 86.66 43.4641 86.505 43.4641 86.285C43.4641 86.185 43.4791 86.105 43.5091 86.045C43.4291 85.885 43.3891 85.705 43.3891 85.505C43.3891 85.445 43.3991 85.355 43.4191 85.235C43.3091 85.105 43.2541 84.895 43.2541 84.605C43.2541 84.365 43.2941 84.19 43.3741 84.08C43.3241 84.01 43.2791 83.915 43.2391 83.795C43.2091 83.665 43.1941 83.545 43.1941 83.435C43.1941 83.245 43.2341 83.1 43.3141 83C43.2241 82.91 43.1791 82.785 43.1791 82.625C43.1791 82.515 43.2041 82.375 43.2541 82.205C43.1541 82.055 43.1041 81.875 43.1041 81.665C43.1041 81.505 43.1341 81.38 43.1941 81.29C43.1441 81.16 43.1191 81.045 43.1191 80.945C43.1191 80.745 43.2191 80.605 43.4191 80.525C43.5291 80.485 43.6291 80.465 43.7191 80.465C43.8891 80.465 44.0091 80.53 44.0791 80.66C44.1591 80.79 44.1991 80.945 44.1991 81.125C44.1991 81.225 44.1941 81.295 44.1841 81.335C44.2641 81.395 44.3291 81.505 44.3791 81.665C44.4291 81.825 44.4541 81.99 44.4541 82.16C44.4541 82.31 44.4341 82.42 44.3941 82.49C44.4641 82.65 44.4991 82.86 44.4991 83.12C44.4991 83.34 44.4741 83.495 44.4241 83.585C44.4841 83.705 44.5141 83.88 44.5141 84.11C44.5141 84.29 44.4941 84.42 44.4541 84.5C44.5041 84.58 44.5441 84.69 44.5741 84.83C44.6141 84.96 44.6341 85.085 44.6341 85.205C44.6341 85.375 44.5991 85.495 44.5291 85.565C44.5991 85.625 44.6541 85.725 44.6941 85.865C44.7341 86.005 44.7541 86.15 44.7541 86.3C44.7541 86.43 44.7391 86.54 44.7091 86.63C44.7891 86.76 44.8291 86.915 44.8291 87.095C44.8291 87.245 44.8041 87.35 44.7541 87.41C44.7841 87.47 44.8091 87.57 44.8291 87.71C44.8491 87.85 44.8491 87.95 44.8291 88.01C44.9291 88.08 44.9791 88.225 44.9791 88.445C44.9791 88.615 44.9441 88.75 44.8741 88.85C44.9241 88.98 44.9491 89.085 44.9491 89.165C44.9491 89.195 44.9391 89.26 44.9191 89.36Z"
      fill="#404040"
    />
    <path
      d="M57.6195 85.925C57.6595 86.035 57.6795 86.16 57.6795 86.3C57.6795 86.46 57.6545 86.62 57.6045 86.78C57.5645 86.93 57.5095 87.045 57.4395 87.125C57.5295 87.215 57.5745 87.415 57.5745 87.725C57.5745 88.025 57.5295 88.235 57.4395 88.355C57.4895 88.405 57.5295 88.495 57.5595 88.625C57.5895 88.755 57.6045 88.9 57.6045 89.06C57.6045 89.36 57.5495 89.595 57.4395 89.765C57.4995 89.955 57.5295 90.125 57.5295 90.275C57.5295 90.505 57.4695 90.68 57.3495 90.8C57.2295 90.92 57.0895 90.98 56.9295 90.98C56.7895 90.98 56.6645 90.93 56.5545 90.83C56.4445 90.73 56.3895 90.595 56.3895 90.425C56.3895 90.335 56.4045 90.245 56.4345 90.155C56.3045 89.925 56.2395 89.665 56.2395 89.375C56.2395 89.085 56.3045 88.875 56.4345 88.745C56.3345 88.645 56.2845 88.505 56.2845 88.325C56.2845 88.155 56.3345 88.02 56.4345 87.92C56.3345 87.72 56.2845 87.495 56.2845 87.245C56.2845 86.995 56.3345 86.825 56.4345 86.735C56.3345 86.535 56.2845 86.27 56.2845 85.94C56.2845 85.61 56.3345 85.4 56.4345 85.31C56.2945 85.12 56.2245 84.895 56.2245 84.635C56.2245 84.405 56.2945 84.225 56.4345 84.095C56.3945 84.045 56.3745 83.975 56.3745 83.885C56.3745 83.815 56.3845 83.725 56.4045 83.615C56.4245 83.495 56.4345 83.385 56.4345 83.285C56.4345 83.545 56.3745 83.885 56.2545 84.305C56.1345 84.715 55.9695 84.995 55.7595 85.145C55.7595 85.805 55.6345 86.19 55.3845 86.3C55.3845 86.52 55.3445 86.78 55.2645 87.08C55.1845 87.37 55.1045 87.515 55.0245 87.515C55.0245 87.635 54.9745 87.77 54.8745 87.92C54.7845 88.06 54.6945 88.13 54.6045 88.13C54.6345 88.23 54.6495 88.34 54.6495 88.46C54.6495 88.6 54.6245 88.735 54.5745 88.865C54.5345 88.985 54.4795 89.08 54.4095 89.15C54.4095 89.33 54.3745 89.48 54.3045 89.6C54.2345 89.72 54.1395 89.835 54.0195 89.945C54.0195 90.135 53.9545 90.285 53.8245 90.395C53.6945 90.505 53.5445 90.56 53.3745 90.56C53.2145 90.56 53.0745 90.51 52.9545 90.41C52.8345 90.3 52.7745 90.15 52.7745 89.96C52.7745 89.87 52.7795 89.805 52.7895 89.765C52.6895 89.765 52.5945 89.68 52.5045 89.51C52.4245 89.33 52.3845 89.14 52.3845 88.94C52.2945 88.94 52.1995 88.865 52.0995 88.715C51.9995 88.555 51.9195 88.38 51.8595 88.19C51.7995 87.99 51.7845 87.84 51.8145 87.74C51.7345 87.68 51.6545 87.565 51.5745 87.395C51.5045 87.225 51.4695 87.045 51.4695 86.855C51.4695 86.655 51.5095 86.48 51.5895 86.33C51.4595 86.32 51.3445 86.23 51.2445 86.06C51.1545 85.88 51.1095 85.705 51.1095 85.535C51.1095 85.435 51.1345 85.36 51.1845 85.31C51.0845 85.23 50.9895 85.1 50.8995 84.92C50.8195 84.74 50.7795 84.595 50.7795 84.485C50.6495 84.355 50.5845 84.09 50.5845 83.69C50.4445 83.69 50.3245 83.565 50.2245 83.315C50.2445 83.505 50.2245 83.695 50.1645 83.885C50.1145 84.065 50.0445 84.2 49.9545 84.29C50.0445 84.37 50.1145 84.525 50.1645 84.755C50.2145 84.975 50.2395 85.2 50.2395 85.43C50.2395 85.64 50.2195 85.79 50.1795 85.88C50.2795 86.04 50.3295 86.285 50.3295 86.615C50.3295 86.985 50.2795 87.285 50.1795 87.515C50.2595 87.685 50.2995 87.855 50.2995 88.025C50.2995 88.175 50.2595 88.345 50.1795 88.535C50.2195 88.575 50.2545 88.675 50.2845 88.835C50.3145 88.985 50.3295 89.15 50.3295 89.33C50.3295 89.67 50.2795 89.875 50.1795 89.945C50.1895 90.005 50.1945 90.085 50.1945 90.185C50.1945 90.445 50.1295 90.645 49.9995 90.785C49.8795 90.925 49.7295 90.995 49.5495 90.995C49.3695 90.995 49.2095 90.925 49.0695 90.785C48.9295 90.645 48.8595 90.46 48.8595 90.23C48.8595 90.06 48.9045 89.87 48.9945 89.66C48.8745 89.25 48.8145 88.865 48.8145 88.505C48.8145 88.175 48.8595 87.92 48.9495 87.74C48.8495 87.61 48.7995 87.405 48.7995 87.125C48.7995 86.995 48.8145 86.875 48.8445 86.765C48.8745 86.645 48.9095 86.56 48.9495 86.51C48.8495 86.28 48.7995 86.05 48.7995 85.82C48.7995 85.58 48.8495 85.41 48.9495 85.31C48.8995 85.24 48.8595 85.15 48.8295 85.04C48.7995 84.93 48.7845 84.815 48.7845 84.695C48.7845 84.515 48.8145 84.38 48.8745 84.29C48.7745 84.12 48.7245 83.9 48.7245 83.63C48.7245 83.28 48.7995 83.03 48.9495 82.88C48.8095 82.74 48.7395 82.455 48.7395 82.025C48.7395 81.825 48.7595 81.635 48.7995 81.455C48.8395 81.265 48.8895 81.14 48.9495 81.08C48.9495 80.89 49.0195 80.735 49.1595 80.615C49.2995 80.495 49.4595 80.435 49.6395 80.435C49.8495 80.435 50.0295 80.51 50.1795 80.66C50.3795 80.66 50.5595 80.75 50.7195 80.93C50.8895 81.11 50.9745 81.295 50.9745 81.485C51.0445 81.545 51.1045 81.63 51.1545 81.74C51.2045 81.84 51.2295 81.945 51.2295 82.055C51.2295 82.135 51.2145 82.215 51.1845 82.295C51.3045 82.305 51.3995 82.375 51.4695 82.505C51.5495 82.635 51.5895 82.76 51.5895 82.88C51.6695 82.95 51.7345 83.05 51.7845 83.18C51.8445 83.3 51.8745 83.425 51.8745 83.555C51.8745 83.675 51.8545 83.79 51.8145 83.9C51.8645 83.9 51.9095 83.945 51.9495 84.035C51.9995 84.115 52.0245 84.205 52.0245 84.305C52.0245 84.385 52.0045 84.445 51.9645 84.485C52.0745 84.545 52.1695 84.67 52.2495 84.86C52.3395 85.04 52.3845 85.19 52.3845 85.31C52.4545 85.38 52.5095 85.495 52.5495 85.655C52.5995 85.815 52.6245 85.98 52.6245 86.15C52.6245 86.28 52.6095 86.4 52.5795 86.51C52.6795 86.58 52.7745 86.725 52.8645 86.945C52.9545 87.155 52.9995 87.36 52.9995 87.56C52.9995 87.64 52.9945 87.7 52.9845 87.74C53.1045 87.83 53.1895 87.915 53.2395 87.995C53.2995 88.075 53.3495 88.195 53.3895 88.355C53.4095 87.915 53.5045 87.65 53.6745 87.56C53.6545 87.48 53.6445 87.42 53.6445 87.38C53.6445 87.23 53.6795 87.085 53.7495 86.945C53.8295 86.805 53.9195 86.735 54.0195 86.735C53.9695 86.635 53.9445 86.55 53.9445 86.48C53.9445 86.26 54.0995 85.98 54.4095 85.64C54.3795 85.58 54.3645 85.5 54.3645 85.4C54.3645 85.23 54.3995 85.055 54.4695 84.875C54.5495 84.695 54.6595 84.565 54.7995 84.485C54.7995 84.185 54.8195 83.935 54.8595 83.735C54.9095 83.525 55.0245 83.375 55.2045 83.285C55.2045 83.105 55.2445 82.96 55.3245 82.85C55.4145 82.73 55.5195 82.67 55.6395 82.67C55.5895 82.59 55.5645 82.485 55.5645 82.355C55.5645 82.145 55.6095 81.93 55.6995 81.71C55.7995 81.49 55.9145 81.34 56.0445 81.26C56.0445 81.04 56.1045 80.85 56.2245 80.69C56.3545 80.53 56.5545 80.45 56.8245 80.45C56.8745 80.43 56.9445 80.42 57.0345 80.42C57.2345 80.42 57.3795 80.51 57.4695 80.69C57.5695 80.86 57.6195 81.015 57.6195 81.155C57.7095 81.465 57.7545 81.7 57.7545 81.86C57.7545 82.01 57.7095 82.245 57.6195 82.565C57.7095 82.665 57.7545 82.81 57.7545 83C57.7545 83.18 57.7095 83.375 57.6195 83.585C57.7095 83.685 57.7545 83.85 57.7545 84.08C57.7545 84.32 57.7045 84.5 57.6045 84.62C57.7345 84.79 57.7995 85.005 57.7995 85.265C57.7995 85.525 57.7395 85.745 57.6195 85.925Z"
      fill="#404040"
    />
    <path
      d="M64.115 80.495C64.215 80.425 64.345 80.39 64.505 80.39C64.735 80.39 64.965 80.465 65.195 80.615C65.305 80.615 65.395 80.66 65.465 80.75C65.535 80.84 65.57 80.95 65.57 81.08C65.57 81.25 65.52 81.4 65.42 81.53C65.32 81.66 65.18 81.725 65 81.725C64.87 81.725 64.73 81.685 64.58 81.605C64.5 81.685 64.395 81.725 64.265 81.725C64.125 81.725 63.98 81.675 63.83 81.575C63.73 81.625 63.58 81.65 63.38 81.65C63.09 81.65 62.865 81.605 62.705 81.515C62.555 81.585 62.4 81.62 62.24 81.62C62.11 81.62 61.985 81.6 61.865 81.56C61.735 81.61 61.61 81.635 61.49 81.635C61.33 81.635 61.17 81.59 61.01 81.5C60.83 81.6 60.67 81.66 60.53 81.68C60.6 81.85 60.635 82.035 60.635 82.235C60.635 82.485 60.58 82.685 60.47 82.835C60.59 83.025 60.65 83.235 60.65 83.465C60.65 83.645 60.605 83.825 60.515 84.005C60.605 84.105 60.65 84.23 60.65 84.38C60.65 84.48 60.615 84.6 60.545 84.74C60.635 84.69 60.745 84.665 60.875 84.665C60.975 84.665 61.045 84.675 61.085 84.695C61.195 84.615 61.315 84.575 61.445 84.575C61.575 84.575 61.705 84.63 61.835 84.74C61.955 84.71 62.055 84.695 62.135 84.695C62.185 84.695 62.27 84.705 62.39 84.725C62.51 84.705 62.595 84.695 62.645 84.695C62.815 84.695 62.94 84.735 63.02 84.815C63.1 84.765 63.19 84.74 63.29 84.74C63.41 84.74 63.485 84.765 63.515 84.815C63.605 84.785 63.675 84.77 63.725 84.77C63.795 84.77 63.89 84.79 64.01 84.83C64.14 84.76 64.265 84.725 64.385 84.725C64.555 84.725 64.7 84.79 64.82 84.92C64.94 85.04 65 85.175 65 85.325C65 85.455 64.955 85.565 64.865 85.655C64.775 85.745 64.635 85.795 64.445 85.805C64.355 85.925 64.205 85.985 63.995 85.985C63.805 85.985 63.635 85.935 63.485 85.835C63.385 85.935 63.24 85.985 63.05 85.985C62.88 85.985 62.74 85.945 62.63 85.865C62.55 85.925 62.465 85.955 62.375 85.955C62.315 85.955 62.265 85.935 62.225 85.895C62.115 85.995 61.965 86.045 61.775 86.045C61.635 86.045 61.505 86.015 61.385 85.955C61.285 86.005 61.2 86.03 61.13 86.03C61.03 86.03 60.93 85.995 60.83 85.925C60.76 85.965 60.705 85.99 60.665 86C60.625 86.01 60.57 86.01 60.5 86C60.59 86.18 60.635 86.32 60.635 86.42C60.635 86.51 60.605 86.615 60.545 86.735C60.615 86.815 60.65 86.915 60.65 87.035C60.65 87.125 60.625 87.22 60.575 87.32C60.645 87.4 60.68 87.505 60.68 87.635C60.68 87.755 60.645 87.855 60.575 87.935C60.635 88.055 60.665 88.15 60.665 88.22C60.665 88.28 60.625 88.38 60.545 88.52C60.585 88.56 60.605 88.615 60.605 88.685C60.605 88.775 60.575 88.835 60.515 88.865C60.615 88.955 60.665 89.07 60.665 89.21C60.665 89.26 60.655 89.345 60.635 89.465L60.725 89.45C60.835 89.45 60.95 89.5 61.07 89.6C61.22 89.49 61.415 89.435 61.655 89.435C61.745 89.435 61.84 89.445 61.94 89.465C62 89.395 62.085 89.34 62.195 89.3C62.305 89.26 62.425 89.24 62.555 89.24C62.765 89.24 62.925 89.285 63.035 89.375C63.095 89.275 63.2 89.195 63.35 89.135C63.5 89.075 63.65 89.045 63.8 89.045C63.91 89.045 64 89.06 64.07 89.09C64.18 89.03 64.28 89 64.37 89C64.53 89 64.67 89.065 64.79 89.195C64.91 89.325 64.97 89.475 64.97 89.645C64.97 89.855 64.875 90.02 64.685 90.14C64.645 90.22 64.565 90.29 64.445 90.35C64.325 90.4 64.195 90.425 64.055 90.425C63.915 90.425 63.805 90.4 63.725 90.35C63.645 90.43 63.54 90.5 63.41 90.56C63.28 90.61 63.15 90.635 63.02 90.635C62.82 90.635 62.665 90.58 62.555 90.47C62.385 90.65 62.165 90.74 61.895 90.74C61.845 90.74 61.76 90.73 61.64 90.71C61.44 90.83 61.245 90.89 61.055 90.89C60.905 90.89 60.775 90.85 60.665 90.77C60.555 90.94 60.395 91.025 60.185 91.025C60.005 91.025 59.845 90.955 59.705 90.815C59.575 90.675 59.53 90.51 59.57 90.32C59.51 90.26 59.465 90.17 59.435 90.05C59.405 89.93 59.39 89.81 59.39 89.69C59.39 89.6 59.395 89.535 59.405 89.495C59.275 89.365 59.21 89.145 59.21 88.835C59.21 88.705 59.225 88.585 59.255 88.475C59.285 88.355 59.32 88.27 59.36 88.22C59.31 88.12 59.285 88.015 59.285 87.905C59.285 87.855 59.295 87.79 59.315 87.71C59.225 87.62 59.18 87.5 59.18 87.35C59.18 87.21 59.215 87.1 59.285 87.02C59.235 86.92 59.21 86.83 59.21 86.75C59.21 86.64 59.245 86.535 59.315 86.435C59.235 86.255 59.195 86.08 59.195 85.91C59.195 85.7 59.26 85.5 59.39 85.31C59.33 85.18 59.275 85.02 59.225 84.83C59.185 84.64 59.165 84.46 59.165 84.29C59.165 83.97 59.24 83.75 59.39 83.63C59.34 83.41 59.315 83.295 59.315 83.285C59.255 83.045 59.225 82.875 59.225 82.775C59.225 82.625 59.26 82.445 59.33 82.235C59.28 82.165 59.24 82.05 59.21 81.89C59.18 81.73 59.17 81.615 59.18 81.545C59.06 81.425 59 81.28 59 81.11C59 80.98 59.04 80.86 59.12 80.75C59.21 80.63 59.325 80.55 59.465 80.51C59.535 80.44 59.63 80.385 59.75 80.345C59.87 80.295 59.995 80.27 60.125 80.27C60.295 80.27 60.44 80.315 60.56 80.405C60.73 80.355 60.9 80.33 61.07 80.33C61.31 80.33 61.505 80.385 61.655 80.495C61.745 80.455 61.85 80.435 61.97 80.435C62.08 80.435 62.165 80.46 62.225 80.51C62.285 80.46 62.43 80.435 62.66 80.435C62.96 80.435 63.195 80.485 63.365 80.585C63.475 80.475 63.61 80.42 63.77 80.42C63.87 80.42 63.985 80.445 64.115 80.495Z"
      fill="#404040"
    />
    <path
      d="M66.7413 86.885C66.6913 86.785 66.6663 86.66 66.6663 86.51C66.6663 86.37 66.6913 86.265 66.7413 86.195C66.7213 86.145 66.7113 86.06 66.7113 85.94C66.7113 85.8 66.7313 85.66 66.7713 85.52C66.8113 85.38 66.8563 85.29 66.9063 85.25C66.8163 85.17 66.7713 84.995 66.7713 84.725C66.7713 84.605 66.7813 84.5 66.8013 84.41C66.8213 84.31 66.8513 84.25 66.8913 84.23C66.8413 84.13 66.8163 83.97 66.8163 83.75C66.8163 83.59 66.8313 83.445 66.8613 83.315C66.8913 83.175 66.9313 83.07 66.9813 83C66.8613 82.88 66.8013 82.715 66.8013 82.505C66.8013 82.375 66.8213 82.255 66.8613 82.145C66.9113 82.025 66.9713 81.935 67.0413 81.875C66.9513 81.745 66.9063 81.585 66.9063 81.395C66.9063 81.275 66.9313 81.13 66.9813 80.96C66.8813 80.83 66.8313 80.705 66.8313 80.585C66.8313 80.425 66.9013 80.29 67.0413 80.18C67.1813 80.06 67.3363 80 67.5063 80C67.6263 80 67.7313 80.04 67.8213 80.12C67.9213 80.19 67.9913 80.3 68.0313 80.45C68.1413 80.58 68.1963 80.72 68.1963 80.87C68.1963 80.97 68.1763 81.055 68.1363 81.125C68.1663 81.155 68.1813 81.4 68.1813 81.86C68.2013 81.94 68.2113 82.005 68.2113 82.055C68.2113 82.255 68.1663 82.47 68.0763 82.7C68.1363 82.78 68.1663 82.915 68.1663 83.105C68.1663 83.235 68.1463 83.365 68.1063 83.495C68.0763 83.615 68.0413 83.705 68.0013 83.765C68.0113 83.795 68.0263 83.85 68.0463 83.93C68.0663 84.01 68.0763 84.085 68.0763 84.155C68.0763 84.265 68.0513 84.36 68.0013 84.44C68.0713 84.54 68.1063 84.74 68.1063 85.04C68.1063 85.15 68.0963 85.245 68.0763 85.325C68.1163 85.375 68.1363 85.48 68.1363 85.64C68.1363 85.77 68.1163 85.9 68.0763 86.03C68.0463 86.15 67.9963 86.235 67.9263 86.285C67.9963 86.365 68.0313 86.475 68.0313 86.615C68.0313 86.745 68.0063 86.85 67.9563 86.93C68.0063 86.95 68.0313 87.02 68.0313 87.14C68.0313 87.21 68.0213 87.285 68.0013 87.365C67.9813 87.435 67.9563 87.475 67.9263 87.485C67.9463 87.565 67.9563 87.63 67.9563 87.68C67.9563 87.84 67.8963 87.985 67.7763 88.115C67.6663 88.235 67.5263 88.295 67.3563 88.295C67.1763 88.295 67.0263 88.23 66.9063 88.1C66.7863 87.96 66.7413 87.8 66.7713 87.62C66.7213 87.5 66.6963 87.34 66.6963 87.14C66.6963 87.03 66.7113 86.945 66.7413 86.885ZM66.8313 90.545C66.8313 90.725 66.8863 90.87 66.9963 90.98C67.1163 91.08 67.2563 91.13 67.4163 91.13C67.5563 91.13 67.6813 91.09 67.7913 91.01C67.9013 90.92 67.9713 90.795 68.0013 90.635C68.0913 90.515 68.1363 90.375 68.1363 90.215L68.1213 89.93C68.1013 89.66 67.9813 89.48 67.7613 89.39C67.6913 89.36 67.6163 89.345 67.5363 89.345C67.3763 89.345 67.2363 89.405 67.1163 89.525C66.9963 89.635 66.9363 89.775 66.9363 89.945C66.9363 89.995 66.9463 90.06 66.9663 90.14C66.8763 90.27 66.8313 90.405 66.8313 90.545Z"
      fill="#404040"
    />
    <rect x={8} y={8} width={64} height={64} fill="url(#pattern0-115)" />
    <defs>
      <pattern
        id="pattern0-115"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_1280_27382" transform="scale(0.000431034)" />
      </pattern>
      <image
        id="image0_1280_27382"
        width={2320}
        height={2320}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const QRDesignDetailIcon = (props) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth={2}
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="alert-icon"
    height="24px"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </svg>
);

export const QRDesignCenter1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-square.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-81)" />
    <defs>
      <pattern
        id="pattern0-81"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4862"
          transform="translate(-0.0833333 -0.0833333) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4862"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAKLWlDQ1BJQ0MgUHJvZmlsZQAASImVlgdQU9kax8+96Y1AEkKHUEOR3gIIhN6liDRRCQmEGkIoYldkcQVWFBERUAQRRRRcCyBrQUSxsCgqYN8gi4K6igVQUXkX2XXLm/fevG/mzPeb757znf+5587cPwCkvTyxOAWWBSBVlCkJ8XJlRURGsXC/AiJQBTQAgDaPnyF2CQryRxj8kf8ekwMAms23jGd7/fvz/xo0QVwGHwAoGuFkQQY/FeHLCM/niyWZAMDoWQ3LM8WzrI8wQ4IIRHj+LAvnOGiWY+dY8HVOaIgbwjkA4Mk8nkQIADEPqbOy+UKkD7EOYTORIFGE8G2EnfgJPGQdiYHwvNTUtFnmIqyPzBcjnIAwJ/YvPYV/6x/7rT+PJ/zGc+f6GnIefhZWZpEsPi8lMVbCE6T9n+/of0ZqStYfe83eBDkuw2PhrAZkqAIP4AcsgBUwA5FIhQ94IAUkglggQUgA0jLjcjJnF7qliVdIEoUJmSwX5BbjWD4ivsk8loWZhRkAs9/EXPu3d77uADHxf9aEDQDYSBE4/Gctzh2A1leIFN6fNYNR5FUg3S6x+FmS7Lna7PUCDPK1UQEDKAF1oA30gTGi1wY4AC6i3RcEglBE+VJEeQJIRVQvB6vBBpAPCsFWsANUgGqwDxwER8Ax0ApOg/PgErgGboB+cB9IwQh4DsbBJJiGIAgHUSA6pARpQLqQEWQBcSAnyAPyh0KgSCgGEkIiKAtaDW2ECqESqAKqgRqgH6FT0HnoCtQH3YWGoDHoDfQRRsFkmAGrwXqwKcyBXWA/OBReAgvhdHglnAdvgcvhWvgw3AKfh6/B/bAUfg5PoACKhGKiNFHGKA7KDRWIikLFoySotagCVBmqFtWEakd1o26hpKgXqA9oLJqOZqGN0Q5ob/QiNB+djl6LLkJXoA+iW9Bd6FvoIfQ4+guGglHFGGHsMT6YCIwQsxyTjynD1GNOYi5i+jEjmEksFsvEsrG2WG9sJDYJuwpbhN2NbcZ2YPuww9gJHA6nhDPCOeICcTxcJi4ftwt3GHcOdxM3gnuPJ+E18BZ4T3wUXoTPxZfhD+HP4m/in+KnCbIEXYI9IZAgIKwgFBPqCO2E64QRwjRRjsgmOhJDiUnEDcRyYhPxIvEB8S2JRNIi2ZGCSYmk9aRy0lHSZdIQ6QOZRjYku5GjyVnkLeQD5A7yXfJbCoWiR+FSoiiZlC2UBsoFyiPKexm6jImMj4xAZp1MpUyLzE2Zl1QCVZfqQl1KXUktox6nXqe+kCXI6sm6yfJk18pWyp6SHZSdkKPLmcsFyqXKFckdkrsiN0rD0fRoHjQBLY+2j3aBNkxH0bXpbnQ+fSO9jn6RPsLAMtgMH0YSo5BxhNHLGJenyVvJh8nnyFfKn5GXMlFMPaYPM4VZzDzGHGB+VFBTcFGIU9is0KRwU2FKUUWRqxinWKDYrNiv+FGJpeShlKy0TalV6aEyWtlQOVh5ufIe5YvKL1QYKg4qfJUClWMq91RhVUPVENVVqvtUe1Qn1NTVvNTEarvULqi9UGeqc9WT1EvVz6qPadA1nDQSNUo1zmk8Y8mzXFgprHJWF2tcU1XTWzNLs0azV3Nai621SCtXq1nroTZRm6Mdr12q3ak9rqOhE6CzWqdR554uQZejm6C7U7dbd0qPrReut0mvVW+Urcj2Ya9kN7If6FP0nfXT9Wv1bxtgDTgGyQa7DW4YwobWhgmGlYbXjWAjG6NEo91GffMw8+zmiebVzhs0Jhu7GGcbNxoPmTBN/E1yTVpNXprqmEaZbjPtNv1iZm2WYlZndt+cZu5rnmvebv7GwtCCb1FpcduSYulpuc6yzfK1lZFVnNUeqzvWdOsA603WndafbWxtJDZNNmO2OrYxtlW2gxwGJ4hTxLlsh7FztVtnd9rug72Nfab9MftXDsYOyQ6HHEbns+fHza+bP+yo5chzrHGUOrGcYpz2OkmdNZ15zrXOj7naXAG3nvvUxcAlyeWwy0tXM1eJ60nXKTd7tzVuHe4ody/3AvdeD5rHIo8Kj0eeWp5Cz0bPcS9rr1VeHd4Ybz/vbd6DPmo+fJ8Gn3FfW981vl1+ZL+FfhV+j/0N/SX+7QFwgG/A9oAHC3QXiBa0BoJAn8DtgQ+D2EHpQT8FY4ODgiuDn4SYh6wO6V5IX7hs4aGFk6GuocWh9xfpL8pa1BlGDYsOawibCncPLwmXRphGrIm4FqkcmRjZFoWLCouqj5pY7LF4x+KRaOvo/OiBJewlOUuuLFVemrL0zDLqMt6y4zGYmPCYQzGfeIG8Wt5ErE9sVew4342/k/9cwBWUCsbiHONK4p7GO8aXxI8KHYXbhWMJzgllCS8S3RIrEl8neSdVJ00lByYfSJ5JCU9pTsWnxqSeEtFEyaKuNPW0nLQ+sZE4XyxNt0/fkT4u8ZPUZ0AZSzLaMhnIz7cnSz/ru6yhbKfsyuz3y8OWH8+RyxHl9KwwXLF5xdOVniv3r0Kv4q/qXK25esPqoTUua2rWQmtj13au016Xt25kvdf6gxuIG5I3/JxrlluS+25j+Mb2PLW89XnD33l915gvky/JH9zksKn6e/T3id/3brbcvGvzlwJBwdVCs8Kywk9F/KKrP5j/UP7DzJb4Lb3FNsV7tmK3irYObHPedrBErmRlyfD2gO0tpazSgtJ3O5btuFJmVVa9k7gza6e03L+8bZfOrq27PlUkVPRXulY2V6lWba6a2i3YfXMPd09TtVp1YfXHvYl779R41bTU6tWW7cPuy973pC6srns/Z39DvXJ9Yf3nA6ID0oMhB7sabBsaDqkeKm6EG7Maxw5HH75xxP1IW5NxU00zs7nwKDiadfTZjzE/DhzzO9Z5nHO86YTuiaqT9JMFLVDLipbx1oRWaVtkW98p31Od7Q7tJ38y+enAac3TlWfkzxSfJZ7NOztzbuW5iQ5xx4vzwvPDncs671+IuHC7K7ir96LfxcuXPC9d6HbpPnfZ8fLpK/ZXTl3lXG29ZnOtpce65+TP1j+f7LXpbblue73tht2N9r75fWdvOt88f8v91qXbPrev9S/o7xtYNHBnMHpQekdwZ/Ruyt3X97LvTd9f/wDzoOCh7MOyR6qPan8x+KVZaiM9M+Q+1PN44eP7w/zh579m/PppJO8J5UnZU42nDaMWo6fHPMduPFv8bOS5+Pn0i/zf5H6reqn/8sQr7que8YjxkdeS1zNvit4qvT3wzupd50TQxKPJ1MnpqYL3Su8PfuB86P4Y/vHp9PJPuE/lnw0+t3/x+/JgJnVmRsyT8L5aARQy4Ph4AN4cAIASCQD9BuKlFs95tt+9DaRh+c3l/Aee83VfwwaA/esR99IBQAiSa7gAsBGmIhyEcCgXQJPob+P3yIi3tJjrRWpFrEnZzMzbcABwBgB8HpyZmW6dmflcj4i9B0DH5JxX/OpjJMicCCiIeuLesRbxP/3ZnI/8yxn/mcE3BX/L/wKxj8w5N9AZVwAAAFZlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA5KGAAcAAAASAAAARKACAAQAAAABAAAARqADAAQAAAABAAAARgAAAABBU0NJSQAAAFNjcmVlbnNob3S5zpSyAAAB1GlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj43MDwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj43MDwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlVzZXJDb21tZW50PlNjcmVlbnNob3Q8L2V4aWY6VXNlckNvbW1lbnQ+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgr3n9XBAAACjUlEQVR4Ae2bMa9hQRiG52xWopCoUSi1gh69+AtUatGpxL8QlX+CnoSSQnRajUaze2Y3N9zc85jPZZvNexJxvPOemTmPz+RzZib6FR9OxxcCP74oEv4QEBgIBIERGCAAsiIGwPwE3fX7fbfdbqn4Kb3T6bhutxu8ptFoBD3tdtsNBoOgr1arBT3esFqtEn0IZrPZuOVymXjRs2K9XjddYmmvVCqZ6vKm9Xr90FutVrFcPyVAIzACAwRAVsQIDBAAWREjMEAAZMxjwP9Jzmazrlwuf9KSPqTTabdYLJKKntaiKDJf8yhPCVXyEhgPxXLDvV7PDYfDUF9M5dbHR5TRmhqJTRpjgJTACAwQAFkRIzBAAGRFjMAAAZAVMQAmogm32WzmjscjXPZXzmQy7nK5PPT4wlQq5a7Xa9A3Ho+DHp/NtlqtoM9iyOfzziefiYcH891jPp/7WczgazQamZqw1PVOTwwZ+6WfUmK46C8BYBEYgUECUKAxRmCAAMiKGIEBAiRThhPPNwcTt7jOt3qoL/f6ZDJ5W5tK8CgqHugaYwCOwAgMEABZESMwQABkRYzAAAGQX5q7LhaLptWYfn7bsvDQ8mgzl8u5+Ikg3M5Nnk6n7nQ63YRnz+6zyvtzS+brPZbDP9qM+/WWl/UxaaVSCbanzPfZaIn9GnwBmsAIDBAAWREjMEAAZEWMwAABkF/KfP1+pmazCVXf5NDigA9nPBf+cYrvh8PBWfY17fd7rMNS8BKY8/lsWs5q6Yj3WG54t9uZ/l5Y2ySfxhggIzACAwRAVsQIDBAAWREjMEAAZMxjLPuQoM5/KhcKBWfdxx3qyKM93LicNVTp/16uMQa+YYERGCAAsiJGYIAAyL8B5wg6FqvpLt4AAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);

export const QRDesignCenter2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-rounded.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-82)" />
    <defs>
      <pattern
        id="pattern0-82"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4987"
          transform="translate(-0.0833333 -0.0833333) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4987"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const QRDesignCenter3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-dots.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-83)" />
    <defs>
      <pattern
        id="pattern0-83"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4973"
          transform="translate(-0.0833333 -0.1) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4973"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const QRDesignCenter4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-extra-rounded.svg"
    role="img"
    {...props}
  >
    <rect x={0.0000305176} width={50} height={50} fill="url(#pattern0-84)" />
    <defs>
      <pattern
        id="pattern0-84"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4993"
          transform="translate(-0.0833333 -0.0666667) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4993"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const QRDesignCenter5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-classy.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-85)" />
    <defs>
      <pattern
        id="pattern0-85"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_5015"
          transform="translate(-0.1 -0.0666667) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_5015"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const QRDesignCenter6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-classy-rounded.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-86)" />
    <defs>
      <pattern
        id="pattern0-86"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4989"
          transform="translate(-0.0833333 -0.0666667) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4989"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const QRDesignCorner1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className="injected-svg"
    data-src="/svg/icon-rounded-dot.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <defs>
      <clipPath id="3iso0wj9oa-492">
        <path d="M14 0a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h6z" />
      </clipPath>
      <clipPath id="1xlj0vjiwb-493">
        <path d="M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#3iso0wj9oa-492)" transform="translate(1 1)">
      <path fill="#FFF" d="M0 0h22v22H0V0z" />
      <path
        d="M8 0h6a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8z"
        stroke="#262626"
        strokeWidth={6}
        fill="none"
        strokeMiterlimit={5}
      />
    </g>
    <g clipPath="url(#1xlj0vjiwb-493)" transform="translate(7 7)">
      <path fill="#262626" d="M0 0h10v10H0V0z" />
    </g>
  </svg>
);
export const QRDesignCorner2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    className="injected-svg"
    data-src="/svg/pattern-rounded.svg"
    role="img"
    {...props}
  >
    <rect width={50} height={50} fill="url(#pattern0-82)" />
    <defs>
      <pattern
        id="pattern0-82"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1451_4987"
          transform="translate(-0.0833333 -0.0833333) scale(0.0166667)"
        />
      </pattern>
      <image
        id="image0_1451_4987"
        width={70}
        height={70}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const QRDesignCorner3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className="injected-svg"
    data-src="/svg/icon-dot-dot.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <defs>
      <clipPath id="wg7ho2lqza-496">
        <path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z" />
      </clipPath>
      <clipPath id="60b4hcjnqb-497">
        <path d="M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#wg7ho2lqza-496)" transform="translate(1 1)">
      <path fill="#FFF" d="M0 0h22v22H0V0z" />
      <path
        d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z"
        stroke="#262626"
        strokeWidth={6}
        fill="none"
        strokeMiterlimit={5}
      />
    </g>
    <g clipPath="url(#60b4hcjnqb-497)" transform="translate(7 7)">
      <path fill="#262626" d="M0 0h10v10H0V0z" />
    </g>
  </svg>
);
export const QRDesignCorner4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className="injected-svg"
    data-src="/svg/icon-dot-square.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <defs>
      <clipPath id="popwrlps0a-498">
        <path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z" />
      </clipPath>
      <clipPath id="485y1pk9bb-499">
        <path d="M10 0v10H0V0h10z" />
      </clipPath>
    </defs>
    <g clipPath="url(#popwrlps0a-498)" transform="translate(1 1)">
      <path fill="#FFF" d="M0 0h22v22H0V0z" />
      <path
        d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z"
        stroke="#262626"
        strokeWidth={6}
        fill="none"
        strokeMiterlimit={5}
      />
    </g>
    <g clipPath="url(#485y1pk9bb-499)" transform="translate(7 7)">
      <path fill="#262626" d="M0 0h10v10H0V0z" />
    </g>
  </svg>
);
export const QRDesignCorner5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className="injected-svg"
    data-src="/svg/icon-square-dot.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <defs>
      <clipPath id="kl08zqq03a-500">
        <path d="M22 0v22H0V0h22z" />
      </clipPath>
      <clipPath id="wt8dvcp4lb-501">
        <path d="M16 0v16H0V0h16z" />
      </clipPath>
      <clipPath id="2mampstfnc-502">
        <path d="M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#kl08zqq03a-500)" transform="translate(1 1)">
      <path
        stroke="#262626"
        strokeWidth={6}
        fill="none"
        strokeMiterlimit={5}
        d="M0 0h22v22H0V0z"
      />
    </g>
    <g clipPath="url(#wt8dvcp4lb-501)" transform="translate(4 4)">
      <path fill="#FFF" d="M0 0h16v16H0V0z" />
    </g>
    <g clipPath="url(#2mampstfnc-502)" transform="translate(7 7)">
      <path fill="#262626" d="M0 0h10v10H0V0z" />
    </g>
  </svg>
);
export const QRDesignCorner6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className="injected-svg"
    data-src="/svg/icon-square-square.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <defs>
      <clipPath id="egzadkt72a-503">
        <path d="M22 0v22H0V0h22z" />
      </clipPath>
      <clipPath id="cs4wgbvcdb-504">
        <path d="M16 0v16H0V0h16z" />
      </clipPath>
      <clipPath id="6g3h9xyzic-505">
        <path d="M10 0v10H0V0h10z" />
      </clipPath>
    </defs>
    <g clipPath="url(#egzadkt72a-503)" transform="translate(1 1)">
      <path
        stroke="#262626"
        strokeWidth={6}
        fill="none"
        strokeMiterlimit={5}
        d="M0 0h22v22H0V0z"
      />
    </g>
    <g clipPath="url(#cs4wgbvcdb-504)" transform="translate(4 4)">
      <path fill="#FFF" d="M0 0h16v16H0V0z" />
    </g>
    <g clipPath="url(#6g3h9xyzic-505)" transform="translate(7 7)">
      <path fill="#262626" d="M0 0h10v10H0V0z" />
    </g>
  </svg>
);

//CANVAS RENDER FRAME IMG1
export const NotSelectedFrameCanvas = ({
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  data,
  qrLogo,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);
  // console.log("data null case", data);
  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  useEffect(() => {
    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]);
  // useEffect(() => {
  //   qrCode.current = new QRCodeStyling(qrCodeOptions);
  //   qrCode.current.append(document.getElementById(qrCodeId.current));
  // }, []);

  // useEffect(() => {
  //   qrCode.current.update({
  //     dotsOptions: {
  //       color: dotsColor,
  //       type: dotsStyle,
  //     },
  //     cornersSquareOptions: {
  //       color: cornerBorderColor,
  //       type: selectedCornerStyle,
  //     },
  //     backgroundOptions: {
  //       color: CornerbgColor,
  //     },
  //     cornersDotOptions: {
  //       color: cornerDotColor,
  //     },
  //   });
  // }, [
  //   dotsStyle,
  //   cornerBorderColor,
  //   dotsColor,
  //   selectedCornerStyle,
  //   CornerbgColor,
  //   cornerDotColor,
  //   // qrLogo,
  // ]);

  return (
    <div className="notselectSvg" {...props}>
      <div id={qrCodeId.current} style={{ width: "100%", height: "100%" }} />
    </div>
  );
};
export const CanvaFrame1 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);
  // console.log("qrCodeyy",qrCode)

  // console.log("frameTextColor",frameTextColor)

  const [imageLogo, setImageLogo] = useState(null);
  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 5,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  // useEffect(() => {
  //   // console.log('qrCodeOptions updated:', qrCodeOptions);

  //   if (qrCode.current ) {
  //     qrCode.current.update(qrCodeOptions);
  //   } else {
  //     qrCode.current = new QRCodeStyling(qrCodeOptions);
  //     qrCode.current.append(document.getElementById(qrCodeId.current));
  //   }
  // }, [qrCodeOptions, imageLogo]); // Ensure QR code updates on option change

  useEffect(() => {
    if (!qrCode.current) {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    } else {
      qrCode.current.update(qrCodeOptions);
    }
  }, [qrCodeOptions]);

  return (
    <svg
      width={72}
      height={96}
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6C0 2.68629 2.68629 0 6 0H66C69.3137 0 72 2.68629 72 6V90C72 93.3137 69.3137 96 66 96H6C2.68629 96 0 93.3137 0 90V6ZM36.0001 93.6C38.9824 93.6 41.4001 91.1823 41.4001 88.2C41.4001 85.2177 38.9824 82.8 36.0001 82.8C33.0177 82.8 30.6001 85.2177 30.6001 88.2C30.6001 91.1823 33.0177 93.6 36.0001 93.6ZM35.9997 92.1C38.1536 92.1 39.8997 90.3539 39.8997 88.2C39.8997 86.0461 38.1536 84.3 35.9997 84.3C33.8458 84.3 32.0997 86.0461 32.0997 88.2C32.0997 90.3539 33.8458 92.1 35.9997 92.1ZM67.1998 18H4.7998V80.4H67.1998V18Z"
        fill={frameColor || "#404040"}
      />
      <foreignObject width="100%" height="18px">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor || "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText || "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>

      {/* QR Code Container */}
      <foreignObject width="90%" height="64px" x={4} y={18}>
        <div
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame2 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  // console.log("imageLogoSvg",imageLogo)
  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  // const qrCodeOptions = {
  //   width: 300,
  //   height: 300,
  //   data: data ? data : "www.example.com",
  //   dotsOptions: {
  //     color: dotsColor,
  //     type: dotsStyle,
  //   },
  //   cornersSquareOptions: {
  //     color: cornerBorderColor,
  //     type: selectedCornerStyle, // This will dynamically change
  //   },
  //   cornersDotOptions: {
  //     color: cornerDotColor, // Customize if needed
  //   },
  //   backgroundOptions: {
  //     color: CornerbgColor, // Background color of the QR code
  //   },
  // };
  // useEffect(() => {
  //   qrCode.current = new QRCodeStyling(qrCodeOptions);
  //   qrCode.current.append(document.getElementById(qrCodeId.current));
  // }, []);

  // useEffect(() => {
  //   qrCode.current.update({
  //     dotsOptions: {
  //       color: dotsColor,
  //       type: dotsStyle, // Update dot style on change
  //     },
  //     cornersSquareOptions: {
  //       color: cornerBorderColor,
  //       type: selectedCornerStyle, // Update corner style on change
  //     },
  //     backgroundOptions: {
  //       color: CornerbgColor, // Background color of the QR code
  //     },
  //     cornersDotOptions: {
  //       color: cornerDotColor, // Customize if needed
  //     },
  //   });
  // }, [
  //   dotsStyle,
  //   cornerBorderColor,
  //   dotsColor,
  //   selectedCornerStyle,
  //   CornerbgColor,
  //   cornerDotColor,
  // ]);

  return (
    <svg
      width={80}
      height={98}
      viewBox="0 0 72 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V92C0 94.2091 1.79086 96 4 96H68C70.2091 96 72 94.2091 72 92V4C72 1.79086 70.2091 0 68 0H4ZM66.9 4.5H4.5V66.9H66.9V4.5Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <foreignObject width="88%" height="64px" x={4} y={4}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "2px 2px 1px",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={72}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame3 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  // console.log("imageLogoSvg",imageLogo)
  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  // console.log("frameTextColormnm",frameTextColor)
  return (
    <svg
      width={72}
      height={96}
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={72} height={96} rx={4} fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V69C1.5 69.8284 2.17157 70.5 3 70.5H69C69.8284 70.5 70.5 69.8284 70.5 69V3C70.5 2.17157 69.8284 1.5 69 1.5ZM3 0C1.34315 0 0 1.34315 0 3V69C0 70.6569 1.34315 72 3 72H69C70.6569 72 72 70.6569 72 69V3C72 1.34315 70.6569 0 69 0H3Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <rect x={4.5} y={4.5} width={62.4} height={62.4} fill="white" />
      <foreignObject width="88%" height="64px" x={4} y={4}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "4px 2px 2px",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={72}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor == "#ffffff" ? "#000000" : frameTextColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame4 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  // console.log("imageLogoSvg",imageLogo)
  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={72}
      height={96}
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4C0 1.79086 1.79086 0 4 0H68C70.2091 0 72 1.79086 72 4V68C72 70.2091 70.2091 72 68 72H4C1.79086 72 0 70.2091 0 68V4ZM0 79C0 76.7909 1.79086 75 4 75H68C70.2091 75 72 76.7909 72 79V92C72 94.2091 70.2091 96 68 96H4C1.79086 96 0 94.2091 0 92V79ZM66.9 4.5H4.5V66.9H66.9V4.5Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <foreignObject width="88%" height="63px" x={4} y={4}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "3px 2px 2px",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={72}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={14}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame5 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={72}
      height={96}
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.9999 8H72V88H71.9999C67.5816 88 63.9999 91.5817 63.9999 96H7.99992C7.99992 91.5817 4.41824 88 0 88V8C4.41824 7.99995 7.99992 4.41825 7.99992 0H63.9999C63.9999 4.41828 67.5816 8 71.9999 8ZM67.2003 21.6H4.80029V84H67.2003V21.6Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <foreignObject width="100%" height="22px">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={12}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
      <foreignObject width="86%" height="63px" y={21} x={5}>
        <div
          // id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "3px 2px 2px",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame6 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  // console.log("imageLogoSvg",imageLogo)
  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={72}
      height={96}
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 73.1429V0H72V73.1429H0ZM2.46963 1.52381H69.5304L66.7447 4.57143H5.25534L2.46963 1.52381ZM2.46963 71.619L5.25535 68.5714H66.7447L69.5304 71.619H2.46963ZM66 6.09524H6V67.0476H66V6.09524Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <foreignObject width="83%" height="60px" x={6} y={6}>
        <div
          // id="#qrCode"
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "3px 2px 2px",
            backgroundColor: "white",
          }}
          bis_skin_checked={1}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={72}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor == "#ffffff" ? "#000000" : frameTextColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame7 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);
  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={83}
      height={96}
      viewBox="0 0 77 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M71.6772 33.6772C69.9122 35.4421 67.6023 36.5366 65.1429 36.7969L65.1429 15.2031C67.6023 15.4634 69.9122 16.5579 71.6772 18.3228C73.7133 20.359 74.8571 23.1205 74.8571 26C74.8571 28.8795 73.7133 31.641 71.6772 33.6772Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2.28571}
      />
      <path
        d="M9 4C9 2.34315 10.3431 1 12 1H62C63.6569 1 65 2.34315 65 4V44C65 50.0751 60.0751 55 54 55H20C13.9249 55 9 50.0751 9 44V4Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2}
      />
      <path
        d="M0 52.6667C0 52.2985 0.298477 52 0.666667 52H74.3333C74.7015 52 75 52.2985 75 52.6667C75 56.7168 71.7168 60 67.6667 60H7.33333C3.28325 60 0 56.7168 0 52.6667Z"
        fill="#404040"
      />
      <foreignObject
        width="60%"
        height="45px"
        x={14}
        y={4}
        style={{
          borderRadius: 3,
        }}
      >
        <div
          // id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: "0px solid rgb(255, 255, 255)",
            borderRadius: 3,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={72}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={5}
            fill={frameTextColor == "#ffffff" ? "#000000" : frameTextColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {"SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame8 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);
  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={84}
      height={96}
      viewBox="0 0 84 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0129935 25.5044C-0.275576 19.7907 4.2793 15 10.0003 15H72.9115C78.6523 15 83.2145 19.8227 82.8961 25.5547L78.5072 104.555C78.2128 109.854 73.8299 114 68.5226 114H13.9902C8.66337 114 4.27158 109.824 4.00289 104.504L0.0129935 25.5044Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <path
        d="M48.882 30C54.6932 30 59.2806 25.0635 58.8552 19.2678L58.121 9.26785C57.7375 4.04312 53.3867 1.66943e-06 48.1479 1.21144e-06L34.2907 0C29.0799 -4.55536e-07 24.7425 4.00126 24.3231 9.19508L23.5156 19.1951C23.0455 25.0163 27.6429 30 33.4831 30L48.882 30ZM47.18 25C50.6691 25 53.4224 22.0343 53.1635 18.5548L52.5682 10.5548C52.3352 7.42246 49.7258 5 46.5848 5L35.8089 5C32.685 5 30.0837 7.39703 29.8289 10.5106L29.1742 18.5106C28.8881 22.0056 31.6474 25 35.1542 25L47.18 25Z"
        fill={frameColor ? frameColor : "#404040"}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <foreignObject width="77%" height="64px" x={8} y={25}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: "white",
            paddingLeft: 1,
            paddingTop: 1,
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={90} style={{}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame9 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={80}
      height={96}
      viewBox="0 0 80 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.25 13C1.25 11.4812 2.48122 10.25 4 10.25H76C77.5188 10.25 78.75 11.4812 78.75 13V105C78.75 106.519 77.5188 107.75 76 107.75H4C2.48122 107.75 1.25 106.519 1.25 105V13Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2.5}
      />
      <rect x={8} y={20} width={64} height={64} fill="url(#pattern0)" />
      <path
        d="M21 10.25C21 7.62665 23.1266 5.5 25.75 5.5H54.25C56.8734 5.5 59 7.62665 59 10.25C59 12.8734 56.8734 15 54.25 15H25.75C23.1266 15 21 12.8734 21 10.25Z"
        fill={"#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 10.25C42.6232 10.25 44.75 8.12335 44.75 5.5C44.75 2.87665 42.6232 0.75 40 0.75C37.3768 0.75 35.25 2.87665 35.25 5.5C35.25 8.12335 37.3768 10.25 40 10.25ZM40 7.875C41.3116 7.875 42.375 6.81169 42.375 5.5C42.375 4.18831 41.3116 3.125 40 3.125C38.6884 3.125 37.625 4.18831 37.625 5.5C37.625 6.81169 38.6884 7.875 40 7.875Z"
        fill={frameColor ? frameColor : "#404040"}
      />
      <foreignObject width="79%" height="64px" x={8} y={22}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `1px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            boxSizing: "border-box",
            padding: "1px 1px 1px 0px",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={90}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={5}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame10 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  CornerbgColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: CornerbgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      CornerbgColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={75}
      height={96}
      viewBox="0 0 75 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 95.5667V51.394C2 50.6683 2.32395 49.9804 2.88345 49.5181L35.8757 22.2594C36.7638 21.5257 38.0447 21.5152 38.9447 22.2344L73.0857 49.5175C73.6636 49.9792 74 50.6787 74 51.4184V95.5667C74 96.9106 72.9106 98 71.5667 98H4.43333C3.08944 98 2 96.9106 2 95.5667Z"
        fill="white"
        stroke="#404040"
        strokeWidth={2.43333}
      />
      <path
        d="M7.215 4C7.215 2.46189 8.46189 1.215 10 1.215H66C67.5381 1.215 68.785 2.46189 68.785 4V80C68.785 81.5381 67.5381 82.785 66 82.785H10C8.46189 82.785 7.215 81.5381 7.215 80V4Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2.43}
      />
      <rect x={10} y={4} width={56} height={55} />
      <path
        d="M71.8348 96.0938L44.4898 75.5046C43.8177 74.9986 43.8497 73.9795 44.5523 73.5167L71.8973 55.5011C72.7063 54.9681 73.7833 55.5484 73.7833 56.5171V95.1219C73.7833 96.1255 72.6366 96.6975 71.8348 96.0938ZM4.16516 55.9062L31.5102 76.4954C32.1823 77.0014 32.1503 78.0205 31.4477 78.4834L4.1027 96.4989C3.29373 97.0319 2.21667 96.4517 2.21667 95.4829L2.21667 56.8781C2.21667 55.8745 3.36338 55.3025 4.16516 55.9062Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2.43333}
      />
      <path
        d="M2 95.5182V91.7332C2 90.9999 2.318 90.3041 2.86868 89.8325L35.8612 61.5811C36.7545 60.8162 38.0543 60.8053 38.9598 61.5552L73.1006 89.8315C73.6696 90.3028 74 91.0105 74 91.7581V95.5182C74 96.8889 72.9106 98 71.5667 98H4.43333C3.08944 98 2 96.8889 2 95.5182Z"
        stroke="#404040"
        fill={frameColor ? frameColor : "#404040"}
        strokeWidth={2.43333}
      />
      <foreignObject width="71%" height="54px" y={4} x={11}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: "white",
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" y={80}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={8}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
export const CanvaFrame11 = ({
  frameColor,
  backgroundColor,
  frameText,
  frameTextColor,
  dotsColor,
  dotsStyle,
  cornerBorderColor,
  selectedCornerStyle,
  cornerBackgroundColor,
  cornerDotColor,
  qrLogo,
  data,
  ...props
}) => {
  const qrCode = useRef(null);
  const qrCodeId = useRef(`qrCode-${Math.random().toString(36).substr(2, 9)}`);

  const [imageLogo, setImageLogo] = useState(null);
  // console.log("frameTextSVGGG",frameText,frameTextColor)

  useEffect(() => {
    if (qrLogo) {
      const logoUrl =
        qrLogo instanceof File ? URL.createObjectURL(qrLogo) : qrLogo;
      setImageLogo(logoUrl);
    }
  }, [qrLogo]);

  // Memoize qrCodeOptions to avoid re-creation on every render
  const qrCodeOptions = useMemo(
    () => ({
      width: 200,
      height: 200,
      data: data || "www.example.com",
      image: imageLogo,
      dotsOptions: {
        color: dotsColor,
        type: dotsStyle,
      },
      cornersSquareOptions: {
        color: cornerBorderColor,
        type: selectedCornerStyle,
      },
      cornersDotOptions: {
        color: cornerDotColor,
      },
      backgroundOptions: {
        color: cornerBackgroundColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    }),
    [
      data,
      imageLogo,
      dotsColor,
      dotsStyle,
      cornerBorderColor,
      selectedCornerStyle,
      cornerDotColor,
      cornerBackgroundColor,
    ]
  );

  // Initialize QR code on mount and update when qrCodeOptions change
  useEffect(() => {
    // console.log('qrCodeOptions updated:', qrCodeOptions);

    if (qrCode.current) {
      qrCode.current.update(qrCodeOptions); // Update QR code with new options
    } else {
      qrCode.current = new QRCodeStyling(qrCodeOptions);
      qrCode.current.append(document.getElementById(qrCodeId.current));
    }
  }, [qrCodeOptions]); // Ensure QR code updates on option change

  return (
    <svg
      width={80}
      height={96}
      viewBox="0 0 80 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.81755 104.903L1.215 108.707V4C1.215 2.46189 2.46189 1.215 4 1.215H76C77.5381 1.215 78.785 2.46189 78.785 4V108.614L73.7147 104.926L72.9073 104.338L72.1746 105.017L67.5 109.344L62.8254 105.017L62.1379 104.38L61.3476 104.883L54.0727 109.514L48.2493 104.952L47.5 104.365L46.7507 104.952L41.0307 109.433L35.7862 104.982L35.0307 104.341L34.2507 104.952L28.4729 109.478L22.2147 104.926L21.5 104.406L20.7853 104.926L14.5 109.498L8.21471 104.926L7.5241 104.423L6.81755 104.903Z"
        fill={frameColor ? frameColor : "#404040"}
        stroke="#404040"
        strokeWidth={2.43}
      />
      <foreignObject width="83%" height="68px" x={7} y={6}>
        <div
          id="#qrCode"
          bis_skin_checked={1}
          style={{
            border: `4px solid ${backgroundColor}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: "white",
            paddingTop: 2,
          }}
        >
          <div
            id={qrCodeId.current}
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </foreignObject>
      <foreignObject width="100%" height="18px" x={-3} y={80}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          }}
          {...props}
        >
          <text
            x="50%"
            y={10}
            fill={frameTextColor ? frameTextColor : "#FFFFFF"}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="Nunito Sans"
            fontWeight="bold"
            style={{
              fontSize: 9,
            }}
          >
            {frameText ? frameText : "SCAN ME!"}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};

export const CreatedIconDashboard = (props) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M16.24 11.51l1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89l-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

export const ModifiedIconDashboard = (props) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth={2}
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const DeleteSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={190}
    height={190}
    viewBox="0 0 190 190"
    className="injected-svg"
    data-src="/svg/icon-delete.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#D1E5FA" cx={95} cy={95} r={95} />
      <path
        d="M119.24 154.054H75.895c-6.383 0-11.751-4.754-12.484-11.053l-9.243-79.528h86.8L131.724 143c-.732 6.3-6.1 11.053-12.484 11.053zM82.306 43.406c0-8.374 6.833-15.163 15.262-15.163 8.428 0 15.261 6.789 15.261 15.163h21.027c7.61 0 13.78 6.13 13.78 13.69v6.377H47.5v-6.376c0-7.562 6.17-13.691 13.78-13.691z"
        fill="#F6FAFE"
      />
      <path
        d="M119.24 154.054H75.895c-6.383 0-11.751-4.754-12.484-11.053l-9.243-79.528h86.8L131.724 143c-.732 6.3-6.1 11.053-12.484 11.053zm14.616-110.648H61.28c-7.61 0-13.78 6.13-13.78 13.69v6.377h100.135v-6.376c0-7.562-6.17-13.691-13.78-13.691zM97.568 28.243c-8.43 0-15.262 6.789-15.262 15.163h30.523c0-8.374-6.833-15.163-15.261-15.163zm.012 56.853v45.577-45.577zm22.851 0-5.068 45.577 5.068-45.577zm-45.726 0 5.067 45.577-5.067-45.577z"
        stroke="#0A335C"
        strokeWidth={5.135}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        fill="#FDEAB5"
        style={{
          mixBlendMode: "multiply",
        }}
        cx={111.125}
        cy={69.966}
        r={25.676}
      />
      <g transform="translate(15.27 110.172)">
        <ellipse
          stroke="#0A335C"
          strokeWidth={5.135}
          fill="#F6FAFE"
          cx={30.972}
          cy={30.811}
          rx={28.405}
          ry={28.243}
        />
        <path
          d="m24.07 38.202-7.445-7.445a2.137 2.137 0 0 0-3.025 0 2.137 2.137 0 0 0 0 3.025l8.968 8.968a2.137 2.137 0 0 0 3.024 0l22.699-22.698a2.137 2.137 0 0 0 0-3.025 2.137 2.137 0 0 0-3.025 0L24.069 38.202z"
          fill="#0A335C"
        />
      </g>
      <g fill="#FACF51" fillRule="nonzero">
        <path d="M138.743 160.229a2.363 2.363 0 0 0-2.732-.752c-.183.07-.426.164-.586.294-1.017.806-1.223 2.27-.479 3.3l3.36 4.387a2.446 2.446 0 0 0 3.317.458c1.018-.806 1.224-2.27.48-3.3l-3.36-4.387zM141.569 155.405l5.514.722c1.326.183 2.503-.753 2.657-1.99.154-1.235-.744-2.483-1.987-2.63l-5.513-.721a2.5 2.5 0 0 0-1.127.155c-.792.304-1.36 1.007-1.508 1.895a2.193 2.193 0 0 0 1.964 2.569zM140.795 145.386l4.434-3.364c1.017-.806 1.223-2.27.479-3.3a2.363 2.363 0 0 0-2.732-.75c-.183.07-.426.163-.586.294l-4.434 3.363c-1.017.806-1.223 2.27-.479 3.3.83 1.067 2.3 1.263 3.318.457zM120.502 157.815a2.363 2.363 0 0 0-2.733-.752c-.182.07-.426.164-.585.294l-4.434 3.364c-1.018.806-1.224 2.27-.48 3.3a2.446 2.446 0 0 0 3.318.457l4.434-3.364c1.041-.746 1.247-2.21.48-3.3zM127.518 161.906a2.5 2.5 0 0 0-1.127.156c-.791.304-1.36 1.007-1.507 1.894l-.758 5.484c-.192 1.32.744 2.483 1.987 2.63 1.327.183 2.503-.754 2.657-1.99l.758-5.483c.191-1.32-.683-2.508-2.01-2.69z" />
      </g>
      <g transform="translate(41.081 71.892)" fill="#DFA706">
        <rect width={23.108} height={5.135} rx={2.568} />
        <rect y={10.27} width={23.108} height={5.135} rx={2.568} />
        <rect x={5.483} y={20.541} width={12.925} height={5.135} rx={2.568} />
      </g>
    </g>
  </svg>
);

export const ActivePausedSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={190}
    height={190}
    viewBox="0 0 190 190"
    className="injected-svg"
    data-src="/svg/icon-pause.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#D1E5FA" cx={95} cy={95} r={95} />
      <g transform="translate(12.702 6.974)">
        <rect
          stroke="#0A335C"
          strokeWidth={5.135}
          fill="#F6FAFE"
          x={19.392}
          y={28.972}
          width={123.243}
          height={122.648}
          rx={3.851}
        />
        <rect
          fill="#197FE6"
          x={34.798}
          y={44.303}
          width={15.405}
          height={15.331}
          rx={3.851}
        />
        <rect
          fill="#197FE6"
          x={57.906}
          y={44.303}
          width={15.405}
          height={15.331}
          rx={3.851}
        />
        <rect
          fill="#197FE6"
          x={34.798}
          y={67.299}
          width={15.405}
          height={15.331}
          rx={3.851}
        />
        <rect
          fill="#197FE6"
          x={57.906}
          y={67.299}
          width={15.405}
          height={15.331}
          rx={3.851}
        />
        <rect
          fill="#197FE6"
          x={46.352}
          y={55.801}
          width={15.405}
          height={15.331}
          rx={3.851}
        />
        <rect
          fill="#0A335C"
          x={42.5}
          y={105.627}
          width={23.108}
          height={22.996}
          rx={3.851}
        />
        <rect
          fill="#0A335C"
          x={96.419}
          y={51.968}
          width={23.108}
          height={22.996}
          rx={3.851}
        />
        <rect
          stroke="#0A335C"
          strokeWidth={5.135}
          x={34.798}
          y={97.961}
          width={38.514}
          height={38.327}
          rx={3.851}
        />
        <rect
          stroke="#0A335C"
          strokeWidth={5.135}
          x={88.717}
          y={44.303}
          width={38.514}
          height={38.327}
          rx={3.851}
        />
        <g fill="#FACF51" fillRule="nonzero">
          <path d="M110.63 117.666c-1.433-1.422-3.91-.711-4.366 1.228l-5.475 24.239c-.457 1.874 1.369 3.555 3.259 3.038l5.735-1.68c.522-.13 1.108.128 1.239.646l4.172 14.22c.39 1.357 1.825 2.132 3.193 1.745l4.889-1.422a2.555 2.555 0 0 0 1.76-3.167l-4.172-14.22c-.13-.517.13-1.1.652-1.229l5.736-1.68c1.89-.517 2.477-2.908 1.108-4.266l-17.73-17.452zM103.005 106.248a2.363 2.363 0 0 0 2.281 1.68c.196 0 .457 0 .652-.064 1.239-.388 1.956-1.68 1.63-2.909l-1.565-5.3a2.446 2.446 0 0 0-2.933-1.616c-1.238.388-1.955 1.68-1.63 2.909l1.565 5.3zM98.637 109.739l-4.888-2.65c-1.173-.647-2.607-.195-3.194.904-.586 1.099-.195 2.585.913 3.168l4.888 2.65a2.5 2.5 0 0 0 1.108.258c.848 0 1.63-.453 2.086-1.228a2.193 2.193 0 0 0-.912-3.103zM95.77 119.37l-5.345 1.55c-1.239.388-1.956 1.681-1.63 2.91a2.363 2.363 0 0 0 2.282 1.68c.195 0 .456 0 .652-.065l5.345-1.551c1.238-.388 1.955-1.68 1.63-2.909-.392-1.293-1.696-2.004-2.934-1.616zM119.17 115.039a2.363 2.363 0 0 0 2.28 1.68c.196 0 .457 0 .653-.064l5.345-1.552c1.238-.388 1.955-1.68 1.63-2.908a2.446 2.446 0 0 0-2.934-1.616l-5.345 1.551c-1.239.323-1.956 1.616-1.63 2.909zM114.085 108.704a2.5 2.5 0 0 0 1.108.259c.848 0 1.63-.453 2.086-1.228l2.673-4.848c.652-1.163.195-2.585-.913-3.167-1.173-.647-2.607-.194-3.194.904l-2.672 4.848c-.652 1.164-.26 2.586.912 3.232z" />
        </g>
        <ellipse
          stroke="#0A335C"
          strokeWidth={5.135}
          fill="#F6FAFE"
          cx={30.972}
          cy={36.441}
          rx={28.405}
          ry={28.243}
        />
        <g fill="#FACF51" fillRule="nonzero">
          <path d="M150.858 16.508a2.363 2.363 0 0 0-.217 2.826c.104.165.242.387.4.518.986.845 2.462.768 3.33-.16l3.667-4.135a2.446 2.446 0 0 0-.184-3.343c-.985-.845-2.462-.768-3.33.16l-3.666 4.134zM145.583 14.654l-.343-5.55c-.073-1.337-1.217-2.313-2.46-2.229-1.242.085-2.296 1.204-2.202 2.453l.343 5.55c.043.434.195.8.368 1.076.449.719 1.247 1.142 2.147 1.118a2.193 2.193 0 0 0 2.147-2.418zM135.896 17.326l-4.148-3.71c-.985-.846-2.461-.769-3.33.158a2.363 2.363 0 0 0-.216 2.826c.104.166.242.387.4.519l4.148 3.71c.985.845 2.461.768 3.33-.16.89-1.016.802-2.498-.184-3.343zM151.969 34.875a2.363 2.363 0 0 0-.217 2.825c.104.166.242.387.4.519l4.149 3.71c.985.846 2.461.769 3.33-.159a2.446 2.446 0 0 0-.184-3.343l-4.148-3.711c-.93-.88-2.407-.802-3.33.159zM154.646 27.207c.043.434.196.8.368 1.076.45.719 1.248 1.142 2.147 1.118l5.527-.302c1.332-.063 2.296-1.204 2.203-2.452-.073-1.338-1.217-2.314-2.46-2.23l-5.527.303c-1.333.065-2.331 1.15-2.258 2.487z" />
        </g>
        <path
          d="M24.527 48.229c2.119 0 3.852-1.568 3.852-3.485V27.321c0-1.916-1.733-3.484-3.852-3.484-2.118 0-3.851 1.568-3.851 3.484v17.423c0 1.917 1.733 3.485 3.851 3.485zm8.987-20.908v17.423c0 1.917 1.733 3.485 3.851 3.485s3.852-1.568 3.852-3.485V27.321c0-1.916-1.734-3.484-3.852-3.484s-3.851 1.568-3.851 3.484z"
          fill="#0A335C"
        />
      </g>
    </g>
  </svg>
);

// export const PreviewFrame = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={287}
//     height={570}
//     fill="none"
//     viewBox="0 0 290 591"
//     className="injected-svg"
//     data-src="/images/phone-previews/phone-empty.svg"
//     xmlnsXlink="http://www.w3.org/1999/xlink"
//     role="img"
//     {...props}
//   >
//     <path
//       fill="#fff"
//       fillRule="evenodd"
//       d="M45.541 1.338h198.03c22.565 0 40.857 18.293 40.857 40.857v505.282c0 22.564-18.292 40.856-40.857 40.856H45.541c-22.564 0-40.856-18.292-40.856-40.856V42.195c0-22.564 18.292-40.857 40.856-40.857zm3.905 8.7h189.61c19.546 0 35.392 15.846 35.392 35.393v498.26c0 19.546-15.846 35.392-35.392 35.392H49.446c-19.547 0-35.392-15.846-35.392-35.392V45.431c0-19.547 15.845-35.393 35.392-35.393z"
//       clipRule="evenodd"
//     />
//     <path
//       fill="#000"
//       fillRule="evenodd"
//       d="M47.195 4.015h195.06c21.261 0 38.495 17.235 38.495 38.495v503.944c0 21.26-17.234 38.495-38.495 38.495H47.195c-21.26 0-38.495-17.235-38.495-38.495V42.51c0-21.26 17.235-38.495 38.495-38.495zm2.258 6.061h189.61c19.547 0 35.392 15.846 35.392 35.393v498.26c0 19.546-15.845 35.392-35.392 35.392H49.453c-19.546 0-35.392-15.846-35.392-35.392V45.469c0-19.547 15.846-35.393 35.392-35.393z"
//       clipRule="evenodd"
//     />
//     <path
//       fill="#000"
//       fillRule="evenodd"
//       d="M45.988 0h197.084c23.92 0 43.311 19.391 43.311 43.311v503.636c0 23.92-19.391 43.311-43.311 43.311H45.988c-23.92 0-43.311-19.391-43.311-43.311V43.311C2.677 19.391 22.068 0 45.988 0zm-.357 1.399h198.031c22.564 0 40.856 18.292 40.856 40.856v505.282c0 22.564-18.292 40.856-40.856 40.856H45.632c-22.565 0-40.857-18.292-40.857-40.856V42.255C4.775 19.691 23.067 1.4 45.63 1.4z"
//       clipRule="evenodd"
//     />
//     <path
//       fill="#515151"
//       fillRule="evenodd"
//       d="M45.872 2.564h197.257c21.668 0 39.233 17.565 39.233 39.231V546.9c0 21.667-17.565 39.231-39.233 39.231H45.872c-21.667 0-39.232-17.564-39.232-39.231V41.796c0-21.667 17.565-39.232 39.232-39.232zm1.085 1.397H241.81c21.238 0 38.454 17.217 38.454 38.454v503.399c0 21.237-17.216 38.453-38.454 38.453H46.957c-21.238 0-38.455-17.216-38.455-38.453v-503.4c0-21.236 17.217-38.453 38.455-38.453z"
//       clipRule="evenodd"
//     />
//     <path
//       fill="#E2E2E2"
//       d="M.241 179.679c0 .259.07.506.268.553l1.614.431c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.468-.326-.468l-1.679.473c-.21.091-.198.601-.198.862l.056 35.136z"
//     />
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="a-5"
//         width={3}
//         height={38}
//         x={0}
//         y={143}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.241 179.679c0 .259.07.506.268.553l1.614.431c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.468-.326-.468l-1.679.473c-.21.091-.198.601-.198.862l.056 35.136z"
//         />
//       </mask>
//       <g mask="url(#a-5)">
//         <path
//           fill="#414042"
//           d="m2.447 178.812-.061-35.604h.06v35.604zm-.01 1.851-.063-37.455h.012l.06 35.604v1.851h-.009z"
//         />
//         <path
//           fill="#464547"
//           d="m2.426 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m2.414 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m2.402 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#545355"
//           d="m2.39 180.663-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#595859"
//           d="m2.379 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m2.37 180.663-.066-37.455h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#616162"
//           d="m2.358 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#666566"
//           d="m2.346 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#6A696B"
//           d="m2.335 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m2.323 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#727173"
//           d="m2.311 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#767576"
//           d="m2.3 180.663-.065-37.455h.011l.065 37.455H2.3z"
//         />
//         <path
//           fill="#79797A"
//           d="m2.288 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m2.276 180.663-.063-37.455h.01l.065 37.455h-.012z"
//         />
//         <path
//           fill="#818081"
//           d="m2.265 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#848485"
//           d="m2.253 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#888788"
//           d="m2.242 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m2.23 180.663-.063-37.455h.012l.062 37.455H2.23z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m2.218 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#929192"
//           d="m2.207 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#959495"
//           d="m2.195 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#989799"
//           d="m2.183 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m2.172 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m2.16 180.663-.063-37.455h.012l.063 37.455H2.16z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m2.148 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m2.137 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m2.125 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m2.113 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m2.104 180.663-.065-37.455h.011l.063 37.455h-.009z"
//         />
//         <path
//           fill="#AEAEAF"
//           d="m2.092 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#B1B0B1"
//           d="m2.08 180.663-.065-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m2.069 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m2.057 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m2.046 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#BABABA"
//           d="m2.034 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m2.022 180.663-.063-37.455h.01l.065 37.455h-.012z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m2.01 180.663-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m1.999 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m1.987 180.663-.063-37.455h.012L2 180.663h-.012z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m1.976 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m1.964 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m1.952 180.663-.062-37.455h.01l.063 37.455h-.012z"
//         />
//         <path
//           fill="#CACACA"
//           d="m1.94 180.663-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#CCC"
//           d="m1.93 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m1.917 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m1.906 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m1.894 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m1.883 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m1.87 180.663-.062-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m1.86 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m1.847 180.663-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="m1.838 180.663-.065-37.455h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m1.827 180.663-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m1.815 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m1.803 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m1.792 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m1.78 180.663-.065-37.455h.011l.066 37.455H1.78z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m1.768 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m1.757 180.663-.063-37.455h.009l.065 37.455h-.011z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m1.745 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m1.733 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m1.722 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m1.71 180.663-.063-37.455h.012l.063 37.455H1.71z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m1.698 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m1.687 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m1.675 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="M1.663 180.663 1.6 143.208h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m1.652 180.663-.063-37.455H1.6l.063 37.455h-.011z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m1.64 180.663-.063-37.455h.012l.063 37.455H1.64z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m1.628 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#ECECED"
//           d="m1.617 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m1.605 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EEE"
//           d="m1.593 180.663-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.582 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.572 180.663-.065-37.455h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.56 180.663-.065-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.55 180.663-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.537 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.526 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.514 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.503 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.49 180.663-.062-37.455h.01l.064 37.455h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.48 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.467 180.663-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.456 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.444 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.433 180.663-.063-37.455h.011l.063 37.455h-.011zm-.013 0-.062-37.455h.012l.063 37.455H1.42z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.41 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.398 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.386 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.374 180.663-.063-37.455h.012l.063 37.455h-.012zm-.011 0L1.3 143.208h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.35 180.663-.062-37.455H1.3l.063 37.455H1.35z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.34 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.328 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.318 180.663-.065-37.455h.012l.063 37.455h-.01zm-.011 0-.066-37.455h.012l.065 37.455h-.011zM1.295 180.663l-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.283 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.272 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.26 180.663-.065-37.455h.011l.066 37.455H1.26z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.248 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.237 180.663-.065-37.455h.011l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.225 180.663-.063-37.455h.01l.065 37.455h-.012zm-.012 0-.062-37.455h.011l.063 37.455h-.012zm-.011 0-.063-37.455h.011l.063 37.455h-.011zM1.19 180.663l-.063-37.455h.012l.063 37.455H1.19z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.178 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.167 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.155 180.663-.063-37.455h.012l.063 37.455h-.012zm-.011 0-.063-37.455h.011l.063 37.455h-.011zm-.012 0-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.12 180.663-.063-37.455h.012l.063 37.455H1.12zm-.012 0-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.097 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.085 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.074 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.062 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.053 180.663-.066-37.455H1l.063 37.455h-.01z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.04 180.663-.064-37.455h.011l.066 37.455H1.04z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.03 180.663-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.018 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.006 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="M.994 180.663.93 143.208h.012l.065 37.455H.994z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.983 180.663-.066-37.455H.93l.065 37.455H.983zm-.012 0-.065-37.455h.011l.066 37.455H.97z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.96 180.663-.064-37.455h.01l.065 37.455H.959z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.948 180.663-.063-37.455h.011l.063 37.455H.948z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.936 180.663-.063-37.455h.012l.063 37.455H.936zm-.012 0-.063-37.455h.012l.063 37.455H.924zm-.011 0L.85 143.208h.01l.063 37.455h-.01z"
//         />
//         <path fill="#fff" d="m.901 180.663-.063-37.455H.85l.063 37.455H.9z" />
//         <path
//           fill="#fff"
//           d="m.89 180.663-.064-37.455h.012l.063 37.455H.889zm-.012 0-.063-37.455h.011l.063 37.455H.878zm-.012 0-.063-37.455h.012l.063 37.455H.866z"
//         />
//         <path
//           fill="#fff"
//           d="m.854 180.663-.062-37.455h.011l.063 37.455H.854zm-.011 0L.78 143.208h.01l.063 37.455h-.01zm-.012 0-.063-37.455H.78l.063 37.455H.83z"
//         />
//         <path fill="#fff" d="m.82 180.663-.064-37.455h.012l.063 37.455H.82z" />
//         <path
//           fill="#fff"
//           d="m.808 180.663-.063-37.455h.012l.062 37.455H.808z"
//         />
//         <path
//           fill="#fff"
//           d="m.796 180.663-.063-37.455h.012l.063 37.455H.796zm-.009 0-.065-37.455h.011l.063 37.455h-.01zm-.012 0L.71 143.208h.01l.066 37.455H.775zm-.011 0-.066-37.455H.71l.065 37.455H.764z"
//         />
//         <path
//           fill="#fff"
//           d="m.752 180.663-.065-37.455h.011l.065 37.455H.752z"
//         />
//         <path fill="#fff" d="m.74 180.663-.065-37.455h.012l.065 37.455H.74z" />
//         <path
//           fill="#fff"
//           d="m.728 180.663-.065-37.455h.012l.065 37.455H.728z"
//         />
//         <path
//           fill="#fff"
//           d="m.717 180.663-.065-37.455h.011l.066 37.455H.717z"
//         />
//         <path fill="#fff" d="M.705 180.663.64 143.208h.012l.065 37.455H.705z" />
//         <path fill="#fff" d="M.694 180.663.63 143.208h.01l.065 37.455H.694z" />
//         <path
//           fill="#fff"
//           d="m.682 180.663-.063-37.455h.012l.063 37.455H.682z"
//         />
//         <path fill="#fff" d="m.67 180.663-.063-37.455H.62l.063 37.455H.67z" />
//         <path fill="#fff" d="m.659 180.663-.063-37.455h.011l.063 37.455H.66z" />
//         <path
//           fill="#fff"
//           d="m.647 180.663-.063-37.455h.012l.063 37.455H.647z"
//         />
//         <path
//           fill="#fff"
//           d="m.635 180.663-.063-37.455h.012l.063 37.455H.635zm-.011 0L.56 143.208h.011l.063 37.455h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="m.612 180.663-.063-37.455h.012l.063 37.455H.612z"
//         />
//         <path fill="#fff" d="m.6 180.663-.063-37.455H.55l.063 37.455H.6z" />
//         <path fill="#fff" d="m.589 180.663-.063-37.455h.011L.6 180.663H.59z" />
//         <path
//           fill="#fff"
//           d="m.577 180.663-.063-37.455h.012l.063 37.455H.577z"
//         />
//         <path
//           fill="#fff"
//           d="m.565 180.663-.063-37.455h.012l.063 37.455H.565zm-.011 0L.49 143.208h.011l.063 37.455h-.01z"
//         />
//         <path fill="#fff" d="M.542 180.663.48 143.208h.012l.063 37.455H.542z" />
//         <path fill="#fff" d="m.53 180.663-.063-37.455H.48l.063 37.455H.53z" />
//         <path
//           fill="#fff"
//           d="m.521 180.663-.065-37.455h.011l.063 37.455H.521z"
//         />
//         <path fill="#fff" d="m.51 180.663-.066-37.455h.012l.065 37.455H.509z" />
//         <path
//           fill="#fff"
//           d="m.498 180.663-.066-37.455h.012l.065 37.455H.498z"
//         />
//         <path
//           fill="#fff"
//           d="m.486 180.663-.065-37.455h.011l.066 37.455H.486z"
//         />
//         <path fill="#fff" d="M.474 180.663.41 143.208h.012l.065 37.455H.474z" />
//         <path fill="#fff" d="m.463 180.663-.066-37.455H.41l.065 37.455H.463z" />
//         <path fill="#fff" d="m.451 180.663-.065-37.455h.012l.065 37.455H.45z" />
//         <path fill="#fff" d="m.44 180.663-.064-37.455h.01l.065 37.455H.44z" />
//         <path
//           fill="#fff"
//           d="m.428 180.663-.063-37.455h.012l.062 37.455H.428z"
//         />
//         <path
//           fill="#fff"
//           d="m.416 180.663-.063-37.455h.012l.063 37.455H.416z"
//         />
//         <path
//           fill="#fff"
//           d="m.404 180.663-.062-37.455h.011l.063 37.455H.404z"
//         />
//         <path
//           fill="#fff"
//           d="M.393 180.663.33 143.208h.012l.063 37.455H.393zm-.012 0-.063-37.455H.33l.063 37.455H.38z"
//         />
//         <path fill="#fff" d="m.37 180.663-.063-37.455h.011l.063 37.455H.37z" />
//         <path
//           fill="#fff"
//           d="m.358 180.663-.063-37.455h.012l.063 37.455H.358z"
//         />
//         <path
//           fill="#fff"
//           d="m.346 180.663-.063-37.455h.012l.063 37.455H.346z"
//         />
//         <path
//           fill="#fff"
//           d="m.335 180.663-.063-37.455h.011l.063 37.455H.335z"
//         />
//         <path
//           fill="#fff"
//           d="M.323 180.663.26 143.208h.012l.063 37.455H.323zm-.012 0-.063-37.455H.26l.063 37.455H.31z"
//         />
//         <path fill="#fff" d="m.3 180.663-.063-37.455h.011l.063 37.455H.3z" />
//         <path fill="#fff" d="m.288 180.663-.063-37.455h.012L.3 180.663H.288z" />
//         <path
//           fill="#fff"
//           d="m.276 180.663-.063-37.455h.012l.063 37.455H.276z"
//         />
//         <path
//           fill="#fff"
//           d="m.265 180.663-.063-37.455h.011l.063 37.455H.265z"
//         />
//         <path
//           fill="#fff"
//           d="M.255 180.663.19 143.208h.012l.063 37.455h-.01zm-.011 0-.066-37.455H.19l.065 37.455H.244z"
//         />
//         <path fill="#fff" d="m.178 143.208.066 37.455h-.07v-37.455h.004z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="b-6"
//         width={3}
//         height={4}
//         x={0}
//         y={143}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m.964 146.32-.776-.089v-1.688s-.091-.795.26-.881c.32-.079 1.612-.454 1.612-.454s.298.007.324.433c.025.424.004 2.606.004 2.606l-1.426.07.002.003z"
//         />
//       </mask>
//       <g mask="url(#b-6)">
//         <path fill="#fff" d="m.097 146.303 2.315-.002v.019H.097v-.017z" />
//         <path fill="#fff" d="m.097 146.296 2.315-.004v.009l-2.315.002v-.007z" />
//         <path
//           fill="#FEFEFE"
//           d="m.097 146.287 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m.097 146.278 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m.097 146.268 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m.097 146.259 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m.097 146.252 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m.097 146.243 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m.097 146.233 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#F6F5F5"
//           d="m.097 146.224 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m.097 146.217 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m.097 146.208 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m.097 146.198 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m.097 146.189 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m.097 146.18 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m.097 146.173 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m.097 146.163 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m.097 146.154 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m.097 146.145 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m.097 146.138 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m.097 146.129 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m.097 146.119 2.315-.004v.009l-2.315.004v-.009z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m.097 146.11 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m.097 146.101 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m.097 146.094 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m.097 146.084 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m.097 146.075 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m.097 146.066 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m.097 146.059 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m.097 146.049 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path fill="#DDD" d="m.097 146.04 2.315-.005v.01l-2.315.004v-.009z" />
//         <path
//           fill="#DCDBDC"
//           d="m.097 146.031 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m.097 146.021 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m.097 146.014 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="M.097 146.005 2.412 146v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m.097 145.996 2.315-.005V146l-2.315.005v-.009z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m.097 145.986 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m.097 145.979 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m.097 145.97 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m.097 145.961 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m.097 145.951 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m.097 145.942 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m.097 145.935 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#CECECE"
//           d="m.097 145.926 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m.097 145.916 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m.097 145.907 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path fill="#CBCACA" d="m.097 145.9 2.315-.005v.01l-2.315.002v-.007z" />
//         <path
//           fill="#CAC9C9"
//           d="m.097 145.891 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#C9C8C8"
//           d="m.097 145.881 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#C8C7C7"
//           d="m.097 145.872 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m.097 145.863 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m.097 145.856 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m.097 145.846 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m.097 145.837 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m.097 145.828 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m.097 145.821 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m.097 145.811 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m.097 145.802 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m.097 145.793 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="m.097 145.783 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m.097 145.777 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m.097 145.767 2.315-.004v.009l-2.315.004v-.009z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m.097 145.758 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m.097 145.749 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m.097 145.742 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m.097 145.732 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m.097 145.723 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m.097 145.714 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m.097 145.704 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m.097 145.697 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m.097 145.688 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m.097 145.679 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m.097 145.669 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m.097 145.662 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m.097 145.653 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m.097 145.644 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m.097 145.634 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m.097 145.625 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m.097 145.618 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m.097 145.609 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m.097 145.599 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m.097 145.59 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m.097 145.583 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m.097 145.574 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m.097 145.564 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m.097 145.555 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m.097 145.546 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m.097 145.539 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m.097 145.529 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m.097 145.52 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#9B9999"
//           d="m.097 145.511 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#9A9898"
//           d="m.097 145.504 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#999797"
//           d="m.097 145.494 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#979696"
//           d="m.097 145.485 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#969495"
//           d="m.097 145.476 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#959394"
//           d="m.097 145.466 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#949293"
//           d="m.097 145.459 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#939192"
//           d="m.097 145.45 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#929091"
//           d="m.097 145.441 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#918F90"
//           d="m.097 145.431 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#908E8F"
//           d="m.097 145.424 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m.097 145.415 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m.097 145.406 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m.097 145.396 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m.097 145.387 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#8B8989"
//           d="m.097 145.38 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#8A8888"
//           d="m.097 145.371 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#898787"
//           d="m.097 145.362 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#888686"
//           d="m.097 145.352 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#878485"
//           d="m.097 145.345 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#868384"
//           d="m.097 145.336 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#858283"
//           d="m.097 145.327 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#848182"
//           d="m.097 145.317 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#838081"
//           d="m.097 145.308 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#817F80"
//           d="m.097 145.301 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#807E7F"
//           d="m.097 145.292 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m.097 145.282 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m.097 145.273 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m.097 145.266 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m.097 145.257 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#7B797A"
//           d="m.097 145.247 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#7A7879"
//           d="m.097 145.238 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#797778"
//           d="m.097 145.231 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#787676"
//           d="m.097 145.222 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#777575"
//           d="m.097 145.212 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#767474"
//           d="m.097 145.203 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#757373"
//           d="m.097 145.194 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#747272"
//           d="m.097 145.187 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#737171"
//           d="m.097 145.177 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#727070"
//           d="m.097 145.168 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#716F6F"
//           d="m.097 145.159 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#706E6E"
//           d="m.097 145.152 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m.097 145.142 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m.097 145.133 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m.097 145.124 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m.097 145.114 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#6B6969"
//           d="m.097 145.107 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#6A6868"
//           d="m.097 145.098 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#696767"
//           d="m.097 145.089 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#686666"
//           d="m.097 145.079 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#676565"
//           d="m.097 145.072 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#666464"
//           d="m.097 145.063 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#666363"
//           d="m.097 145.054 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#656262"
//           d="m.097 145.045 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#646161"
//           d="m.097 145.035 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#636060"
//           d="m.097 145.028 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#625F5F"
//           d="m.097 145.019 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#615E5F"
//           d="m.097 145.01 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path fill="#605D5E" d="m.097 145 2.315-.002v.007l-2.315.005V145z" />
//         <path
//           fill="#5F5C5D"
//           d="m.097 144.993 2.315-.004v.009L.097 145v-.007z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m.097 144.984 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m.097 144.975 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#5C595A"
//           d="m.097 144.965 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#5B5859"
//           d="m.097 144.956 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#5A5758"
//           d="m.097 144.949 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#595657"
//           d="m.097 144.94 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#585556"
//           d="m.097 144.93 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#575455"
//           d="m.097 144.921 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#565354"
//           d="m.097 144.914 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#555253"
//           d="m.097 144.905 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#545152"
//           d="m.097 144.895 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#545051"
//           d="m.097 144.886 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#534F50"
//           d="m.097 144.877 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#524F4F"
//           d="m.097 144.87 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#514E4E"
//           d="m.097 144.86 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#504D4D"
//           d="m.097 144.851 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m.097 144.842 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m.097 144.835 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m.097 144.825 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#4C494A"
//           d="m.097 144.816 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#4B4849"
//           d="m.097 144.807 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#4A4748"
//           d="m.097 144.797 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#4A4647"
//           d="m.097 144.79 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#494546"
//           d="m.097 144.781 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#484445"
//           d="m.097 144.772 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#474444"
//           d="m.097 144.762 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#464344"
//           d="m.097 144.755 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#454243"
//           d="m.097 144.746 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#444142"
//           d="m.097 144.737 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#434041"
//           d="m.097 144.727 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#433F40"
//           d="m.097 144.718 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#423E3F"
//           d="m.097 144.711 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#413D3E"
//           d="m.097 144.702 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#403D3D"
//           d="m.097 144.692 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m.097 144.683 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m.097 144.676 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m.097 144.667 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#3D393A"
//           d="m.097 144.657 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3C3839"
//           d="m.097 144.648 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3B3738"
//           d="m.097 144.639 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#3A3738"
//           d="m.097 144.632 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#393637"
//           d="m.097 144.623 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#393536"
//           d="m.097 144.613 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#383435"
//           d="m.097 144.604 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#373334"
//           d="m.097 144.597 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#363333"
//           d="m.097 144.588 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#353233"
//           d="m.097 144.578 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#353132"
//           d="m.097 144.569 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#343031"
//           d="m.097 144.56 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#332F30"
//           d="m.097 144.553 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#322F30"
//           d="m.097 144.543 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#322E2F"
//           d="m.097 144.534 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#312D2E"
//           d="m.097 144.525 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#302C2D"
//           d="m.097 144.518 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m.097 144.508 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m.097 144.499 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m.097 144.49 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#2D292A"
//           d="m.097 144.48 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#2C292A"
//           d="m.097 144.473 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#2C2829"
//           d="m.097 144.464 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#2B2728"
//           d="m.097 144.455 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#2A2627"
//           d="m.097 144.445 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#2A2627"
//           d="m.097 144.438 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#292526"
//           d="m.097 144.429 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#282425"
//           d="m.097 144.42 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#282425"
//           d="m.097 144.41 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#272324"
//           d="m.097 144.401 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#272324"
//           d="m.097 144.394 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#262223"
//           d="m.097 144.385 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#252122"
//           d="m.097 144.375 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#252122"
//           d="m.097 144.366 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#242021"
//           d="m.097 144.359 2.315-.005v.01l-2.315.002v-.007zm0-.009 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#231F20"
//           d="m.097 144.34 2.315-.004v.009l-2.315.005v-.01zm0-.009 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path fill="#231F20" d="m2.412 144.329-2.315.002v-1.123h2.315v1.121z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="c-7"
//         width={3}
//         height={4}
//         x={0}
//         y={177}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m1.013 177.555-.776.091v1.688s-.087.853.26.895c.325.04 1.62.434 1.62.434s.3-.01.325-.434c.026-.424-.005-2.608-.005-2.608l-1.426-.066h.002z"
//         />
//       </mask>
//       <g mask="url(#c-7)">
//         <path
//           fill="#fff"
//           d="m2.47 177.569-2.32.005v-.019h2.32v.014zm0 .01-2.32.004v-.009l2.32-.005v.01z"
//         />
//         <path fill="#FEFEFE" d="m2.47 177.588-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#FDFDFD" d="m2.47 177.597-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#FBFBFB" d="m2.47 177.604-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#FAFAFA" d="m2.47 177.614-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#F9F9F9" d="m2.47 177.623-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#F8F8F8" d="m2.47 177.632-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#F7F7F7" d="m2.47 177.639-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#F6F5F5" d="m2.47 177.649-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#F4F4F4" d="m2.47 177.658-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#F3F3F3" d="m2.47 177.667-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#F2F2F2" d="m2.47 177.676-2.32.003v-.009l2.32-.003v.009z" />
//         <path fill="#F1F1F1" d="m2.47 177.684-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#F0EFF0" d="m2.47 177.693-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#EFEEEE" d="m2.47 177.702-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#EDEDED" d="m2.47 177.711-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#ECECEC" d="m2.47 177.718-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#EBEBEB" d="m2.47 177.728-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#EAEAEA" d="m2.47 177.737-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#E9E8E8" d="m2.47 177.746-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#E8E7E7" d="m2.47 177.756-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#E6E6E6" d="m2.47 177.763-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#E5E5E5" d="m2.47 177.772-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#E4E4E4" d="m2.47 177.781-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#E3E2E3" d="m2.47 177.791-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#E2E1E1" d="m2.47 177.798-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#E1E0E0" d="m2.47 177.807-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#E0DFDF" d="m2.47 177.816-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#DEDEDE" d="m2.47 177.826-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#DDD" d="m2.47 177.835-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#DCDBDC" d="m2.47 177.842-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#DBDADA" d="m2.47 177.851-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#DAD9D9" d="m2.47 177.861-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#D9D8D8" d="m2.47 177.87-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#D8D7D7" d="m2.47 177.877-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#D6D6D6" d="m2.47 177.886-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#D5D4D5" d="m2.47 177.896-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#D4D3D4" d="m2.47 177.905-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#D3D2D2" d="m2.47 177.912-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#D2D1D1" d="m2.47 177.921-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#D1D0D0" d="m2.47 177.931-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#D0CFCF" d="m2.47 177.94-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#CECECE" d="m2.47 177.949-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#CDCCCD" d="m2.47 177.956-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#CCCBCB" d="m2.47 177.966-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#CBCACA" d="m2.47 177.975-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#CAC9C9" d="m2.47 177.984-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#C9C8C8" d="m2.47 177.991-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#C8C7C7" d="m2.47 178.001-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#C7C5C6" d="m2.47 178.01-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#C5C4C5" d="m2.47 178.019-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#C4C3C3" d="m2.47 178.029-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#C3C2C2" d="m2.47 178.036-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#C2C1C1" d="m2.47 178.045-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#C1C0C0" d="m2.47 178.054-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#C0BFBF" d="m2.47 178.063-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#BFBEBE" d="m2.47 178.07-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#BEBCBD" d="m2.47 178.08-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#BCBBBC" d="m2.47 178.089-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#BBBABA" d="m2.47 178.098-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#BAB9B9" d="m2.47 178.108-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#B9B8B8" d="m2.47 178.115-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#B8B7B7" d="m2.47 178.124-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#B7B6B6" d="m2.47 178.133-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#B6B4B5" d="m2.47 178.143-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#B5B3B4" d="m2.47 178.15-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#B4B2B3" d="m2.47 178.159-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#B2B1B1" d="m2.47 178.168-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#B1B0B0" d="m2.47 178.178-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#B0AFAF" d="m2.47 178.187-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#AFAEAE" d="m2.47 178.194-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#AEADAD" d="m2.47 178.203-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#ADACAC" d="m2.47 178.213-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#ACAAAB" d="m2.47 178.222-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#ABA9AA" d="m2.47 178.229-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#AAA8A9" d="m2.47 178.238-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#A9A7A7" d="m2.47 178.248-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#A8A6A6" d="m2.47 178.257-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#A6A5A5" d="m2.47 178.266-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#A5A4A4" d="m2.47 178.273-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#A4A3A3" d="m2.47 178.283-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#A3A2A2" d="m2.47 178.292-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#A2A0A1" d="m2.47 178.301-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#A19FA0" d="m2.47 178.308-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#A09E9F" d="m2.47 178.318-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#9F9D9E" d="m2.47 178.327-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#9E9C9D" d="m2.47 178.336-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#9D9B9B" d="m2.47 178.346-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#9C9A9A" d="m2.47 178.353-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#9B9999" d="m2.47 178.362-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#9A9898" d="m2.47 178.371-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#999797" d="m2.47 178.381-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#979696" d="m2.47 178.388-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#969495" d="m2.47 178.397-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#959394" d="m2.47 178.406-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#949293" d="m2.47 178.416-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#939192" d="m2.47 178.425-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#929091" d="m2.47 178.432-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#918F90" d="m2.47 178.441-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#908E8F" d="m2.47 178.45-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#8F8D8D" d="m2.47 178.46-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#8E8C8C" d="m2.47 178.467-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#8D8B8B" d="m2.47 178.476-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#8C8A8A" d="m2.47 178.485-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#8B8989" d="m2.47 178.495-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#8A8888" d="m2.47 178.504-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#898787" d="m2.47 178.511-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#888686" d="m2.47 178.52-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#878485" d="m2.47 178.53-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#868384" d="m2.47 178.539-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#858283" d="m2.47 178.546-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#848182" d="m2.47 178.555-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#838081" d="m2.47 178.565-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#817F80" d="m2.47 178.574-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#807E7F" d="m2.47 178.583-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#7F7D7E" d="m2.47 178.59-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#7E7C7D" d="m2.47 178.6-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#7D7B7C" d="m2.47 178.609-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#7C7A7B" d="m2.47 178.618-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#7B797A" d="m2.47 178.625-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#7A7879" d="m2.47 178.635-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#797778" d="m2.47 178.644-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#787676" d="m2.47 178.653-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#777575" d="m2.47 178.663-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#767474" d="m2.47 178.67-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#757373" d="m2.47 178.679-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#747272" d="m2.47 178.688-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#737171" d="m2.47 178.698-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#727070" d="m2.47 178.705-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#716F6F" d="m2.47 178.714-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#706E6E" d="m2.47 178.723-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#6F6D6D" d="m2.47 178.733-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#6E6C6C" d="m2.47 178.742-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#6D6B6B" d="m2.47 178.749-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#6C6A6A" d="m2.47 178.758-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#6B6969" d="m2.47 178.767-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#6A6868" d="m2.47 178.777-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#696767" d="m2.47 178.784-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#686666" d="m2.47 178.793-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#676565" d="m2.47 178.802-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#666464" d="m2.47 178.812-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#666363" d="m2.47 178.821-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#656262" d="m2.47 178.828-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#646161" d="m2.47 178.837-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#636060" d="m2.47 178.847-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#625F5F" d="m2.47 178.856-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#615E5F" d="m2.47 178.863-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#605D5E" d="m2.47 178.872-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#5F5C5D" d="m2.47 178.882-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#5E5B5C" d="m2.47 178.891-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#5D5A5B" d="m2.47 178.9-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#5C595A" d="m2.47 178.907-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#5B5859" d="m2.47 178.917-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#5A5758" d="m2.47 178.926-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#595657" d="m2.47 178.935-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#585556" d="m2.47 178.942-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#575455" d="m2.47 178.952-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#565354" d="m2.47 178.961-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#555253" d="m2.47 178.97-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#545152" d="m2.47 178.98-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#545051" d="m2.47 178.987-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#534F50" d="m2.47 178.996-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#524F4F" d="m2.47 179.005-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#514E4E" d="m2.47 179.015-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#504D4D" d="m2.47 179.022-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#4F4C4D" d="m2.47 179.031-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#4E4B4C" d="m2.47 179.04-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#4D4A4B" d="m2.47 179.05-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#4C494A" d="m2.47 179.059-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#4B4849" d="m2.47 179.066-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#4A4748" d="m2.47 179.075-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#4A4647" d="m2.47 179.085-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#494546" d="m2.47 179.094-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#484445" d="m2.47 179.101-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#474444" d="m2.47 179.11-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#464344" d="m2.47 179.12-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#454243" d="m2.47 179.129-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#444142" d="m2.47 179.136-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#434041" d="m2.47 179.145-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#433F40" d="m2.47 179.154-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#423E3F" d="m2.47 179.164-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#413D3E" d="m2.47 179.173-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#403D3D" d="m2.47 179.18-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#3F3C3D" d="m2.47 179.189-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#3E3B3C" d="m2.47 179.199-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#3E3A3B" d="m2.47 179.208-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#3D393A" d="m2.47 179.215-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#3C3839" d="m2.47 179.224-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#3B3738" d="m2.47 179.234-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#3A3738" d="m2.47 179.243-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#393637" d="m2.47 179.252-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#393536" d="m2.47 179.259-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#383435" d="m2.47 179.269-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#373334" d="m2.47 179.278-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#363333" d="m2.47 179.287-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#353233" d="m2.47 179.294-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#353132" d="m2.47 179.304-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#343031" d="m2.47 179.313-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#332F30" d="m2.47 179.322-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#322F30" d="m2.47 179.332-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#322E2F" d="m2.47 179.339-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#312D2E" d="m2.47 179.348-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#302C2D" d="m2.47 179.357-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#2F2C2C" d="m2.47 179.367-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#2F2B2C" d="m2.47 179.374-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#2E2A2B" d="m2.47 179.383-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#2D292A" d="m2.47 179.392-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#2C292A" d="m2.47 179.402-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#2C2829" d="m2.47 179.411-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#2B2728" d="m2.47 179.418-2.32.005v-.01l2.32-.002v.007z" />
//         <path
//           fill="#2A2627"
//           d="m2.47 179.427-2.32.005v-.009l2.32-.005v.009zm0 .01-2.32.004v-.009l2.32-.005v.01z"
//         />
//         <path fill="#292526" d="m2.47 179.446-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#282425" d="m2.47 179.453-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#282425" d="m2.47 179.462-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#272324" d="m2.47 179.472-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#272324" d="m2.47 179.481-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#262223" d="m2.47 179.49-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#252122" d="m2.47 179.497-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#252122" d="m2.47 179.507-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#242021" d="m2.47 179.516-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#242021" d="m2.47 179.525-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#231F20" d="m2.47 179.532-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#231F20" d="m2.47 179.541-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#231F20" d="m.15 179.546 2.32-.005v1.122H.15v-1.117z" />
//       </g>
//     </g>
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="d-8"
//         width={3}
//         height={38}
//         x={0}
//         y={143}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.241 179.679c0 .259.07.506.268.553l1.614.431c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.468-.326-.468l-1.679.473c-.21.091-.198.601-.198.862l.056 35.136z"
//         />
//       </mask>
//       <g mask="url(#d-8)">
//         <path
//           fill="#fff"
//           d="m2.447 178.812-.061-35.604h.06v35.604zm-.01 1.851-.063-37.455h.012l.06 35.604v1.851h-.009z"
//         />
//         <path
//           fill="#fff"
//           d="m2.426 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.414 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.402 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.39 180.663-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.379 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.37 180.663-.066-37.455h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="m2.358 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.346 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.335 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.323 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.311 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.3 180.663-.065-37.455h.011l.065 37.455H2.3zm-.012 0-.065-37.455h.011l.066 37.455h-.012zm-.012 0-.063-37.455h.01l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.265 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.253 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.242 180.663-.063-37.455h.011l.063 37.455h-.011zm-.012 0-.063-37.455h.012l.062 37.455H2.23z"
//         />
//         <path
//           fill="#fff"
//           d="m2.218 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.207 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.195 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.183 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.172 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.16 180.663-.063-37.455h.012l.063 37.455H2.16z"
//         />
//         <path
//           fill="#fff"
//           d="m2.148 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.137 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.125 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.113 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.104 180.663-.065-37.455h.011l.063 37.455h-.009z"
//         />
//         <path
//           fill="#fff"
//           d="m2.092 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.08 180.663-.065-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.069 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.057 180.663-.065-37.455h.012l.065 37.455h-.012zm-.011 0-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.034 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.022 180.663-.063-37.455h.01l.065 37.455h-.012zm-.012 0-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.999 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.987 180.663-.063-37.455h.012L2 180.663h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.976 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.964 180.663-.063-37.455h.012l.063 37.455h-.012zm-.012 0-.062-37.455h.01l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.94 180.663-.062-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.93 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.917 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.906 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.894 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.883 180.663-.063-37.455h.011l.063 37.455h-.011zm-.013 0-.062-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.86 180.663-.064-37.455h.012l.063 37.455h-.012zm-.013 0-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.838 180.663-.065-37.455h.012l.063 37.455h-.01zm-.011 0-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.815 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.803 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.792 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.78 180.663-.065-37.455h.011l.066 37.455H1.78z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.768 180.663-.065-37.455h.012l.065 37.455h-.012zm-.011 0-.063-37.455h.009l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.745 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.733 180.663-.063-37.455h.012l.063 37.455h-.012zm-.011 0-.063-37.455h.011l.063 37.455h-.011zM1.71 180.663l-.063-37.455h.012l.063 37.455H1.71z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.698 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.687 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.675 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="M1.663 180.663 1.6 143.208h.012l.063 37.455h-.012zm-.011 0-.063-37.455H1.6l.063 37.455h-.011zM1.64 180.663l-.063-37.455h.012l.063 37.455H1.64z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.628 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.617 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.605 180.663-.063-37.455h.012l.063 37.455h-.012zm-.012 0-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.582 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.572 180.663-.065-37.455h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.56 180.663-.065-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.55 180.663-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.537 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.526 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.514 180.663-.065-37.455h.012l.065 37.455h-.012zm-.011 0-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.49 180.663-.062-37.455h.01l.064 37.455h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.48 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.467 180.663-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.456 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.444 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.433 180.663-.063-37.455h.011l.063 37.455h-.011zm-.013 0-.062-37.455h.012l.063 37.455H1.42z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.41 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.398 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.386 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.374 180.663-.063-37.455h.012l.063 37.455h-.012zm-.011 0L1.3 143.208h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.35 180.663-.062-37.455H1.3l.063 37.455H1.35z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.34 180.663-.064-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.328 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.318 180.663-.065-37.455h.012l.063 37.455h-.01zm-.011 0-.066-37.455h.012l.065 37.455h-.011zM1.295 180.663l-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.283 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.272 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.26 180.663-.065-37.455h.011l.066 37.455H1.26z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.248 180.663-.065-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.237 180.663-.065-37.455h.011l.065 37.455h-.011z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.225 180.663-.063-37.455h.01l.065 37.455h-.012zm-.012 0-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.202 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.19 180.663-.063-37.455h.012l.063 37.455H1.19z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.178 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.167 180.663-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.155 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.144 180.663-.063-37.455h.011l.063 37.455h-.011zm-.012 0-.063-37.455h.012l.062 37.455h-.011z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.12 180.663-.063-37.455h.012l.063 37.455H1.12z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.108 180.663-.062-37.455h.011l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.097 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EEE"
//           d="m1.085 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m1.074 180.663-.063-37.455h.011l.063 37.455h-.011z"
//         />
//         <path
//           fill="#ECECED"
//           d="m1.062 180.663-.063-37.455h.012l.063 37.455h-.012z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m1.053 180.663-.066-37.455H1l.063 37.455h-.01z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m1.04 180.663-.064-37.455h.011l.066 37.455H1.04z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m1.03 180.663-.066-37.455h.012l.065 37.455h-.012z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="m1.018 180.663-.066-37.455h.012l.065 37.455h-.011z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m1.006 180.663-.065-37.455h.011l.066 37.455h-.012z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="M.994 180.663.93 143.208h.012l.065 37.455H.994z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m.983 180.663-.066-37.455H.93l.065 37.455H.983z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m.971 180.663-.065-37.455h.011l.066 37.455H.97z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m.96 180.663-.064-37.455h.01l.065 37.455H.959z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m.948 180.663-.063-37.455h.011l.063 37.455H.948z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m.936 180.663-.063-37.455h.012l.063 37.455H.936z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m.924 180.663-.063-37.455h.012l.063 37.455H.924z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="M.913 180.663.85 143.208h.01l.063 37.455h-.01z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m.901 180.663-.063-37.455H.85l.063 37.455H.9z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m.89 180.663-.064-37.455h.012l.063 37.455H.889z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m.878 180.663-.063-37.455h.011l.063 37.455H.878z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m.866 180.663-.063-37.455h.012l.063 37.455H.866z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m.854 180.663-.062-37.455h.011l.063 37.455H.854z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="M.843 180.663.78 143.208h.01l.063 37.455h-.01z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m.831 180.663-.063-37.455H.78l.063 37.455H.83z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m.82 180.663-.064-37.455h.012l.063 37.455H.82z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m.808 180.663-.063-37.455h.012l.062 37.455H.808z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m.796 180.663-.063-37.455h.012l.063 37.455H.796z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m.787 180.663-.065-37.455h.011l.063 37.455h-.01z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="M.775 180.663.71 143.208h.01l.066 37.455H.775z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m.764 180.663-.066-37.455H.71l.065 37.455H.764z"
//         />
//         <path
//           fill="#CCC"
//           d="m.752 180.663-.065-37.455h.011l.065 37.455H.752z"
//         />
//         <path
//           fill="#CACACA"
//           d="m.74 180.663-.065-37.455h.012l.065 37.455H.74z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m.728 180.663-.065-37.455h.012l.065 37.455H.728z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m.717 180.663-.065-37.455h.011l.066 37.455H.717z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="M.705 180.663.64 143.208h.012l.065 37.455H.705z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="M.694 180.663.63 143.208h.01l.065 37.455H.694z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m.682 180.663-.063-37.455h.012l.063 37.455H.682z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m.67 180.663-.063-37.455H.62l.063 37.455H.67z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m.659 180.663-.063-37.455h.011l.063 37.455H.66z"
//         />
//         <path
//           fill="#BABABA"
//           d="m.647 180.663-.063-37.455h.012l.063 37.455H.647z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m.635 180.663-.063-37.455h.012l.063 37.455H.635z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="M.624 180.663.56 143.208h.011l.063 37.455h-.01z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m.612 180.663-.063-37.455h.012l.063 37.455H.612z"
//         />
//         <path fill="#B1B0B1" d="m.6 180.663-.063-37.455H.55l.063 37.455H.6z" />
//         <path
//           fill="#AEAEAF"
//           d="m.589 180.663-.063-37.455h.011L.6 180.663H.59z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m.577 180.663-.063-37.455h.012l.063 37.455H.577z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m.565 180.663-.063-37.455h.012l.063 37.455H.565z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="M.554 180.663.49 143.208h.011l.063 37.455h-.01z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="M.542 180.663.48 143.208h.012l.063 37.455H.542z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m.53 180.663-.063-37.455H.48l.063 37.455H.53z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m.521 180.663-.065-37.455h.011l.063 37.455H.521z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m.51 180.663-.066-37.455h.012l.065 37.455H.509z"
//         />
//         <path
//           fill="#989799"
//           d="m.498 180.663-.066-37.455h.012l.065 37.455H.498z"
//         />
//         <path
//           fill="#959495"
//           d="m.486 180.663-.065-37.455h.011l.066 37.455H.486z"
//         />
//         <path
//           fill="#929192"
//           d="M.474 180.663.41 143.208h.012l.065 37.455H.474z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m.463 180.663-.066-37.455H.41l.065 37.455H.463z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m.451 180.663-.065-37.455h.012l.065 37.455H.45z"
//         />
//         <path
//           fill="#888788"
//           d="m.44 180.663-.064-37.455h.01l.065 37.455H.44z"
//         />
//         <path
//           fill="#848485"
//           d="m.428 180.663-.063-37.455h.012l.062 37.455H.428z"
//         />
//         <path
//           fill="#818081"
//           d="m.416 180.663-.063-37.455h.012l.063 37.455H.416z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m.404 180.663-.062-37.455h.011l.063 37.455H.404z"
//         />
//         <path
//           fill="#79797A"
//           d="M.393 180.663.33 143.208h.012l.063 37.455H.393z"
//         />
//         <path
//           fill="#767576"
//           d="m.381 180.663-.063-37.455H.33l.063 37.455H.38z"
//         />
//         <path
//           fill="#727173"
//           d="m.37 180.663-.063-37.455h.011l.063 37.455H.37z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m.358 180.663-.063-37.455h.012l.063 37.455H.358z"
//         />
//         <path
//           fill="#6A696B"
//           d="m.346 180.663-.063-37.455h.012l.063 37.455H.346z"
//         />
//         <path
//           fill="#666566"
//           d="m.335 180.663-.063-37.455h.011l.063 37.455H.335z"
//         />
//         <path
//           fill="#616162"
//           d="M.323 180.663.26 143.208h.012l.063 37.455H.323z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m.311 180.663-.063-37.455H.26l.063 37.455H.31z"
//         />
//         <path fill="#595859" d="m.3 180.663-.063-37.455h.011l.063 37.455H.3z" />
//         <path
//           fill="#545355"
//           d="m.288 180.663-.063-37.455h.012L.3 180.663H.288z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m.276 180.663-.063-37.455h.012l.063 37.455H.276z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m.265 180.663-.063-37.455h.011l.063 37.455H.265z"
//         />
//         <path
//           fill="#464547"
//           d="M.255 180.663.19 143.208h.012l.063 37.455h-.01z"
//         />
//         <path
//           fill="#414042"
//           d="m.244 180.663-.066-37.455H.19l.065 37.455H.244z"
//         />
//         <path fill="#414042" d="m.178 143.208.066 37.455h-.07v-37.455h.004z" />
//       </g>
//     </g>
//     <path
//       fill="#E2E2E2"
//       d="M.241 231.898c0 .259.07.506.268.552l1.614.432c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.469-.326-.469l-1.679.474c-.21.09-.198.601-.198.862l.056 35.136z"
//     />
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="e-9"
//         width={3}
//         height={38}
//         x={0}
//         y={195}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.241 231.898c0 .259.07.506.268.552l1.614.432c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.469-.326-.469l-1.679.474c-.21.09-.198.601-.198.862l.056 35.136z"
//         />
//       </mask>
//       <g mask="url(#e-9)">
//         <path
//           fill="#414042"
//           d="m2.447 231.031-.061-35.605h.06v35.605zm-.01 1.851-.063-37.456h.012l.06 35.605v1.851h-.009z"
//         />
//         <path
//           fill="#464547"
//           d="m2.426 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m2.414 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m2.402 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#545355"
//           d="m2.39 232.882-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#595859"
//           d="m2.379 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m2.37 232.882-.066-37.456h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#616162"
//           d="m2.358 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#666566"
//           d="m2.346 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#6A696B"
//           d="m2.335 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m2.323 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#727173"
//           d="m2.311 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#767576"
//           d="m2.3 232.882-.065-37.456h.011l.065 37.456H2.3z"
//         />
//         <path
//           fill="#79797A"
//           d="m2.288 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m2.276 232.882-.063-37.456h.01l.065 37.456h-.012z"
//         />
//         <path
//           fill="#818081"
//           d="m2.265 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#848485"
//           d="m2.253 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#888788"
//           d="m2.242 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m2.23 232.882-.063-37.456h.012l.062 37.456H2.23z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m2.218 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#929192"
//           d="m2.207 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#959495"
//           d="m2.195 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#989799"
//           d="m2.183 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m2.172 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m2.16 232.882-.063-37.456h.012l.063 37.456H2.16z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m2.148 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m2.137 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m2.125 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m2.113 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m2.104 232.882-.065-37.456h.011l.063 37.456h-.009z"
//         />
//         <path
//           fill="#AEAEAF"
//           d="m2.092 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#B1B0B1"
//           d="m2.08 232.882-.065-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m2.069 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m2.057 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m2.046 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#BABABA"
//           d="m2.034 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m2.022 232.882-.063-37.456h.01l.065 37.456h-.012z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m2.01 232.882-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m1.999 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m1.987 232.882-.063-37.456h.012L2 232.882h-.012z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m1.976 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m1.964 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m1.952 232.882-.062-37.456h.01l.063 37.456h-.012z"
//         />
//         <path
//           fill="#CACACA"
//           d="m1.94 232.882-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#CCC"
//           d="m1.93 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m1.917 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m1.906 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m1.894 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m1.883 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m1.87 232.882-.062-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m1.86 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m1.847 232.882-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="m1.838 232.882-.065-37.456h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m1.827 232.882-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m1.815 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m1.803 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m1.792 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m1.78 232.882-.065-37.456h.011l.066 37.456H1.78z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m1.768 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m1.757 232.882-.063-37.456h.009l.065 37.456h-.011z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m1.745 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m1.733 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m1.722 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m1.71 232.882-.063-37.456h.012l.063 37.456H1.71z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m1.698 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m1.687 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m1.675 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="M1.663 232.882 1.6 195.426h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m1.652 232.882-.063-37.456H1.6l.063 37.456h-.011z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m1.64 232.882-.063-37.456h.012l.063 37.456H1.64z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m1.628 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#ECECED"
//           d="m1.617 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m1.605 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EEE"
//           d="m1.593 232.882-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.582 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.572 232.882-.065-37.456h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.56 232.882-.065-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.55 232.882-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.537 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.526 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.514 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.503 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.49 232.882-.062-37.456h.01l.064 37.456h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.48 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.467 232.882-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.456 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.444 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.433 232.882-.063-37.456h.011l.063 37.456h-.011zm-.013 0-.062-37.456h.012l.063 37.456H1.42z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.41 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.398 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.386 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.374 232.882-.063-37.456h.012l.063 37.456h-.012zm-.011 0L1.3 195.426h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.35 232.882-.062-37.456H1.3l.063 37.456H1.35z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.34 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.328 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.318 232.882-.065-37.456h.012l.063 37.456h-.01zm-.011 0-.066-37.456h.012l.065 37.456h-.011zM1.295 232.882l-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.283 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.272 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.26 232.882-.065-37.456h.011l.066 37.456H1.26z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.248 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.237 232.882-.065-37.456h.011l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.225 232.882-.063-37.456h.01l.065 37.456h-.012zm-.012 0-.062-37.456h.011l.063 37.456h-.012zm-.011 0-.063-37.456h.011l.063 37.456h-.011zM1.19 232.882l-.063-37.456h.012l.063 37.456H1.19z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.178 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.167 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.155 232.882-.063-37.456h.012l.063 37.456h-.012zm-.011 0-.063-37.456h.011l.063 37.456h-.011zm-.012 0-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.12 232.882-.063-37.456h.012l.063 37.456H1.12zm-.012 0-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.097 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.085 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.074 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.062 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.053 232.882-.066-37.456H1l.063 37.456h-.01z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.04 232.882-.064-37.456h.011l.066 37.456H1.04z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.03 232.882-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.018 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.006 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="M.994 232.882.93 195.426h.012l.065 37.456H.994z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.983 232.882-.066-37.456H.93l.065 37.456H.983zm-.012 0-.065-37.456h.011l.066 37.456H.97z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.96 232.882-.064-37.456h.01l.065 37.456H.959z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.948 232.882-.063-37.456h.011l.063 37.456H.948z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.936 232.882-.063-37.456h.012l.063 37.456H.936zm-.012 0-.063-37.456h.012l.063 37.456H.924zm-.011 0L.85 195.426h.01l.063 37.456h-.01z"
//         />
//         <path fill="#fff" d="m.901 232.882-.063-37.456H.85l.063 37.456H.9z" />
//         <path
//           fill="#fff"
//           d="m.89 232.882-.064-37.456h.012l.063 37.456H.889zm-.012 0-.063-37.456h.011l.063 37.456H.878zm-.012 0-.063-37.456h.012l.063 37.456H.866z"
//         />
//         <path
//           fill="#fff"
//           d="m.854 232.882-.062-37.456h.011l.063 37.456H.854zm-.011 0L.78 195.426h.01l.063 37.456h-.01z"
//         />
//         <path fill="#fff" d="m.831 232.882-.063-37.456H.78l.063 37.456H.83z" />
//         <path fill="#fff" d="m.82 232.882-.064-37.456h.012l.063 37.456H.82z" />
//         <path
//           fill="#fff"
//           d="m.808 232.882-.063-37.456h.012l.062 37.456H.808z"
//         />
//         <path
//           fill="#fff"
//           d="m.796 232.882-.063-37.456h.012l.063 37.456H.796zm-.009 0-.065-37.456h.011l.063 37.456h-.01zm-.012 0L.71 195.426h.01l.066 37.456H.775zm-.011 0-.066-37.456H.71l.065 37.456H.764z"
//         />
//         <path
//           fill="#fff"
//           d="m.752 232.882-.065-37.456h.011l.065 37.456H.752z"
//         />
//         <path fill="#fff" d="m.74 232.882-.065-37.456h.012l.065 37.456H.74z" />
//         <path
//           fill="#fff"
//           d="m.728 232.882-.065-37.456h.012l.065 37.456H.728z"
//         />
//         <path
//           fill="#fff"
//           d="m.717 232.882-.065-37.456h.011l.066 37.456H.717z"
//         />
//         <path fill="#fff" d="M.705 232.882.64 195.426h.012l.065 37.456H.705z" />
//         <path fill="#fff" d="M.694 232.882.63 195.426h.01l.065 37.456H.694z" />
//         <path
//           fill="#fff"
//           d="m.682 232.882-.063-37.456h.012l.063 37.456H.682z"
//         />
//         <path fill="#fff" d="m.67 232.882-.063-37.456H.62l.063 37.456H.67z" />
//         <path fill="#fff" d="m.659 232.882-.063-37.456h.011l.063 37.456H.66z" />
//         <path
//           fill="#fff"
//           d="m.647 232.882-.063-37.456h.012l.063 37.456H.647z"
//         />
//         <path
//           fill="#fff"
//           d="m.635 232.882-.063-37.456h.012l.063 37.456H.635zm-.011 0L.56 195.426h.011l.063 37.456h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="m.612 232.882-.063-37.456h.012l.063 37.456H.612z"
//         />
//         <path fill="#fff" d="m.6 232.882-.063-37.456H.55l.063 37.456H.6z" />
//         <path fill="#fff" d="m.589 232.882-.063-37.456h.011L.6 232.882H.59z" />
//         <path
//           fill="#fff"
//           d="m.577 232.882-.063-37.456h.012l.063 37.456H.577z"
//         />
//         <path
//           fill="#fff"
//           d="m.565 232.882-.063-37.456h.012l.063 37.456H.565zm-.011 0L.49 195.426h.011l.063 37.456h-.01z"
//         />
//         <path fill="#fff" d="M.542 232.882.48 195.426h.012l.063 37.456H.542z" />
//         <path fill="#fff" d="m.53 232.882-.063-37.456H.48l.063 37.456H.53z" />
//         <path
//           fill="#fff"
//           d="m.521 232.882-.065-37.456h.011l.063 37.456H.521z"
//         />
//         <path fill="#fff" d="m.51 232.882-.066-37.456h.012l.065 37.456H.509z" />
//         <path
//           fill="#fff"
//           d="m.498 232.882-.066-37.456h.012l.065 37.456H.498z"
//         />
//         <path
//           fill="#fff"
//           d="m.486 232.882-.065-37.456h.011l.066 37.456H.486z"
//         />
//         <path fill="#fff" d="M.474 232.882.41 195.426h.012l.065 37.456H.474z" />
//         <path fill="#fff" d="m.463 232.882-.066-37.456H.41l.065 37.456H.463z" />
//         <path fill="#fff" d="m.451 232.882-.065-37.456h.012l.065 37.456H.45z" />
//         <path fill="#fff" d="m.44 232.882-.064-37.456h.01l.065 37.456H.44z" />
//         <path
//           fill="#fff"
//           d="m.428 232.882-.063-37.456h.012l.062 37.456H.428z"
//         />
//         <path
//           fill="#fff"
//           d="m.416 232.882-.063-37.456h.012l.063 37.456H.416z"
//         />
//         <path
//           fill="#fff"
//           d="m.404 232.882-.062-37.456h.011l.063 37.456H.404z"
//         />
//         <path fill="#fff" d="M.393 232.882.33 195.426h.012l.063 37.456H.393z" />
//         <path fill="#fff" d="m.381 232.882-.063-37.456H.33l.063 37.456H.38z" />
//         <path fill="#fff" d="m.37 232.882-.063-37.456h.011l.063 37.456H.37z" />
//         <path
//           fill="#fff"
//           d="m.358 232.882-.063-37.456h.012l.063 37.456H.358z"
//         />
//         <path
//           fill="#fff"
//           d="m.346 232.882-.063-37.456h.012l.063 37.456H.346z"
//         />
//         <path
//           fill="#fff"
//           d="m.335 232.882-.063-37.456h.011l.063 37.456H.335z"
//         />
//         <path fill="#fff" d="M.323 232.882.26 195.426h.012l.063 37.456H.323z" />
//         <path fill="#fff" d="m.311 232.882-.063-37.456H.26l.063 37.456H.31z" />
//         <path fill="#fff" d="m.3 232.882-.063-37.456h.011l.063 37.456H.3z" />
//         <path fill="#fff" d="m.288 232.882-.063-37.456h.012L.3 232.882H.288z" />
//         <path
//           fill="#fff"
//           d="m.276 232.882-.063-37.456h.012l.063 37.456H.276z"
//         />
//         <path
//           fill="#fff"
//           d="m.265 232.882-.063-37.456h.011l.063 37.456H.265z"
//         />
//         <path fill="#fff" d="M.255 232.882.19 195.426h.012l.063 37.456h-.01z" />
//         <path fill="#fff" d="m.244 232.882-.066-37.456H.19l.065 37.456H.244z" />
//         <path fill="#fff" d="m.178 195.426.066 37.456h-.07v-37.456h.004z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="f-10"
//         width={3}
//         height={4}
//         x={0}
//         y={195}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m.964 198.538-.776-.088v-1.688s-.091-.795.26-.881a84.7 84.7 0 0 0 1.612-.455s.298.007.324.434c.025.424.004 2.606.004 2.606l-1.426.07.002.002z"
//         />
//       </mask>
//       <g mask="url(#f-10)">
//         <path fill="#fff" d="m.097 198.522 2.315-.002v.018H.097v-.016z" />
//         <path fill="#fff" d="m.097 198.515 2.315-.005v.01l-2.315.002v-.007z" />
//         <path
//           fill="#FEFEFE"
//           d="m.097 198.506 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m.097 198.496 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m.097 198.487 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m.097 198.478 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m.097 198.471 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m.097 198.462 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m.097 198.452 2.315-.004v.009l-2.315.004v-.009z"
//         />
//         <path
//           fill="#F6F5F5"
//           d="m.097 198.443 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m.097 198.436 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m.097 198.427 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m.097 198.417 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m.097 198.408 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m.097 198.399 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m.097 198.392 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m.097 198.382 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m.097 198.373 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m.097 198.364 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m.097 198.357 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m.097 198.347 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m.097 198.338 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m.097 198.329 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m.097 198.319 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m.097 198.312 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m.097 198.303 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m.097 198.294 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m.097 198.284 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m.097 198.277 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m.097 198.268 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path fill="#DDD" d="m.097 198.259 2.315-.005v.009l-2.315.005v-.009z" />
//         <path
//           fill="#DCDBDC"
//           d="m.097 198.249 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m.097 198.24 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m.097 198.233 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="m.097 198.224 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m.097 198.214 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m.097 198.205 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m.097 198.198 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m.097 198.189 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m.097 198.179 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m.097 198.17 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m.097 198.161 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m.097 198.154 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#CECECE"
//           d="m.097 198.144 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m.097 198.135 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m.097 198.126 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#CBCACA"
//           d="m.097 198.119 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#CAC9C9"
//           d="m.097 198.109 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path fill="#C9C8C8" d="m.097 198.1 2.315-.004v.009l-2.315.005v-.01z" />
//         <path
//           fill="#C8C7C7"
//           d="m.097 198.091 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m.097 198.081 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m.097 198.074 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m.097 198.065 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m.097 198.056 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m.097 198.047 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m.097 198.04 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m.097 198.03 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m.097 198.021 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m.097 198.012 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="M.097 198.002 2.412 198v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m.097 197.995 2.315-.004V198l-2.315.002v-.007z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m.097 197.986 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m.097 197.977 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m.097 197.967 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m.097 197.96 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m.097 197.951 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m.097 197.942 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m.097 197.932 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m.097 197.923 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m.097 197.916 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m.097 197.907 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m.097 197.897 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m.097 197.888 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m.097 197.881 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m.097 197.872 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m.097 197.862 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m.097 197.853 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m.097 197.844 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m.097 197.837 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m.097 197.827 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m.097 197.818 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m.097 197.809 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m.097 197.802 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m.097 197.792 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m.097 197.783 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m.097 197.774 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m.097 197.764 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m.097 197.757 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m.097 197.748 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m.097 197.739 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#9B9999"
//           d="m.097 197.73 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#9A9898"
//           d="m.097 197.722 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#999797"
//           d="m.097 197.713 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#979696"
//           d="m.097 197.704 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#969495"
//           d="m.097 197.695 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#959394"
//           d="m.097 197.685 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#949293"
//           d="m.097 197.678 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#939192"
//           d="m.097 197.669 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#929091"
//           d="m.097 197.66 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#918F90"
//           d="m.097 197.65 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#908E8F"
//           d="m.097 197.643 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m.097 197.634 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m.097 197.625 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m.097 197.615 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m.097 197.606 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#8B8989"
//           d="m.097 197.599 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#8A8888"
//           d="m.097 197.59 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#898787"
//           d="m.097 197.58 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#888686"
//           d="m.097 197.571 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#878485"
//           d="m.097 197.564 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#868384"
//           d="m.097 197.555 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#858283"
//           d="m.097 197.545 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#848182"
//           d="m.097 197.536 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#838081"
//           d="m.097 197.527 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#817F80"
//           d="m.097 197.52 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#807E7F"
//           d="m.097 197.51 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m.097 197.501 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m.097 197.492 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m.097 197.485 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m.097 197.475 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#7B797A"
//           d="m.097 197.466 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#7A7879"
//           d="m.097 197.457 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#797778"
//           d="m.097 197.45 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#787676"
//           d="m.097 197.44 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#777575"
//           d="m.097 197.431 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#767474"
//           d="m.097 197.422 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#757373"
//           d="m.097 197.412 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#747272"
//           d="m.097 197.405 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#737171"
//           d="m.097 197.396 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#727070"
//           d="m.097 197.387 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#716F6F"
//           d="m.097 197.377 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#706E6E"
//           d="m.097 197.371 2.315-.005v.009l-2.315.002v-.006z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m.097 197.361 2.315-.004v.009l-2.315.004v-.009z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m.097 197.352 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m.097 197.343 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m.097 197.333 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#6B6969"
//           d="m.097 197.326 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#6A6868"
//           d="m.097 197.317 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#696767"
//           d="m.097 197.308 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#686666"
//           d="m.097 197.298 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#676565"
//           d="m.097 197.291 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#666464"
//           d="m.097 197.282 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#666363"
//           d="m.097 197.273 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#656262"
//           d="m.097 197.263 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#646161"
//           d="m.097 197.254 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#636060"
//           d="m.097 197.247 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#625F5F"
//           d="m.097 197.238 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#615E5F"
//           d="m.097 197.228 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#605D5E"
//           d="m.097 197.219 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#5F5C5D"
//           d="m.097 197.212 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m.097 197.203 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m.097 197.193 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#5C595A"
//           d="m.097 197.184 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#5B5859"
//           d="m.097 197.175 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#5A5758"
//           d="m.097 197.168 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#595657"
//           d="m.097 197.158 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#585556"
//           d="m.097 197.149 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#575455"
//           d="m.097 197.14 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#565354"
//           d="m.097 197.133 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#555253"
//           d="m.097 197.123 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#545152"
//           d="m.097 197.114 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#545051"
//           d="m.097 197.105 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#534F50"
//           d="m.097 197.095 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#524F4F"
//           d="m.097 197.088 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#514E4E"
//           d="m.097 197.079 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#504D4D"
//           d="m.097 197.07 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m.097 197.06 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m.097 197.053 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m.097 197.044 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#4C494A"
//           d="m.097 197.035 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#4B4849"
//           d="m.097 197.025 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#4A4748"
//           d="m.097 197.016 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#4A4647"
//           d="m.097 197.009 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path fill="#494546" d="m.097 197 2.315-.005v.01l-2.315.004V197z" />
//         <path
//           fill="#484445"
//           d="m.097 196.991 2.315-.005v.009L.097 197v-.009z"
//         />
//         <path
//           fill="#474444"
//           d="m.097 196.981 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#464344"
//           d="m.097 196.974 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#454243"
//           d="m.097 196.965 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#444142"
//           d="m.097 196.956 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#434041"
//           d="m.097 196.946 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#433F40"
//           d="m.097 196.937 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#423E3F"
//           d="m.097 196.93 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#413D3E"
//           d="m.097 196.921 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#403D3D"
//           d="m.097 196.911 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m.097 196.902 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m.097 196.895 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m.097 196.886 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#3D393A"
//           d="m.097 196.876 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#3C3839"
//           d="m.097 196.867 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#3B3738"
//           d="m.097 196.858 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#3A3738"
//           d="m.097 196.851 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#393637"
//           d="m.097 196.841 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#393536"
//           d="m.097 196.832 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#383435"
//           d="m.097 196.823 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#373334"
//           d="m.097 196.816 2.315-.005v.009l-2.315.003v-.007z"
//         />
//         <path
//           fill="#363333"
//           d="m.097 196.806 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#353233"
//           d="m.097 196.797 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#353132"
//           d="m.097 196.788 2.315-.003v.007l-2.315.005v-.009z"
//         />
//         <path
//           fill="#343031"
//           d="m.097 196.778 2.315-.002v.009l-2.315.003v-.01z"
//         />
//         <path
//           fill="#332F30"
//           d="m.097 196.771 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#322F30"
//           d="m.097 196.762 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#322E2F"
//           d="m.097 196.753 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#312D2E"
//           d="m.097 196.743 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#302C2D"
//           d="m.097 196.736 2.315-.004v.009l-2.315.002v-.007z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m.097 196.727 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m.097 196.718 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m.097 196.708 2.315-.002v.007l-2.315.005v-.01z"
//         />
//         <path
//           fill="#2D292A"
//           d="m.097 196.699 2.315-.002v.009l-2.315.002v-.009z"
//         />
//         <path
//           fill="#2C292A"
//           d="m.097 196.692 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#2C2829"
//           d="m.097 196.683 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#2B2728"
//           d="m.097 196.673 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#2A2627"
//           d="m.097 196.664 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#2A2627"
//           d="m.097 196.657 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#292526"
//           d="m.097 196.648 2.315-.005v.01l-2.315.004v-.009z"
//         />
//         <path
//           fill="#282425"
//           d="m.097 196.639 2.315-.005v.009l-2.315.005v-.009zm0-.01 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#272324"
//           d="m.097 196.62 2.315-.003v.01l-2.315.002v-.009z"
//         />
//         <path
//           fill="#272324"
//           d="m.097 196.613 2.315-.005v.01l-2.315.002v-.007z"
//         />
//         <path
//           fill="#262223"
//           d="m.097 196.604 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#252122"
//           d="m.097 196.594 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#252122"
//           d="m.097 196.585 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path
//           fill="#242021"
//           d="m.097 196.578 2.315-.005v.01l-2.315.002v-.007zm0-.009 2.315-.005v.009l-2.315.005v-.009z"
//         />
//         <path
//           fill="#231F20"
//           d="m.097 196.559 2.315-.004v.009l-2.315.005v-.01z"
//         />
//         <path
//           fill="#231F20"
//           d="m.097 196.55 2.315-.002v.007l-2.315.004v-.009z"
//         />
//         <path fill="#231F20" d="m2.412 196.548-2.315.002v-1.124h2.315v1.122z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="g-11"
//         width={3}
//         height={4}
//         x={0}
//         y={229}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m1.013 229.774-.776.091v1.688s-.087.853.26.895c.325.04 1.62.434 1.62.434s.3-.01.325-.434c.026-.424-.005-2.609-.005-2.609l-1.426-.065h.002z"
//         />
//       </mask>
//       <g mask="url(#g-11)">
//         <path fill="#fff" d="m2.47 229.788-2.32.005v-.019h2.32v.014z" />
//         <path fill="#fff" d="m2.47 229.797-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#FEFEFE" d="m2.47 229.807-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#FDFDFD" d="m2.47 229.816-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#FBFBFB" d="m2.47 229.823-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#FAFAFA" d="m2.47 229.832-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#F9F9F9" d="m2.47 229.842-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#F8F8F8" d="m2.47 229.851-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#F7F7F7" d="m2.47 229.858-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#F6F5F5" d="m2.47 229.867-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#F4F4F4" d="m2.47 229.877-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#F3F3F3" d="m2.47 229.886-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#F2F2F2" d="m2.47 229.895-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#F1F1F1" d="m2.47 229.902-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#F0EFF0" d="m2.47 229.912-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#EFEEEE" d="m2.47 229.921-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#EDEDED" d="m2.47 229.93-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#ECECEC" d="m2.47 229.937-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#EBEBEB" d="m2.47 229.947-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#EAEAEA" d="m2.47 229.956-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#E9E8E8" d="m2.47 229.965-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#E8E7E7" d="m2.47 229.975-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#E6E6E6" d="m2.47 229.982-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#E5E5E5" d="m2.47 229.991-2.32.004v-.009l2.32-.004v.009z" />
//         <path fill="#E4E4E4" d="m2.47 230-2.32.005v-.01l2.32-.004V230z" />
//         <path fill="#E3E2E3" d="m2.47 230.01-2.32.002v-.007L2.47 230v.01z" />
//         <path fill="#E2E1E1" d="m2.47 230.016-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#E1E0E0" d="m2.47 230.026-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#E0DFDF" d="m2.47 230.035-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#DEDEDE" d="m2.47 230.044-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#DDD" d="m2.47 230.054-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#DCDBDC" d="m2.47 230.061-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#DBDADA" d="m2.47 230.07-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#DAD9D9" d="m2.47 230.079-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#D9D8D8" d="m2.47 230.089-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#D8D7D7" d="m2.47 230.096-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#D6D6D6" d="m2.47 230.105-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#D5D4D5" d="m2.47 230.114-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#D4D3D4" d="m2.47 230.124-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#D3D2D2" d="m2.47 230.131-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#D2D1D1" d="m2.47 230.14-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#D1D0D0" d="m2.47 230.149-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#D0CFCF" d="m2.47 230.159-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#CECECE" d="m2.47 230.168-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#CDCCCD" d="m2.47 230.175-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#CCCBCB" d="m2.47 230.184-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#CBCACA" d="m2.47 230.194-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#CAC9C9" d="m2.47 230.203-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#C9C8C8" d="m2.47 230.21-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#C8C7C7" d="m2.47 230.219-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#C7C5C6" d="m2.47 230.229-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#C5C4C5" d="m2.47 230.238-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#C4C3C3" d="m2.47 230.247-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#C3C2C2" d="m2.47 230.254-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#C2C1C1" d="m2.47 230.264-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#C1C0C0" d="m2.47 230.273-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#C0BFBF" d="m2.47 230.282-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#BFBEBE" d="m2.47 230.289-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#BEBCBD" d="m2.47 230.299-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#BCBBBC" d="m2.47 230.308-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#BBBABA" d="m2.47 230.317-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#BAB9B9" d="m2.47 230.327-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#B9B8B8" d="m2.47 230.334-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#B8B7B7" d="m2.47 230.343-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#B7B6B6" d="m2.47 230.352-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#B6B4B5" d="m2.47 230.361-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#B5B3B4" d="m2.47 230.369-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#B4B2B3" d="m2.47 230.378-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#B2B1B1" d="m2.47 230.387-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#B1B0B0" d="m2.47 230.396-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#B0AFAF" d="m2.47 230.406-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#AFAEAE" d="m2.47 230.413-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#AEADAD" d="m2.47 230.422-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#ADACAC" d="m2.47 230.431-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#ACAAAB" d="m2.47 230.441-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#ABA9AA" d="m2.47 230.448-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#AAA8A9" d="m2.47 230.457-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#A9A7A7" d="m2.47 230.466-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#A8A6A6" d="m2.47 230.476-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#A6A5A5" d="m2.47 230.485-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#A5A4A4" d="m2.47 230.492-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#A4A3A3" d="m2.47 230.501-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#A3A2A2" d="m2.47 230.511-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#A2A0A1" d="m2.47 230.52-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#A19FA0" d="m2.47 230.527-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#A09E9F" d="m2.47 230.536-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#9F9D9E" d="m2.47 230.546-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#9E9C9D" d="m2.47 230.555-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#9D9B9B" d="m2.47 230.564-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#9C9A9A" d="m2.47 230.571-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#9B9999" d="m2.47 230.581-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#9A9898" d="m2.47 230.59-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#999797" d="m2.47 230.599-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#979696" d="m2.47 230.606-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#969495" d="m2.47 230.616-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#959394" d="m2.47 230.625-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#949293" d="m2.47 230.634-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#939192" d="m2.47 230.644-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#929091" d="m2.47 230.651-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#918F90" d="m2.47 230.66-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#908E8F" d="m2.47 230.669-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#8F8D8D" d="m2.47 230.679-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#8E8C8C" d="m2.47 230.686-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#8D8B8B" d="m2.47 230.695-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#8C8A8A" d="m2.47 230.704-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#8B8989" d="m2.47 230.713-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#8A8888" d="m2.47 230.723-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#898787" d="m2.47 230.73-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#888686" d="m2.47 230.739-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#878485" d="m2.47 230.748-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#868384" d="m2.47 230.758-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#858283" d="m2.47 230.765-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#848182" d="m2.47 230.774-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#838081" d="m2.47 230.783-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#817F80" d="m2.47 230.793-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#807E7F" d="m2.47 230.802-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#7F7D7E" d="m2.47 230.809-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#7E7C7D" d="m2.47 230.818-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#7D7B7C" d="m2.47 230.828-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#7C7A7B" d="m2.47 230.837-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#7B797A" d="m2.47 230.844-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#7A7879" d="m2.47 230.853-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#797778" d="m2.47 230.863-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#787676" d="m2.47 230.872-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#777575" d="m2.47 230.881-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#767474" d="m2.47 230.888-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#757373" d="m2.47 230.898-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#747272" d="m2.47 230.907-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#737171" d="m2.47 230.916-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#727070" d="m2.47 230.923-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#716F6F" d="m2.47 230.933-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#706E6E" d="m2.47 230.942-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#6F6D6D" d="m2.47 230.951-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#6E6C6C" d="m2.47 230.961-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#6D6B6B" d="m2.47 230.968-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#6C6A6A" d="m2.47 230.977-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#6B6969" d="m2.47 230.986-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#6A6868" d="m2.47 230.996-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#696767" d="m2.47 231.003-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#686666" d="m2.47 231.012-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#676565" d="m2.47 231.021-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#666464" d="m2.47 231.031-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#666363" d="m2.47 231.04-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#656262" d="m2.47 231.047-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#646161" d="m2.47 231.056-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#636060" d="m2.47 231.066-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#625F5F" d="m2.47 231.075-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#615E5F" d="m2.47 231.082-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#605D5E" d="m2.47 231.091-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#5F5C5D" d="m2.47 231.101-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#5E5B5C" d="m2.47 231.11-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#5D5A5B" d="m2.47 231.119-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#5C595A" d="m2.47 231.126-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#5B5859" d="m2.47 231.135-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#5A5758" d="m2.47 231.145-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#595657" d="m2.47 231.154-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#585556" d="m2.47 231.161-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#575455" d="m2.47 231.17-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#565354" d="m2.47 231.18-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#555253" d="m2.47 231.189-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#545152" d="m2.47 231.198-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#545051" d="m2.47 231.205-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#534F50" d="m2.47 231.215-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#524F4F" d="m2.47 231.224-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#514E4E" d="m2.47 231.233-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#504D4D" d="m2.47 231.24-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#4F4C4D" d="m2.47 231.25-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#4E4B4C" d="m2.47 231.259-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#4D4A4B" d="m2.47 231.268-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#4C494A" d="m2.47 231.278-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#4B4849" d="m2.47 231.285-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#4A4748" d="m2.47 231.294-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#4A4647" d="m2.47 231.303-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#494546" d="m2.47 231.313-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#484445" d="m2.47 231.32-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#474444" d="m2.47 231.329-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#464344" d="m2.47 231.338-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#454243" d="m2.47 231.348-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#444142" d="m2.47 231.355-2.32.004v-.009l2.32-.002v.007z" />
//         <path fill="#434041" d="m2.47 231.364-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#433F40" d="m2.47 231.373-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#423E3F" d="m2.47 231.383-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#413D3E" d="m2.47 231.392-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#403D3D" d="m2.47 231.399-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#3F3C3D" d="m2.47 231.408-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#3E3B3C" d="m2.47 231.418-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#3E3A3B" d="m2.47 231.427-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#3D393A" d="m2.47 231.434-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#3C3839" d="m2.47 231.443-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#3B3738" d="m2.47 231.452-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#3A3738" d="m2.47 231.462-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#393637" d="m2.47 231.471-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#393536" d="m2.47 231.478-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#383435" d="m2.47 231.487-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#373334" d="m2.47 231.497-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#363333" d="m2.47 231.506-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#353233" d="m2.47 231.513-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#353132" d="m2.47 231.522-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#343031" d="m2.47 231.532-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#332F30" d="m2.47 231.541-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#322F30" d="m2.47 231.55-2.32.003v-.01l2.32-.002v.009z" />
//         <path fill="#322E2F" d="m2.47 231.557-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#312D2E" d="m2.47 231.567-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#302C2D" d="m2.47 231.576-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#2F2C2C" d="m2.47 231.585-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#2F2B2C" d="m2.47 231.592-2.32.005v-.009l2.32-.003v.007z" />
//         <path fill="#2E2A2B" d="m2.47 231.602-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#2D292A" d="m2.47 231.611-2.32.005v-.01l2.32-.004v.009z" />
//         <path fill="#2C292A" d="m2.47 231.62-2.32.003v-.007l2.32-.005v.009z" />
//         <path fill="#2C2829" d="m2.47 231.63-2.32.002v-.009l2.32-.003v.01z" />
//         <path fill="#2B2728" d="m2.47 231.637-2.32.004v-.009l2.32-.002v.007z" />
//         <path
//           fill="#2A2627"
//           d="m2.47 231.646-2.32.005v-.01l2.32-.004v.009zm0 .009-2.32.005v-.009l2.32-.005v.009z"
//         />
//         <path fill="#292526" d="m2.47 231.665-2.32.002v-.007l2.32-.005v.01z" />
//         <path
//           fill="#282425"
//           d="m2.47 231.672-2.32.004v-.009l2.32-.002v.007zm0 .009-2.32.005v-.01l2.32-.004v.009z"
//         />
//         <path fill="#272324" d="m2.47 231.69-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#272324" d="m2.47 231.7-2.32.002v-.007l2.32-.005v.01z" />
//         <path fill="#262223" d="m2.47 231.709-2.32.002v-.009l2.32-.002v.009z" />
//         <path fill="#252122" d="m2.47 231.716-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#252122" d="m2.47 231.725-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#242021" d="m2.47 231.735-2.32.004v-.009l2.32-.005v.01z" />
//         <path fill="#242021" d="m2.47 231.744-2.32.002v-.007l2.32-.004v.009z" />
//         <path fill="#231F20" d="m2.47 231.751-2.32.005v-.01l2.32-.002v.007z" />
//         <path fill="#231F20" d="m2.47 231.76-2.32.005v-.009l2.32-.005v.009z" />
//         <path fill="#231F20" d="m.15 231.765 2.32-.005v1.121H.15v-1.116z" />
//       </g>
//     </g>
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="h-12"
//         width={3}
//         height={38}
//         x={0}
//         y={195}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.241 231.898c0 .259.07.506.268.552l1.614.432c.179 0 .324-.21.324-.471l-.059-36.516c0-.259-.147-.469-.326-.469l-1.679.474c-.21.09-.198.601-.198.862l.056 35.136z"
//         />
//       </mask>
//       <g mask="url(#h-12)">
//         <path
//           fill="#fff"
//           d="m2.447 231.031-.061-35.605h.06v35.605zm-.01 1.851-.063-37.456h.012l.06 35.605v1.851h-.009z"
//         />
//         <path
//           fill="#fff"
//           d="m2.426 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.414 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.402 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.39 232.882-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.379 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.37 232.882-.066-37.456h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="m2.358 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.346 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.335 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.323 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.311 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.3 232.882-.065-37.456h.011l.065 37.456H2.3zm-.012 0-.065-37.456h.011l.066 37.456h-.012zm-.012 0-.063-37.456h.01l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.265 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.253 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.242 232.882-.063-37.456h.011l.063 37.456h-.011zm-.012 0-.063-37.456h.012l.062 37.456H2.23z"
//         />
//         <path
//           fill="#fff"
//           d="m2.218 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.207 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.195 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.183 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.172 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.16 232.882-.063-37.456h.012l.063 37.456H2.16z"
//         />
//         <path
//           fill="#fff"
//           d="m2.148 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.137 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.125 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.113 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.104 232.882-.065-37.456h.011l.063 37.456h-.009z"
//         />
//         <path
//           fill="#fff"
//           d="m2.092 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.08 232.882-.065-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.069 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.057 232.882-.065-37.456h.012l.065 37.456h-.012zm-.011 0-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.034 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.022 232.882-.063-37.456h.01l.065 37.456h-.012zm-.012 0-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.999 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.987 232.882-.063-37.456h.012L2 232.882h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.976 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.964 232.882-.063-37.456h.012l.063 37.456h-.012zm-.012 0-.062-37.456h.01l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.94 232.882-.062-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.93 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.917 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.906 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.894 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.883 232.882-.063-37.456h.011l.063 37.456h-.011zm-.013 0-.062-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.86 232.882-.064-37.456h.012l.063 37.456h-.012zm-.013 0-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.838 232.882-.065-37.456h.012l.063 37.456h-.01zm-.011 0-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.815 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.803 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.792 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.78 232.882-.065-37.456h.011l.066 37.456H1.78z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.768 232.882-.065-37.456h.012l.065 37.456h-.012zm-.011 0-.063-37.456h.009l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.745 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.733 232.882-.063-37.456h.012l.063 37.456h-.012zm-.011 0-.063-37.456h.011l.063 37.456h-.011zM1.71 232.882l-.063-37.456h.012l.063 37.456H1.71z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.698 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.687 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.675 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="M1.663 232.882 1.6 195.426h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.652 232.882-.063-37.456H1.6l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.64 232.882-.063-37.456h.012l.063 37.456H1.64z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.628 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.617 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.605 232.882-.063-37.456h.012l.063 37.456h-.012zm-.012 0-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.582 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.572 232.882-.065-37.456h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.56 232.882-.065-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.55 232.882-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.537 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.526 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.514 232.882-.065-37.456h.012l.065 37.456h-.012zm-.011 0-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.49 232.882-.062-37.456h.01l.064 37.456h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.48 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.467 232.882-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.456 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.444 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.433 232.882-.063-37.456h.011l.063 37.456h-.011zm-.013 0-.062-37.456h.012l.063 37.456H1.42z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.41 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.398 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.386 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.374 232.882-.063-37.456h.012l.063 37.456h-.012zm-.011 0L1.3 195.426h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.35 232.882-.062-37.456H1.3l.063 37.456H1.35z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.34 232.882-.064-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.328 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.318 232.882-.065-37.456h.012l.063 37.456h-.01zm-.011 0-.066-37.456h.012l.065 37.456h-.011zM1.295 232.882l-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.283 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.272 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.26 232.882-.065-37.456h.011l.066 37.456H1.26z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.248 232.882-.065-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.237 232.882-.065-37.456h.011l.065 37.456h-.011z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.225 232.882-.063-37.456h.01l.065 37.456h-.012zm-.012 0-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.202 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.19 232.882-.063-37.456h.012l.063 37.456H1.19z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.178 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.167 232.882-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.155 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.144 232.882-.063-37.456h.011l.063 37.456h-.011zm-.012 0-.063-37.456h.012l.062 37.456h-.011z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.12 232.882-.063-37.456h.012l.063 37.456H1.12z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.108 232.882-.062-37.456h.011l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.097 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EEE"
//           d="m1.085 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m1.074 232.882-.063-37.456h.011l.063 37.456h-.011z"
//         />
//         <path
//           fill="#ECECED"
//           d="m1.062 232.882-.063-37.456h.012l.063 37.456h-.012z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m1.053 232.882-.066-37.456H1l.063 37.456h-.01z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m1.04 232.882-.064-37.456h.011l.066 37.456H1.04z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m1.03 232.882-.066-37.456h.012l.065 37.456h-.012z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="m1.018 232.882-.066-37.456h.012l.065 37.456h-.011z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m1.006 232.882-.065-37.456h.011l.066 37.456h-.012z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="M.994 232.882.93 195.426h.012l.065 37.456H.994z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m.983 232.882-.066-37.456H.93l.065 37.456H.983z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m.971 232.882-.065-37.456h.011l.066 37.456H.97z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m.96 232.882-.064-37.456h.01l.065 37.456H.959z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m.948 232.882-.063-37.456h.011l.063 37.456H.948z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m.936 232.882-.063-37.456h.012l.063 37.456H.936z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m.924 232.882-.063-37.456h.012l.063 37.456H.924z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="M.913 232.882.85 195.426h.01l.063 37.456h-.01z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m.901 232.882-.063-37.456H.85l.063 37.456H.9z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m.89 232.882-.064-37.456h.012l.063 37.456H.889z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m.878 232.882-.063-37.456h.011l.063 37.456H.878z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m.866 232.882-.063-37.456h.012l.063 37.456H.866z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m.854 232.882-.062-37.456h.011l.063 37.456H.854z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="M.843 232.882.78 195.426h.01l.063 37.456h-.01z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m.831 232.882-.063-37.456H.78l.063 37.456H.83z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m.82 232.882-.064-37.456h.012l.063 37.456H.82z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m.808 232.882-.063-37.456h.012l.062 37.456H.808z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m.796 232.882-.063-37.456h.012l.063 37.456H.796z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m.787 232.882-.065-37.456h.011l.063 37.456h-.01z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="M.775 232.882.71 195.426h.01l.066 37.456H.775z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m.764 232.882-.066-37.456H.71l.065 37.456H.764z"
//         />
//         <path
//           fill="#CCC"
//           d="m.752 232.882-.065-37.456h.011l.065 37.456H.752z"
//         />
//         <path
//           fill="#CACACA"
//           d="m.74 232.882-.065-37.456h.012l.065 37.456H.74z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m.728 232.882-.065-37.456h.012l.065 37.456H.728z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m.717 232.882-.065-37.456h.011l.066 37.456H.717z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="M.705 232.882.64 195.426h.012l.065 37.456H.705z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="M.694 232.882.63 195.426h.01l.065 37.456H.694z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m.682 232.882-.063-37.456h.012l.063 37.456H.682z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m.67 232.882-.063-37.456H.62l.063 37.456H.67z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m.659 232.882-.063-37.456h.011l.063 37.456H.66z"
//         />
//         <path
//           fill="#BABABA"
//           d="m.647 232.882-.063-37.456h.012l.063 37.456H.647z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m.635 232.882-.063-37.456h.012l.063 37.456H.635z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="M.624 232.882.56 195.426h.011l.063 37.456h-.01z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m.612 232.882-.063-37.456h.012l.063 37.456H.612z"
//         />
//         <path fill="#B1B0B1" d="m.6 232.882-.063-37.456H.55l.063 37.456H.6z" />
//         <path
//           fill="#AEAEAF"
//           d="m.589 232.882-.063-37.456h.011L.6 232.882H.59z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m.577 232.882-.063-37.456h.012l.063 37.456H.577z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m.565 232.882-.063-37.456h.012l.063 37.456H.565z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="M.554 232.882.49 195.426h.011l.063 37.456h-.01z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="M.542 232.882.48 195.426h.012l.063 37.456H.542z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m.53 232.882-.063-37.456H.48l.063 37.456H.53z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m.521 232.882-.065-37.456h.011l.063 37.456H.521z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m.51 232.882-.066-37.456h.012l.065 37.456H.509z"
//         />
//         <path
//           fill="#989799"
//           d="m.498 232.882-.066-37.456h.012l.065 37.456H.498z"
//         />
//         <path
//           fill="#959495"
//           d="m.486 232.882-.065-37.456h.011l.066 37.456H.486z"
//         />
//         <path
//           fill="#929192"
//           d="M.474 232.882.41 195.426h.012l.065 37.456H.474z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m.463 232.882-.066-37.456H.41l.065 37.456H.463z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m.451 232.882-.065-37.456h.012l.065 37.456H.45z"
//         />
//         <path
//           fill="#888788"
//           d="m.44 232.882-.064-37.456h.01l.065 37.456H.44z"
//         />
//         <path
//           fill="#848485"
//           d="m.428 232.882-.063-37.456h.012l.062 37.456H.428z"
//         />
//         <path
//           fill="#818081"
//           d="m.416 232.882-.063-37.456h.012l.063 37.456H.416z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m.404 232.882-.062-37.456h.011l.063 37.456H.404z"
//         />
//         <path
//           fill="#79797A"
//           d="M.393 232.882.33 195.426h.012l.063 37.456H.393z"
//         />
//         <path
//           fill="#767576"
//           d="m.381 232.882-.063-37.456H.33l.063 37.456H.38z"
//         />
//         <path
//           fill="#727173"
//           d="m.37 232.882-.063-37.456h.011l.063 37.456H.37z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m.358 232.882-.063-37.456h.012l.063 37.456H.358z"
//         />
//         <path
//           fill="#6A696B"
//           d="m.346 232.882-.063-37.456h.012l.063 37.456H.346z"
//         />
//         <path
//           fill="#666566"
//           d="m.335 232.882-.063-37.456h.011l.063 37.456H.335z"
//         />
//         <path
//           fill="#616162"
//           d="M.323 232.882.26 195.426h.012l.063 37.456H.323z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m.311 232.882-.063-37.456H.26l.063 37.456H.31z"
//         />
//         <path fill="#595859" d="m.3 232.882-.063-37.456h.011l.063 37.456H.3z" />
//         <path
//           fill="#545355"
//           d="m.288 232.882-.063-37.456h.012L.3 232.882H.288z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m.276 232.882-.063-37.456h.012l.063 37.456H.276z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m.265 232.882-.063-37.456h.011l.063 37.456H.265z"
//         />
//         <path
//           fill="#464547"
//           d="M.255 232.882.19 195.426h.012l.063 37.456h-.01z"
//         />
//         <path
//           fill="#414042"
//           d="m.244 232.882-.066-37.456H.19l.065 37.456H.244z"
//         />
//         <path fill="#414042" d="m.178 195.426.066 37.456h-.07v-37.456h.004z" />
//       </g>
//     </g>
//     <path
//       fill="#E2E2E2"
//       d="M.036 121.931c0 .121.077.238.294.261l1.767.2c.198 0 .357-.1.357-.221l-.028-17.174c0-.121-.161-.221-.357-.221l-1.842.223c-.228.042-.219.285-.219.406l.026 16.523.002.003z"
//     />
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="i-13"
//         width={3}
//         height={19}
//         x={0}
//         y={104}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.036 121.931c0 .121.077.238.294.261l1.767.2c.198 0 .357-.1.357-.221l-.028-17.174c0-.121-.161-.221-.357-.221l-1.842.223c-.228.042-.219.285-.219.406l.026 16.523.002.003z"
//         />
//       </mask>
//       <g mask="url(#i-13)">
//         <path fill="#414042" d="m2.456 121.227-.028-16.451h.028v16.451z" />
//         <path
//           fill="#414042"
//           d="m2.444 122.392-.03-17.616h.014l.028 16.451v1.165h-.012z"
//         />
//         <path
//           fill="#464547"
//           d="m2.433 122.392-.03-17.616h.01l.031 17.616h-.011z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m2.419 122.392-.028-17.616h.011l.03 17.616H2.42z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m2.407 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#545355"
//           d="m2.395 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#595859"
//           d="m2.381 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m2.37 122.392-.03-17.616h.01l.031 17.616H2.37z"
//         />
//         <path
//           fill="#616162"
//           d="m2.356 122.392-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#666566"
//           d="m2.344 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#6A696B"
//           d="m2.33 122.392-.028-17.616h.012l.03 17.616H2.33z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m2.318 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#727173"
//           d="m2.307 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#767576"
//           d="m2.293 122.392-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#79797A"
//           d="m2.281 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m2.267 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#818081"
//           d="m2.255 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#848485"
//           d="m2.241 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#888788"
//           d="m2.23 122.392-.03-17.616h.011l.03 17.616H2.23z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m2.216 122.392-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m2.204 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#929192"
//           d="m2.192 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#959495"
//           d="m2.178 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#989799"
//           d="m2.167 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m2.153 122.392-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m2.141 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="M2.127 122.392 2.1 104.776h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m2.116 122.392-.03-17.616h.013l.028 17.616h-.011z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m2.104 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m2.09 122.392-.03-17.616h.014l.03 17.616H2.09z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m2.078 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#AEAEAF"
//           d="m2.064 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#B1B0B1"
//           d="m2.053 122.392-.03-17.616h.01l.031 17.616h-.011z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m2.039 122.392-.03-17.616h.013l.03 17.616H2.04z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m2.027 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m2.015 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#BABABA"
//           d="m2.001 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m1.99 122.392-.03-17.616h.011l.03 17.616H1.99z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m1.976 122.392-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m1.964 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m1.95 122.392-.03-17.616h.014l.03 17.616H1.95z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m1.938 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m1.924 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m1.913 122.392-.03-17.616h.013l.028 17.616h-.011z"
//         />
//         <path
//           fill="#CACACA"
//           d="m1.901 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#CCC"
//           d="m1.887 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m1.875 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m1.861 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m1.85 122.392-.03-17.616h.011l.03 17.616H1.85z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m1.836 122.392-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m1.824 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m1.812 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m1.798 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="m1.787 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m1.773 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m1.761 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m1.747 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m1.736 122.392-.03-17.616h.01l.031 17.616h-.011z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m1.724 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m1.71 122.392-.03-17.616h.014l.03 17.616H1.71z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m1.698 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m1.684 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m1.673 122.392-.03-17.616h.01l.031 17.616h-.011z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m1.659 122.392-.03-17.616h.013l.03 17.616H1.66z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m1.647 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m1.633 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m1.621 122.392-.03-17.616h.014l.028 17.616H1.62z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m1.61 122.392-.03-17.616h.011l.03 17.616H1.61z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="m1.596 122.392-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m1.584 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m1.57 122.392-.03-17.616h.014l.03 17.616H1.57z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m1.558 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#ECECED"
//           d="m1.544 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m1.533 122.392-.03-17.616h.013l.028 17.616h-.011z"
//         />
//         <path
//           fill="#EEE"
//           d="m1.521 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.507 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m1.495 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.481 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.47 122.392-.03-17.616h.011l.03 17.616H1.47zm-.014 0-.03-17.616h.013l.03 17.616h-.013z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.444 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.432 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.418 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.407 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.393 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.381 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.367 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.355 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.342 122.392-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.33 122.392-.03-17.616h.014l.028 17.616H1.33z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.318 122.392-.03-17.616H1.3l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.304 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.293 122.392-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616H1.28zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.253 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.241 122.392-.03-17.616h.012l.03 17.616H1.24z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.23 122.392-.03-17.616h.011l.03 17.616H1.23z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.216 122.392-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.19 122.392-.03-17.616h.014l.03 17.616H1.19z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.178 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.164 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.153 122.392-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.028-17.616h.011l.03 17.616H1.14z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.127 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.115 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.101 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.09 122.392-.03-17.616h.011l.03 17.616H1.09z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.076 122.392-.03-17.616h.014l.03 17.616h-.014zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.05 122.392-.028-17.616h.012l.03 17.616H1.05z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.038 122.392-.03-17.616h.014l.028 17.616h-.012zm-.011 0-.03-17.616h.011l.03 17.616h-.011zM1.013 122.392l-.03-17.616h.014l.03 17.616h-.014zm-.012 0-.03-17.616h.011l.03 17.616h-.01zm-.014 0-.03-17.616H.97L1 122.392H.987z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m.975 122.392-.03-17.616h.012l.03 17.616H.975z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m.962 122.392-.03-17.616h.013l.03 17.616H.963zm-.012 0-.03-17.616h.01l.03 17.616H.95z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.938 122.392-.03-17.616H.92l.03 17.616H.938z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.924 122.392-.03-17.616h.014l.03 17.616H.924z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.913 122.392-.03-17.616h.011l.03 17.616H.913zm-.014 0-.03-17.616h.013l.03 17.616H.9zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.873 122.392-.03-17.616h.014l.03 17.616H.873z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.861 122.392-.03-17.616h.012l.03 17.616H.861z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="M.847 122.392.82 104.776h.012l.03 17.616H.847zm-.011 0-.03-17.616h.013l.028 17.616H.836zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#FEFEFE" d="m.81 122.392-.03-17.616h.014l.03 17.616H.81z" />
//         <path
//           fill="#FEFEFE"
//           d="m.798 122.392-.03-17.616H.78l.03 17.616H.798z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.784 122.392-.03-17.616h.014l.03 17.616H.784z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m.773 122.392-.03-17.616h.011l.03 17.616H.773z"
//         />
//         <path
//           fill="#fff"
//           d="M.759 122.392.73 104.776h.011l.03 17.616H.76zm-.012 0-.03-17.616H.73l.028 17.616H.747z"
//         />
//         <path fill="#fff" d="m.735 122.392-.03-17.616h.012l.03 17.616H.735z" />
//         <path
//           fill="#fff"
//           d="m.721 122.392-.03-17.616h.014l.03 17.616H.721zm-.011 0-.03-17.616h.01l.03 17.616H.71z"
//         />
//         <path
//           fill="#fff"
//           d="m.696 122.392-.03-17.616H.68l.03 17.616H.696zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="m.67 122.392-.03-17.616h.014l.03 17.616H.67z" />
//         <path fill="#fff" d="m.658 122.392-.03-17.616H.64l.03 17.616H.658z" />
//         <path fill="#fff" d="m.647 122.392-.03-17.616h.011l.03 17.616h-.01z" />
//         <path fill="#fff" d="m.633 122.392-.03-17.616h.014l.03 17.616H.633z" />
//         <path
//           fill="#fff"
//           d="m.621 122.392-.03-17.616h.012l.03 17.616H.62zm-.014 0-.03-17.616H.59l.03 17.616H.607z"
//         />
//         <path
//           fill="#fff"
//           d="m.596 122.392-.03-17.616h.011l.03 17.616H.596zm-.014 0-.03-17.616h.013l.03 17.616H.583zm-.012 0-.03-17.616h.01l.03 17.616H.57z"
//         />
//         <path fill="#fff" d="m.556 122.392-.028-17.616H.54l.03 17.616H.556z" />
//         <path fill="#fff" d="m.544 122.392-.03-17.616h.014l.028 17.616H.544z" />
//         <path
//           fill="#fff"
//           d="m.533 122.392-.03-17.616h.011l.03 17.616H.533zm-.014 0-.03-17.616h.013l.03 17.616H.52zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="m.493 122.392-.03-17.616h.014l.03 17.616H.493z" />
//         <path fill="#fff" d="m.481 122.392-.03-17.616h.012l.03 17.616H.481z" />
//         <path fill="#fff" d="M.467 122.392.44 104.776h.012l.03 17.616H.467z" />
//         <path
//           fill="#fff"
//           d="m.456 122.392-.03-17.616h.013l.028 17.616H.456zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="M.43 122.392.4 104.776h.014l.03 17.616H.43z" />
//         <path fill="#fff" d="m.418 122.392-.03-17.616H.4l.03 17.616H.418z" />
//         <path fill="#fff" d="m.404 122.392-.03-17.616h.014l.03 17.616H.404z" />
//         <path
//           fill="#fff"
//           d="m.393 122.392-.03-17.616h.011l.03 17.616H.393zm-.014 0-.03-17.616h.013l.03 17.616H.38zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="m.353 122.392-.028-17.616h.012l.03 17.616H.353z" />
//         <path
//           fill="#fff"
//           d="m.341 122.392-.03-17.616h.014l.028 17.616H.341zm-.011 0L.3 104.776h.01l.03 17.616H.33zm-.014 0-.03-17.616H.3l.03 17.616H.316zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="m.29 122.392-.03-17.616h.014l.03 17.616H.29z" />
//         <path fill="#fff" d="m.278 122.392-.03-17.616H.26l.03 17.616H.278z" />
//         <path
//           fill="#fff"
//           d="m.265 122.392-.028-17.616h.011l.03 17.616H.266zm-.012 0-.03-17.616h.014l.027 17.616H.253z"
//         />
//         <path
//           fill="#fff"
//           d="m.241 122.392-.03-17.616h.012l.03 17.616H.24zm-.014 0-.03-17.616H.21l.03 17.616H.227z"
//         />
//         <path
//           fill="#fff"
//           d="m.216 122.392-.03-17.616h.011l.03 17.616H.216zm-.014 0-.03-17.616h.013l.03 17.616H.203zm-.012 0-.03-17.616h.01l.03 17.616H.19z"
//         />
//         <path fill="#fff" d="m.176 122.392-.03-17.616H.16l.03 17.616H.176z" />
//         <path fill="#fff" d="m.164 122.392-.03-17.616h.012l.03 17.616H.164z" />
//         <path
//           fill="#fff"
//           d="m.153 122.392-.03-17.616h.011l.03 17.616H.153zm-.014 0-.03-17.616h.013l.03 17.616H.14zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#fff" d="m.113 122.392-.03-17.616h.014l.03 17.616H.113z" />
//         <path
//           fill="#fff"
//           d="m.101 122.392-.03-17.616h.012l.03 17.616H.101zm-.014 0-.03-17.616h.014l.03 17.616H.087zM.076 122.392l-.03-17.616h.011l.03 17.616H.076zm-.014 0-.028-17.616h.011l.03 17.616H.063z"
//         />
//         <path
//           fill="#fff"
//           d="m.05 122.392-.03-17.616h.014l.028 17.616H.05zm-.012 0-.03-17.616H.02l.03 17.616H.038z"
//         />
//         <path fill="#fff" d="m.008 104.776.03 17.616H.001v-17.616h.007z" />
//       </g>
//     </g>
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="j-14"
//         width={3}
//         height={19}
//         x={0}
//         y={104}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M.036 121.931c0 .121.077.238.294.261l1.767.2c.198 0 .357-.1.357-.221l-.028-17.174c0-.121-.161-.221-.357-.221l-1.842.223c-.228.042-.219.285-.219.406l.026 16.523.002.003z"
//         />
//       </mask>
//       <g mask="url(#j-14)">
//         <path fill="#fff" d="m2.456 121.227-.028-16.451h.028v16.451z" />
//         <path
//           fill="#fff"
//           d="m2.444 122.392-.03-17.616h.014l.028 16.451v1.165h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.433 122.392-.03-17.616h.01l.031 17.616h-.011zm-.014 0-.028-17.616h.011l.03 17.616H2.42z"
//         />
//         <path
//           fill="#fff"
//           d="m2.407 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.395 122.392-.03-17.616h.012l.03 17.616h-.012zm-.014 0-.03-17.616h.014l.03 17.616h-.014zM2.37 122.392l-.03-17.616h.01l.031 17.616H2.37zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011zM2.33 122.392l-.028-17.616h.012l.03 17.616H2.33z"
//         />
//         <path
//           fill="#fff"
//           d="m2.318 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.307 122.392-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.014l.03 17.616h-.014zM2.255 122.392l-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.241 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#fff"
//           d="m2.23 122.392-.03-17.616h.011l.03 17.616H2.23zm-.014 0-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#fff"
//           d="m2.204 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.192 122.392-.03-17.616h.012l.03 17.616h-.012zm-.014 0-.03-17.616h.014l.03 17.616h-.014zM2.167 122.392l-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="M2.127 122.392 2.1 104.776h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#fff"
//           d="m2.116 122.392-.03-17.616h.013l.028 17.616h-.011zm-.012 0-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.014l.03 17.616H2.09zM2.078 122.392l-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m2.064 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.01l.031 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616H2.04zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m2.015 122.392-.03-17.616h.012l.03 17.616h-.012zm-.014 0-.03-17.616h.014l.03 17.616h-.014zM1.99 122.392l-.03-17.616h.011l.03 17.616H1.99zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path fill="#fff" d="m1.95 122.392-.03-17.616h.014l.03 17.616H1.95z" />
//         <path
//           fill="#fff"
//           d="m1.938 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.924 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#fff"
//           d="m1.913 122.392-.03-17.616h.013l.028 17.616h-.011zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#fff"
//           d="m1.887 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#fff"
//           d="m1.875 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.861 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#fff"
//           d="m1.85 122.392-.03-17.616h.011l.03 17.616H1.85zm-.014 0-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#fff"
//           d="m1.824 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.812 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#fff"
//           d="m1.798 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.011l.03 17.616h-.011zM1.773 122.392l-.03-17.616h.014l.03 17.616h-.014zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#fff"
//           d="m1.747 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.01l.031 17.616h-.011zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.71 122.392-.03-17.616h.014l.03 17.616H1.71z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.698 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.684 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.01l.031 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616H1.66zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.633 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.621 122.392-.03-17.616h.014l.028 17.616H1.62z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.61 122.392-.03-17.616h.011l.03 17.616H1.61zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.57 122.392-.03-17.616h.014l.03 17.616H1.57z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.558 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m1.544 122.392-.028-17.616h.012l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.533 122.392-.03-17.616h.013l.028 17.616h-.011zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.507 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.495 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m1.481 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.011l.03 17.616H1.47zm-.014 0-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.432 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.418 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.407 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.393 122.392-.03-17.616h.014l.03 17.616h-.014zm-.012 0-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m1.367 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.355 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.342 122.392-.028-17.616h.011l.03 17.616h-.013z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.33 122.392-.03-17.616h.014l.028 17.616H1.33z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m1.318 122.392-.03-17.616H1.3l.03 17.616h-.012z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m1.304 122.392-.03-17.616h.014l.03 17.616h-.014zm-.011 0-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.03-17.616h.013l.03 17.616H1.28zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.253 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.241 122.392-.03-17.616h.012l.03 17.616H1.24z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m1.23 122.392-.03-17.616h.011l.03 17.616H1.23z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.216 122.392-.03-17.616h.013l.03 17.616h-.013zm-.012 0-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m1.19 122.392-.03-17.616h.014l.03 17.616H1.19z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.178 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m1.164 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m1.153 122.392-.03-17.616h.011l.03 17.616h-.011zm-.014 0-.028-17.616h.011l.03 17.616H1.14z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m1.127 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.115 122.392-.03-17.616h.012l.03 17.616h-.012z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m1.101 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.09 122.392-.03-17.616h.011l.03 17.616H1.09z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m1.076 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m1.064 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m1.05 122.392-.028-17.616h.012l.03 17.616H1.05z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m1.038 122.392-.03-17.616h.014l.028 17.616h-.012z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.027 122.392-.03-17.616h.011l.03 17.616h-.011z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m1.013 122.392-.03-17.616h.014l.03 17.616h-.014z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m1.001 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#EFEFEF" d="m.987 122.392-.03-17.616H.97L1 122.392H.987z" />
//         <path
//           fill="#EFEFEF"
//           d="m.975 122.392-.03-17.616h.012l.03 17.616H.975z"
//         />
//         <path fill="#EEE" d="m.962 122.392-.03-17.616h.013l.03 17.616H.963z" />
//         <path fill="#EDEDED" d="m.95 122.392-.03-17.616h.01l.03 17.616H.95z" />
//         <path
//           fill="#ECECED"
//           d="m.938 122.392-.03-17.616H.92l.03 17.616H.938z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m.924 122.392-.03-17.616h.014l.03 17.616H.924z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m.913 122.392-.03-17.616h.011l.03 17.616H.913z"
//         />
//         <path fill="#EAEAEA" d="m.899 122.392-.03-17.616h.013l.03 17.616H.9z" />
//         <path
//           fill="#E9E9E9"
//           d="m.887 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m.873 122.392-.03-17.616h.014l.03 17.616H.873z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m.861 122.392-.03-17.616h.012l.03 17.616H.861z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="M.847 122.392.82 104.776h.012l.03 17.616H.847z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m.836 122.392-.03-17.616h.013l.028 17.616H.836z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m.824 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#E3E3E3" d="m.81 122.392-.03-17.616h.014l.03 17.616H.81z" />
//         <path
//           fill="#E2E2E2"
//           d="m.798 122.392-.03-17.616H.78l.03 17.616H.798z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m.784 122.392-.03-17.616h.014l.03 17.616H.784z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m.773 122.392-.03-17.616h.011l.03 17.616H.773z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="M.759 122.392.73 104.776h.011l.03 17.616H.76z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m.747 122.392-.03-17.616H.73l.028 17.616H.747z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m.735 122.392-.03-17.616h.012l.03 17.616H.735z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m.721 122.392-.03-17.616h.014l.03 17.616H.721z"
//         />
//         <path fill="#DAD9DA" d="m.71 122.392-.03-17.616h.01l.03 17.616H.71z" />
//         <path
//           fill="#D8D8D9"
//           d="m.696 122.392-.03-17.616H.68l.03 17.616H.696z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m.684 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#D5D5D6" d="m.67 122.392-.03-17.616h.014l.03 17.616H.67z" />
//         <path
//           fill="#D4D4D4"
//           d="m.658 122.392-.03-17.616H.64l.03 17.616H.658z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m.647 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m.633 122.392-.03-17.616h.014l.03 17.616H.633z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m.621 122.392-.03-17.616h.012l.03 17.616H.62z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m.607 122.392-.03-17.616H.59l.03 17.616H.607z"
//         />
//         <path fill="#CCC" d="m.596 122.392-.03-17.616h.011l.03 17.616H.596z" />
//         <path
//           fill="#CACACA"
//           d="m.582 122.392-.03-17.616h.013l.03 17.616H.583z"
//         />
//         <path fill="#C8C8C8" d="m.57 122.392-.03-17.616h.01l.03 17.616H.57z" />
//         <path
//           fill="#C6C6C7"
//           d="m.556 122.392-.028-17.616H.54l.03 17.616H.556z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m.544 122.392-.03-17.616h.014l.028 17.616H.544z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m.533 122.392-.03-17.616h.011l.03 17.616H.533z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m.519 122.392-.03-17.616h.013l.03 17.616H.52z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m.507 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m.493 122.392-.03-17.616h.014l.03 17.616H.493z"
//         />
//         <path
//           fill="#BABABA"
//           d="m.481 122.392-.03-17.616h.012l.03 17.616H.481z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="M.467 122.392.44 104.776h.012l.03 17.616H.467z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m.456 122.392-.03-17.616h.013l.028 17.616H.456z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m.444 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#B1B0B1" d="M.43 122.392.4 104.776h.014l.03 17.616H.43z" />
//         <path fill="#AEAEAF" d="m.418 122.392-.03-17.616H.4l.03 17.616H.418z" />
//         <path
//           fill="#ACABAC"
//           d="m.404 122.392-.03-17.616h.014l.03 17.616H.404z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m.393 122.392-.03-17.616h.011l.03 17.616H.393z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m.379 122.392-.03-17.616h.013l.03 17.616H.38z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m.367 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m.353 122.392-.028-17.616h.012l.03 17.616H.353z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m.341 122.392-.03-17.616h.014l.028 17.616H.341z"
//         />
//         <path fill="#9B9B9C" d="M.33 122.392.3 104.776h.01l.03 17.616H.33z" />
//         <path fill="#989799" d="m.316 122.392-.03-17.616H.3l.03 17.616H.316z" />
//         <path
//           fill="#959495"
//           d="m.304 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path fill="#929192" d="m.29 122.392-.03-17.616h.014l.03 17.616H.29z" />
//         <path
//           fill="#8F8E8F"
//           d="m.278 122.392-.03-17.616H.26l.03 17.616H.278z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m.265 122.392-.028-17.616h.011l.03 17.616H.266z"
//         />
//         <path
//           fill="#888788"
//           d="m.253 122.392-.03-17.616h.014l.027 17.616H.253z"
//         />
//         <path
//           fill="#848485"
//           d="m.241 122.392-.03-17.616h.012l.03 17.616H.24z"
//         />
//         <path
//           fill="#818081"
//           d="m.227 122.392-.03-17.616H.21l.03 17.616H.227z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m.216 122.392-.03-17.616h.011l.03 17.616H.216z"
//         />
//         <path
//           fill="#79797A"
//           d="m.202 122.392-.03-17.616h.013l.03 17.616H.203z"
//         />
//         <path fill="#767576" d="m.19 122.392-.03-17.616h.01l.03 17.616H.19z" />
//         <path
//           fill="#727173"
//           d="m.176 122.392-.03-17.616H.16l.03 17.616H.176z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m.164 122.392-.03-17.616h.012l.03 17.616H.164z"
//         />
//         <path
//           fill="#6A696B"
//           d="m.153 122.392-.03-17.616h.011l.03 17.616H.153z"
//         />
//         <path
//           fill="#666566"
//           d="m.139 122.392-.03-17.616h.013l.03 17.616H.14z"
//         />
//         <path
//           fill="#616162"
//           d="m.127 122.392-.03-17.616h.011l.03 17.616h-.01z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m.113 122.392-.03-17.616h.014l.03 17.616H.113z"
//         />
//         <path
//           fill="#595859"
//           d="m.101 122.392-.03-17.616h.012l.03 17.616H.101z"
//         />
//         <path
//           fill="#545355"
//           d="m.087 122.392-.03-17.616h.014l.03 17.616H.087z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m.076 122.392-.03-17.616h.011l.03 17.616H.076z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m.062 122.392-.028-17.616h.011l.03 17.616H.063z"
//         />
//         <path
//           fill="#464547"
//           d="m.05 122.392-.03-17.616h.014l.028 17.616H.05z"
//         />
//         <path
//           fill="#414042"
//           d="m.038 122.392-.03-17.616H.02l.03 17.616H.038z"
//         />
//         <path fill="#414042" d="m.008 104.776.03 17.616H.001v-17.616h.007z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="k-15"
//         width={3}
//         height={3}
//         x={0}
//         y={104}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m.864 106.24-.853-.042v-.793s-.096-.373.289-.415c.352-.037 1.769-.214 1.769-.214s.329.002.357.202c.028.201 0 1.227 0 1.227l-1.565.035h.003z"
//         />
//       </mask>
//       <g mask="url(#k-15)">
//         <path fill="#fff" d="m-.085 106.235 2.54-.005v.009h-2.54v-.004z" />
//         <path fill="#fff" d="m-.085 106.23 2.54-.004v.004l-2.54.005v-.005z" />
//         <path
//           fill="#FEFEFE"
//           d="m-.085 106.225 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m-.085 106.221 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m-.085 106.219 2.54-.005v.002l-2.54.005v-.002z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m-.085 106.214 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m-.085 106.209 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m-.085 106.205 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path fill="#F7F7F7" d="m-.085 106.2 2.54-.002v.002l-2.54.005v-.005z" />
//         <path
//           fill="#F6F5F5"
//           d="m-.085 106.198 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m-.085 106.193 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m-.085 106.188 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m-.085 106.184 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m-.085 106.181 2.54-.004v.002l-2.54.005v-.003z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m-.085 106.177 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m-.085 106.172 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m-.085 106.167 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m-.085 106.163 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m-.085 106.16 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m-.085 106.156 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m-.085 106.151 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m-.085 106.146 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m-.085 106.144 2.54-.005v.003l-2.54.004v-.002z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m-.085 106.139 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m-.085 106.135 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m-.085 106.13 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m-.085 106.125 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m-.085 106.123 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m-.085 106.118 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m-.085 106.114 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path fill="#DDD" d="m-.085 106.109 2.54-.005v.005l-2.54.005v-.005z" />
//         <path
//           fill="#DCDBDC"
//           d="m-.085 106.107 2.54-.005v.002l-2.54.005v-.002z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m-.085 106.102 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m-.085 106.097 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="m-.085 106.093 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m-.085 106.088 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m-.085 106.086 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m-.085 106.081 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m-.085 106.076 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m-.085 106.072 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m-.085 106.069 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m-.085 106.065 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m-.085 106.06 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#CECECE"
//           d="m-.085 106.055 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m-.085 106.051 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m-.085 106.048 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#CBCACA"
//           d="m-.085 106.044 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#CAC9C9"
//           d="m-.085 106.039 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C9C8C8"
//           d="m-.085 106.034 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C8C7C7"
//           d="m-.085 106.032 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m-.085 106.027 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m-.085 106.023 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m-.085 106.018 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m-.085 106.013 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m-.085 106.011 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m-.085 106.006 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m-.085 106.002 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m-.085 105.997 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m-.085 105.995 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="m-.085 105.99 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m-.085 105.985 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m-.085 105.981 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m-.085 105.976 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m-.085 105.974 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m-.085 105.969 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m-.085 105.964 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m-.085 105.96 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m-.085 105.957 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m-.085 105.953 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m-.085 105.948 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m-.085 105.943 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m-.085 105.941 2.54-.005v.003l-2.54.004v-.002z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m-.085 105.936 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m-.085 105.932 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m-.085 105.927 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m-.085 105.922 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m-.085 105.92 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m-.085 105.915 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m-.085 105.911 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m-.085 105.906 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m-.085 105.904 2.54-.005v.003l-2.54.004v-.002z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m-.085 105.899 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m-.085 105.894 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m-.085 105.89 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m-.085 105.885 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m-.085 105.883 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m-.085 105.878 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m-.085 105.873 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m-.085 105.869 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m-.085 105.867 2.54-.005v.002l-2.54.005v-.002z"
//         />
//         <path
//           fill="#9B9999"
//           d="m-.085 105.862 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#9A9898"
//           d="m-.085 105.857 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#999797"
//           d="m-.085 105.853 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#979696"
//           d="m-.085 105.848 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#969495"
//           d="m-.085 105.846 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#959394"
//           d="m-.085 105.841 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#949293"
//           d="m-.085 105.836 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#939192"
//           d="m-.085 105.832 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#929091"
//           d="m-.085 105.829 2.54-.004v.002l-2.54.005v-.003z"
//         />
//         <path
//           fill="#918F90"
//           d="m-.085 105.825 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#908E8F"
//           d="m-.085 105.82 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m-.085 105.815 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m-.085 105.811 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m-.085 105.808 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m-.085 105.804 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#8B8989"
//           d="m-.085 105.799 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#8A8888"
//           d="m-.085 105.794 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#898787"
//           d="m-.085 105.792 2.54-.005v.003l-2.54.004v-.002z"
//         />
//         <path
//           fill="#888686"
//           d="m-.085 105.787 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#878485"
//           d="m-.085 105.783 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#868384"
//           d="m-.085 105.778 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#858283"
//           d="m-.085 105.773 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#848182"
//           d="m-.085 105.771 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#838081"
//           d="m-.085 105.766 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#817F80"
//           d="m-.085 105.762 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#807E7F"
//           d="m-.085 105.757 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m-.085 105.755 2.54-.005v.002l-2.54.005v-.002z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m-.085 105.75 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m-.085 105.745 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m-.085 105.741 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#7B797A"
//           d="m-.085 105.736 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#7A7879"
//           d="m-.085 105.734 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#797778"
//           d="m-.085 105.729 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#787676"
//           d="m-.085 105.724 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#777575"
//           d="m-.085 105.72 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#767474"
//           d="m-.085 105.717 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#757373"
//           d="m-.085 105.713 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#747272"
//           d="m-.085 105.708 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#737171"
//           d="m-.085 105.703 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#727070"
//           d="m-.085 105.699 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#716F6F"
//           d="m-.085 105.696 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#706E6E"
//           d="m-.085 105.692 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m-.085 105.687 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m-.085 105.682 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m-.085 105.68 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m-.085 105.675 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#6B6969"
//           d="m-.085 105.671 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#6A6868"
//           d="m-.085 105.666 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#696767"
//           d="m-.085 105.661 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#686666"
//           d="m-.085 105.659 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#676565"
//           d="m-.085 105.654 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#666464"
//           d="m-.085 105.65 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#666363"
//           d="m-.085 105.645 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#656262"
//           d="m-.085 105.643 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#646161"
//           d="m-.085 105.638 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#636060"
//           d="m-.085 105.633 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#625F5F"
//           d="m-.085 105.629 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#615E5F"
//           d="m-.085 105.624 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#605D5E"
//           d="m-.085 105.622 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#5F5C5D"
//           d="m-.085 105.617 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m-.085 105.612 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m-.085 105.608 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#5C595A"
//           d="m-.085 105.605 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#5B5859"
//           d="m-.085 105.601 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#5A5758"
//           d="m-.085 105.596 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#595657"
//           d="m-.085 105.591 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#585556"
//           d="m-.085 105.587 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#575455"
//           d="m-.085 105.584 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#565354"
//           d="m-.085 105.58 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#555253"
//           d="m-.085 105.575 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#545152"
//           d="m-.085 105.57 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#545051"
//           d="m-.085 105.568 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#534F50"
//           d="m-.085 105.563 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#524F4F"
//           d="m-.085 105.559 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#514E4E"
//           d="m-.085 105.554 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#504D4D"
//           d="m-.085 105.549 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m-.085 105.547 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m-.085 105.543 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m-.085 105.538 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#4C494A"
//           d="m-.085 105.533 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#4B4849"
//           d="m-.085 105.531 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#4A4748"
//           d="m-.085 105.526 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#4A4647"
//           d="m-.085 105.522 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#494546"
//           d="m-.085 105.517 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#484445"
//           d="m-.085 105.514 2.54-.004v.002l-2.54.005v-.003z"
//         />
//         <path
//           fill="#474444"
//           d="m-.085 105.51 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#464344"
//           d="m-.085 105.505 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#454243"
//           d="m-.085 105.501 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#444142"
//           d="m-.085 105.496 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#434041"
//           d="m-.085 105.493 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#433F40"
//           d="m-.085 105.489 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#423E3F"
//           d="m-.085 105.484 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#413D3E"
//           d="m-.085 105.48 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#403D3D"
//           d="m-.085 105.477 2.54-.004v.002l-2.54.005v-.003z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m-.085 105.473 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m-.085 105.468 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m-.085 105.463 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#3D393A"
//           d="m-.085 105.459 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#3C3839"
//           d="m-.085 105.456 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#3B3738"
//           d="m-.085 105.452 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#3A3738"
//           d="m-.085 105.447 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#393637"
//           d="m-.085 105.442 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#393536"
//           d="m-.085 105.44 2.54-.005v.003l-2.54.004v-.002z"
//         />
//         <path
//           fill="#383435"
//           d="m-.085 105.435 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#373334"
//           d="m-.085 105.431 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#363333"
//           d="m-.085 105.426 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#353233"
//           d="m-.085 105.421 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#353132"
//           d="m-.085 105.419 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#343031"
//           d="m-.085 105.414 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#332F30"
//           d="m-.085 105.41 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#322F30"
//           d="m-.085 105.405 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#322E2F"
//           d="m-.085 105.403 2.54-.005v.002l-2.54.005v-.002z"
//         />
//         <path
//           fill="#312D2E"
//           d="m-.085 105.398 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#302C2D"
//           d="m-.085 105.393 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m-.085 105.389 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m-.085 105.384 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m-.085 105.382 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path
//           fill="#2D292A"
//           d="m-.085 105.377 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#2C292A"
//           d="m-.085 105.372 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#2C2829"
//           d="m-.085 105.368 2.54-.005v.005l-2.54.004v-.004z"
//         />
//         <path
//           fill="#2B2728"
//           d="m-.085 105.365 2.54-.004v.002l-2.54.005v-.003z"
//         />
//         <path
//           fill="#2A2627"
//           d="m-.085 105.361 2.54-.005v.005l-2.54.004v-.004zm0-.005 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#292526"
//           d="m-.085 105.351 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#282425"
//           d="m-.085 105.347 2.54-.003v.003l-2.54.004v-.004z"
//         />
//         <path
//           fill="#282425"
//           d="m-.085 105.344 2.54-.004v.004l-2.54.003v-.003z"
//         />
//         <path
//           fill="#272324"
//           d="m-.085 105.34 2.54-.005v.005l-2.54.004v-.004zm0-.005 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#262223"
//           d="m-.085 105.33 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#252122"
//           d="m-.085 105.328 2.54-.005v.003l-2.54.004v-.002zm0-.005 2.54-.004v.004l-2.54.005v-.005z"
//         />
//         <path
//           fill="#242021"
//           d="m-.085 105.319 2.54-.005v.005l-2.54.004v-.004zm0-.005 2.54-.005v.005l-2.54.005v-.005z"
//         />
//         <path
//           fill="#231F20"
//           d="m-.085 105.309 2.54-.002v.002l-2.54.005v-.005z"
//         />
//         <path
//           fill="#231F20"
//           d="m-.085 105.307 2.54-.005v.005l-2.54.002v-.002z"
//         />
//         <path fill="#231F20" d="m2.456 105.302-2.541.005v-.531h2.54v.526z" />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="l-16"
//         width={3}
//         height={3}
//         x={0}
//         y={120}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m.887 120.931-.853.044v.793s-.098.401.284.419c.357.019 1.779.203 1.779.203s.329-.005.357-.205c.028-.201 0-1.226 0-1.226l-1.565-.028H.887z"
//         />
//       </mask>
//       <g mask="url(#l-16)">
//         <path fill="#fff" d="m2.482 120.935-2.546.005v-.009h2.546v.004z" />
//         <path fill="#fff" d="m2.482 120.94-2.546.005v-.005l2.546-.005v.005z" />
//         <path
//           fill="#FEFEFE"
//           d="m2.482 120.945-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m2.482 120.949-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m2.482 120.954-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m2.482 120.956-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m2.482 120.961-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m2.482 120.966-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m2.482 120.97-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#F6F5F5"
//           d="m2.482 120.973-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m2.482 120.977-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m2.482 120.982-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m2.482 120.987-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m2.482 120.991-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m2.482 120.994-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m2.482 120.998-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m2.482 121.003-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m2.482 121.008-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m2.482 121.01-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m2.482 121.015-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m2.482 121.019-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m2.482 121.024-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m2.482 121.026-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m2.482 121.031-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m2.482 121.036-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m2.482 121.04-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m2.482 121.045-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m2.482 121.047-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m2.482 121.052-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m2.482 121.057-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path fill="#DDD" d="m2.482 121.061-2.546.005v-.005l2.546-.004v.004z" />
//         <path
//           fill="#DCDBDC"
//           d="m2.482 121.064-2.546.004v-.002l2.546-.005v.003z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m2.482 121.068-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m2.482 121.073-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="m2.482 121.078-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m2.482 121.082-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m2.482 121.085-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m2.482 121.089-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m2.482 121.094-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m2.482 121.099-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m2.482 121.101-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m2.482 121.105-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m2.482 121.11-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#CECECE"
//           d="m2.482 121.115-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m2.482 121.119-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m2.482 121.122-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#CBCACA"
//           d="m2.482 121.126-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#CAC9C9"
//           d="m2.482 121.131-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#C9C8C8"
//           d="m2.482 121.136-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#C8C7C7"
//           d="m2.482 121.138-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m2.482 121.143-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m2.482 121.147-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m2.482 121.152-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m2.482 121.157-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m2.482 121.159-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m2.482 121.164-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m2.482 121.168-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m2.482 121.173-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m2.482 121.175-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="m2.482 121.18-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m2.482 121.185-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m2.482 121.189-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m2.482 121.194-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m2.482 121.196-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m2.482 121.201-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m2.482 121.206-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m2.482 121.21-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m2.482 121.213-2.546.004v-.002l2.546-.005v.003z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m2.482 121.217-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m2.482 121.222-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m2.482 121.227-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m2.482 121.231-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m2.482 121.234-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m2.482 121.238-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m2.482 121.243-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m2.482 121.248-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m2.482 121.25-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m2.482 121.255-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m2.482 121.259-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m2.482 121.264-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m2.482 121.269-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m2.482 121.271-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m2.482 121.276-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m2.482 121.28-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m2.482 121.285-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m2.482 121.287-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m2.482 121.292-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m2.482 121.297-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m2.482 121.301-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m2.482 121.306-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#9B9999"
//           d="m2.482 121.308-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#9A9898"
//           d="m2.482 121.313-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#999797"
//           d="m2.482 121.318-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#979696"
//           d="m2.482 121.322-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#969495"
//           d="m2.482 121.325-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#959394"
//           d="m2.482 121.329-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#949293"
//           d="m2.482 121.334-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#939192"
//           d="m2.482 121.339-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#929091"
//           d="m2.482 121.343-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#918F90"
//           d="m2.482 121.346-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#908E8F"
//           d="m2.482 121.35-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m2.482 121.355-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m2.482 121.36-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m2.482 121.362-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m2.482 121.367-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#8B8989"
//           d="m2.482 121.371-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#8A8888"
//           d="m2.482 121.376-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#898787"
//           d="m2.482 121.378-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#888686"
//           d="m2.482 121.383-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#878485"
//           d="m2.482 121.388-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#868384"
//           d="m2.482 121.392-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#858283"
//           d="m2.482 121.397-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#848182"
//           d="m2.482 121.399-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#838081"
//           d="m2.482 121.404-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#817F80"
//           d="m2.482 121.409-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#807E7F"
//           d="m2.482 121.413-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m2.482 121.416-2.546.004v-.002l2.546-.005v.003z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m2.482 121.42-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m2.482 121.425-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m2.482 121.43-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#7B797A"
//           d="m2.482 121.434-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#7A7879"
//           d="m2.482 121.437-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#797778"
//           d="m2.482 121.441-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#787676"
//           d="m2.482 121.446-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#777575"
//           d="m2.482 121.451-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#767474"
//           d="m2.482 121.453-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#757373"
//           d="m2.482 121.458-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#747272"
//           d="m2.482 121.462-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#737171"
//           d="m2.482 121.467-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#727070"
//           d="m2.482 121.472-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#716F6F"
//           d="m2.482 121.474-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#706E6E"
//           d="m2.482 121.478-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m2.482 121.483-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m2.482 121.488-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m2.482 121.49-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m2.482 121.495-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#6B6969"
//           d="m2.482 121.499-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#6A6868"
//           d="m2.482 121.504-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#696767"
//           d="m2.482 121.509-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#686666"
//           d="m2.482 121.511-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#676565"
//           d="m2.482 121.516-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#666464"
//           d="m2.482 121.52-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#666363"
//           d="m2.482 121.525-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#656262"
//           d="m2.482 121.527-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#646161"
//           d="m2.482 121.532-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#636060"
//           d="m2.482 121.537-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#625F5F"
//           d="m2.482 121.541-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#615E5F"
//           d="m2.482 121.546-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#605D5E"
//           d="m2.482 121.548-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#5F5C5D"
//           d="m2.482 121.553-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m2.482 121.558-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m2.482 121.562-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#5C595A"
//           d="m2.482 121.565-2.546.004v-.002l2.546-.005v.003z"
//         />
//         <path
//           fill="#5B5859"
//           d="m2.482 121.569-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#5A5758"
//           d="m2.482 121.574-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#595657"
//           d="m2.482 121.579-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#585556"
//           d="m2.482 121.583-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#575455"
//           d="m2.482 121.586-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#565354"
//           d="m2.482 121.59-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#555253"
//           d="m2.482 121.595-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#545152"
//           d="m2.482 121.6-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#545051"
//           d="m2.482 121.602-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#534F50"
//           d="m2.482 121.607-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#524F4F"
//           d="m2.482 121.611-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#514E4E"
//           d="m2.482 121.616-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#504D4D"
//           d="m2.482 121.621-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m2.482 121.623-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m2.482 121.628-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m2.482 121.632-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#4C494A"
//           d="m2.482 121.637-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#4B4849"
//           d="m2.482 121.639-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#4A4748"
//           d="m2.482 121.644-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#4A4647"
//           d="m2.482 121.649-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#494546"
//           d="m2.482 121.653-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#484445"
//           d="m2.482 121.658-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#474444"
//           d="m2.482 121.66-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#464344"
//           d="m2.482 121.665-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#454243"
//           d="m2.482 121.67-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#444142"
//           d="m2.482 121.674-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#434041"
//           d="m2.482 121.677-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#433F40"
//           d="m2.482 121.681-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#423E3F"
//           d="m2.482 121.686-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#413D3E"
//           d="m2.482 121.691-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#403D3D"
//           d="m2.482 121.695-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m2.482 121.698-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m2.482 121.702-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m2.482 121.707-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#3D393A"
//           d="m2.482 121.712-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#3C3839"
//           d="m2.482 121.714-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#3B3738"
//           d="m2.482 121.719-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#3A3738"
//           d="m2.482 121.723-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#393637"
//           d="m2.482 121.728-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#393536"
//           d="m2.482 121.73-2.546.005v-.002l2.546-.005v.002z"
//         />
//         <path
//           fill="#383435"
//           d="m2.482 121.735-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#373334"
//           d="m2.482 121.74-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#363333"
//           d="m2.482 121.744-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#353233"
//           d="m2.482 121.749-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#353132"
//           d="m2.482 121.751-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#343031"
//           d="m2.482 121.756-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#332F30"
//           d="m2.482 121.761-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#322F30"
//           d="m2.482 121.765-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#322E2F"
//           d="m2.482 121.768-2.546.004v-.002l2.546-.005v.003z"
//         />
//         <path
//           fill="#312D2E"
//           d="m2.482 121.772-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#302C2D"
//           d="m2.482 121.777-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m2.482 121.782-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m2.482 121.786-2.546.003v-.003l2.546-.004v.004z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m2.482 121.789-2.546.004v-.004l2.546-.003v.003z"
//         />
//         <path
//           fill="#2D292A"
//           d="m2.482 121.793-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#2C292A"
//           d="m2.482 121.798-2.546.005v-.005l2.546-.005v.005z"
//         />
//         <path
//           fill="#2C2829"
//           d="m2.482 121.803-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#2B2728"
//           d="m2.482 121.805-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#2A2627"
//           d="m2.482 121.81-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#2A2627"
//           d="m2.482 121.814-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#292526"
//           d="m2.482 121.819-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#282425"
//           d="m2.482 121.824-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#282425"
//           d="m2.482 121.826-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path
//           fill="#272324"
//           d="m2.482 121.831-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#272324"
//           d="m2.482 121.835-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#262223"
//           d="m2.482 121.84-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#252122"
//           d="m2.482 121.842-2.546.005v-.003l2.546-.004v.002z"
//         />
//         <path
//           fill="#252122"
//           d="m2.482 121.847-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#242021"
//           d="m2.482 121.852-2.546.004v-.004l2.546-.005v.005z"
//         />
//         <path
//           fill="#242021"
//           d="m2.482 121.856-2.546.005v-.005l2.546-.004v.004z"
//         />
//         <path
//           fill="#231F20"
//           d="m2.482 121.861-2.546.002v-.002l2.546-.005v.005z"
//         />
//         <path
//           fill="#231F20"
//           d="m2.482 121.863-2.546.005v-.005l2.546-.002v.002z"
//         />
//         <path fill="#231F20" d="m-.064 121.868 2.546-.005v.529H-.064v-.524z" />
//       </g>
//     </g>
//     <path
//       fill="#E2E2E2"
//       d="M289.894 174.595c0-.415-.104-.809-.408-.886l-2.459-.69c-.275 0-.496.336-.496.75l.093 58.369c0 .415.224.751.499.751l2.557-.756c.319-.144.303-.963.303-1.377l-.091-56.164.002.003z"
//     />
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="m-17"
//         width={4}
//         height={60}
//         x={286}
//         y={173}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M289.894 174.595c0-.415-.104-.809-.408-.886l-2.459-.69c-.275 0-.496.336-.496.75l.093 58.369c0 .415.224.751.499.751l2.557-.756c.319-.144.303-.963.303-1.377l-.091-56.164.002.003z"
//         />
//       </mask>
//       <g mask="url(#m-17)">
//         <path fill="#414042" d="m286.531 176.991.095 55.9h-.095v-55.9z" />
//         <path
//           fill="#414042"
//           d="m286.54 173.019.102 59.872h-.016l-.095-55.9v-3.972h.009z"
//         />
//         <path
//           fill="#464547"
//           d="m286.558 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m286.577 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m286.593 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#545355"
//           d="m286.612 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#595859"
//           d="m286.628 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m286.647 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#616162"
//           d="m286.663 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#666566"
//           d="m286.682 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#6A696B"
//           d="m286.701 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m286.717 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#727173"
//           d="m286.736 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#767576"
//           d="m286.752 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#79797A"
//           d="m286.771 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m286.787 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#818081"
//           d="m286.806 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#848485"
//           d="m286.824 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#888788"
//           d="m286.841 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m286.859 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m286.876 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#929192"
//           d="m286.894 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#959495"
//           d="m286.91 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#989799"
//           d="m286.929 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m286.945 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m286.964 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m286.983 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m286.999 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m287.018 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m287.034 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m287.053 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#AEAEAF"
//           d="m287.069 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#B1B0B1"
//           d="m287.088 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m287.106 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m287.123 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m287.141 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#BABABA"
//           d="m287.158 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m287.176 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m287.193 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m287.211 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m287.23 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m287.246 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m287.265 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m287.281 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#CACACA"
//           d="m287.3 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#CCC"
//           d="m287.316 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m287.335 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m287.353 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m287.37 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m287.388 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m287.405 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m287.423 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m287.44 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="m287.458 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m287.475 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m287.493 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m287.512 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m287.528 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m287.547 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m287.563 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m287.582 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m287.598 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m287.617 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m287.635 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m287.652 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m287.67 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m287.687 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m287.705 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="m287.722 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m287.74 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m287.759 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m287.775 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#ECECED"
//           d="m287.794 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m287.81 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#EEE"
//           d="m287.829 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m287.845 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m287.864 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m287.88 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m287.899 173.019.102 59.872h-.018l-.103-59.872h.019zm.019 0 .1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m287.934 173.019.102 59.872h-.018l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m287.952 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m287.969 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m287.988 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m288.004 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m288.022 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m288.041 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m288.057 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m288.076 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m288.092 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m288.111 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m288.127 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.146 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.165 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.181 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.2 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.216 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.235 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.251 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.27 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.286 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.305 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.323 173.019.1 59.872h-.016l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.34 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.358 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.374 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.393 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.41 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.428 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.447 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.463 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.482 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.498 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.517 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.552 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.57 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.587 173.019.102 59.872h-.018l-.101-59.872h.017zm.018 0 .101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m288.622 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.64 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.657 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.691 173.019.103 59.872h-.016l-.103-59.872h.016zm.019 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.729 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.745 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.764 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.78 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.799 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.834 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m288.852 173.019.101 59.872h-.017l-.102-59.872h.018zm.017 0 .102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m288.887 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m288.904 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m288.939 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m288.957 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m288.976 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m288.992 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.011 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.027 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.046 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.081 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.097 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.116 173.019.102 59.872h-.018l-.103-59.872h.019zm.019 0 .1 59.872h-.017l-.102-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.151 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m289.169 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.186 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.221 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m289.239 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.258 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.274 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.293 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.309 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.328 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.344 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.363 173.019.102 59.872h-.018l-.103-59.872h.019zm.019 0 .1 59.872h-.017l-.102-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.398 173.019.102 59.872h-.018l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.417 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.433 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.452 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.468 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.486 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.503 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018zM289.54 173.019l.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.556 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.575 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.591 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.61 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.626 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.645 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.664 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.68 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.699 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.715 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.734 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.75 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.769 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.787 173.019.1 59.872h-.016l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.804 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m289.822 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m289.838 173.019.103 59.872h-.019l-.1-59.872h.016zm.019 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m289.873 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m289.892 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path fill="#fff" d="m289.995 232.891-.103-59.872h.107v59.872h-.004z" />
//       </g>
//     </g>
//     <g
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="n-18"
//         width={4}
//         height={60}
//         x={286}
//         y={173}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M289.894 174.595c0-.415-.104-.809-.408-.886l-2.459-.69c-.275 0-.496.336-.496.75l.093 58.369c0 .415.224.751.499.751l2.557-.756c.319-.144.303-.963.303-1.377l-.091-56.164.002.003z"
//         />
//       </mask>
//       <g mask="url(#n-18)">
//         <path fill="#fff" d="m286.531 176.991.095 55.9h-.095v-55.9z" />
//         <path
//           fill="#fff"
//           d="m286.54 173.019.102 59.872h-.016l-.095-55.9v-3.972h.009z"
//         />
//         <path
//           fill="#fff"
//           d="m286.558 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m286.577 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.593 173.019.103 59.872h-.019l-.1-59.872h.016zm.019 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m286.628 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.647 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.663 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.682 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.701 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.717 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.736 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.752 173.019.102 59.872h-.016l-.102-59.872h.016zm.019 0 .102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.787 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.806 173.019.102 59.872h-.018l-.103-59.872h.019zm.018 0 .101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m286.841 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m286.859 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m286.876 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m286.894 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.91 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.929 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m286.945 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m286.964 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.983 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m286.999 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.018 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.053 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.088 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m287.106 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.123 173.019.102 59.872h-.018l-.101-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.158 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m287.176 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.193 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018zM287.23 173.019l.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m287.246 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.265 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.3 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m287.316 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.335 173.019.102 59.872h-.018l-.103-59.872h.019zm.018 0 .101 59.872h-.017l-.102-59.872h.018zM287.37 173.019l.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m287.388 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.405 173.019.102 59.872h-.018l-.101-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.44 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.475 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#fff"
//           d="m287.493 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#fff"
//           d="m287.512 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#fff"
//           d="m287.528 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#fff"
//           d="m287.547 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.563 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.582 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.617 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.635 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.652 173.019.102 59.872h-.018l-.101-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.687 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.705 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.722 173.019.102 59.872h-.016l-.103-59.872h.017zm.018 0 .103 59.872h-.019l-.102-59.872h.018zM287.759 173.019l.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.775 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m287.794 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.81 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.829 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.845 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.864 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.88 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.899 173.019.102 59.872h-.018l-.103-59.872h.019zm.019 0 .1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m287.934 173.019.102 59.872h-.018l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m287.952 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m287.969 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m287.988 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.004 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.022 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#FCFCFC"
//           d="m288.041 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.057 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.076 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.092 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m288.111 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.127 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.146 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.165 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m288.181 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.2 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.216 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m288.235 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.251 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.27 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m288.286 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m288.305 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m288.323 173.019.1 59.872h-.016l-.102-59.872h.018z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m288.34 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#F6F6F6"
//           d="m288.358 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F6F5F6"
//           d="m288.374 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m288.393 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#F5F5F5"
//           d="m288.41 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m288.428 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m288.447 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m288.463 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#F2F2F3"
//           d="m288.482 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m288.498 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m288.517 173.019.102 59.872h-.018l-.103-59.872h.019zm.016 0 .103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#F0F0F0"
//           d="m288.552 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m288.57 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#EFEFEF"
//           d="m288.587 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#EEE"
//           d="m288.605 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m288.622 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#ECECED"
//           d="m288.64 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m288.657 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m288.675 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m288.691 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#E9E9E9"
//           d="m288.71 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#E8E8E8"
//           d="m288.729 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E7E7E7"
//           d="m288.745 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#E6E6E7"
//           d="m288.764 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E5E5E6"
//           d="m288.78 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#E4E4E5"
//           d="m288.799 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E3E3E3"
//           d="m288.815 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#E2E2E2"
//           d="m288.834 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#E1E1E1"
//           d="m288.852 173.019.101 59.872h-.017l-.102-59.872h.018z"
//         />
//         <path
//           fill="#E0E0E0"
//           d="m288.869 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#DFDFDF"
//           d="m288.887 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#DEDDDE"
//           d="m288.904 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#DCDCDD"
//           d="m288.922 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#DBDBDB"
//           d="m288.939 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#DAD9DA"
//           d="m288.957 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#D8D8D9"
//           d="m288.976 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#D7D7D7"
//           d="m288.992 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#D5D5D6"
//           d="m289.011 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#D4D4D4"
//           d="m289.027 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#D2D2D3"
//           d="m289.046 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#D1D1D1"
//           d="m289.062 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#CFCFCF"
//           d="m289.081 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#CECDCE"
//           d="m289.097 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#CCC"
//           d="m289.116 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#CACACA"
//           d="m289.135 173.019.1 59.872h-.017l-.102-59.872h.019z"
//         />
//         <path
//           fill="#C8C8C8"
//           d="m289.151 173.019.102 59.872h-.018l-.101-59.872h.017z"
//         />
//         <path
//           fill="#C6C6C7"
//           d="m289.169 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#C4C4C5"
//           d="m289.186 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#C2C2C3"
//           d="m289.204 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#C0C0C1"
//           d="m289.221 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#BEBEBF"
//           d="m289.239 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#BCBCBD"
//           d="m289.258 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#BABABA"
//           d="m289.274 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#B8B7B8"
//           d="m289.293 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#B5B5B6"
//           d="m289.309 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#B3B3B4"
//           d="m289.328 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#B1B0B1"
//           d="m289.344 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#AEAEAF"
//           d="m289.363 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#ACABAC"
//           d="m289.382 173.019.1 59.872h-.017l-.102-59.872h.019z"
//         />
//         <path
//           fill="#A9A9AA"
//           d="m289.398 173.019.102 59.872h-.018l-.1-59.872h.016z"
//         />
//         <path
//           fill="#A6A6A7"
//           d="m289.417 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#A4A3A4"
//           d="m289.433 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#A1A0A1"
//           d="m289.452 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#9E9D9E"
//           d="m289.468 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#9B9B9C"
//           d="m289.486 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#989799"
//           d="m289.503 173.019.102 59.872h-.016l-.103-59.872h.017z"
//         />
//         <path
//           fill="#959495"
//           d="m289.521 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#929192"
//           d="m289.54 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#8F8E8F"
//           d="m289.556 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#8B8B8C"
//           d="m289.575 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#888788"
//           d="m289.591 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#848485"
//           d="m289.61 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#818081"
//           d="m289.626 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#7D7D7E"
//           d="m289.645 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#79797A"
//           d="m289.664 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#767576"
//           d="m289.68 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#727173"
//           d="m289.699 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#6E6D6F"
//           d="m289.715 173.019.103 59.872h-.017l-.102-59.872h.016z"
//         />
//         <path
//           fill="#6A696B"
//           d="m289.734 173.019.102 59.872h-.018l-.103-59.872h.019z"
//         />
//         <path
//           fill="#666566"
//           d="m289.75 173.019.102 59.872h-.016l-.102-59.872h.016z"
//         />
//         <path
//           fill="#616162"
//           d="m289.769 173.019.102 59.872h-.019l-.102-59.872h.019z"
//         />
//         <path
//           fill="#5D5C5E"
//           d="m289.787 173.019.1 59.872h-.016l-.102-59.872h.018z"
//         />
//         <path
//           fill="#595859"
//           d="m289.804 173.019.102 59.872h-.019l-.1-59.872h.017z"
//         />
//         <path
//           fill="#545355"
//           d="m289.822 173.019.1 59.872h-.016l-.103-59.872h.019z"
//         />
//         <path
//           fill="#4F4F50"
//           d="m289.838 173.019.103 59.872h-.019l-.1-59.872h.016z"
//         />
//         <path
//           fill="#4B4A4C"
//           d="m289.857 173.019.103 59.872h-.019l-.102-59.872h.018z"
//         />
//         <path
//           fill="#464547"
//           d="m289.873 173.019.103 59.872h-.016l-.103-59.872h.016z"
//         />
//         <path
//           fill="#414042"
//           d="m289.892 173.019.103 59.872h-.019l-.103-59.872h.019z"
//         />
//         <path
//           fill="#414042"
//           d="m289.995 232.891-.103-59.872h.107v59.872h-.004z"
//         />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="o-19"
//         width={4}
//         height={6}
//         x={286}
//         y={227}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m288.794 227.918 1.187.143.004 2.694s.133 1.271-.403 1.409c-.489.125-2.459.725-2.459.725s-.457-.014-.497-.693c-.039-.681-.007-4.168-.007-4.168l2.175-.112v.002z"
//         />
//       </mask>
//       <g mask="url(#o-19)">
//         <path fill="#fff" d="m290.118 227.942-3.531.007v-.031h3.531v.024z" />
//         <path
//           fill="#fff"
//           d="m290.118 227.956-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m290.118 227.972-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m290.118 227.986-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path fill="#FBFBFB" d="m290.118 228-3.531.005v-.014l3.531-.005V228z" />
//         <path
//           fill="#FAFAFA"
//           d="m290.118 228.014-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m290.118 228.028-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m290.118 228.042-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m290.118 228.056-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F6F5F5"
//           d="m290.118 228.07-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m290.118 228.084-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m290.118 228.098-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m290.118 228.112-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m290.118 228.126-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m290.118 228.14-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m290.118 228.154-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m290.118 228.168-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m290.118 228.182-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m290.118 228.196-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m290.118 228.21-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m290.118 228.224-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m290.118 228.238-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m290.118 228.252-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m290.118 228.266-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m290.118 228.28-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m290.118 228.294-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m290.118 228.308-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m290.118 228.322-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m290.118 228.338-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m290.118 228.352-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#DDD"
//           d="m290.118 228.366-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#DCDBDC"
//           d="m290.118 228.38-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m290.118 228.394-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m290.118 228.408-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="m290.118 228.422-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m290.118 228.436-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m290.118 228.45-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m290.118 228.464-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m290.118 228.478-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m290.118 228.492-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m290.118 228.506-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m290.118 228.52-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m290.118 228.534-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#CECECE"
//           d="m290.118 228.548-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m290.118 228.562-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m290.118 228.576-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#CBCACA"
//           d="m290.118 228.59-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#CAC9C9"
//           d="m290.118 228.604-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C9C8C8"
//           d="m290.118 228.618-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C8C7C7"
//           d="m290.118 228.632-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m290.118 228.646-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m290.118 228.66-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m290.118 228.674-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m290.118 228.688-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m290.118 228.704-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m290.118 228.718-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m290.118 228.732-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m290.118 228.746-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m290.118 228.76-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="m290.118 228.774-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m290.118 228.788-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m290.118 228.802-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m290.118 228.816-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m290.118 228.83-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m290.118 228.844-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m290.118 228.858-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m290.118 228.872-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m290.118 228.886-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m290.118 228.9-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m290.118 228.914-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m290.118 228.928-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m290.118 228.942-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m290.118 228.956-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m290.118 228.97-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m290.118 228.984-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m290.118 228.998-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m290.118 229.012-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m290.118 229.026-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m290.118 229.04-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m290.118 229.054-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m290.118 229.07-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m290.118 229.084-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m290.118 229.098-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m290.118 229.112-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m290.118 229.126-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m290.118 229.14-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m290.118 229.154-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m290.118 229.168-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m290.118 229.182-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m290.118 229.196-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9B9999"
//           d="m290.118 229.21-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#9A9898"
//           d="m290.118 229.224-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#999797"
//           d="m290.118 229.238-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#979696"
//           d="m290.118 229.252-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#969495"
//           d="m290.118 229.266-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#959394"
//           d="m290.118 229.28-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#949293"
//           d="m290.118 229.294-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#939192"
//           d="m290.118 229.308-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#929091"
//           d="m290.118 229.322-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#918F90"
//           d="m290.118 229.336-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#908E8F"
//           d="m290.118 229.35-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m290.118 229.364-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m290.118 229.378-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m290.118 229.392-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m290.118 229.406-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8B8989"
//           d="m290.118 229.42-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#8A8888"
//           d="m290.118 229.434-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#898787"
//           d="m290.118 229.45-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#888686"
//           d="m290.118 229.464-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#878485"
//           d="m290.118 229.478-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#868384"
//           d="m290.118 229.492-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#858283"
//           d="m290.118 229.506-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#848182"
//           d="m290.118 229.52-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#838081"
//           d="m290.118 229.534-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#817F80"
//           d="m290.118 229.548-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#807E7F"
//           d="m290.118 229.562-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m290.118 229.576-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m290.118 229.59-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m290.118 229.604-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m290.118 229.618-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#7B797A"
//           d="m290.118 229.632-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#7A7879"
//           d="m290.118 229.646-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#797778"
//           d="m290.118 229.66-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#787676"
//           d="m290.118 229.674-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#777575"
//           d="m290.118 229.688-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#767474"
//           d="m290.118 229.702-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#757373"
//           d="m290.118 229.716-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#747272"
//           d="m290.118 229.73-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#737171"
//           d="m290.118 229.744-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#727070"
//           d="m290.118 229.758-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#716F6F"
//           d="m290.118 229.772-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#706E6E"
//           d="m290.118 229.786-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m290.118 229.8-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m290.118 229.816-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m290.118 229.83-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m290.118 229.844-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#6B6969"
//           d="m290.118 229.858-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#6A6868"
//           d="m290.118 229.872-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#696767"
//           d="m290.118 229.886-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#686666"
//           d="m290.118 229.9-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#676565"
//           d="m290.118 229.914-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#666464"
//           d="m290.118 229.928-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#666363"
//           d="m290.118 229.942-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#656262"
//           d="m290.118 229.956-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#646161"
//           d="m290.118 229.97-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#636060"
//           d="m290.118 229.984-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#625F5F"
//           d="m290.118 229.998-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#615E5F"
//           d="m290.118 230.012-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#605D5E"
//           d="m290.118 230.026-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5F5C5D"
//           d="m290.118 230.04-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m290.118 230.054-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m290.118 230.068-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5C595A"
//           d="m290.118 230.082-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5B5859"
//           d="m290.118 230.096-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#5A5758"
//           d="m290.118 230.11-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#595657"
//           d="m290.118 230.124-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#585556"
//           d="m290.118 230.138-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#575455"
//           d="m290.118 230.152-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#565354"
//           d="m290.118 230.166-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#555253"
//           d="m290.118 230.182-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#545152"
//           d="m290.118 230.196-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#545051"
//           d="m290.118 230.21-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#534F50"
//           d="m290.118 230.224-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#524F4F"
//           d="m290.118 230.238-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#514E4E"
//           d="m290.118 230.252-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#504D4D"
//           d="m290.118 230.266-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m290.118 230.28-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m290.118 230.294-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m290.118 230.308-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#4C494A"
//           d="m290.118 230.322-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#4B4849"
//           d="m290.118 230.336-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#4A4748"
//           d="m290.118 230.35-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#4A4647"
//           d="m290.118 230.364-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#494546"
//           d="m290.118 230.378-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#484445"
//           d="m290.118 230.392-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#474444"
//           d="m290.118 230.406-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#464344"
//           d="m290.118 230.42-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#454243"
//           d="m290.118 230.434-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#444142"
//           d="m290.118 230.448-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#434041"
//           d="m290.118 230.462-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#433F40"
//           d="m290.118 230.476-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#423E3F"
//           d="m290.118 230.49-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#413D3E"
//           d="m290.118 230.504-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#403D3D"
//           d="m290.118 230.518-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m290.118 230.532-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m290.118 230.548-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m290.118 230.562-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#3D393A"
//           d="m290.118 230.576-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#3C3839"
//           d="m290.118 230.59-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#3B3738"
//           d="m290.118 230.604-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#3A3738"
//           d="m290.118 230.618-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#393637"
//           d="m290.118 230.632-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#393536"
//           d="m290.118 230.646-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#383435"
//           d="m290.118 230.66-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#373334"
//           d="m290.118 230.674-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#363333"
//           d="m290.118 230.688-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#353233"
//           d="m290.118 230.702-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#353132"
//           d="m290.118 230.716-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#343031"
//           d="m290.118 230.73-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#332F30"
//           d="m290.118 230.744-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#322F30"
//           d="m290.118 230.758-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#322E2F"
//           d="m290.118 230.772-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#312D2E"
//           d="m290.118 230.786-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#302C2D"
//           d="m290.118 230.8-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m290.118 230.814-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m290.118 230.828-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m290.118 230.842-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2D292A"
//           d="m290.118 230.856-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2C292A"
//           d="m290.118 230.87-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2C2829"
//           d="m290.118 230.884-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2B2728"
//           d="m290.118 230.898-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2A2627"
//           d="m290.118 230.912-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#2A2627"
//           d="m290.118 230.928-3.531.005v-.014l3.531-.007v.016z"
//         />
//         <path
//           fill="#292526"
//           d="m290.118 230.942-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#282425"
//           d="m290.118 230.956-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#282425"
//           d="m290.118 230.97-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#272324"
//           d="m290.118 230.984-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#272324"
//           d="m290.118 230.998-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#262223"
//           d="m290.118 231.012-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#252122"
//           d="m290.118 231.026-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#252122"
//           d="m290.118 231.04-3.531.005v-.014l3.531-.005v.014z"
//         />
//         <path
//           fill="#242021"
//           d="m290.118 231.054-3.531.004v-.013l3.531-.005v.014z"
//         />
//         <path
//           fill="#242021"
//           d="m290.118 231.068-3.531.004v-.014l3.531-.004v.014z"
//         />
//         <path
//           fill="#231F20"
//           d="m290.118 231.082-3.531.007v-.016l3.531-.005v.014z"
//         />
//         <path
//           fill="#231F20"
//           d="m290.118 231.096-3.531.007v-.014l3.531-.007v.014z"
//         />
//         <path
//           fill="#231F20"
//           d="m286.587 231.103 3.531-.007v1.795h-3.531v-1.788z"
//         />
//       </g>
//     </g>
//     <g
//       opacity={0.5}
//       style={{
//         mixBlendMode: "multiply",
//       }}
//     >
//       <mask
//         id="p-20"
//         width={4}
//         height={5}
//         x={286}
//         y={173}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="m288.715 177.987 1.184-.147-.005-2.697s.138-1.364-.396-1.432c-.496-.063-2.473-.692-2.473-.692s-.457.014-.495.695c-.039.68.007 4.168.007 4.168l2.175.102.003.003z"
//         />
//       </mask>
//       <g mask="url(#p-20)">
//         <path fill="#fff" d="m286.495 177.963 3.539-.004v.028h-3.539v-.024z" />
//         <path
//           fill="#fff"
//           d="m286.495 177.949 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#FEFEFE"
//           d="m286.495 177.935 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#FDFDFD"
//           d="m286.495 177.921 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#FBFBFB"
//           d="m286.495 177.907 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#FAFAFA"
//           d="m286.495 177.893 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F9F9F9"
//           d="m286.495 177.879 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F8F8F8"
//           d="m286.495 177.865 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F7F7F7"
//           d="m286.495 177.851 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F6F5F5"
//           d="m286.495 177.837 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F4F4F4"
//           d="m286.495 177.823 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F3F3F3"
//           d="m286.495 177.809 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F2F2F2"
//           d="m286.495 177.795 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F1F1F1"
//           d="m286.495 177.781 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#F0EFF0"
//           d="m286.495 177.767 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#EFEEEE"
//           d="m286.495 177.754 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#EDEDED"
//           d="m286.495 177.739 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#ECECEC"
//           d="m286.495 177.723 3.539-.004v.013l-3.539.007v-.016z"
//         />
//         <path
//           fill="#EBEBEB"
//           d="m286.495 177.709 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#EAEAEA"
//           d="m286.495 177.695 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E9E8E8"
//           d="m286.495 177.681 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E8E7E7"
//           d="m286.495 177.667 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E6E6E6"
//           d="m286.495 177.653 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E5E5E5"
//           d="m286.495 177.639 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E4E4E4"
//           d="m286.495 177.625 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E3E2E3"
//           d="m286.495 177.611 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E2E1E1"
//           d="m286.495 177.597 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E1E0E0"
//           d="m286.495 177.583 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#E0DFDF"
//           d="m286.495 177.569 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#DEDEDE"
//           d="m286.495 177.555 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#DDD"
//           d="m286.495 177.541 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#DCDBDC"
//           d="m286.495 177.527 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#DBDADA"
//           d="m286.495 177.513 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#DAD9D9"
//           d="m286.495 177.499 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D9D8D8"
//           d="m286.495 177.485 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D8D7D7"
//           d="m286.495 177.471 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D6D6D6"
//           d="m286.495 177.457 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D5D4D5"
//           d="m286.495 177.443 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D4D3D4"
//           d="m286.495 177.429 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D3D2D2"
//           d="m286.495 177.415 3.539-.006v.013l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D2D1D1"
//           d="m286.495 177.401 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D1D0D0"
//           d="m286.495 177.387 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#D0CFCF"
//           d="m286.495 177.374 3.539-.007v.014l-3.539.006v-.013z"
//         />
//         <path
//           fill="#CECECE"
//           d="m286.495 177.36 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#CDCCCD"
//           d="m286.495 177.343 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#CCCBCB"
//           d="m286.495 177.329 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#CBCACA"
//           d="m286.495 177.315 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#CAC9C9"
//           d="m286.495 177.301 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C9C8C8"
//           d="m286.495 177.287 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C8C7C7"
//           d="m286.495 177.273 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C7C5C6"
//           d="m286.495 177.259 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C5C4C5"
//           d="m286.495 177.245 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C4C3C3"
//           d="m286.495 177.231 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C3C2C2"
//           d="m286.495 177.217 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C2C1C1"
//           d="m286.495 177.203 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C1C0C0"
//           d="m286.495 177.189 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#C0BFBF"
//           d="m286.495 177.175 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#BFBEBE"
//           d="m286.495 177.161 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#BEBCBD"
//           d="m286.495 177.147 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#BCBBBC"
//           d="m286.495 177.133 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#BBBABA"
//           d="m286.495 177.119 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#BAB9B9"
//           d="m286.495 177.105 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B9B8B8"
//           d="m286.495 177.091 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B8B7B7"
//           d="m286.495 177.077 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B7B6B6"
//           d="m286.495 177.063 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B6B4B5"
//           d="m286.495 177.049 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B5B3B4"
//           d="m286.495 177.035 3.539-.006v.013l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B4B2B3"
//           d="m286.495 177.022 3.539-.007v.014l-3.539.006v-.013z"
//         />
//         <path
//           fill="#B2B1B1"
//           d="m286.495 177.008 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B1B0B0"
//           d="m286.495 176.994 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#B0AFAF"
//           d="m286.495 176.98 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#AFAEAE"
//           d="m286.495 176.963 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#AEADAD"
//           d="m286.495 176.949 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#ADACAC"
//           d="m286.495 176.935 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#ACAAAB"
//           d="m286.495 176.921 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#ABA9AA"
//           d="m286.495 176.907 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#AAA8A9"
//           d="m286.495 176.893 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A9A7A7"
//           d="m286.495 176.879 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A8A6A6"
//           d="m286.495 176.865 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A6A5A5"
//           d="m286.495 176.851 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A5A4A4"
//           d="m286.495 176.837 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A4A3A3"
//           d="m286.495 176.823 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A3A2A2"
//           d="m286.495 176.809 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#A2A0A1"
//           d="m286.495 176.795 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#A19FA0"
//           d="m286.495 176.781 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#A09E9F"
//           d="m286.495 176.767 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9F9D9E"
//           d="m286.495 176.753 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9E9C9D"
//           d="m286.495 176.739 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9D9B9B"
//           d="m286.495 176.725 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9C9A9A"
//           d="m286.495 176.711 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9B9999"
//           d="m286.495 176.697 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#9A9898"
//           d="m286.495 176.683 3.539-.006v.014l-3.539.006v-.014z"
//         />
//         <path
//           fill="#999797"
//           d="m286.495 176.669 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#979696"
//           d="m286.495 176.655 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#969495"
//           d="m286.495 176.642 3.539-.007v.014l-3.539.006v-.013z"
//         />
//         <path
//           fill="#959394"
//           d="m286.495 176.628 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#949293"
//           d="m286.495 176.614 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#939192"
//           d="m286.495 176.597 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#929091"
//           d="m286.495 176.583 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#918F90"
//           d="m286.495 176.569 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#908E8F"
//           d="m286.495 176.555 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8F8D8D"
//           d="m286.495 176.541 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8E8C8C"
//           d="m286.495 176.527 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8D8B8B"
//           d="m286.495 176.513 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8C8A8A"
//           d="m286.495 176.499 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8B8989"
//           d="m286.495 176.485 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#8A8888"
//           d="m286.495 176.471 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#898787"
//           d="m286.495 176.457 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#888686"
//           d="m286.495 176.443 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#878485"
//           d="m286.495 176.429 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#868384"
//           d="m286.495 176.415 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#858283"
//           d="m286.495 176.401 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#848182"
//           d="m286.495 176.387 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#838081"
//           d="m286.495 176.373 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#817F80"
//           d="m286.495 176.359 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#807E7F"
//           d="m286.495 176.345 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#7F7D7E"
//           d="m286.495 176.331 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#7E7C7D"
//           d="m286.495 176.317 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#7D7B7C"
//           d="m286.495 176.304 3.539-.007v.013l-3.539.007v-.013z"
//         />
//         <path
//           fill="#7C7A7B"
//           d="m286.495 176.29 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#7B797A"
//           d="m286.495 176.276 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#7A7879"
//           d="m286.495 176.262 3.539-.007v.014l-3.539.006v-.013z"
//         />
//         <path
//           fill="#797778"
//           d="m286.495 176.248 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#787676"
//           d="m286.495 176.234 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#777575"
//           d="m286.495 176.217 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#767474"
//           d="m286.495 176.203 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#757373"
//           d="m286.495 176.189 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#747272"
//           d="m286.495 176.175 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#737171"
//           d="m286.495 176.161 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#727070"
//           d="m286.495 176.147 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#716F6F"
//           d="m286.495 176.133 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#706E6E"
//           d="m286.495 176.119 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6F6D6D"
//           d="m286.495 176.105 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6E6C6C"
//           d="m286.495 176.091 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6D6B6B"
//           d="m286.495 176.077 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6C6A6A"
//           d="m286.495 176.063 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6B6969"
//           d="m286.495 176.049 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#6A6868"
//           d="m286.495 176.035 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#696767"
//           d="m286.495 176.021 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#686666"
//           d="m286.495 176.007 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#676565"
//           d="m286.495 175.993 3.539-.007V176l-3.539.007v-.014z"
//         />
//         <path
//           fill="#666464"
//           d="m286.495 175.979 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#666363"
//           d="m286.495 175.965 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#656262"
//           d="m286.495 175.952 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#646161"
//           d="m286.495 175.937 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#636060"
//           d="m286.495 175.924 3.539-.007v.013l-3.539.007v-.013z"
//         />
//         <path
//           fill="#625F5F"
//           d="m286.495 175.91 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#615E5F"
//           d="m286.495 175.896 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#605D5E"
//           d="m286.495 175.882 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#5F5C5D"
//           d="m286.495 175.868 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#5E5B5C"
//           d="m286.495 175.854 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#5D5A5B"
//           d="m286.495 175.837 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#5C595A"
//           d="m286.495 175.823 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#5B5859"
//           d="m286.495 175.809 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#5A5758"
//           d="m286.495 175.795 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#595657"
//           d="m286.495 175.781 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#585556"
//           d="m286.495 175.767 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#575455"
//           d="m286.495 175.753 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#565354"
//           d="m286.495 175.739 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#555253"
//           d="m286.495 175.725 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#545152"
//           d="m286.495 175.711 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#545051"
//           d="m286.495 175.697 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#534F50"
//           d="m286.495 175.683 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#524F4F"
//           d="m286.495 175.669 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#514E4E"
//           d="m286.495 175.655 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#504D4D"
//           d="m286.495 175.641 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4F4C4D"
//           d="m286.495 175.627 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4E4B4C"
//           d="m286.495 175.613 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4D4A4B"
//           d="m286.495 175.599 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4C494A"
//           d="m286.495 175.585 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4B4849"
//           d="m286.495 175.572 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4A4748"
//           d="m286.495 175.558 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#4A4647"
//           d="m286.495 175.543 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#494546"
//           d="m286.495 175.53 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#484445"
//           d="m286.495 175.516 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#474444"
//           d="m286.495 175.502 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#464344"
//           d="m286.495 175.488 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#454243"
//           d="m286.495 175.474 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#444142"
//           d="m286.495 175.457 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#434041"
//           d="m286.495 175.443 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#433F40"
//           d="m286.495 175.429 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#423E3F"
//           d="m286.495 175.415 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#413D3E"
//           d="m286.495 175.401 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#403D3D"
//           d="m286.495 175.387 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3F3C3D"
//           d="m286.495 175.373 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3E3B3C"
//           d="m286.495 175.359 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3E3A3B"
//           d="m286.495 175.345 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3D393A"
//           d="m286.495 175.331 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3C3839"
//           d="m286.495 175.317 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3B3738"
//           d="m286.495 175.303 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#3A3738"
//           d="m286.495 175.289 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#393637"
//           d="m286.495 175.275 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#393536"
//           d="m286.495 175.261 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#383435"
//           d="m286.495 175.247 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#373334"
//           d="m286.495 175.234 3.539-.007v.013l-3.539.007v-.013z"
//         />
//         <path
//           fill="#363333"
//           d="m286.495 175.219 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#353233"
//           d="m286.495 175.205 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#353132"
//           d="m286.495 175.192 3.539-.007v.013l-3.539.007v-.013z"
//         />
//         <path
//           fill="#343031"
//           d="m286.495 175.178 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#332F30"
//           d="m286.495 175.164 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#322F30"
//           d="m286.495 175.15 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#322E2F"
//           d="m286.495 175.136 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#312D2E"
//           d="m286.495 175.122 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#302C2D"
//           d="m286.495 175.108 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#2F2C2C"
//           d="m286.495 175.094 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#2F2B2C"
//           d="m286.495 175.077 3.539-.004v.014l-3.539.007v-.017z"
//         />
//         <path
//           fill="#2E2A2B"
//           d="m286.495 175.063 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2D292A"
//           d="m286.495 175.049 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2C292A"
//           d="m286.495 175.035 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2C2829"
//           d="m286.495 175.021 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2B2728"
//           d="m286.495 175.007 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2A2627"
//           d="m286.495 174.993 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#2A2627"
//           d="m286.495 174.979 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#292526"
//           d="m286.495 174.965 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#282425"
//           d="m286.495 174.951 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#282425"
//           d="m286.495 174.937 3.539-.004v.014l-3.539.004v-.014z"
//         />
//         <path
//           fill="#272324"
//           d="m286.495 174.923 3.539-.007v.017l-3.539.004v-.014z"
//         />
//         <path
//           fill="#272324"
//           d="m286.495 174.909 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#262223"
//           d="m286.495 174.895 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#252122"
//           d="m286.495 174.881 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#252122"
//           d="m286.495 174.867 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#242021"
//           d="m286.495 174.853 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#242021"
//           d="m286.495 174.84 3.539-.007v.014l-3.539.007v-.014z"
//         />
//         <path
//           fill="#231F20"
//           d="m286.495 174.826 3.539-.007v.014l-3.539.007v-.014zm0-.014 3.539-.007v.013l-3.539.007v-.013z"
//         />
//         <path
//           fill="#231F20"
//           d="m290.034 174.805-3.539.007v-1.791h3.539v1.784z"
//         />
//       </g>
//     </g>
//     <path
//       fill="#161616"
//       d="M284.502 52.918h-1.865v1.399h1.865v-1.399zM234.615 1.399h-1.865v1.165h1.865V1.4zM6.624 52.918H4.759v2.098h1.865v-2.098zm227.758 533.843h-1.632v1.632h1.632v-1.632zM6.624 528.015H4.759v1.632h1.865v-1.632zm49.654 58.746h-1.631v1.632h1.631v-1.632z"
//     />
//     <path
//       fill="#050505"
//       d="M184.86 571.376h-82.524a1.282 1.282 0 1 0 0 2.564h82.524a1.281 1.281 0 1 0 0-2.564z"
//     />
//     <path
//       fill="#000"
//       d="M177.941 29.429c0-5.29-4.17-9.602-9.402-9.838v-.011h-47.337a9.846 9.846 0 0 0-9.847 9.847 9.846 9.846 0 0 0 9.847 9.847h47.337v-.012c5.232-.233 9.402-4.548 9.402-9.838v.005z"
//     />
//     <path
//       fill="#000"
//       d="M175.68 31.197a7.707 7.707 0 1 0-15.001-3.54 7.707 7.707 0 0 0 15.001 3.54z"
//     />
//     <mask
//       id="q-21"
//       width={13}
//       height={13}
//       x={162}
//       y={23}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "luminance",
//       }}
//     >
//       <path
//         fill="#fff"
//         d="M174.146 30.835a6.13 6.13 0 1 0-11.934-2.817 6.13 6.13 0 0 0 11.934 2.817z"
//       />
//     </mask>
//     <g mask="url(#q-21)">
//       <path fill="#060606" d="M174.318 23.3h-12.262v12.262h12.262V23.3z" />
//       <path
//         fill="#060606"
//         d="M174.146 30.835a6.13 6.13 0 1 0-11.934-2.817 6.13 6.13 0 0 0 11.934 2.817z"
//       />
//       <path
//         fill="#040404"
//         d="M168.811 34.495a5.11 5.11 0 1 0-1.249-10.143 5.11 5.11 0 0 0 1.249 10.143z"
//       />
//       <path
//         fill="#030303"
//         d="M172.249 29.93a4.087 4.087 0 1 0-8.113-.998 4.087 4.087 0 0 0 8.113.999z"
//       />
//       <path
//         fill="#020202"
//         d="M171.163 30.131a3.066 3.066 0 1 0-5.968-1.408 3.066 3.066 0 0 0 5.968 1.408z"
//       />
//       <path
//         fill="#010101"
//         d="M170.169 29.896a2.044 2.044 0 1 0-3.978-.94 2.044 2.044 0 0 0 3.978.94z"
//       />
//       <path
//         fill="#000"
//         d="M168.187 30.45a1.022 1.022 0 1 0 0-2.044 1.022 1.022 0 0 0 0 2.044z"
//       />
//     </g>
//     <path
//       fill="#000"
//       d="M149.812 30.312a6.13 6.13 0 1 0-12.17-1.5 6.13 6.13 0 0 0 12.17 1.5z"
//     />
//     <mask
//       id="r-22"
//       width={13}
//       height={13}
//       x={137}
//       y={23}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "luminance",
//       }}
//     >
//       <path
//         fill="#fff"
//         d="M149.812 30.312a6.13 6.13 0 1 0-12.17-1.5 6.13 6.13 0 0 0 12.17 1.5z"
//       />
//     </mask>
//     <g fill="#000" mask="url(#r-22)">
//       <path d="M149.855 23.43h-12.262v12.263h12.262V23.43z" />
//       <path d="M149.812 30.312a6.13 6.13 0 1 0-12.17-1.5 6.13 6.13 0 0 0 12.17 1.5z" />
//       <path d="M143.724 34.672a5.11 5.11 0 1 0 0-10.22 5.11 5.11 0 0 0 0 10.22z" />
//       <path d="M143.724 33.648a4.086 4.086 0 1 0 0-8.172 4.086 4.086 0 0 0 0 8.172z" />
//       <path d="M146.755 30.055a3.065 3.065 0 1 0-6.051-.983 3.065 3.065 0 0 0 6.051.983z" />
//       <path d="M145.708 30.028a2.045 2.045 0 1 0-3.98-.939 2.045 2.045 0 0 0 3.98.94z" />
//       <path d="M144.745 29.562a1.02 1.02 0 1 1-2.042 0 1.02 1.02 0 0 1 2.042 0z" />
//     </g>
//     <path
//       fill="#000"
//       d="M126.632 30.415a6.131 6.131 0 1 0-12.104-1.965 6.131 6.131 0 0 0 12.104 1.965z"
//     />
//     <mask
//       id="s-23"
//       width={13}
//       height={13}
//       x={114}
//       y={23}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "luminance",
//       }}
//     >
//       <path
//         fill="#fff"
//         d="M126.632 30.415a6.131 6.131 0 1 0-12.104-1.965 6.131 6.131 0 0 0 12.104 1.965z"
//       />
//     </mask>
//     <g fill="#000" mask="url(#s-23)">
//       <path d="M126.706 23.3h-12.262v12.262h12.262V23.3z" />
//       <path d="M126.632 30.415a6.131 6.131 0 1 0-12.104-1.965 6.131 6.131 0 0 0 12.104 1.965z" />
//       <path d="M122.531 34.15a5.11 5.11 0 1 0-3.912-9.442 5.11 5.11 0 0 0 3.912 9.441z" />
//       <path d="M120.575 33.516a4.087 4.087 0 1 0 0-8.174 4.087 4.087 0 0 0 0 8.174z" />
//       <path d="M121.748 32.26a3.065 3.065 0 1 0-2.344-5.663 3.065 3.065 0 0 0 2.344 5.664z" />
//       <path d="M122.558 29.896a2.045 2.045 0 1 0-3.98-.939 2.045 2.045 0 0 0 3.98.94z" />
//       <path d="M121.596 29.429a1.02 1.02 0 1 1-2.042 0 1.02 1.02 0 0 1 2.042 0z" />
//     </g>
//     <g opacity={0.5}>
//       <mask
//         id="t-24"
//         width={4}
//         height={11}
//         x={162}
//         y={24}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M163.774 25.177s-3.364 4.175 0 8.504c0 0 2.313 1.88 1.087-.573-1.227-2.453-1.751-5.604-.525-6.83 1.226-1.227 1.154-2.551-.562-1.101z"
//         />
//       </mask>
//       <g mask="url(#t-24)">
//         <path fill="#000" d="M166.087 23.727h-5.676V35.56h5.676V23.727z" />
//         <path
//           fill="#000"
//           d="M167.372 29.82a3.628 3.628 0 1 0-7.221-.715 3.628 3.628 0 0 0 7.221.714z"
//         />
//         <path
//           fill="#000001"
//           d="M167.339 29.457a3.59 3.59 0 1 1-7.18 0 3.59 3.59 0 0 1 7.18 0z"
//         />
//         <path
//           fill="#000002"
//           d="M167.302 29.457a3.556 3.556 0 0 1-7.111 0 3.556 3.556 0 0 1 7.111 0z"
//         />
//         <path
//           fill="#010002"
//           d="M163.749 32.975a3.517 3.517 0 1 0 0-7.034 3.517 3.517 0 0 0 0 7.034z"
//         />
//         <path
//           fill="#010103"
//           d="M163.749 32.938a3.48 3.48 0 1 0 0-6.961 3.48 3.48 0 0 0 0 6.96z"
//         />
//         <path
//           fill="#010104"
//           d="M163.749 32.903a3.445 3.445 0 1 0 0-6.89 3.445 3.445 0 0 0 0 6.89z"
//         />
//         <path
//           fill="#010105"
//           d="M163.749 32.865a3.408 3.408 0 1 0 0-6.816 3.408 3.408 0 0 0 0 6.816z"
//         />
//         <path
//           fill="#020106"
//           d="M163.749 32.83a3.373 3.373 0 1 0 0-6.746 3.373 3.373 0 0 0 0 6.746z"
//         />
//         <path
//           fill="#020107"
//           d="M163.749 32.793a3.336 3.336 0 1 0 0-6.672 3.336 3.336 0 0 0 0 6.672z"
//         />
//         <path
//           fill="#020208"
//           d="M167.05 29.457a3.301 3.301 0 1 1-6.602 0 3.301 3.301 0 0 1 6.602 0z"
//         />
//         <path
//           fill="#020208"
//           d="M163.749 32.72a3.263 3.263 0 1 0 0-6.526 3.263 3.263 0 0 0 0 6.527z"
//         />
//         <path
//           fill="#030209"
//           d="M163.749 32.686a3.228 3.228 0 1 0 0-6.457 3.228 3.228 0 0 0 0 6.457z"
//         />
//         <path
//           fill="#03020A"
//           d="M166.94 29.457a3.192 3.192 0 1 1-6.383 0 3.192 3.192 0 0 1 6.383 0z"
//         />
//         <path
//           fill="#03020B"
//           d="M166.903 29.457a3.155 3.155 0 1 1-6.31-.002 3.155 3.155 0 0 1 6.31.002z"
//         />
//         <path
//           fill="#03020C"
//           d="M166.868 29.457a3.119 3.119 0 1 1-6.237 0 3.119 3.119 0 0 1 6.237 0z"
//         />
//         <path
//           fill="#04030D"
//           d="M166.831 29.457a3.083 3.083 0 1 1-6.166-.002 3.083 3.083 0 0 1 6.166.002z"
//         />
//         <path
//           fill="#04030E"
//           d="M166.796 29.457a3.047 3.047 0 1 1-6.093 0 3.047 3.047 0 0 1 6.093 0z"
//         />
//         <path
//           fill="#04030F"
//           d="M166.758 29.457a3.01 3.01 0 1 1-6.018 0 3.01 3.01 0 0 1 6.018 0z"
//         />
//         <path
//           fill="#040310"
//           d="M166.723 29.457a2.974 2.974 0 1 1-5.949 0 2.974 2.974 0 1 1 5.949 0z"
//         />
//         <path
//           fill="#050311"
//           d="M166.686 29.457a2.937 2.937 0 1 1-5.874 0 2.937 2.937 0 0 1 5.874 0z"
//         />
//         <path
//           fill="#050412"
//           d="M166.649 29.457a2.9 2.9 0 1 1-2.9-2.902 2.9 2.9 0 0 1 2.9 2.902z"
//         />
//         <path
//           fill="#050413"
//           d="M166.614 29.457a2.864 2.864 0 1 1-5.73 0 2.864 2.864 0 1 1 5.73 0z"
//         />
//         <path
//           fill="#050414"
//           d="M166.577 29.457a2.828 2.828 0 1 1-5.655 0 2.828 2.828 0 0 1 5.655 0z"
//         />
//         <path
//           fill="#060415"
//           d="M163.749 32.25a2.792 2.792 0 1 0 0-5.585 2.792 2.792 0 0 0 0 5.585z"
//         />
//         <path
//           fill="#060416"
//           d="M166.504 29.457a2.755 2.755 0 1 1-5.511 0 2.755 2.755 0 1 1 5.511 0z"
//         />
//         <path
//           fill="#060517"
//           d="M166.469 29.457a2.72 2.72 0 1 1-5.441 0 2.72 2.72 0 0 1 5.441 0z"
//         />
//         <path
//           fill="#060518"
//           d="M166.432 29.457a2.683 2.683 0 1 1-5.365.001 2.683 2.683 0 0 1 5.365 0z"
//         />
//         <path
//           fill="#070519"
//           d="M166.397 29.457a2.648 2.648 0 1 1-5.297 0 2.647 2.647 0 0 1 2.649-2.648 2.646 2.646 0 0 1 2.648 2.648z"
//         />
//         <path
//           fill="#07051A"
//           d="M166.36 29.457a2.61 2.61 0 0 1-2.611 2.611 2.61 2.61 0 0 1-2.611-2.61 2.61 2.61 0 0 1 2.611-2.612 2.61 2.61 0 0 1 2.611 2.611z"
//         />
//         <path
//           fill="#07051B"
//           d="M166.322 29.457a2.574 2.574 0 1 1-5.149 0 2.577 2.577 0 0 1 2.576-2.576 2.573 2.573 0 0 1 2.573 2.576z"
//         />
//         <path
//           fill="#07061C"
//           d="M166.287 29.457a2.54 2.54 0 0 1-5.077 0 2.54 2.54 0 0 1 5.077 0z"
//         />
//         <path
//           fill="#08061D"
//           d="M166.25 29.457a2.501 2.501 0 1 1-5.003 0 2.501 2.501 0 0 1 5.003 0z"
//         />
//         <path
//           fill="#08061E"
//           d="M166.215 29.457a2.467 2.467 0 1 1-4.935-.002 2.467 2.467 0 0 1 4.935.002z"
//         />
//         <path
//           fill="#08061F"
//           d="M166.178 29.457a2.43 2.43 0 1 1-4.859 0 2.43 2.43 0 0 1 4.859 0z"
//         />
//         <path
//           fill="#090620"
//           d="M166.143 29.457a2.394 2.394 0 1 1-4.789 0 2.394 2.394 0 0 1 4.789 0z"
//         />
//         <path
//           fill="#090721"
//           d="M166.106 29.457a2.358 2.358 0 0 1-4.714 0 2.358 2.358 0 0 1 4.714 0z"
//         />
//         <path
//           fill="#090722"
//           d="M166.071 29.457a2.322 2.322 0 1 1-4.645 0 2.322 2.322 0 0 1 4.645 0z"
//         />
//         <path
//           fill="#090723"
//           d="M166.033 29.457a2.285 2.285 0 1 1-4.57 0 2.285 2.285 0 0 1 4.57 0z"
//         />
//         <path
//           fill="#0A0724"
//           d="M165.996 29.457a2.247 2.247 0 0 1-2.247 2.247 2.251 2.251 0 0 1-2.25-2.247 2.249 2.249 0 0 1 4.497 0z"
//         />
//         <path
//           fill="#0A0725"
//           d="M165.961 29.457a2.213 2.213 0 1 1-4.426 0 2.213 2.213 0 0 1 4.426 0z"
//         />
//         <path
//           fill="#0A0826"
//           d="M165.924 29.457a2.176 2.176 0 1 1-4.349-.001 2.176 2.176 0 0 1 4.349.001z"
//         />
//         <path
//           fill="#0A0827"
//           d="M165.889 29.457a2.14 2.14 0 1 1-4.28 0 2.14 2.14 0 0 1 4.28 0z"
//         />
//         <path
//           fill="#0B0828"
//           d="M165.851 29.457a2.103 2.103 0 1 1-4.205 0 2.103 2.103 0 0 1 4.205 0z"
//         />
//         <path
//           fill="#0B0829"
//           d="M165.817 29.457a2.068 2.068 0 1 1-4.136 0 2.068 2.068 0 0 1 4.136 0z"
//         />
//         <path
//           fill="#0B082A"
//           d="M165.779 29.457a2.03 2.03 0 1 1-4.06 0 2.03 2.03 0 0 1 4.06 0z"
//         />
//         <path
//           fill="#0C092B"
//           d="M165.744 29.457a1.995 1.995 0 1 1-3.99.002 1.995 1.995 0 0 1 3.99-.002z"
//         />
//         <path
//           fill="#0C092C"
//           d="M165.707 29.457a1.958 1.958 0 1 1-3.916 0 1.958 1.958 0 0 1 3.916 0z"
//         />
//         <path
//           fill="#0C092D"
//           d="M165.67 29.457a1.922 1.922 0 1 1-3.844-.002 1.922 1.922 0 0 1 3.844.002z"
//         />
//         <path
//           fill="#0C092E"
//           d="M165.635 29.457a1.885 1.885 0 1 1-3.77.001 1.885 1.885 0 0 1 3.77-.001z"
//         />
//         <path
//           fill="#0D092F"
//           d="M165.597 29.457a1.848 1.848 0 1 1-3.696.001 1.848 1.848 0 0 1 3.696 0z"
//         />
//         <path
//           fill="#0D0A30"
//           d="M165.562 29.457a1.812 1.812 0 1 1-3.627 0 1.813 1.813 0 1 1 3.627 0z"
//         />
//         <path
//           fill="#0D0A31"
//           d="M165.525 29.457a1.776 1.776 0 1 1-3.552.001 1.776 1.776 0 0 1 3.552 0z"
//         />
//         <path
//           fill="#0E0A32"
//           d="M165.49 29.457a1.741 1.741 0 1 1-3.482 0 1.741 1.741 0 0 1 3.482 0z"
//         />
//         <path
//           fill="#0E0A33"
//           d="M163.749 31.161a1.704 1.704 0 1 0 0-3.408 1.704 1.704 0 0 0 0 3.408z"
//         />
//         <path
//           fill="#0E0A34"
//           d="M163.749 31.126a1.669 1.669 0 1 0 0-3.338 1.669 1.669 0 0 0 0 3.338z"
//         />
//         <path
//           fill="#0E0B35"
//           d="M163.749 31.089a1.632 1.632 0 1 0 0-3.264 1.632 1.632 0 0 0 0 3.264z"
//         />
//         <path
//           fill="#0F0B36"
//           d="M165.343 29.457a1.593 1.593 0 1 1-3.189 0 1.594 1.594 0 1 1 3.189 0z"
//         />
//         <path
//           fill="#0F0B37"
//           d="M165.308 29.457a1.56 1.56 0 1 1-3.119 0 1.56 1.56 0 0 1 3.119 0z"
//         />
//         <path
//           fill="#0F0B38"
//           d="M165.271 29.457a1.523 1.523 0 1 1-3.045 0 1.523 1.523 0 0 1 3.045 0z"
//         />
//         <path
//           fill="#0F0B39"
//           d="M165.236 29.457a1.488 1.488 0 0 1-2.975 0 1.489 1.489 0 0 1 2.975 0z"
//         />
//         <path
//           fill="#100C3A"
//           d="M165.199 29.457a1.45 1.45 0 1 1-2.9 0 1.45 1.45 0 0 1 2.9 0z"
//         />
//         <path
//           fill="#100C3B"
//           d="M165.164 29.457a1.416 1.416 0 1 1-2.831-.001 1.416 1.416 0 0 1 2.831.001z"
//         />
//         <path
//           fill="#100C3C"
//           d="M165.126 29.457a1.378 1.378 0 1 1-2.756-.001 1.378 1.378 0 0 1 2.756.001z"
//         />
//         <path
//           fill="#110C3D"
//           d="M165.089 29.457a1.343 1.343 0 1 1-2.686 0 1.343 1.343 0 0 1 2.686 0z"
//         />
//         <path
//           fill="#110D3F"
//           d="M165.054 29.457a1.306 1.306 0 1 1-2.612-.001 1.306 1.306 0 0 1 2.612.001z"
//         />
//         <path
//           fill="#110D40"
//           d="M165.017 29.457a1.268 1.268 0 1 1-2.536 0 1.268 1.268 0 0 1 2.536 0z"
//         />
//         <path
//           fill="#110D41"
//           d="M164.982 29.457a1.234 1.234 0 1 1-2.468-.001 1.234 1.234 0 0 1 2.468.001z"
//         />
//         <path
//           fill="#120D42"
//           d="M164.945 29.457a1.196 1.196 0 1 1-2.392 0 1.196 1.196 0 0 1 2.392 0z"
//         />
//         <path
//           fill="#120D43"
//           d="M164.91 29.457a1.161 1.161 0 1 1-2.322 0 1.161 1.161 0 0 1 2.322 0z"
//         />
//         <path
//           fill="#120E44"
//           d="M164.872 29.457a1.124 1.124 0 1 1-2.247 0 1.124 1.124 0 0 1 2.247 0z"
//         />
//         <path
//           fill="#130E45"
//           d="M164.837 29.457a1.088 1.088 0 1 1-2.176.001 1.088 1.088 0 0 1 2.176 0z"
//         />
//         <path
//           fill="#130E46"
//           d="M164.8 29.457a1.052 1.052 0 1 1-2.103 0 1.052 1.052 0 0 1 2.103 0z"
//         />
//         <path
//           fill="#130E47"
//           d="M164.763 29.457a1.016 1.016 0 1 1-2.032 0 1.016 1.016 0 0 1 2.032 0z"
//         />
//         <path
//           fill="#130E48"
//           d="M164.728 29.457a.979.979 0 1 1-1.958 0 .979.979 0 0 1 1.958 0z"
//         />
//         <path
//           fill="#140F49"
//           d="M164.691 29.457a.942.942 0 1 1-1.885 0 .942.942 0 0 1 1.885 0z"
//         />
//         <path
//           fill="#140F4A"
//           d="M164.656 29.457a.907.907 0 1 1-1.813 0 .907.907 0 0 1 1.813 0z"
//         />
//         <path
//           fill="#140F4B"
//           d="M164.618 29.457a.87.87 0 1 1-1.738 0 .87.87 0 0 1 1.738 0z"
//         />
//         <path
//           fill="#150F4C"
//           d="M164.583 29.457a.834.834 0 1 1-1.669 0 .834.834 0 1 1 1.669 0z"
//         />
//         <path
//           fill="#150F4D"
//           d="M164.546 29.457a.797.797 0 1 1-1.594 0 .797.797 0 0 1 1.594 0z"
//         />
//         <path
//           fill="#15104E"
//           d="M164.511 29.457a.762.762 0 1 1-1.525 0 .762.762 0 0 1 1.525 0z"
//         />
//         <path
//           fill="#151050"
//           d="M164.474 29.457a.724.724 0 1 1-1.449.001.724.724 0 0 1 1.449 0z"
//         />
//         <path
//           fill="#161051"
//           d="M164.436 29.457a.69.69 0 1 1-1.379.001.69.69 0 0 1 1.379 0z"
//         />
//         <path
//           fill="#161052"
//           d="M164.402 29.457a.652.652 0 1 1-1.304.001.652.652 0 0 1 1.304 0z"
//         />
//         <path
//           fill="#161153"
//           d="M164.364 29.457a.615.615 0 1 1-1.23.002.615.615 0 0 1 1.23-.002z"
//         />
//         <path
//           fill="#171154"
//           d="M164.329 29.457a.58.58 0 1 1-1.16.001.58.58 0 0 1 1.16 0z"
//         />
//         <path
//           fill="#171155"
//           d="M164.292 29.457a.543.543 0 1 1-1.085.001.543.543 0 0 1 1.085-.001z"
//         />
//         <path
//           fill="#171156"
//           d="M164.257 29.457a.51.51 0 1 1-1.018-.002.51.51 0 0 1 1.018.002z"
//         />
//         <path
//           fill="#171157"
//           d="M164.22 29.457a.472.472 0 1 1-.943-.002.472.472 0 0 1 .943.002z"
//         />
//         <path
//           fill="#181258"
//           d="M164.185 29.457a.437.437 0 0 1-.872 0 .437.437 0 0 1 .872 0z"
//         />
//         <path
//           fill="#181259"
//           d="M164.147 29.457a.398.398 0 1 1-.796.001.398.398 0 0 1 .796-.001z"
//         />
//         <path
//           fill="#18125A"
//           d="M164.11 29.457a.364.364 0 1 1-.728 0 .364.364 0 0 1 .728 0z"
//         />
//         <path
//           fill="#19125B"
//           d="M164.075 29.457c0 .18-.147.326-.326.326a.328.328 0 0 1-.327-.326.327.327 0 0 1 .653 0z"
//         />
//         <path
//           fill="#19125C"
//           d="M164.038 29.457a.29.29 0 1 1-.579 0 .29.29 0 0 1 .579 0z"
//         />
//         <path
//           fill="#19135D"
//           d="M164.003 29.457a.255.255 0 0 1-.508 0 .255.255 0 0 1 .508 0z"
//         />
//         <path
//           fill="#1A135F"
//           d="M163.966 29.457a.217.217 0 1 1-.433 0 .217.217 0 0 1 .433 0z"
//         />
//         <path
//           fill="#1A1360"
//           d="M163.931 29.457a.182.182 0 0 1-.364 0 .182.182 0 1 1 .364 0z"
//         />
//         <path
//           fill="#1A1361"
//           d="M163.893 29.457c0 .08-.065.145-.144.145a.146.146 0 0 1-.145-.145.145.145 0 0 1 .289 0z"
//         />
//         <path
//           fill="#1A1462"
//           d="M163.858 29.457a.11.11 0 1 1-.219 0 .11.11 0 0 1 .219 0z"
//         />
//         <path
//           fill="#1B1463"
//           d="M163.821 29.457c0 .04-.033.072-.072.072a.072.072 0 0 1 0-.144c.039 0 .072.032.072.072z"
//         />
//         <path
//           fill="#1B1464"
//           d="M163.784 29.457a.037.037 0 0 1-.038.037.037.037 0 0 1-.037-.037c0-.02.016-.037.037-.037.021 0 .038.016.038.037z"
//         />
//       </g>
//     </g>
//     <g opacity={0.5}>
//       <mask
//         id="u-25"
//         width={5}
//         height={10}
//         x={170}
//         y={24}
//         maskUnits="userSpaceOnUse"
//         style={{
//           maskType: "luminance",
//         }}
//       >
//         <path
//           fill="#fff"
//           d="M173.19 33.005s2.816-4.562-1.061-8.439c0 0-2.529-1.576-1.007.707 1.522 2.28 2.436 5.343 1.373 6.711-1.063 1.368-.827 2.674.695 1.021z"
//         />
//       </mask>
//       <g mask="url(#u-25)">
//         <path fill="#000" d="M176.008 22.99h-6.406v11.666h6.406V22.99z" />
//         <path
//           fill="#000"
//           d="M169.082 29.207a3.627 3.627 0 1 1 7.197-.901 3.627 3.627 0 0 1-7.197.901z"
//         />
//         <path
//           fill="#000001"
//           d="M169.12 29.203a3.59 3.59 0 1 1 7.124-.896 3.59 3.59 0 0 1-7.124.896z"
//         />
//         <path
//           fill="#000002"
//           d="M169.155 29.198a3.555 3.555 0 1 1 7.054-.886 3.555 3.555 0 0 1-7.054.886z"
//         />
//         <path
//           fill="#010002"
//           d="M169.192 29.194a3.517 3.517 0 1 1 6.98-.877 3.517 3.517 0 0 1-6.98.877z"
//         />
//         <path
//           fill="#010103"
//           d="M169.227 29.191a3.482 3.482 0 1 1 6.91-.867 3.482 3.482 0 0 1-6.91.867z"
//         />
//         <path
//           fill="#010104"
//           d="M169.264 29.186a3.446 3.446 0 1 1 6.84-.858 3.446 3.446 0 0 1-6.84.858z"
//         />
//         <path
//           fill="#010105"
//           d="M169.299 29.182a3.408 3.408 0 0 1 2.958-3.807 3.408 3.408 0 0 1 3.807 2.958 3.409 3.409 0 1 1-6.765.849z"
//         />
//         <path
//           fill="#020106"
//           d="M169.337 29.177a3.371 3.371 0 1 1 6.692-.841 3.371 3.371 0 1 1-6.692.841z"
//         />
//         <path
//           fill="#020107"
//           d="M169.372 29.173a3.333 3.333 0 0 1 2.895-3.726 3.333 3.333 0 0 1 3.725 2.896 3.333 3.333 0 0 1-2.895 3.725 3.333 3.333 0 0 1-3.725-2.895z"
//         />
//         <path
//           fill="#020208"
//           d="M169.407 29.168a3.3 3.3 0 1 1 6.549-.824 3.3 3.3 0 0 1-6.549.824z"
//         />
//         <path
//           fill="#020208"
//           d="M169.444 29.163a3.265 3.265 0 1 1 6.48-.812 3.265 3.265 0 0 1-6.48.812z"
//         />
//         <path
//           fill="#030209"
//           d="M169.479 29.159a3.225 3.225 0 0 1 2.8-3.604 3.226 3.226 0 1 1 .804 6.403 3.225 3.225 0 0 1-3.604-2.8z"
//         />
//         <path
//           fill="#03020A"
//           d="M169.516 29.154a3.191 3.191 0 1 1 6.333-.796 3.191 3.191 0 0 1-6.333.796z"
//         />
//         <path
//           fill="#03020B"
//           d="M169.551 29.15a3.156 3.156 0 1 1 6.262-.788 3.156 3.156 0 0 1-6.262.787z"
//         />
//         <path
//           fill="#03020C"
//           d="M169.588 29.145a3.118 3.118 0 1 1 6.188-.777 3.118 3.118 0 0 1-6.188.777z"
//         />
//         <path
//           fill="#04030D"
//           d="M169.623 29.14a3.083 3.083 0 1 1 6.118-.768 3.083 3.083 0 0 1-6.118.768z"
//         />
//         <path
//           fill="#04030E"
//           d="M169.658 29.135a3.046 3.046 0 1 1 6.046-.757 3.046 3.046 0 0 1-6.046.757z"
//         />
//         <path
//           fill="#04030F"
//           d="M169.696 29.13a3.009 3.009 0 1 1 5.97-.751 3.009 3.009 0 0 1-5.97.752z"
//         />
//         <path
//           fill="#040310"
//           d="M169.73 29.126a2.976 2.976 0 0 1 5.903-.741 2.975 2.975 0 0 1-5.903.74z"
//         />
//         <path
//           fill="#050311"
//           d="M169.768 29.121a2.936 2.936 0 1 1 5.828-.732 2.937 2.937 0 1 1-5.828.732z"
//         />
//         <path
//           fill="#050412"
//           d="M169.803 29.119a2.901 2.901 0 1 1 5.758-.723 2.901 2.901 0 0 1-5.758.723z"
//         />
//         <path
//           fill="#050413"
//           d="M169.84 29.114a2.867 2.867 0 0 1 2.485-3.2 2.867 2.867 0 0 1 3.201 2.485 2.867 2.867 0 0 1-2.485 3.2 2.867 2.867 0 0 1-3.201-2.485z"
//         />
//         <path
//           fill="#050414"
//           d="M169.875 29.11a2.827 2.827 0 0 1 2.455-3.16 2.828 2.828 0 1 1-2.455 3.159z"
//         />
//         <path
//           fill="#060415"
//           d="M169.91 29.105a2.793 2.793 0 1 1 3.119 2.422 2.796 2.796 0 0 1-3.119-2.422z"
//         />
//         <path
//           fill="#060416"
//           d="M169.947 29.1a2.757 2.757 0 1 1 5.47-.684 2.757 2.757 0 0 1-5.47.684z"
//         />
//         <path
//           fill="#060517"
//           d="M169.982 29.096a2.721 2.721 0 0 1 2.359-3.038 2.721 2.721 0 0 1 3.038 2.36 2.721 2.721 0 0 1-2.359 3.037 2.721 2.721 0 0 1-3.038-2.36z"
//         />
//         <path
//           fill="#060518"
//           d="M170.02 29.091a2.685 2.685 0 1 1 5.329-.668 2.685 2.685 0 0 1-5.329.668z"
//         />
//         <path
//           fill="#070519"
//           d="M170.055 29.086a2.647 2.647 0 1 1 5.253-.66 2.647 2.647 0 0 1-5.253.66z"
//         />
//         <path
//           fill="#07051A"
//           d="M170.092 29.082a2.61 2.61 0 1 1 2.916 2.266 2.61 2.61 0 0 1-2.916-2.266z"
//         />
//         <path
//           fill="#07051B"
//           d="M170.127 29.077a2.576 2.576 0 0 1 5.11-.643 2.576 2.576 0 0 1-5.11.643z"
//         />
//         <path
//           fill="#07061C"
//           d="M170.164 29.072a2.538 2.538 0 1 1 5.04-.633 2.538 2.538 0 0 1-5.04.633z"
//         />
//         <path
//           fill="#08061D"
//           d="M170.199 29.068a2.504 2.504 0 0 1 4.966-.625 2.504 2.504 0 0 1-4.966.625z"
//         />
//         <path
//           fill="#08061E"
//           d="M170.234 29.063a2.463 2.463 0 0 1 2.14-2.753 2.463 2.463 0 0 1 2.753 2.14 2.463 2.463 0 0 1-2.14 2.753 2.463 2.463 0 0 1-2.753-2.14z"
//         />
//         <path
//           fill="#08061F"
//           d="M170.271 29.058a2.43 2.43 0 0 1 4.821-.606 2.43 2.43 0 1 1-4.821.606z"
//         />
//         <path
//           fill="#090620"
//           d="M170.306 29.054a2.394 2.394 0 1 1 4.75-.597 2.394 2.394 0 0 1-4.75.597z"
//         />
//         <path
//           fill="#090721"
//           d="M170.344 29.049a2.354 2.354 0 0 1 2.044-2.632 2.355 2.355 0 0 1 2.632 2.044 2.355 2.355 0 0 1-2.044 2.633 2.355 2.355 0 0 1-2.632-2.045z"
//         />
//         <path
//           fill="#090722"
//           d="M170.379 29.044a2.32 2.32 0 0 1 2.014-2.592 2.32 2.32 0 0 1 2.592 2.014 2.32 2.32 0 0 1-2.014 2.592 2.32 2.32 0 0 1-2.592-2.014z"
//         />
//         <path
//           fill="#090723"
//           d="M170.416 29.042a2.287 2.287 0 0 1 1.981-2.553 2.287 2.287 0 0 1 2.553 1.982 2.285 2.285 0 0 1-4.534.571z"
//         />
//         <path
//           fill="#0A0724"
//           d="M170.451 29.037a2.248 2.248 0 1 1 4.462-.56 2.248 2.248 0 0 1-4.462.56z"
//         />
//         <path
//           fill="#0A0725"
//           d="M170.486 29.033a2.212 2.212 0 1 1 4.388-.554 2.212 2.212 0 0 1-4.388.554z"
//         />
//         <path
//           fill="#0A0826"
//           d="M170.523 29.028a2.176 2.176 0 1 1 4.317-.541 2.176 2.176 0 0 1-4.317.541z"
//         />
//         <path
//           fill="#0A0827"
//           d="M170.558 29.023a2.139 2.139 0 1 1 4.244-.534 2.139 2.139 0 0 1-4.244.534z"
//         />
//         <path
//           fill="#0B0828"
//           d="M170.595 29.019a2.105 2.105 0 1 1 4.177-.523 2.105 2.105 0 0 1-4.177.523z"
//         />
//         <path
//           fill="#0B0829"
//           d="M170.63 29.014a2.066 2.066 0 1 1 4.1-.516 2.066 2.066 0 0 1-4.1.516z"
//         />
//         <path
//           fill="#0B082A"
//           d="M170.668 29.01a2.03 2.03 0 1 1 4.03-.507 2.03 2.03 0 0 1-4.03.506z"
//         />
//         <path
//           fill="#0C092B"
//           d="M170.703 29.005a1.994 1.994 0 1 1 3.958-.5 1.994 1.994 0 1 1-3.958.5z"
//         />
//         <path
//           fill="#0C092C"
//           d="M170.738 29a1.958 1.958 0 1 1 3.887-.488 1.958 1.958 0 0 1-3.887.488z"
//         />
//         <path
//           fill="#0C092D"
//           d="M170.775 28.995a1.921 1.921 0 1 1 3.814-.48 1.921 1.921 0 1 1-3.814.48z"
//         />
//         <path
//           fill="#0C092E"
//           d="M170.81 28.99a1.882 1.882 0 0 1 1.636-2.104 1.882 1.882 0 0 1 2.105 1.636 1.882 1.882 0 0 1-1.636 2.105 1.882 1.882 0 0 1-2.105-1.636z"
//         />
//         <path
//           fill="#0D092F"
//           d="M170.847 28.986a1.85 1.85 0 1 1 3.67-.46 1.85 1.85 0 0 1-3.67.46z"
//         />
//         <path
//           fill="#0D0A30"
//           d="M170.882 28.981a1.815 1.815 0 0 1 3.6-.452 1.815 1.815 0 0 1-3.6.452z"
//         />
//         <path
//           fill="#0D0A31"
//           d="M170.919 28.977a1.777 1.777 0 1 1 3.526-.442 1.777 1.777 0 0 1-3.526.442z"
//         />
//         <path
//           fill="#0E0A32"
//           d="M170.954 28.972a1.741 1.741 0 1 1 3.454-.433 1.741 1.741 0 0 1-3.454.433z"
//         />
//         <path
//           fill="#0E0A33"
//           d="M170.992 28.97a1.706 1.706 0 0 1 1.478-1.905 1.707 1.707 0 0 1 1.904 1.478 1.706 1.706 0 0 1-1.478 1.905 1.706 1.706 0 0 1-1.904-1.478z"
//         />
//         <path
//           fill="#0E0A34"
//           d="M171.027 28.965a1.668 1.668 0 1 1 3.31-.415 1.668 1.668 0 0 1-3.31.415z"
//         />
//         <path
//           fill="#0E0B35"
//           d="M171.062 28.96a1.632 1.632 0 1 1 3.239-.407 1.632 1.632 0 0 1-3.239.407z"
//         />
//         <path
//           fill="#0F0B36"
//           d="M171.099 28.956a1.595 1.595 0 1 1 3.166-.396 1.595 1.595 0 0 1-3.166.396z"
//         />
//         <path
//           fill="#0F0B37"
//           d="M171.134 28.951a1.56 1.56 0 1 1 3.094-.389 1.56 1.56 0 0 1-3.094.39z"
//         />
//         <path
//           fill="#0F0B38"
//           d="M171.171 28.946a1.524 1.524 0 1 1 3.024-.379 1.524 1.524 0 0 1-3.024.38z"
//         />
//         <path
//           fill="#0F0B39"
//           d="M171.206 28.942a1.486 1.486 0 1 1 2.95-.37 1.486 1.486 0 0 1-2.95.37z"
//         />
//         <path
//           fill="#100C3A"
//           d="M171.243 28.937a1.451 1.451 0 1 1 2.88-.36 1.451 1.451 0 0 1-2.88.36z"
//         />
//         <path
//           fill="#100C3B"
//           d="M171.278 28.933a1.415 1.415 0 1 1 1.581 1.226 1.416 1.416 0 0 1-1.581-1.226z"
//         />
//         <path
//           fill="#100C3C"
//           d="M171.313 28.928a1.378 1.378 0 1 1 2.736-.343 1.378 1.378 0 0 1-2.736.343z"
//         />
//         <path
//           fill="#110C3D"
//           d="M171.351 28.923a1.342 1.342 0 1 1 2.663-.335 1.342 1.342 0 0 1-2.663.335z"
//         />
//         <path
//           fill="#110D3F"
//           d="M171.386 28.918a1.303 1.303 0 0 1 1.133-1.456 1.303 1.303 0 0 1 1.457 1.132 1.303 1.303 0 0 1-1.133 1.457 1.302 1.302 0 0 1-1.457-1.133z"
//         />
//         <path
//           fill="#110D40"
//           d="M171.423 28.914a1.27 1.27 0 0 1 2.518-.317 1.27 1.27 0 0 1-2.518.317z"
//         />
//         <path
//           fill="#110D41"
//           d="M171.458 28.91a1.235 1.235 0 0 1 2.448-.309 1.235 1.235 0 0 1-2.448.308z"
//         />
//         <path
//           fill="#120D42"
//           d="M171.495 28.904a1.195 1.195 0 1 1 2.374-.3 1.195 1.195 0 0 1-2.374.3z"
//         />
//         <path
//           fill="#120D43"
//           d="M171.53 28.9a1.16 1.16 0 1 1 2.303-.29 1.16 1.16 0 0 1-2.303.29z"
//         />
//         <path
//           fill="#120E44"
//           d="M171.565 28.895a1.127 1.127 0 0 1 .975-1.256 1.126 1.126 0 0 1 1.256.974 1.127 1.127 0 0 1-.974 1.257 1.127 1.127 0 0 1-1.257-.975z"
//         />
//         <path
//           fill="#130E45"
//           d="M171.602 28.893a1.088 1.088 0 1 1 2.159-.27 1.088 1.088 0 0 1-2.159.27z"
//         />
//         <path
//           fill="#130E46"
//           d="M171.637 28.888a1.052 1.052 0 1 1 2.088-.262 1.052 1.052 0 0 1-2.088.262z"
//         />
//         <path
//           fill="#130E47"
//           d="M171.675 28.884a1.014 1.014 0 0 1 .881-1.134 1.013 1.013 0 0 1 1.133.882 1.014 1.014 0 1 1-2.014.252z"
//         />
//         <path
//           fill="#130E48"
//           d="M171.71 28.879a.978.978 0 1 1 1.94-.246.978.978 0 0 1-1.94.246z"
//         />
//         <path
//           fill="#140F49"
//           d="M171.747 28.874a.943.943 0 1 1 1.87-.236.943.943 0 0 1-1.87.236z"
//         />
//         <path
//           fill="#140F4A"
//           d="M171.782 28.87a.904.904 0 0 1 .786-1.012.905.905 0 1 1-.786 1.012z"
//         />
//         <path
//           fill="#140F4B"
//           d="M171.819 28.865a.87.87 0 1 1 1.727-.217.87.87 0 0 1-1.727.217z"
//         />
//         <path
//           fill="#150F4C"
//           d="M171.854 28.86a.835.835 0 1 1 1.656-.209.835.835 0 0 1-1.656.21z"
//         />
//         <path
//           fill="#150F4D"
//           d="M171.889 28.855a.795.795 0 0 1 .693-.89.795.795 0 0 1 .89.692.795.795 0 0 1-.692.89.795.795 0 0 1-.891-.692z"
//         />
//         <path
//           fill="#15104E"
//           d="M171.927 28.85a.76.76 0 1 1 1.509-.192.76.76 0 0 1-1.509.193z"
//         />
//         <path
//           fill="#151050"
//           d="M171.961 28.846a.725.725 0 1 1 1.44-.178.725.725 0 0 1-1.44.178z"
//         />
//         <path
//           fill="#161051"
//           d="M171.999 28.842a.688.688 0 1 1 1.364-.174.688.688 0 0 1-1.364.174z"
//         />
//         <path
//           fill="#161052"
//           d="M172.034 28.837a.654.654 0 1 1 1.297-.163.654.654 0 0 1-1.297.163z"
//         />
//         <path
//           fill="#161153"
//           d="M172.071 28.832a.616.616 0 1 1 1.223-.152.616.616 0 0 1-1.223.152z"
//         />
//         <path
//           fill="#171154"
//           d="M172.106 28.828a.582.582 0 0 1 1.152-.145.582.582 0 0 1-.504.648.582.582 0 0 1-.648-.503z"
//         />
//         <path
//           fill="#171155"
//           d="M172.141 28.823a.545.545 0 1 1 .608.47.545.545 0 0 1-.608-.47z"
//         />
//         <path
//           fill="#171156"
//           d="M172.178 28.818a.508.508 0 1 1 1.006-.124.508.508 0 0 1-1.006.124z"
//         />
//         <path
//           fill="#171157"
//           d="M172.213 28.816a.472.472 0 0 1 .935-.119.471.471 0 0 1-.935.119z"
//         />
//         <path
//           fill="#181258"
//           d="M172.251 28.811a.434.434 0 1 1 .862-.107.438.438 0 0 1-.378.487.433.433 0 0 1-.484-.377v-.003z"
//         />
//         <path
//           fill="#181259"
//           d="M172.285 28.806a.4.4 0 1 1 .792-.098.4.4 0 0 1-.792.099z"
//         />
//         <path
//           fill="#18125A"
//           d="M172.323 28.802a.363.363 0 1 1 .72-.09.363.363 0 0 1-.72.09z"
//         />
//         <path
//           fill="#19125B"
//           d="M172.358 28.797a.325.325 0 1 1 .364.282.324.324 0 0 1-.364-.282z"
//         />
//         <path
//           fill="#19125C"
//           d="M172.393 28.793a.29.29 0 1 1 .576-.072.29.29 0 0 1-.576.072z"
//         />
//         <path
//           fill="#19135D"
//           d="M172.43 28.788a.255.255 0 0 1 .504-.065.257.257 0 0 1-.22.284.256.256 0 0 1-.284-.22z"
//         />
//         <path
//           fill="#1A135F"
//           d="M172.465 28.783a.218.218 0 0 1 .431-.053.218.218 0 0 1-.431.053z"
//         />
//         <path
//           fill="#1A1360"
//           d="M172.502 28.779a.182.182 0 0 1 .157-.203.181.181 0 1 1-.157.203z"
//         />
//         <path
//           fill="#1A1361"
//           d="M172.537 28.774a.145.145 0 0 1 .287-.035.145.145 0 0 1-.287.035z"
//         />
//         <path
//           fill="#1A1462"
//           d="M172.575 28.77a.108.108 0 0 1 .093-.122.108.108 0 0 1 .028.215.108.108 0 0 1-.121-.094z"
//         />
//         <path
//           fill="#1B1463"
//           d="M172.61 28.765a.073.073 0 0 1 .062-.082.073.073 0 1 1-.062.082z"
//         />
//         <path
//           fill="#1B1464"
//           d="M172.647 28.76a.035.035 0 0 1 .03-.04c.021-.002.037.012.04.033.002.02-.012.037-.033.04-.021.002-.037-.012-.039-.033h.002z"
//         />
//       </g>
//     </g>
//     <mask
//       id="v-26"
//       width={8}
//       height={13}
//       x={164}
//       y={23}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "luminance",
//       }}
//     >
//       <path
//         fill="#fff"
//         d="M171.5 28.828c.671 3.049-.282 5.849-2.126 6.254-1.844.406-3.884-1.736-4.555-4.786-.672-3.049.282-5.849 2.126-6.254 1.844-.406 3.884 1.736 4.555 4.786z"
//       />
//     </mask>
//     <g mask="url(#v-26)">
//       <path fill="#000" d="M172.171 23.636h-8.021v11.852h8.021V23.636z" />
//       <path
//         fill="#000"
//         d="M166.84 23.78c2.357-.538 4.858 1.616 5.588 4.81.729 3.194-.59 6.22-2.947 6.756-2.357.538-4.858-1.616-5.588-4.81-.729-3.193.59-6.22 2.947-6.755z"
//       />
//       <path
//         fill="#010002"
//         d="M166.854 23.837c2.333-.532 4.809 1.599 5.532 4.76.723 3.16-.585 6.157-2.919 6.688-2.333.532-4.809-1.6-5.532-4.76-.722-3.161.585-6.157 2.919-6.69v.002z"
//       />
//       <path
//         fill="#010105"
//         d="M166.866 23.895c2.31-.527 4.76 1.583 5.476 4.713.713 3.131-.579 6.094-2.889 6.623-2.31.527-4.76-1.583-5.476-4.713-.713-3.131.578-6.094 2.889-6.62v-.003z"
//       />
//       <path
//         fill="#020107"
//         d="M166.88 23.953c2.286-.522 4.711 1.567 5.42 4.665.706 3.098-.574 6.033-2.859 6.555-2.286.522-4.711-1.567-5.42-4.665-.706-3.098.574-6.033 2.859-6.555z"
//       />
//       <path
//         fill="#03020A"
//         d="M166.894 24.011c2.261-.515 4.664 1.55 5.364 4.616.699 3.066-.567 5.97-2.83 6.488-2.264.517-4.665-1.55-5.365-4.616-.699-3.065.567-5.97 2.831-6.488z"
//       />
//       <path
//         fill="#03020C"
//         d="M166.905 24.07c2.238-.51 4.616 1.534 5.308 4.569.693 3.035-.561 5.907-2.799 6.42-2.238.513-4.616-1.534-5.309-4.57-.692-3.034.562-5.907 2.8-6.42z"
//       />
//       <path
//         fill="#04030E"
//         d="M169.401 34.986c2.215-.505 3.455-3.35 2.77-6.352-.685-3.002-3.037-5.026-5.252-4.52-2.216.505-3.456 3.35-2.771 6.352.686 3.002 3.037 5.026 5.253 4.52z"
//       />
//       <path
//         fill="#040311"
//         d="M166.933 24.184c2.192-.501 4.518 1.501 5.196 4.473.679 2.97-.55 5.784-2.741 6.285-2.191.502-4.518-1.501-5.196-4.473-.679-2.97.55-5.784 2.741-6.285z"
//       />
//       <path
//         fill="#050413"
//         d="M166.945 24.242c2.168-.494 4.469 1.485 5.14 4.425.671 2.937-.543 5.72-2.711 6.217-2.168.494-4.469-1.485-5.14-4.425-.672-2.937.543-5.72 2.711-6.217z"
//       />
//       <path
//         fill="#060415"
//         d="M166.959 24.3c2.145-.49 4.42 1.471 5.084 4.376.665 2.907-.538 5.66-2.681 6.15-2.144.49-4.42-1.471-5.084-4.376-.664-2.907.538-5.66 2.683-6.15h-.002z"
//       />
//       <path
//         fill="#060517"
//         d="M166.97 24.359c2.122-.485 4.374 1.454 5.029 4.329.655 2.874-.532 5.597-2.653 6.082-2.121.485-4.373-1.455-5.028-4.33-.656-2.874.531-5.596 2.652-6.081z"
//       />
//       <path
//         fill="#070519"
//         d="M166.984 24.415c2.098-.478 4.325 1.438 4.973 4.28.648 2.841-.525 5.534-2.623 6.014-2.098.478-4.324-1.438-4.972-4.28-.648-2.842.527-5.534 2.622-6.014z"
//       />
//       <path
//         fill="#07051B"
//         d="M166.998 24.473c2.075-.473 4.276 1.422 4.917 4.231.641 2.811-.52 5.474-2.595 5.947-2.074.473-4.275-1.422-4.916-4.231-.641-2.812.52-5.474 2.594-5.947z"
//       />
//       <path
//         fill="#08061D"
//         d="M167.01 24.531c2.052-.468 4.227 1.406 4.861 4.185.634 2.778-.513 5.41-2.565 5.879-2.051.468-4.226-1.406-4.86-4.184-.634-2.78.513-5.411 2.564-5.88z"
//       />
//       <path
//         fill="#08061F"
//         d="M169.295 34.523c2.027-.463 3.162-3.065 2.535-5.811-.627-2.746-2.778-4.598-4.806-4.135-2.027.463-3.162 3.064-2.535 5.81.627 2.747 2.779 4.598 4.806 4.136z"
//       />
//       <path
//         fill="#090721"
//         d="M167.038 24.648c2.003-.457 4.129 1.373 4.749 4.089.62 2.716-.502 5.287-2.506 5.744-2.003.457-4.129-1.373-4.749-4.09-.62-2.715.501-5.286 2.506-5.743z"
//       />
//       <path
//         fill="#0A0723"
//         d="M167.05 24.704c1.979-.453 4.082 1.357 4.692 4.04.613 2.683-.496 5.224-2.475 5.676-1.98.452-4.08-1.357-4.693-4.04-.613-2.683.496-5.224 2.476-5.676z"
//       />
//       <path
//         fill="#0A0725"
//         d="M167.064 24.762c1.956-.448 4.033 1.34 4.636 3.991.607 2.65-.489 5.161-2.445 5.609-1.956.445-4.033-1.34-4.637-3.991-.606-2.65.49-5.161 2.446-5.609z"
//       />
//       <path
//         fill="#0B0827"
//         d="M167.078 24.82c1.932-.44 3.984 1.324 4.58 3.945.597 2.618-.484 5.1-2.417 5.54-1.933.441-3.984-1.323-4.581-3.944-.597-2.617.485-5.1 2.418-5.54z"
//       />
//       <path
//         fill="#0B0829"
//         d="M167.089 24.879c1.91-.436 3.935 1.307 4.525 3.895.59 2.588-.478 5.038-2.387 5.474-1.909.436-3.935-1.308-4.525-3.896-.59-2.587.478-5.038 2.387-5.473z"
//       />
//       <path
//         fill="#0C092B"
//         d="M167.103 24.937c1.886-.431 3.886 1.291 4.469 3.846.583 2.555-.473 4.975-2.357 5.406-1.883.432-3.886-1.291-4.468-3.846-.583-2.555.473-4.975 2.356-5.406z"
//       />
//       <path
//         fill="#0C092C"
//         d="M167.117 24.995c1.863-.424 3.838 1.275 4.413 3.8.576 2.522-.466 4.914-2.329 5.338-1.862.425-3.837-1.275-4.412-3.8-.576-2.524.466-4.914 2.328-5.338z"
//       />
//       <path
//         fill="#0C092E"
//         d="M167.129 25.051c1.839-.42 3.788 1.259 4.357 3.751.569 2.492-.462 4.851-2.299 5.27-1.839.42-3.788-1.258-4.357-3.75-.568-2.492.462-4.851 2.299-5.27z"
//       />
//       <path
//         fill="#0D0A30"
//         d="M167.143 25.11c1.814-.416 3.742 1.244 4.301 3.701.562 2.46-.455 4.789-2.271 5.203-1.813.415-3.741-1.244-4.301-3.701-.561-2.46.455-4.789 2.269-5.204h.002z"
//       />
//       <path
//         fill="#0D0A32"
//         d="M167.157 25.168c1.79-.408 3.693 1.228 4.245 3.655.555 2.427-.45 4.725-2.24 5.136-1.791.407-3.693-1.229-4.245-3.656-.555-2.427.45-4.727 2.24-5.135z"
//       />
//       <path
//         fill="#0E0A33"
//         d="M167.169 25.226c1.767-.403 3.643 1.212 4.189 3.606.548 2.397-.443 4.665-2.21 5.068-1.767.404-3.644-1.212-4.189-3.606-.548-2.396.443-4.665 2.21-5.068z"
//       />
//       <path
//         fill="#0E0B35"
//         d="M167.183 25.284c1.743-.398 3.594 1.196 4.135 3.56.539 2.364-.436 4.602-2.182 5-1.744.399-3.595-1.196-4.133-3.56-.539-2.363.438-4.601 2.182-5h-.002z"
//       />
//       <path
//         fill="#0F0B36"
//         d="M167.197 25.34c1.72-.392 3.545 1.18 4.079 3.51.532 2.332-.431 4.54-2.151 4.934-1.721.394-3.546-1.18-4.08-3.511-.532-2.331.431-4.539 2.152-4.933z"
//       />
//       <path
//         fill="#0F0B38"
//         d="M167.208 25.398c1.697-.386 3.497 1.164 4.024 3.462.524 2.299-.424 4.479-2.122 4.865-1.697.387-3.496-1.163-4.023-3.461-.525-2.299.424-4.479 2.121-4.866z"
//       />
//       <path
//         fill="#100B39"
//         d="M167.222 25.457c1.674-.383 3.45 1.147 3.968 3.415.518 2.268-.42 4.415-2.093 4.797-1.674.383-3.451-1.146-3.968-3.415-.518-2.268.419-4.415 2.093-4.797z"
//       />
//       <path
//         fill="#100C3B"
//         d="M167.236 25.515c1.651-.375 3.401 1.13 3.912 3.366.51 2.236-.413 4.353-2.063 4.73-1.651.376-3.401-1.13-3.912-3.366-.51-2.236.413-4.352 2.063-4.73z"
//       />
//       <path
//         fill="#100C3C"
//         d="M167.248 25.573c1.627-.37 3.352 1.115 3.856 3.317.503 2.203-.408 4.292-2.033 4.663-1.627.37-3.352-1.114-3.856-3.317-.503-2.203.408-4.292 2.033-4.663z"
//       />
//       <path
//         fill="#110C3E"
//         d="M167.262 25.63c1.601-.367 3.303 1.097 3.8 3.27.496 2.173-.401 4.229-2.005 4.595-1.604.366-3.303-1.098-3.8-3.271-.496-2.173.401-4.229 2.005-4.595z"
//       />
//       <path
//         fill="#110D3F"
//         d="M167.276 25.688c1.578-.362 3.254 1.081 3.744 3.221.487 2.14-.397 4.166-1.975 4.527-1.578.362-3.254-1.081-3.744-3.221-.487-2.14.397-4.166 1.975-4.527z"
//       />
//       <path
//         fill="#110D41"
//         d="M167.288 25.746c1.554-.355 3.205 1.065 3.687 3.175.481 2.107-.389 4.105-1.944 4.46-1.555.354-3.205-1.066-3.688-3.176-.48-2.107.39-4.105 1.945-4.46z"
//       />
//       <path
//         fill="#120D42"
//         d="M167.302 25.804c1.531-.35 3.158 1.05 3.632 3.126.473 2.077-.385 4.042-1.917 4.392-1.531.35-3.159-1.049-3.632-3.126-.473-2.077.385-4.042 1.917-4.392z"
//       />
//       <path
//         fill="#120D43"
//         d="M167.316 25.862c1.508-.345 3.109 1.033 3.576 3.078.466 2.044-.378 3.979-1.886 4.324-1.509.345-3.11-1.033-3.576-3.077-.467-2.045.377-3.98 1.886-4.325z"
//       />
//       <path
//         fill="#120E44"
//         d="M167.327 25.918c1.485-.338 3.061 1.019 3.52 3.03.46 2.013-.373 3.92-1.855 4.258-1.485.338-3.061-1.02-3.52-3.031-.46-2.012.373-3.919 1.858-4.257h-.003z"
//       />
//       <path
//         fill="#130E46"
//         d="M167.341 25.977c1.462-.334 3.012 1.002 3.464 2.981.453 1.98-.366 3.856-1.827 4.19-1.462.333-3.012-1.003-3.465-2.982-.452-1.98.366-3.856 1.828-4.19z"
//       />
//       <path
//         fill="#130E47"
//         d="M167.355 26.035c1.438-.329 2.963.986 3.408 2.933.446 1.948-.361 3.792-1.797 4.121-1.438.329-2.963-.986-3.408-2.933-.446-1.948.361-3.792 1.797-4.121z"
//       />
//       <path
//         fill="#130E48"
//         d="M167.367 26.093c1.415-.322 2.914.97 3.352 2.886.438 1.916-.354 3.732-1.769 4.054-1.415.322-2.914-.97-3.353-2.886-.438-1.916.355-3.732 1.77-4.054z"
//       />
//       <path
//         fill="#140F49"
//         d="M167.381 26.151c1.389-.317 2.867.954 3.296 2.837.429 1.884-.347 3.67-1.739 3.987-1.389.317-2.867-.954-3.296-2.837-.429-1.884.347-3.67 1.739-3.987z"
//       />
//       <path
//         fill="#140F4A"
//         d="M167.395 26.207c1.366-.312 2.818.938 3.24 2.79.422 1.854-.343 3.607-1.709 3.92-1.366.312-2.818-.938-3.24-2.79-.422-1.854.343-3.607 1.709-3.92z"
//       />
//       <path
//         fill="#140F4B"
//         d="M167.406 26.266c1.343-.306 2.77.92 3.185 2.741.415 1.82-.336 3.546-1.681 3.851-1.345.306-2.769-.92-3.184-2.741-.415-1.82.335-3.546 1.68-3.851z"
//       />
//       <path
//         fill="#150F4C"
//         d="M167.42 26.324c1.32-.3 2.721.904 3.129 2.692.408 1.789-.331 3.483-1.651 3.784-1.319.3-2.72-.905-3.128-2.693-.408-1.788.331-3.482 1.65-3.783z"
//       />
//       <path
//         fill="#15104E"
//         d="M167.434 26.382c1.296-.296 2.672.888 3.073 2.646.401 1.758-.324 3.42-1.62 3.716-1.296.296-2.672-.888-3.073-2.646-.401-1.758.324-3.42 1.62-3.716z"
//       />
//       <path
//         fill="#15104F"
//         d="M167.446 26.44c1.273-.29 2.623.872 3.017 2.597.394 1.726-.32 3.36-1.593 3.649-1.272.291-2.622-.872-3.016-2.597-.394-1.725.319-3.36 1.592-3.648z"
//       />
//       <path
//         fill="#151050"
//         d="M167.46 26.496c1.25-.284 2.574.856 2.961 2.548.387 1.693-.313 3.297-1.562 3.581-1.25.285-2.574-.855-2.961-2.548-.387-1.692.313-3.296 1.562-3.58z"
//       />
//       <path
//         fill="#161050"
//         d="M167.474 26.555c1.226-.28 2.527.839 2.905 2.501.38 1.66-.308 3.233-1.532 3.513-1.226.28-2.527-.84-2.905-2.501-.38-1.66.308-3.234 1.532-3.513z"
//       />
//       <path
//         fill="#161051"
//         d="M167.486 26.613c1.203-.275 2.478.823 2.848 2.452.371 1.63-.3 3.173-1.503 3.446-1.203.275-2.478-.823-2.849-2.453-.371-1.629.301-3.172 1.504-3.445z"
//       />
//       <path
//         fill="#161052"
//         d="M167.5 26.671c1.177-.268 2.429.807 2.792 2.404.364 1.597-.296 3.11-1.473 3.378-1.177.268-2.429-.807-2.793-2.406-.363-1.597.296-3.11 1.474-3.378v.002z"
//       />
//       <path
//         fill="#161153"
//         d="M167.514 26.73c1.154-.264 2.38.792 2.737 2.356.356 1.565-.29 3.047-1.443 3.31-1.154.264-2.381-.792-2.737-2.356-.357-1.564.289-3.047 1.445-3.31h-.002z"
//       />
//       <path
//         fill="#171154"
//         d="M167.525 26.788c1.131-.259 2.332.776 2.681 2.308.35 1.534-.284 2.986-1.415 3.242-1.13.26-2.331-.776-2.681-2.308-.349-1.533.285-2.986 1.415-3.242z"
//       />
//       <path
//         fill="#171155"
//         d="M167.539 26.844c1.108-.252 2.283.76 2.625 2.261.343 1.501-.277 2.923-1.385 3.175-1.107.252-2.282-.76-2.624-2.261-.343-1.501.277-2.923 1.384-3.175z"
//       />
//       <path
//         fill="#171156"
//         d="M167.553 26.902c1.084-.247 2.236.744 2.569 2.212.336 1.469-.273 2.86-1.357 3.108-1.084.247-2.235-.744-2.569-2.213-.335-1.468.273-2.86 1.357-3.107z"
//       />
//       <path
//         fill="#171156"
//         d="M167.565 26.96c1.061-.242 2.187.728 2.513 2.164.329 1.438-.266 2.797-1.326 3.04-1.061.242-2.187-.728-2.514-2.164-.328-1.438.266-2.797 1.327-3.04z"
//       />
//       <path
//         fill="#181157"
//         d="M167.579 27.019c1.037-.238 2.138.71 2.459 2.116.322 1.406-.258 2.737-1.296 2.973-1.037.237-2.138-.711-2.459-2.117-.322-1.406.258-2.737 1.296-2.972z"
//       />
//       <path
//         fill="#181258"
//         d="M167.593 27.077c1.014-.23 2.089.695 2.403 2.068.313 1.373-.254 2.674-1.268 2.904-1.014.231-2.089-.694-2.403-2.067-.313-1.373.254-2.674 1.268-2.905z"
//       />
//       <path
//         fill="#181259"
//         d="M167.605 27.133c.99-.226 2.039.678 2.347 2.019.305 1.34-.247 2.61-1.238 2.837-.991.226-2.04-.679-2.347-2.02-.306-1.34.247-2.61 1.238-2.836z"
//       />
//       <path
//         fill="#181259"
//         d="M167.619 27.191c.965-.221 1.99.662 2.291 1.972.299 1.31-.242 2.55-1.207 2.77-.966.221-1.991-.662-2.292-1.972-.298-1.31.242-2.55 1.208-2.77z"
//       />
//       <path
//         fill="#18125A"
//         d="M167.633 27.25c.941-.215 1.944.645 2.235 1.923.292 1.277-.235 2.487-1.179 2.702-.942.214-1.945-.646-2.236-1.924-.291-1.277.235-2.487 1.18-2.702z"
//       />
//       <path
//         fill="#18125B"
//         d="M167.644 27.308c.919-.21 1.895.63 2.18 1.876.284 1.245-.231 2.425-1.149 2.634-.919.21-1.896-.629-2.18-1.876-.285-1.245.231-2.425 1.149-2.634z"
//       />
//       <path
//         fill="#19125B"
//         d="M167.658 27.366c.895-.205 1.847.613 2.124 1.828.277 1.214-.224 2.364-1.119 2.566-.895.205-1.846-.613-2.124-1.827-.277-1.215.224-2.364 1.119-2.567z"
//       />
//       <path
//         fill="#19125C"
//         d="M167.672 27.422c.872-.198 1.798.597 2.068 1.779.27 1.181-.219 2.3-1.091 2.499-.872.198-1.797-.597-2.068-1.78-.27-1.181.219-2.3 1.091-2.498z"
//       />
//       <path
//         fill="#19125C"
//         d="M167.684 27.48c.848-.193 1.748.58 2.012 1.732.263 1.15-.213 2.238-1.061 2.432-.849.193-1.749-.58-2.012-1.732-.263-1.15.212-2.238 1.061-2.432z"
//       />
//       <path
//         fill="#19135D"
//         d="M167.698 27.538c.825-.188 1.699.567 1.956 1.684.254 1.119-.208 2.177-1.031 2.363-.825.19-1.699-.566-1.956-1.683-.254-1.119.208-2.177 1.033-2.364h-.002z"
//       />
//       <path
//         fill="#19135D"
//         d="M167.712 27.597c.802-.182 1.653.55 1.9 1.634.247 1.086-.201 2.114-1.003 2.296-.802.182-1.653-.55-1.9-1.634-.247-1.086.201-2.114 1.003-2.296z"
//       />
//       <path
//         fill="#19135E"
//         d="M167.723 27.655c.779-.177 1.604.534 1.844 1.588.24 1.053-.195 2.051-.972 2.23-.778.178-1.604-.533-1.844-1.587-.24-1.054.196-2.051.972-2.229v-.002z"
//       />
//       <path
//         fill="#19135E"
//         d="M167.737 27.71c.753-.172 1.555.518 1.788 1.54.234 1.02-.188 1.99-.944 2.163-.753.172-1.555-.518-1.788-1.539-.233-1.02.189-1.99.944-2.163z"
//       />
//       <path
//         fill="#1A135F"
//         d="M167.751 27.77c.73-.169 1.506.5 1.732 1.491.227.991-.184 1.928-.913 2.096-.73.168-1.506-.501-1.732-1.492-.227-.99.184-1.928.913-2.096z"
//       />
//       <path
//         fill="#1A135F"
//         d="M167.763 27.828c.706-.161 1.457.484 1.676 1.443.219.958-.177 1.864-.883 2.028-.707.16-1.457-.485-1.676-1.443-.22-.958.177-1.865.883-2.028z"
//       />
//       <path
//         fill="#1A1360"
//         d="M167.777 27.886c.683-.156 1.408.468 1.62 1.394.212.925-.17 1.804-.855 1.96-.683.157-1.408-.468-1.621-1.394-.212-.925.171-1.804.856-1.96z"
//       />
//       <path
//         fill="#1A1360"
//         d="M167.789 27.944c.66-.151 1.361.452 1.564 1.348.205.895-.166 1.741-.825 1.892-.66.152-1.359-.452-1.564-1.347-.206-.895.165-1.741.825-1.893z"
//       />
//       <path
//         fill="#1A1360"
//         d="M167.803 28c.636-.145 1.312.436 1.508 1.299.196.862-.159 1.678-.795 1.825-.636.144-1.312-.436-1.508-1.299-.196-.862.158-1.678.795-1.825z"
//       />
//       <path
//         fill="#1A1361"
//         d="M167.817 28.058c.613-.14 1.263.42 1.452 1.25.189.83-.154 1.618-.767 1.758-.613.14-1.263-.42-1.452-1.25-.189-.83.154-1.618.767-1.758z"
//       />
//       <path
//         fill="#1A1361"
//         d="M167.831 28.117c.589-.136 1.214.403 1.396 1.203.182.8-.147 1.554-.737 1.69-.589.135-1.214-.404-1.396-1.203-.182-.8.147-1.555.737-1.69z"
//       />
//       <path
//         fill="#1A1361"
//         d="M167.842 28.175c.567-.128 1.166.387 1.341 1.154.175.767-.142 1.492-.707 1.622-.566.129-1.165-.387-1.34-1.154-.175-.767.142-1.492.706-1.622z"
//       />
//       <path
//         fill="#1A1462"
//         d="M167.856 28.233c.544-.123 1.117.37 1.285 1.105.168.735-.135 1.431-.679 1.555-.543.124-1.116-.37-1.284-1.105-.168-.734.135-1.431.678-1.555z"
//       />
//       <path
//         fill="#1A1462"
//         d="M167.868 28.291c.518-.119 1.068.355 1.229 1.059.16.701-.131 1.368-.649 1.487-.517.119-1.067-.354-1.228-1.058-.161-.702.13-1.369.648-1.488z"
//       />
//       <path
//         fill="#1A1462"
//         d="M167.882 28.347c.494-.112 1.021.34 1.173 1.01.153.671-.124 1.305-.621 1.42-.494.111-1.021-.34-1.172-1.01-.154-.671.123-1.305.62-1.42z"
//       />
//       <path
//         fill="#1B1462"
//         d="M167.896 28.406c.471-.107.972.324 1.117.963.147.638-.119 1.244-.59 1.352-.471.107-.972-.325-1.117-.963-.147-.639.119-1.245.59-1.352z"
//       />
//       <path
//         fill="#1B1462"
//         d="M167.908 28.464c.447-.103.923.308 1.06.914.138.606-.112 1.182-.559 1.284-.448.103-.923-.307-1.061-.914-.137-.606.112-1.181.56-1.284z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.922 28.522c.424-.098.874.292 1.004.865.131.576-.107 1.12-.531 1.217-.424.098-.874-.291-1.005-.865-.131-.576.107-1.119.532-1.217z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.936 28.58c.401-.09.825.276.948.819.124.543-.1 1.058-.501 1.149-.401.091-.825-.275-.949-.818-.123-.543.101-1.059.502-1.15z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.947 28.636c.378-.086.777.26.893.77.117.51-.096.995-.471 1.081-.377.087-.776-.258-.893-.769-.116-.51.096-.995.471-1.082z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.961 28.695c.355-.082.73.242.837.72.11.478-.088.933-.443 1.014-.354.082-.729-.242-.837-.72-.109-.48.089-.933.443-1.014z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.975 28.753c.331-.075.681.226.783.674.103.447-.081.87-.412.946-.331.075-.681-.226-.783-.674-.103-.447.081-.87.412-.946z"
//       />
//       <path
//         fill="#1B1463"
//         d="M167.987 28.811c.305-.07.632.21.727.625.096.415-.077.809-.382.879-.306.07-.632-.21-.727-.625-.096-.415.076-.809.382-.879z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.001 28.87c.282-.066.583.193.671.578.089.382-.07.746-.354.811-.282.065-.583-.194-.671-.578-.089-.383.069-.746.354-.811z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.015 28.925c.259-.058.534.178.615.53.079.352-.065.683-.324.743-.259.059-.534-.177-.615-.529-.079-.352.065-.683.324-.744z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.027 28.984c.235-.054.484.16.559.48.072.32-.058.623-.294.676-.235.054-.485-.16-.559-.48-.072-.32.058-.623.294-.676z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.04 29.042c.213-.049.439.145.504.434.065.286-.054.56-.266.608-.212.05-.438-.144-.503-.433-.066-.287.053-.56.265-.609z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.055 29.1c.188-.042.389.129.447.385.058.256-.047.497-.235.54-.189.043-.39-.127-.448-.384-.058-.256.047-.496.236-.54z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.066 29.159c.166-.038.341.114.392.335.051.224-.042.436-.205.474-.166.037-.341-.115-.392-.336-.051-.224.042-.436.207-.473h-.002z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.08 29.215c.142-.033.291.098.336.289.044.19-.035.373-.177.405-.143.033-.292-.098-.336-.289-.044-.19.035-.373.177-.405z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.094 29.273c.119-.028.243.082.28.24.037.159-.03.31-.147.338-.119.028-.242-.082-.28-.24-.037-.161.031-.31.147-.338z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.106 29.331c.093-.02.193.065.224.194.03.128-.024.25-.119.27-.094.021-.194-.065-.224-.193-.028-.129.023-.25.119-.27z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.12 29.39c.07-.017.147.048.168.144.021.096-.019.186-.089.203-.07.016-.147-.05-.168-.145-.021-.095.019-.186.089-.203z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.134 29.448c.046-.012.098.032.112.095.014.063-.012.124-.059.136-.046.011-.098-.033-.112-.096-.014-.063.012-.124.059-.135z"
//       />
//       <path
//         fill="#1B1464"
//         d="M168.145 29.504c.024-.005.049.016.056.049.007.032-.007.063-.03.067-.023.005-.049-.016-.056-.049-.007-.032.007-.063.03-.067z"
//       />
//     </g>
//     <mask
//       id="w-27"
//       width={4}
//       height={5}
//       x={166}
//       y={27}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "luminance",
//       }}
//     >
//       <path
//         fill="#fff"
//         d="M169.94 29.518a1.665 1.665 0 0 1-3.329 0 1.666 1.666 0 0 1 3.329 0z"
//       />
//     </mask>
//     <g mask="url(#w-27)">
//       <path fill="#000" d="M169.94 27.853h-3.329v3.33h3.329v-3.33z" />
//       <path
//         fill="#000"
//         d="M168.266 27.853a1.664 1.664 0 1 1 .019 3.329 1.665 1.665 0 0 1-.019-3.329z"
//       />
//       <path
//         fill="#000001"
//         d="M168.267 27.893a1.625 1.625 0 1 1 .018 3.25 1.625 1.625 0 0 1-.018-3.25z"
//       />
//       <path
//         fill="#000001"
//         d="M168.267 27.93a1.587 1.587 0 1 1 .017 3.175 1.587 1.587 0 0 1-.017-3.175z"
//       />
//       <path
//         fill="#000002"
//         d="M168.267 27.97a1.547 1.547 0 1 1 .02 3.094 1.547 1.547 0 0 1-.02-3.094z"
//       />
//       <path
//         fill="#000003"
//         d="M168.267 28.01a1.508 1.508 0 0 1 1.517 1.5 1.509 1.509 0 1 1-1.517-1.501z"
//       />
//       <path
//         fill="#000004"
//         d="M168.267 28.047a1.47 1.47 0 0 1 .016 2.94 1.47 1.47 0 0 1-.016-2.94z"
//       />
//       <path
//         fill="#000005"
//         d="M168.267 28.086a1.431 1.431 0 0 1 1.44 1.425 1.433 1.433 0 1 1-1.44-1.424z"
//       />
//       <path
//         fill="#000006"
//         d="M168.267 28.124a1.393 1.393 0 1 1 .016 2.786 1.393 1.393 0 0 1-.016-2.786z"
//       />
//       <path
//         fill="#000007"
//         d="M168.269 28.163a1.353 1.353 0 1 1 .014 2.709 1.352 1.352 0 0 1-1.361-1.347 1.352 1.352 0 0 1 1.347-1.362z"
//       />
//       <path
//         fill="#000008"
//         d="M168.269 28.203a1.316 1.316 0 1 1 .017 2.631 1.316 1.316 0 0 1-.017-2.631z"
//       />
//       <path
//         fill="#000009"
//         d="M168.269 28.24a1.276 1.276 0 0 1 1.284 1.27 1.277 1.277 0 1 1-1.284-1.27z"
//       />
//       <path
//         fill="#00000A"
//         d="M168.269 28.28a1.237 1.237 0 1 1 .014 2.476 1.237 1.237 0 1 1-.014-2.476z"
//       />
//       <path
//         fill="#00000B"
//         d="M168.269 28.317a1.2 1.2 0 1 1 .014 2.401 1.2 1.2 0 1 1-.014-2.401z"
//       />
//       <path
//         fill="#00000C"
//         d="M168.269 28.357a1.161 1.161 0 1 1 .013 2.322 1.161 1.161 0 0 1-.013-2.322z"
//       />
//       <path
//         fill="#00000D"
//         d="M168.269 28.396a1.12 1.12 0 0 1 1.128 1.117 1.12 1.12 0 0 1-1.116 1.128 1.122 1.122 0 1 1-.012-2.245z"
//       />
//       <path
//         fill="#00000E"
//         d="M168.269 28.434a1.085 1.085 0 0 1 .012 2.168 1.083 1.083 0 0 1-.012-2.168z"
//       />
//       <path
//         fill="#00000F"
//         d="M168.269 28.473a1.046 1.046 0 1 1 .011 2.091 1.046 1.046 0 0 1-.011-2.09z"
//       />
//       <path
//         fill="#000010"
//         d="M168.269 28.51a1.007 1.007 0 0 1 1.012 1 1.007 1.007 0 1 1-1.012-1z"
//       />
//       <path
//         fill="#001"
//         d="M168.269 28.55a.967.967 0 1 1 .01 1.936.967.967 0 0 1-.01-1.936z"
//       />
//       <path
//         fill="#000012"
//         d="M168.271 28.59a.93.93 0 0 1 .935.923.93.93 0 0 1-.923.935.931.931 0 0 1-.935-.923.93.93 0 0 1 .923-.935z"
//       />
//       <path
//         fill="#000013"
//         d="M168.271 28.627a.89.89 0 1 1 .01 1.78.89.89 0 0 1-.01-1.78z"
//       />
//       <path
//         fill="#000014"
//         d="M168.271 28.667a.85.85 0 1 1 .011 1.7.85.85 0 0 1-.011-1.7z"
//       />
//       <path
//         fill="#000015"
//         d="M168.271 28.704a.812.812 0 0 1 .818.809.812.812 0 1 1-1.627.01.813.813 0 0 1 .809-.819z"
//       />
//       <path
//         fill="#000016"
//         d="M168.271 28.744a.775.775 0 1 1 .008 1.55.775.775 0 0 1-.008-1.55z"
//       />
//       <path
//         fill="#000017"
//         d="M168.271 28.783a.734.734 0 1 1-.732.739.735.735 0 0 1 .732-.739z"
//       />
//       <path
//         fill="#000018"
//         d="M168.271 28.82a.7.7 0 0 1 .702.693c0 .385-.308.7-.692.702a.699.699 0 0 1-.702-.693c0-.384.308-.7.692-.701z"
//       />
//       <path
//         fill="#000019"
//         d="M168.271 28.86a.66.66 0 0 1 .007 1.317.661.661 0 0 1-.662-.655.66.66 0 0 1 .655-.662z"
//       />
//       <path
//         fill="#00001A"
//         d="M168.271 28.898a.62.62 0 0 1 .007 1.237.62.62 0 0 1-.007-1.238z"
//       />
//       <path
//         fill="#00001B"
//         d="M168.271 28.937a.58.58 0 0 1 .583.578.579.579 0 0 1-.578.583.58.58 0 1 1-.005-1.161z"
//       />
//       <path
//         fill="#00001C"
//         d="M168.274 28.977c.298 0 .543.24.545.538 0 .299-.24.543-.538.546a.545.545 0 0 1-.546-.539c0-.298.24-.543.539-.545z"
//       />
//       <path
//         fill="#00001E"
//         d="M168.274 29.014a.504.504 0 1 1 .003 1.007.504.504 0 0 1-.003-1.007z"
//       />
//       <path
//         fill="#00001F"
//         d="M168.274 29.054a.464.464 0 1 1 .005.927.464.464 0 0 1-.005-.927z"
//       />
//       <path
//         fill="#000020"
//         d="M168.274 29.091a.43.43 0 0 1 .429.424.429.429 0 0 1-.425.43.43.43 0 0 1-.429-.425c0-.235.189-.427.425-.429z"
//       />
//       <path
//         fill="#000021"
//         d="M168.274 29.13a.387.387 0 1 1 .003.775.387.387 0 0 1-.003-.774z"
//       />
//       <path
//         fill="#002"
//         d="M168.274 29.17a.348.348 0 1 1 .002.697.348.348 0 0 1-.002-.697z"
//       />
//       <path
//         fill="#000023"
//         d="M168.274 29.208c.17 0 .31.137.312.307 0 .17-.138.31-.308.313a.313.313 0 0 1-.312-.308c0-.17.137-.31.308-.312z"
//       />
//       <path
//         fill="#000024"
//         d="M168.274 29.247a.27.27 0 0 1 .272.27c0 .15-.119.271-.27.273a.273.273 0 0 1-.273-.27c0-.15.119-.27.271-.273z"
//       />
//       <path
//         fill="#000025"
//         d="M168.274 29.285a.232.232 0 1 1 .002.463.232.232 0 0 1-.002-.463z"
//       />
//       <path
//         fill="#000026"
//         d="M168.274 29.324c.107 0 .193.086.193.194a.192.192 0 1 1-.385 0c0-.108.087-.194.194-.194h-.002z"
//       />
//       <path
//         fill="#000028"
//         d="M168.276 29.364c.086 0 .156.067.156.154a.154.154 0 0 1-.154.156.154.154 0 0 1-.156-.154c0-.086.068-.156.154-.156z"
//       />
//       <path
//         fill="#000029"
//         d="M168.276 29.401a.115.115 0 1 1 0 .23.117.117 0 0 1-.117-.116c0-.065.052-.116.115-.116l.002.002z"
//       />
//       <path
//         fill="#00002A"
//         d="M168.276 29.44c.042 0 .077.036.077.078a.078.078 0 0 1-.077.076.078.078 0 0 1-.077-.076c0-.042.035-.077.077-.077z"
//       />
//       <path
//         fill="#00002B"
//         d="M168.276 29.478a.04.04 0 0 1 .04.04c0 .02-.017.04-.038.04a.038.038 0 0 1-.039-.038.04.04 0 0 1 .039-.04l-.002-.002z"
//       />
//     </g>
//   </svg>
// );


export const PreviewFrame = ({ urlLink, ...props }) => (
  <svg
    width={360}
    height={740}
    viewBox="0 0 360 740"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0}
      y={0}
      width={360}
      height={740}
      rx={30}
      ry={30}
      fill="#000000"
      stroke="#333"
      strokeWidth={2}
    />
    <rect
      x={16}
      y={60}
      width={328}
      height={664}
      rx={20}
      ry={20}
      fill="#ffffff"
    />
    <rect
      x={16}
      y={60}
      width={328}
      height={40}
      rx={10}
      ry={10}
      fill="#f5f5f5"
    />
    <text
      x={180}
      y={85}
      textAnchor="middle"
      fill="#888"
      fontFamily="Arial"
      fontSize={14}
    >
      {/* {"\n    https://integratedqr.com\n  "} */}
        {urlLink || "https://integratedqr.com"}

    </text>
    <rect x={150} y={20} width={60} height={5} rx={2.5} fill="#888" />
    <rect x={0} y={100} width={4} height={40} fill="#555" rx={2} />
    <rect x={356} y={140} width={4} height={60} fill="#555" rx={2} />
  </svg>
);


export const TopPreviewHeader = ({ urlLink, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={260}
    height={70}
    viewBox="0 0 262 60"
    fill="none"
    className="injected-svg"
    data-src="/images/phone-previews/browser-mobile.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <path
      opacity={1}
      d="M226.278 0H35.5929C15.9355 0 0 15.8722 0 35.4516V60H261.871V35.4516C261.871 15.8722 245.936 0 226.278 0Z"
      fill="white"
    />
    <rect y={32} width={262} height={28} fill="white" />
    <path
      d="M28.2357 41.7644C27.0119 40.5421 25.2777 39.8372 23.3707 40.0322C20.6154 40.3096 18.3481 42.5442 18.0403 45.2962C17.6274 48.9331 20.4427 52 23.9939 52C26.3888 52 28.4459 50.5978 29.4069 48.5806C29.6471 48.0782 29.2868 47.5008 28.7312 47.5008C28.4534 47.5008 28.1907 47.6508 28.0705 47.8982C27.2222 49.7204 25.1876 50.8752 22.9653 50.3803C21.2986 50.0129 19.9547 48.6556 19.6019 46.9909C18.9712 44.0814 21.186 41.5019 23.9939 41.5019C25.2401 41.5019 26.3513 42.0193 27.1621 42.8367L26.0284 43.969C25.5555 44.4414 25.8858 45.2512 26.554 45.2512H29.2492C29.6622 45.2512 30 44.9138 30 44.5014V41.8094C30 41.142 29.1892 40.8045 28.7162 41.277L28.2357 41.7644Z"
      fill="#BFBFBF"
    />
    <path
      d="M242.5 43.2308C243.325 43.2308 244 42.5038 244 41.6154C244 40.7269 243.325 40 242.5 40C241.675 40 241 40.7269 241 41.6154C241 42.5038 241.675 43.2308 242.5 43.2308ZM242.5 44.8462C241.675 44.8462 241 45.5731 241 46.4615C241 47.35 241.675 48.0769 242.5 48.0769C243.325 48.0769 244 47.35 244 46.4615C244 45.5731 243.325 44.8462 242.5 44.8462ZM242.5 49.6923C241.675 49.6923 241 50.4192 241 51.3077C241 52.1962 241.675 52.9231 242.5 52.9231C243.325 52.9231 244 52.1962 244 51.3077C244 50.4192 243.325 49.6923 242.5 49.6923Z"
      fill="#BFBFBF"
    />
    <rect
      x={40.5}
      y={36.5}
      width={181}
      height={19}
      rx={9.5}
      fill="white"
      stroke="#BFBFBF"
    />
    <text
      x={40.5 + 181 / 2}
      y={36.5 + 19 / 2}
      fill="black"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="10px"
      color="#404040"
    >
      {urlLink
        ? urlLink.length > 25
          ? `${urlLink.slice(0, 25)}...`
          : urlLink
        : "https://integratedqr.com/"}
    </text>

    <path
      d="M33.6859 24C33.5536 24 33.4496 23.9622 33.374 23.8866C33.2984 23.811 33.2606 23.7102 33.2606 23.5842C33.2606 23.4519 33.2984 23.3511 33.374 23.2818C33.4496 23.2125 33.5536 23.1779 33.6859 23.1779H34.8388V18.1505H35.3302L33.9505 19.0293C33.8497 19.086 33.7552 19.1081 33.667 19.0955C33.5851 19.0829 33.5126 19.0482 33.4496 18.9915C33.3929 18.9348 33.352 18.8655 33.3268 18.7836C33.3079 18.7017 33.3142 18.6167 33.3457 18.5285C33.3835 18.4403 33.4496 18.3678 33.5441 18.3111L34.8482 17.489C34.9553 17.426 35.0561 17.3756 35.1506 17.3378C35.2514 17.2937 35.3459 17.2716 35.4341 17.2716C35.5412 17.2716 35.6294 17.3031 35.6987 17.3661C35.7743 17.4228 35.8121 17.5205 35.8121 17.6591V23.1779H36.8705C37.0091 23.1779 37.1162 23.2125 37.1918 23.2818C37.2674 23.3511 37.3052 23.4519 37.3052 23.5842C37.3052 23.7165 37.2674 23.8205 37.1918 23.8961C37.1162 23.9654 37.0091 24 36.8705 24H33.6859ZM41.4811 24.0661C41.3299 24.0661 41.2102 24.0252 41.122 23.9433C41.0338 23.8551 40.9897 23.7354 40.9897 23.5842V22.6487H38.4571C38.2996 22.6487 38.1736 22.614 38.0791 22.5447C37.9846 22.4754 37.9374 22.3683 37.9374 22.2234C37.9374 22.1415 37.9563 22.0533 37.9941 21.9588C38.0382 21.8643 38.1138 21.7415 38.2209 21.5903L40.9708 17.5929C41.0401 17.4858 41.1189 17.4071 41.2071 17.3567C41.2953 17.3 41.3961 17.2716 41.5095 17.2716C41.6418 17.2716 41.7489 17.3126 41.8308 17.3945C41.919 17.4701 41.9631 17.5898 41.9631 17.7536V21.8265H42.5584C42.7096 21.8265 42.8199 21.8612 42.8892 21.9305C42.9648 21.9998 43.0026 22.1006 43.0026 22.2329C43.0026 22.3715 42.9648 22.4754 42.8892 22.5447C42.8199 22.614 42.7096 22.6487 42.5584 22.6487H41.9631V23.5842C41.9631 23.7354 41.919 23.8551 41.8308 23.9433C41.7489 24.0252 41.6323 24.0661 41.4811 24.0661ZM40.9897 21.8265V18.4907H41.2449L38.7784 22.0911V21.8265H40.9897ZM44.0127 24.0378C43.83 24.0378 43.682 23.9811 43.5686 23.8677C43.4552 23.7543 43.3985 23.6094 43.3985 23.433C43.3985 23.2566 43.4552 23.1149 43.5686 23.0078C43.682 22.8944 43.83 22.8377 44.0127 22.8377C44.1954 22.8377 44.3403 22.8944 44.4474 23.0078C44.5545 23.1149 44.6081 23.2566 44.6081 23.433C44.6081 23.6094 44.5545 23.7543 44.4474 23.8677C44.3403 23.9811 44.1954 24.0378 44.0127 24.0378ZM44.0127 20.5508C43.83 20.5508 43.682 20.4941 43.5686 20.3807C43.4552 20.2673 43.3985 20.1255 43.3985 19.9554C43.3985 19.7727 43.4552 19.6278 43.5686 19.5207C43.682 19.4073 43.83 19.3506 44.0127 19.3506C44.1954 19.3506 44.3403 19.4073 44.4474 19.5207C44.5545 19.6278 44.6081 19.7727 44.6081 19.9554C44.6081 20.1255 44.5545 20.2673 44.4474 20.3807C44.3403 20.4941 44.1954 20.5508 44.0127 20.5508ZM48.715 24.0661C48.5638 24.0661 48.4441 24.0252 48.3559 23.9433C48.2677 23.8551 48.2236 23.7354 48.2236 23.5842V22.6487H45.691C45.5335 22.6487 45.4075 22.614 45.313 22.5447C45.2185 22.4754 45.1712 22.3683 45.1712 22.2234C45.1712 22.1415 45.1901 22.0533 45.2279 21.9588C45.272 21.8643 45.3476 21.7415 45.4547 21.5903L48.2047 17.5929C48.274 17.4858 48.3527 17.4071 48.4409 17.3567C48.5291 17.3 48.6299 17.2716 48.7433 17.2716C48.8756 17.2716 48.9827 17.3126 49.0646 17.3945C49.1528 17.4701 49.1969 17.5898 49.1969 17.7536V21.8265H49.7923C49.9435 21.8265 50.0537 21.8612 50.123 21.9305C50.1986 21.9998 50.2364 22.1006 50.2364 22.2329C50.2364 22.3715 50.1986 22.4754 50.123 22.5447C50.0537 22.614 49.9435 22.6487 49.7923 22.6487H49.1969V23.5842C49.1969 23.7354 49.1528 23.8551 49.0646 23.9433C48.9827 24.0252 48.8662 24.0661 48.715 24.0661ZM48.2236 21.8265V18.4907H48.4787L46.0123 22.0911V21.8265H48.2236ZM51.5773 24C51.445 24 51.3411 23.9622 51.2655 23.8866C51.1899 23.811 51.1521 23.7102 51.1521 23.5842C51.1521 23.4519 51.1899 23.3511 51.2655 23.2818C51.3411 23.2125 51.445 23.1779 51.5773 23.1779H52.7302V18.1505H53.2216L51.8419 19.0293C51.7411 19.086 51.6466 19.1081 51.5584 19.0955C51.4765 19.0829 51.4041 19.0482 51.3411 18.9915C51.2844 18.9348 51.2434 18.8655 51.2182 18.7836C51.1993 18.7017 51.2056 18.6167 51.2371 18.5285C51.2749 18.4403 51.3411 18.3678 51.4356 18.3111L52.7397 17.489C52.8468 17.426 52.9476 17.3756 53.0421 17.3378C53.1429 17.2937 53.2374 17.2716 53.3256 17.2716C53.4327 17.2716 53.5209 17.3031 53.5902 17.3661C53.6658 17.4228 53.7036 17.5205 53.7036 17.6591V23.1779H54.762C54.9006 23.1779 55.0077 23.2125 55.0833 23.2818C55.1589 23.3511 55.1967 23.4519 55.1967 23.5842C55.1967 23.7165 55.1589 23.8205 55.0833 23.8961C55.0077 23.9654 54.9006 24 54.762 24H51.5773Z"
      fill="#404040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M191.867 16.6874H191.079C190.644 16.6874 190.292 17.0274 190.292 17.4468V24.0281C190.292 24.4475 190.644 24.7874 191.079 24.7874H191.867C192.302 24.7874 192.654 24.4475 192.654 24.0281V17.4468C192.654 17.0274 192.302 16.6874 191.867 16.6874ZM187.373 18.4594H188.161C188.596 18.4594 188.948 18.7994 188.948 19.2188V24.0282C188.948 24.4475 188.596 24.7875 188.161 24.7875H187.373C186.938 24.7875 186.586 24.4475 186.586 24.0282V19.2188C186.586 18.7994 186.938 18.4594 187.373 18.4594ZM184.455 20.2311H183.667C183.232 20.2311 182.88 20.5711 182.88 20.9905V24.028C182.88 24.4474 183.232 24.7874 183.667 24.7874H184.455C184.89 24.7874 185.242 24.4474 185.242 24.028V20.9905C185.242 20.5711 184.89 20.2311 184.455 20.2311ZM180.749 21.7499H179.961C179.527 21.7499 179.174 22.0898 179.174 22.5092V24.028C179.174 24.4474 179.527 24.7874 179.961 24.7874H180.749C181.184 24.7874 181.536 24.4474 181.536 24.028V22.5092C181.536 22.0898 181.184 21.7499 180.749 21.7499Z"
      fill="#404040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M203.792 18.271C205.457 18.2711 207.058 18.9262 208.265 20.101C208.356 20.1917 208.501 20.1906 208.59 20.0985L209.459 19.2008C209.504 19.1541 209.529 19.0908 209.529 19.0249C209.529 18.9591 209.503 18.8961 209.457 18.8499C206.29 15.7417 201.293 15.7417 198.126 18.8499C198.081 18.8961 198.055 18.959 198.054 19.0249C198.054 19.0907 198.079 19.154 198.124 19.2008L198.993 20.0985C199.082 20.1907 199.228 20.1919 199.319 20.101C200.525 18.9262 202.127 18.271 203.792 18.271ZM203.792 21.1915C204.707 21.1915 205.589 21.5397 206.267 22.1685C206.359 22.2577 206.503 22.2558 206.592 22.1641L207.46 21.2664C207.506 21.2193 207.531 21.1555 207.53 21.0891C207.53 21.0227 207.503 20.9594 207.457 20.9132C205.392 18.9462 202.194 18.9462 200.129 20.9132C200.082 20.9594 200.056 21.0227 200.055 21.0891C200.055 21.1555 200.08 21.2194 200.126 21.2664L200.993 22.1641C201.082 22.2558 201.227 22.2577 201.319 22.1685C201.996 21.5401 202.878 21.1919 203.792 21.1915ZM205.53 23.1567C205.531 23.2232 205.506 23.2874 205.459 23.334L203.958 24.885C203.914 24.9306 203.854 24.9562 203.792 24.9562C203.729 24.9562 203.669 24.9306 203.625 24.885L202.124 23.334C202.078 23.2874 202.053 23.2232 202.054 23.1566C202.055 23.0901 202.083 23.027 202.132 22.9824C203.09 22.1523 204.494 22.1523 205.452 22.9824C205.5 23.0271 205.528 23.0901 205.53 23.1567Z"
      fill="#404040"
    />
    <rect
      opacity={0.4}
      x={215.267}
      y={16.6875}
      width={16.2}
      height={8.1}
      rx={2.3625}
      stroke="#404040"
      strokeWidth={0.675}
    />
    <path
      opacity={0.5}
      d="M232.479 19.3875V22.0875C233.023 21.8588 233.377 21.3268 233.377 20.7375C233.377 20.1481 233.023 19.6161 232.479 19.3875Z"
      fill="#404040"
    />
    <rect
      x={216.279}
      y={17.7}
      width={11.475}
      height={6.075}
      rx={1.35}
      fill="#404040"
    />
    <rect
      x={0.25}
      y={31.25}
      width={261.5}
      height={0.5}
      stroke="#F2F2F2"
      strokeWidth={0.5}
    />
  </svg>
);

export const Step1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 294 220"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M130.46 59.98c-7.76 2.66-16.68 4.1-31.5 9.56-14.83 5.45-31.13 16.09-36.27 47.9-5.14 31.84 8.25 68.21 60.3 86.09 36.42 12.5 83.08.86 113.53-29.67 30.7-30.78 39.81-74.04 37.76-108.73-2.05-34.7-29.38-58.47-51.07-62.75-21.57-4.3-37.32.73-53.13 23.52-15.8 22.78-23.37 28.56-39.5 34.08Z"
        fill="#e0201c"
        opacity={0.8}
      />
      <path
        d="m141.3 53.38-.05-.5.06.5c-3.15.39-6.43.56-10.15.76l-3.47.19c-5.22.3-11.37.76-19.17 1.9-7.77 1.12-16.13 3.43-23.98 9.16-7.85 5.74-15.24 14.93-21.02 29.9-5.76 14.94-7.25 31.93-1.45 48.68s18.92 33.31 42.46 47.39c32.87 19.65 80.71 17.93 116.68-5.55 36.24-23.67 54.04-63.96 59.2-98.23 5.13-34.12-16.56-62.83-36.7-71.42-10.1-4.31-19.2-6.04-28.25-4.35-9.05 1.68-18.12 6.79-28.17 16.26-10.1 9.51-17.4 15.33-24.2 19.02-6.9 3.7-13.3 5.26-21.8 6.3Z"
        stroke="#e0201c"
        opacity={0.8}
      />
      <path
        d="M106.93 119.93a32.9 32.9 0 0 1-32.95 32.86c-43.7-1.8-43.7-64 0-65.8a32.9 32.9 0 0 1 32.95 32.84Z"
        stroke="#e0201c"
        strokeDasharray=".93 4.66"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.4}
      />
      <path
        d="M2.53 44.45h220.98v117.97c0 1.23-1 2.22-2.22 2.22H4.74c-1.22 0-2.2-1-2.2-2.22V44.45Z"
        fill="#fff"
        stroke="#e0201c"
        strokeWidth={0.5}
      />
      <path
        d="M2.28 31.73c0-1.36 1.1-2.46 2.46-2.46H221.3c1.35 0 2.46 1.1 2.46 2.46V44.2H2.28V31.73Z"
        fill="#3C4858"
      />
      <circle fill="#fff" cx={10.06} cy={37.35} r={3.11} />
      <circle fill="#fff" cx={20.55} cy={37.35} r={3.11} />
      <circle fill="#fff" cx={31.04} cy={37.35} r={3.11} />
      <rect
        fill="#e0201c"
        fillOpacity={0.15}
        width={87.53}
        height={34.41}
        x={117.05}
        y={64.61}
        stroke="#e0201c"
        rx={1.25}
      />
      <path
        d="M182.06 86.38c-.43 0-.82-.07-1.16-.2a2.54 2.54 0 0 1-1.4-1.44 2.88 2.88 0 0 1-.2-1.04v-.2c0-.43.06-.81.18-1.16.12-.35.3-.65.51-.9a2.32 2.32 0 0 1 1.9-.8 2.38 2.38 0 0 1 1.71.74c.2.24.37.53.47.86.11.33.17.7.17 1.1v.62h-4.4v-.98h2.95v-.11c0-.2-.04-.4-.11-.55a.87.87 0 0 0-.31-.4.97.97 0 0 0-.56-.13c-.2 0-.36.04-.5.13a1 1 0 0 0-.34.35 2.81 2.81 0 0 0-.27 1.22v.2a1.75 1.75 0 0 0 .37 1.1 1.31 1.31 0 0 0 1 .44c.28 0 .52-.06.75-.16.22-.1.42-.26.6-.47l.7.77a2.55 2.55 0 0 1-2.15 1Zm-5.03-5.64h1.33v5.35c0 .5-.1.93-.33 1.28-.23.36-.54.63-.94.8a3.29 3.29 0 0 1-2.86-.1 1.85 1.85 0 0 1-.58-.49l.65-.87c.17.2.36.36.59.46.12.12.36.17.64.17.27 0 .5-.05.68-.15.2-.1.34-.23.44-.42.1-.18.14-.4.14-.67v-4.08l.16-1.28Zm-3.72 2.83v-.1c0-.43.05-.81.15-1.16.1-.34.25-.64.44-.9a2.03 2.03 0 0 1 1.64-.77c.37 0 .68.06.93.2s.46.33.62.58c.16.25.28.55.37.89.1.34.16.7.21 1.1v.24c-.05.4-.13.75-.23 1.08-.1.33-.23.62-.4.87a1.71 1.71 0 0 1-1.5.77 2.02 2.02 0 0 1-1.63-.8c-.2-.24-.35-.54-.45-.88-.1-.34-.16-.71-.16-1.12Zm1.47-.1v.1a2.34 2.34 0 0 0 .26 1.17c.1.15.22.27.36.35a1 1 0 0 0 .5.12c.28 0 .5-.05.67-.16.17-.12.3-.28.38-.48.09-.2.14-.43.15-.7v-.67a2 2 0 0 0-.09-.57 1.37 1.37 0 0 0-.21-.45.93.93 0 0 0-.36-.28c-.15-.07-.32-.1-.52-.1s-.36.04-.5.13a1 1 0 0 0-.36.35c-.1.15-.16.33-.21.53-.05.2-.07.42-.07.66Zm-3.87 1.56v-2.47a.95.95 0 0 0-.1-.46.65.65 0 0 0-.26-.3.9.9 0 0 0-.47-.1c-.16 0-.3.02-.42.08a.62.62 0 0 0-.28.24c-.06.1-.1.23-.1.37h-1.47a1.54 1.54 0 0 1 .64-1.23c.2-.17.46-.3.74-.39a3.2 3.2 0 0 1 2.12.08c.34.14.6.36.8.65.2.28.28.64.28 1.07v3.12c0 .2.1.35.13.5v.08h-1.47a2.13 2.13 0 0 1-.16-.56 4.65 4.65 0 0 1-.05-.68Zm.2-2.13.1.84h-.81c-.2 0-.37.02-.5.06a.94.94 0 0 0-.36.2.74.74 0 0 0-.27.62c0 .12.04.24.1.34.06.1.14.18.25.23.1.06.24.1.38.1a1.18 1.18 0 0 0 .96-.47.66.66 0 0 0 .13-.37l.4.62a2.6 2.6 0 0 1-.6.86c-.13.13-.3.24-.5.32a2.16 2.16 0 0 1-1.67-.09 1.54 1.54 0 0 1-.93-1.45c0-.28.05-.54.16-.76.1-.23.27-.42.48-.57.2-.16.48-.28.8-.35.32-.09.7-.13 1.12-.13h.85Zm-10.7-1.02v4.4h-1.47v-5.54h1.38l.09 1.14Zm-.2 1.43h-.4c0-.38.04-.74.13-1.06.1-.33.24-.6.42-.85a1.9 1.9 0 0 1 1.6-.76c.27 0 .49.03.7.1a1.45 1.45 0 0 1 .87.95c.09.25.13.55.13.9v3.68h-1.48v-3.53c0-.25-.03-.44-.1-.58a.58.58 0 0 0-.3-.29 1.1 1.1 0 0 0-.43-.08 1 1 0 0 0-.5.12 1 1 0 0 0-.34.33c-.1.13-.17.3-.2.48-.06.18-.1.38-.1.6Zm3.3-.17-.53.07c0-.36.05-.7.13-1 .1-.32.23-.6.4-.83a2.03 2.03 0 0 1 1.6-.75c.27 0 .5.05.73.12a1.45 1.45 0 0 1 .9 1.01c.09.27.13.6.13.98v3.53h-1.48v-3.53c0-.26-.03-.45-.1-.58a.54.54 0 0 0-.3-.29 1.08 1.08 0 0 0-.43-.08.97.97 0 0 0-.8.4 1 1 0 0 0-.2.4c-.03.1-.05.3-.05.5Zm-5.91-4.32v7.45h-1.6v-7.45h1.54Z"
        fill="#e0201c"
      />
      <path
        d="M129.46 76.27a.8.8 0 0 0-.8.8v11.19c0 .44.37.8.8.8h14.16a.8.8 0 0 0 .8-.8v-11.2a.8.8 0 0 0-.8-.8h-14.16Zm-2.1.8c0-1.16.94-2.1 2.1-2.1h14.16c1.16 0 2.1.94 2.1 2.1v11.19a2.1 2.1 0 0 1-2.1 2.1h-14.16a2.1 2.1 0 0 1-2.1-2.1v-11.2Z"
        fill="#e0201c"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="m133 80.1 8.54 9.23-.96.9-7.53-8.14-4.53 5.4-1-.9 5.48-6.5Z"
        fill="#e0201c"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="m140.04 81.72 5.5 5.48-.94.93-4.48-4.48-2.17 2.51-1-.85 3.1-3.6Z"
        fill="#e0201c"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M140.35 80.08a1.26 1.26 0 1 0 0-2.52 1.26 1.26 0 0 0 0 2.52Z"
        fill="#e0201c"
      />
      <rect
        width={88.03}
        height={34.91}
        x={21.19}
        y={106.85}
        stroke="#e0201c"
        strokeWidth={0.5}
        rx={1.5}
      />
      <path
        d="M71.44 120.47v7.45h-1.53v-7.45h1.53Zm2.97 3.18v1.2h-3.38v-1.2h3.38Zm.36-3.18v1.2h-3.74v-1.2h3.74Zm-9.39 7.45h-1.62l.01-1.2h1.6c.4 0 .76-.09 1.03-.27.28-.18.49-.45.63-.8.14-.35.2-.78.2-1.27V124c0-.37-.03-.7-.11-1a2 2 0 0 0-.35-.73c-.16-.2-.35-.34-.58-.44a2 2 0 0 0-.8-.16h-1.66v-1.2h1.67c.5 0 .95.09 1.37.26a3.1 3.1 0 0 1 1.78 1.84 4 4 0 0 1 .25 1.45v.36c0 .52-.09 1-.25 1.44a3.12 3.12 0 0 1-1.78 1.85c-.42.17-.88.25-1.39.25Zm-.75-7.45v7.45H63.1v-7.45h1.53Zm-5.39 4.8h-1.9v-1.2h1.9c.3 0 .54-.05.72-.14.18-.1.32-.24.4-.41a1.5 1.5 0 0 0 0-1.2.97.97 0 0 0-.4-.47 1.33 1.33 0 0 0-.72-.17h-1.36v6.24h-1.54v-7.45h2.9c.59 0 1.09.1 1.5.32a2.26 2.26 0 0 1 1.3 2.13 2.16 2.16 0 0 1-1.3 2.06c-.41.19-.91.29-1.5.29Z"
        fill="#e0201c"
      />
      <g fill="#e0201c" clipPath="url(#b)">
        <path
          d="M30.96 132.62v-2.5h1.31v2.5c0 .04.04.07.07.07h12.87c.04 0 .07-.03.07-.07v-2.5h1.31v2.5c0 .77-.63 1.38-1.38 1.38H32.34c-.77 0-1.38-.63-1.38-1.38Zm1.87-15.66c-.3 0-.55.25-.55.55v4.42h-1.31v-4.3c0-1.04.84-1.88 1.86-1.88h9.28c.5 0 .97.2 1.32.55l2.88 2.88c.3.28.45.67.45 1.09v1.66h-1.3v-1.66a.23.23 0 0 0-.07-.16l-2.89-2.88a.56.56 0 0 0-.39-.16h-9.28Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path d="M35.75 123.43c-.15-.16-.33-.3-.55-.4a2 2 0 0 0-.8-.14h-2.42v6.17h1.62v-2.35h.56c.67 0 1.17-.16 1.5-.48.35-.32.52-.8.52-1.44 0-.27-.03-.52-.1-.75a1.52 1.52 0 0 0-.33-.6Zm-1.38 1.93a.59.59 0 0 1-.46.2h-.31v-1.5h.3c.4 0 .62.24.62.74 0 .26-.05.45-.15.56Zm2.54-2.47v6.17h2.33c.47 0 .83-.09 1.09-.26.25-.17.46-.4.59-.68.12-.29.2-.6.23-.98a13.63 13.63 0 0 0 0-2.33 3 3 0 0 0-.23-.98 1.52 1.52 0 0 0-.6-.69 1.98 1.98 0 0 0-1.08-.25H36.9Zm2.51 1.5c.05.13.09.32.1.58a23.53 23.53 0 0 1 0 2 1.9 1.9 0 0 1-.1.6.5.5 0 0 1-.21.27.9.9 0 0 1-.38.07h-.32v-3.87h.32a1 1 0 0 1 .38.06c.1.06.16.14.2.28Zm4.27 2.13h1.91v-1.26h-1.9v-1.06h2.04v-1.31h-3.66v6.17h1.61v-2.54Z" />
      </g>
      <rect
        fill="#fff"
        width={88.03}
        height={34.91}
        x={21.19}
        y={64.36}
        stroke="#e0201c"
        strokeWidth={0.5}
        rx={1.5}
      />
      <path
        d="M80.23 84.7v-4.22h1.48v5.54h-1.4V84.7Zm.17-1.14.43-.01c0 .37-.04.7-.13 1.03-.08.31-.2.58-.38.82a1.8 1.8 0 0 1-1.56.72c-.27 0-.52-.04-.75-.11-.22-.08-.42-.2-.58-.36a1.76 1.76 0 0 1-.38-.64 2.97 2.97 0 0 1-.13-.95v-3.58h1.47v3.6c0 .15.02.3.06.4.04.12.1.2.17.28.07.07.15.12.25.15s.2.05.32.05c.3 0 .55-.06.72-.18.18-.13.3-.3.37-.5.08-.22.12-.46.12-.72Zm-7.87-1.9v4.36h-1.48v-5.53h1.39l.09 1.18Zm-.22 1.4h-.4c0-.41.06-.78.16-1.1.1-.34.26-.62.45-.85a1.91 1.91 0 0 1 1.57-.73c.26 0 .5.04.7.12.22.07.4.2.56.35.16.17.28.38.36.65.08.27.13.6.13 1v3.52h-1.5V82.5c0-.25-.02-.44-.1-.58a.57.57 0 0 0-.29-.28 1.18 1.18 0 0 0-.48-.1 1.03 1.03 0 0 0-.87.45c-.1.1-.17.3-.22.4a2.9 2.9 0 0 0-.07.6Zm-4.33 3.06a3.1 3.1 0 0 1-1.16-.2 2.54 2.54 0 0 1-1.6-2.48v-.2c0-.42.06-.8.18-1.15a3 3 0 0 1 .5-.9c.23-.27.5-.46.83-.6.32-.14.68-.2 1.08-.2s.74.06 1.05.19c.3.13.55.3.76.55.2.24.36.52.47.86.1.33.16.7.16 1.1v.62h-4.4v-.98h2.95v-.12c0-.2-.04-.38-.1-.54a.87.87 0 0 0-.34-.4 1.06 1.06 0 0 0-.56-.14c-.2 0-.36.05-.5.13a1 1 0 0 0-.35.36c-.08.15-.15.33-.2.54-.03.2-.05.43-.05.68v.2c0 .22.03.43.1.62a1.33 1.33 0 0 0 .7.8c.15.07.34.1.56.1a1.6 1.6 0 0 0 1.34-.62l.72.78a2.54 2.54 0 0 1-1.2.86c-.27.1-.59.14-.94.14Zm-10.94-7.55h1.3l1.92 5.47 1.91-5.47h1.3l-2.7 7.45h-1.03l-2.7-7.45Zm-.7 0h1.3l.23 5.33v2.12h-1.53v-7.45Zm6.54 0h1.3v7.45h-1.54V83.9l.24-5.33Z"
        fill="#e0201c"
      />
      <g
        fill="#e0201c"
        fillRule="evenodd"
        clipPath="url(#c)"
        clipRule="evenodd"
      >
        <path d="M34.07 73.74h9.71l.84 3.94a5.82 5.82 0 1 1-11.39 0l.84-3.94Zm1.06 1.31-.62 2.9a4.5 4.5 0 1 0 8.82 0l-.6-2.9h-7.6Z" />
        <path d="M38.27 90.44v-6.39h1.31v6.4h-1.3Z" />
        <path d="M43.1 91.1h-8.35v-1.3h8.35v1.31Zm.88-12.05h-10.1v-1.31h10.1v1.3Z" />
      </g>
      <rect
        width={88.03}
        height={34.91}
        x={116.8}
        y={106.85}
        stroke="#e0201c"
        strokeWidth={0.5}
        rx={1.5}
      />
      <path
        d="M138.41 119.7h2.44a5.13 5.13 0 1 1 0 10.26h-2.44v-1.75h2.44a3.39 3.39 0 1 0 0-6.77h-2.44v-1.75Zm-11.27 5.13a5.13 5.13 0 0 1 5.13-5.14h2.47v1.75h-2.47a3.38 3.38 0 1 0 0 6.78h2.47v1.74h-2.47a5.13 5.13 0 0 1-5.13-5.13Z"
        fill="#e0201c"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M141.15 125.7h-9.17v-1.74h9.17v1.74Z"
        fill="#e0201c"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M171.56 120.48v7.86h-1.47v-7.86h1.47Zm3.49 2.32-2.4 2.75-1.3 1.3-.53-1.06 1.02-1.3 1.44-1.8h1.77Zm-1.53 5.54-1.64-2.56 1.02-.89 2.32 3.45h-1.7Zm-7.86-4.35v4.3h-1.48v-5.58h1.38l.1 1.18Zm-.22 1.3h-.4c0-.4.06-.79.16-1.1.1-.35.26-.63.45-.86a1.9 1.9 0 0 1 1.57-.73c.26 0 .5.04.7.12.22.07.4.2.56.35.16.17.28.38.36.65.08.27.13.6.13 1v3.52h-1.5v-3.53c0-.25-.02-.44-.1-.58a.58.58 0 0 0-.3-.28c-.12-.06-.3-.1-.47-.1a1.03 1.03 0 0 0-.88.45 2.35 2.35 0 0 0-.28 1.08Zm-2.44-2.5v5.52h-1.48v-5.53H163Zm-1.57-1.46a.7.7 0 0 1 .22-.53.85.85 0 0 1 .6-.2c.25 0 .45.06.6.2.16.14.23.32.23.53 0 .22-.07.4-.23.53a.84.84 0 0 1-.6.22.85.85 0 0 1-.6-.22.7.7 0 0 1-.22-.53Zm-.78 5.78v1.2h-3.74v-1.2h3.75Zm-3.25-6.25v7.45h-1.53v-7.45h1.53Zm70.41 82.4.02 3.7-.58.01-.01-3.72h.57Zm9.56-.06.01 3.72h-.57l-.02-3.72h.58Zm24.51-.08 2.26 6.62-.54.18-2.26-6.6.54-.2Zm9.47-3.23 2.26 6.61-.55.2-2.26-6.6.55-.2Z"
        fill="#e0201c"
      />
      <path
        d="m237.84 216.54-26.67.17c0-.3.05-.6.12-1 .6-2.8 3.3-3.6 8.14-6 5.68-2.84 7.66-4.64 9.65-3.31.93.6.85 1.24 1.86 1.7 2.6 1.2 4.77-2.03 6.21-1.18.9.52 1.57 2.68.7 9.72Z"
        fill="#e0201c"
      />
      <path
        d="m210.82 217.08 27.32-.17.04-.32c1-8-.02-9.6-.87-10.1-.8-.46-1.68.01-2.62.52-1.1.6-2.31 1.25-3.62.65a2.07 2.07 0 0 1-.9-.77 3.52 3.52 0 0 0-.91-.9c-1.7-1.14-3.34-.25-6.6 1.52-.97.53-2.07 1.14-3.4 1.8-.81.42-1.6.8-2.27 1.12-3.45 1.67-5.52 2.67-6.05 5.2-.07.36-.11.72-.12 1.08v.37Zm26.71-.91-26 .16c.03-.18.05-.36.1-.54.44-2.2 2.29-3.1 5.65-4.7a118 118 0 0 0 2.3-1.2c1.32-.68 2.42-1.28 3.4-1.8 3.12-1.7 4.56-2.48 5.92-1.57.3.2.55.45.75.75.25.34.52.7 1.15.98 1.6.74 3.05-.04 4.2-.66.81-.44 1.51-.8 1.98-.54.58.34 1.4 1.97.55 9.03Z"
        fill="#e0201c"
      />
      <path d="m230.14 211.96-1.16-.7-2.03 5.3 1.16.7 2.1-5.3Z" fill="#fff" />
      <path
        d="m228.25 217.67 2.24-5.84-1.66-1-2.24 5.85 1.66.99Zm1.53-5.59-1.82 4.74-.66-.39 1.82-4.74.66.4Z"
        fill="#e0201c"
      />
      <path
        d="m232.97 211.3-1.16-.69-2.44 6.36 1.16.7 2.44-6.37Z"
        fill="#fff"
      />
      <path
        d="m230.68 218.08 2.64-6.9-1.66-.99-2.65 6.9 1.67 1Zm1.93-6.65-2.23 5.8-.66-.38 2.23-5.8.66.38Z"
        fill="#e0201c"
      />
      <path
        d="m236.8 219.14-26.54.27a1.4 1.4 0 0 1-1.43-1.4v-.61a1.41 1.41 0 0 1 1.4-1.43l26.54-.26c.78 0 1.42.62 1.43 1.4v.6a1.4 1.4 0 0 1-1.4 1.43Z"
        fill="#fff"
      />
      <path
        d="M210.98 220h.01l26.55-.17a1.7 1.7 0 0 0 1.69-1.7v-.62a1.7 1.7 0 0 0-1.71-1.69l-26.55.17a1.7 1.7 0 0 0-1.7 1.7v.62a1.7 1.7 0 0 0 1.7 1.69Zm26.55-.75-26.54.17a1.13 1.13 0 0 1-.8-.32 1.12 1.12 0 0 1-.33-.79v-.61a1.12 1.12 0 0 1 1.1-1.13l26.56-.17a1.12 1.12 0 0 1 1.13 1.11v.62a1.12 1.12 0 0 1-1.11 1.12Zm-13.82-6.74c0-.02.33-2.8-2.38-3.7l-.14.5c2.2.77 2 3.04 2 3.13l.5.07Zm-2.98 1.03c0-.03.33-2.81-2.38-3.71l-.15.5c2.3.77 2.05 3.04 2.04 3.13l.49.08Z"
        fill="#e0201c"
      />
      <path
        d="M234 216.43c0-.06.23-5.48 4.25-6.61l-.12-.52c-4.4 1.24-4.62 7.05-4.63 7.1l.5.03Z"
        fill="#e0201c"
      />
      <path
        d="m261.93 216.42 26.66-.08a5.47 5.47 0 0 0-.2-1c-.63-2.82-3.35-3.58-8.2-6-5.7-2.8-7.7-4.6-9.7-3.25-.9.62-.83 1.25-1.83 1.73-2.6 1.22-4.8-2-6.23-1.13-.9.54-1.55 2.7-.6 9.73Z"
        fill="#e0201c"
      />
      <path
        d="M288.94 216.32a5.5 5.5 0 0 0-.13-1.07c-.55-2.52-2.64-3.5-6.1-5.13l-2.3-1.1c-1.3-.66-2.4-1.25-3.4-1.77-3.2-1.74-4.9-2.62-6.6-1.47-.3.25-.6.56-.9.92-.2.3-.4.55-.8.78-1.3.6-2.54-.04-3.62-.62-.95-.5-1.84-.97-2.63-.5-.85.52-1.85 2.12-.77 10.1l.03.33 27.3-.18v-.37Zm-26.24-9.3c.47-.3 1.17.08 1.98.5 1.17.62 2.61 1.39 4.2.63.64-.3.9-.65 1.16-1 .2-.28.44-.54.73-.74 1.36-.93 2.8-.16 5.93 1.5 1 .53 2.1 1.13 3.43 1.78l2.31 1.1c3.37 1.6 5.23 2.47 5.7 4.63l.1.54-26 .08c-.93-7.04-.1-8.68.46-9.03Z"
        fill="#e0201c"
      />
      <path
        d="m269.58 211.77 1.16-.7 2.08 5.27-1.15.7-2.09-5.27Z"
        fill="#fff"
      />
      <path
        d="m271.52 217.46 1.66-1-2.3-5.82-1.65 1 2.3 5.82Zm.94-1.25-.65.4-1.87-4.72.66-.5 1.86 4.72Z"
        fill="#e0201c"
      />
      <path d="m266.75 211.14 1.15-.7 2.5 6.33-1.15.7-2.5-6.33Z" fill="#fff" />
      <path
        d="m269.1 217.9 1.66-1-2.7-6.88-1.67 1 2.72 6.88Zm.95-1.25-.66.4-2.28-5.79.65-.4 2.29 5.8Z"
        fill="#e0201c"
      />
      <path
        d="m262.25 215.99 26.55-.08c.78 0 1.4.62 1.41 1.4v.62c0 .77-.62 1.4-1.4 1.4l-26.55.1c-.78 0-1.4-.63-1.42-1.41v-.62c0-.77.63-1.4 1.4-1.4Z"
        fill="#fff"
      />
      <path
        d="m262.25 219.72 26.56-.09a1.7 1.7 0 0 0 1.69-1.7v-.61a1.7 1.7 0 0 0-1.7-1.7l-26.55.09a1.7 1.7 0 0 0-1.7 1.7v.61a1.7 1.7 0 0 0 1.7 1.7Zm26.55-3.52a1.12 1.12 0 0 1 1.12 1.11v.62a1.12 1.12 0 0 1-1.12 1.12l-26.55.08a1.12 1.12 0 0 1-1.12-1.1v-.62a1.1 1.1 0 0 1 .33-.8 1.12 1.12 0 0 1 .8-.23l26.54-.08Zm-12.8-3.93c0-.03-.35-2.81 2.35-3.74l.15.5a2.9 2.9 0 0 0-2 3.16l-.5.08Zm3 .99c0-.03-.36-2.8 2.34-3.73l.15.5c-2.3.8-2.01 3.06-2 3.15l-.5.08Z"
        fill="#e0201c"
      />
      <path
        d="M265.77 216.28c0-.06-.28-5.48-4.32-6.57l.11-.52c4.4 1.2 4.7 7 4.7 7.06l-.5.03Z"
        fill="#e0201c"
      />
      <path
        d="M185.61 86.7c.08.01.13.04.15.02.03-.04-.44-.26-.52-.62-.08-.33.17-.79.51-.92.5-.18 1.13.33 1.15.3.02-.03-.7-.3-.75-.74-.03-.27.18-.48.22-.53.37-.38.98-.21 1-.2.45.2.73.6.72.6-.05.1-2.97-2.2-2.53-3.4a.7.7 0 0 1 .35-.32c.55-.25 1.33.48 3 1.98.4.38 1.18 1.09 2.22 2.03-.12-.6-.32-1.96.45-2.95.1-.15.46-.6.76-.52.36.09.4.86.53 1.6a9.03 9.03 0 0 0 1.8 3.78 9.05 9.05 0 0 0 2.37 2.22l-2.96 6.86c-.25-.32-.68-.86-1.26-1.48a28.05 28.05 0 0 0-5.76-4.6c-.46-.22-2.2-1.08-2.26-2.2a.8.8 0 0 1 .17-.57.72.72 0 0 1 .64-.23Z"
        fill="#fff"
      />
      <path
        d="m194.15 96.35 3.25-7.54-.2-.1a8.82 8.82 0 0 1-2.3-2.1 8.83 8.83 0 0 1-1.75-3.63l-.07-.46c-.1-.7-.2-1.27-.67-1.4-.47-.1-.9.44-1.06.64-.56.72-.67 1.6-.62 2.38l-1.64-1.5-.06-.05c-1.73-1.58-2.53-2.3-3.24-1.98a1 1 0 0 0-.5.55c-.3.8.54 1.87 1.34 2.65-.17.05-.34.15-.47.29a.95.95 0 0 0-.3.75l.02.1a.91.91 0 0 0-.23.05c-.47.17-.8.77-.69 1.25.03.1.08.22.14.3a.98.98 0 0 0-.59 1.06c.05.86.86 1.68 2.43 2.45.21.12 3.2 1.88 5.68 4.52.44.46.85.96 1.24 1.46l.3.4Zm2.52-7.32-2.66 6.2c-.3-.39-.64-.76-.98-1.13a27.98 27.98 0 0 0-5.82-4.63h-.02c-1.79-.9-2.09-1.63-2.1-1.98a.54.54 0 0 1 .1-.37.45.45 0 0 1 .36-.14l.06-.28-.06.28.05.01c.22 0 .34-.1.4-.1a.34.34 0 0 0-.17-.5c-.1-.1-.28-.3-.3-.4a.6.6 0 0 1 .32-.6c.26-.1.66.11.81.2a.39.39 0 0 0 .32.08l.12-.04.06-.1c.06-.12.08-.3-.2-.46-.12-.06-.5-.26-.52-.46a.4.4 0 0 1 .14-.3c.2-.2.51-.17.65-.14.36.3.63.5.64.5.2.14.34.08.42 0l.12-.1-.04-.17c-.04-.16-.4-.6-.9-.76-.78-.7-1.86-1.86-1.64-2.46a.4.4 0 0 1 .2-.23c.37-.17 1.26.65 2.61 1.88l.06.05 2.24 2.03.66.6-.19-.87c-.13-.65-.26-1.86.4-2.7.32-.43.45-.43.46-.43.1.07.2.6.23.9l.08.5c.35 1.84 1.3 3.11 1.85 3.9a9.32 9.32 0 0 0 2.25 2.12Z"
        fill="#e0201c"
      />
      <path
        d="M268.89 122.97c.21.75.29 1.53.23 2.31a6 6 0 0 1-.1 1.04c-.07.4-.16.74-.22 1-.05.27-.03.42.05.5.2.22.8-.08 1.17-.36.77-.63.9-1.72.93-2.16.47.9.84 1.63 1.1 2.16.86 1.73 1.29 2.74 1.8 2.68a.5.5 0 0 0 .26-.13c.83-.75-.8-3.9-.74-3.94.1.16.18.32.25.48 1 2.26 1.52 3.4 2.15 3.44a.5.5 0 0 0 .39-.1c.5-.4-.08-2-.42-2.9-.32-.9-.65-1.5-.6-1.5.05-.08.45.6.7 1 .73 1.2.95 1.84 1.3 1.83.19 0 .3-.2.35-.24.74-1.04-1.48-4.09-1.44-4.12.03 0 .57 1.34 1.4 1.4.06 0 .3.01.44-.14.25-.3-.17-1.04-.51-1.6-1.42-2.28-2.76-3.2-3.98-5.24-.3-.5-.5-.9-.6-1.13l-4.36 4.53c.18.35.34.71.45 1.1Z"
        fill="#fff"
      />
      <path
        d="M273.8 130.43a.7.7 0 0 0 .1 0 .8.8 0 0 0 .4-.2c.24-.2.34-.53.34-.9.37.6.7.91 1.11.95a.78.78 0 0 0 .6-.16c.41-.35.34-1.08.1-1.94.22.35.42.53.72.52.14 0 .36-.07.56-.36.43-.6.13-1.61-.37-2.62l.08.01c.38.03.57-.11.68-.23.36-.43-.03-1.18-.5-1.93a21.05 21.05 0 0 0-2.1-2.76 13.99 13.99 0 0 1-2.47-3.5l-.17-.35-4.8 4.98.1.18a6.18 6.18 0 0 1 .66 3.17v.1a7.64 7.64 0 0 1-.3 1.98c-.06.25-.1.56.1.77.41.42 1.27-.1 1.56-.34.5-.4.76-.97.9-1.5l.7 1.4.25.52c.75 1.5 1.14 2.3 1.75 2.3Zm-.42-4.65a.3.3 0 0 0-.1.02l-.12.04-.05.12c-.06.12-.04.17.12.55 1 2.44.92 3.18.69 3.4a.22.22 0 0 1-.1.04c-.26.02-.74-.96-1.25-2l-.26-.53c-.35-.72-.72-1.45-1.1-2.17l-.48-.9-.06 1.03c-.04.5-.2 1.43-.84 1.95a1.7 1.7 0 0 1-.77.38c0-.08 0-.17.03-.25l.07-.33.15-.66c.06-.36.1-.72.1-1.08v-.09a6.85 6.85 0 0 0-.63-3.27l3.93-4.08.43.78c.62 1.04 1.26 1.77 1.94 2.56.68.78 1.34 1.55 2.05 2.68.65 1.04.54 1.23.53 1.25 0 0-.05.04-.2.03-.14 0-.38-.1-.7-.47l-.36-.6-.07-.1a.33.33 0 0 0-.2-.2l-.12-.05-.22.12-.03.12a.3.3 0 0 0 0 .12 4.78 4.78 0 0 0 .53.87c1.22 2.02 1.14 2.74.96 3-.08.1-.12.1-.12.1-.1 0-.33-.42-.54-.79l-.51-.89-.43-.69c-.23-.33-.4-.58-.65-.44-.27.14-.17.35.03.8.12.27.28.63.44 1.05.56 1.5.73 2.36.5 2.55a.27.27 0 0 1-.18.03c-.47-.05-1.08-1.4-1.9-3.28h-.12l-.21-.45c-.08-.18-.18-.2-.28-.2Z"
        fill="#e0201c"
      />
      <path
        d="M234.81 76.32a3.9 3.9 0 0 1-2.2-1.82c-.37-.7-.51-1.5-.41-2.27-.32-.13-.72-.35-.75-.65-.03-.35.45-.6.74-.86.93-.8.7-2.2.84-3.44.2-1.63 1.1-3.66 2.56-4.62 1.73-1.14 4.46-.76 6.17.58 2.7 2.11 2.2 6.3 1.3 8.6a9.3 9.3 0 0 1-3.39 4.2l.65 5.17a4.03 4.03 0 0 1-2.7 1.36 4.1 4.1 0 0 1-3.74-2.16l.93-4.1Z"
        fill="#fff"
      />
      <path
        d="m237.41 82.87.23-.01a4.3 4.3 0 0 0 2.9-1.45l.08-.1-.65-5.14a9.52 9.52 0 0 0 3.35-4.22c.81-2.07 1.57-6.61-1.39-8.94-1.9-1.49-4.75-1.75-6.5-.6-1.6 1.05-2.5 3.24-2.69 4.84-.03.3-.05.63-.06.93-.04.93-.07 1.8-.68 2.32l-.2.17c-.3.23-.68.51-.64.94.03.31.27.58.73.8a4.04 4.04 0 0 0 2.58 4.1l-.9 4 .06.1a4.44 4.44 0 0 0 3.78 2.3Zm2.6-1.75a3.7 3.7 0 0 1-2.4 1.16 3.82 3.82 0 0 1-3.4-1.91l1-4.24-.21-.08a3.58 3.58 0 0 1-2.04-1.68 3.54 3.54 0 0 1-.4-2.1l.04-.22-.2-.09c-.55-.22-.58-.38-.58-.4-.01-.12.23-.3.39-.43l.25-.2c.8-.68.82-1.72.86-2.72l.04-.9c.17-1.4 1-3.4 2.43-4.4 1.56-1 4.12-.7 5.83.6 2.7 2.1 1.97 6.39 1.2 8.3a9 9 0 0 1-3.28 4.09l-.14.1.64 5.22Z"
        fill="#e0201c"
      />
      <path
        d="M244.9 203.82c-.8-18.54-1.62-37.07-2.43-55.6L255 203.76l23.64-.22-24.88-85.28-30.05.96-2.7 84.7 23.9-.11Z"
        fill="#e0201c"
      />
      <path
        d="M191.98 95.53a55.2 55.2 0 0 0 11.29 9.66c2.26 1.45 3.92 2.5 5.7 3.14.77.28 1.56.48 2.38.6 1.75.24 3.54.15 5.26-.27a20.3 20.3 0 0 0 7.7-3.94l-2.2 12.05a2.85 2.85 0 0 0 2.9 3.35l27.9-.54a2.85 2.85 0 0 0 2.55-3.98l-1.92-4.34 13.7 12.45 9.2-6.17a288.02 288.02 0 0 0-19.4-24.2 138.71 138.71 0 0 0-11.68-11.45 124.75 124.75 0 0 0-5.05-4.11 3.92 3.92 0 0 1-2.76 1.24c-2.07.02-3.2-1.74-3.28-1.84a394.42 394.42 0 0 1-24.4 15.44L196.9 87l-4.96 8.53Z"
        fill="#fff"
      />
      <path
        d="m267.13 124.08.19-.13 6.8-4.55 2.65-1.78-.17-.25c-3.78-5.23-11.33-15.34-19.44-24.2a141.13 141.13 0 0 0-11.7-11.5c-1.66-1.41-3.36-2.8-5.05-4.12l-.21-.16-.18.2a3.64 3.64 0 0 1-2.56 1.15h-.02c-1.91 0-2.97-1.65-3.01-1.72l-.16-.25-.25.17a379.44 379.44 0 0 1-24.26 15.36l-12.96-5.67-5.17 8.94.14.16a55.3 55.3 0 0 0 11.34 9.7c2.42 1.56 4 2.55 5.76 3.18.79.28 1.6.48 2.44.6 1.79.25 3.6.16 5.37-.27 2.42-.6 4.9-1.8 7.2-3.53l-2.07 11.31a3.13 3.13 0 0 0 3.14 3.7l27.87-.54a3.13 3.13 0 0 0 2.8-4.4l-1.36-3.1 12.87 11.7Zm8.82-6.6-2.15 1.43-6.62 4.43-14.54-13.2 2.45 5.58a2.56 2.56 0 0 1-2.29 3.58l-27.86.54a2.56 2.56 0 0 1-2.56-3.01l2.35-12.82-.6.5a19.78 19.78 0 0 1-7.59 3.9c-1.68.49-3.43.5-5.15.3-.8-.1-1.57-.3-2.33-.6-1.7-.56-3.25-1.53-5.64-3.06a55.17 55.17 0 0 1-11.09-9.45l4.7-8.12L209.8 93l.12-.08a373.92 373.92 0 0 0 24.2-15.3 4.33 4.33 0 0 0 3.32 1.75h.03a4.18 4.18 0 0 0 2.78-1.15c1.63 1.26 3.25 2.59 4.82 3.94 3.66 3.15 7.7 7.1 11.66 11.44 7.97 8.7 15.4 18.63 19.22 23.92Zm-43.77-54.76c0 .14-.01 1.4.82 2.3 1 1.07 1.98.68 2.9 1.73 1.05 1.2.75 2.97 1.16 3 .37.01.44-1.4 1.19-1.58.52-.1 1.23.41 1.4 1.06.16.63-.24 1.17-.41 1.42-.5.7-.92.53-1.4 1.07-.74.87-.6 2.36-.17 3.33.2.46.4.88.78 1.1 1.58.91 5.1-1.73 7.02-4.6 1.16-1.74 2.65-3.96 1.8-6.4-.93-2.63-3.88-3.53-4.3-3.66-.2-.4-1.5-3-4.16-3.5-3.2-.59-6.58 2.2-6.63 4.63Zm1.65 7.24c-.25-.09-.36-.43-.24-.75.12-.33.4-.52.66-.43.25.09.36.43.25.75-.12.33-.42.52-.67.43Z"
        fill="#e0201c"
      />
      <path
        d="M235.1 68.03a.17.17 0 0 0 .16-.1l.01-.06a.17.17 0 0 0-.04-.13 1.4 1.4 0 0 0-1.66-.36.17.17 0 0 0-.09.23c.02.04.06.07.1.1h.13a1.06 1.06 0 0 1 1.26.26.18.18 0 0 0 .13.06Zm2.87 1.52c-.03.2.17.27.16.5-.01.31-.33.49-.3.55.05.1 1.1-.18 1.18-.8.03-.28-.13-.66-.43-.7a.6.6 0 0 0-.61.45Zm20.5 39.31a3.92 3.92 0 1 1 0-7.83 3.92 3.92 0 0 1 0 7.83Zm-49.57-1.19c0 .22.03.45.06.67a12 12 0 0 0 2.4.6c1.75.24 3.53.14 5.25-.28a3.94 3.94 0 0 0-1.73-4.34 3.92 3.92 0 0 0-5.98 3.35Zm47.93 92.13a845.2 845.2 0 0 1 17.65-.08h.38l-22.14-75.86-24.48.03a.3.3 0 0 0-.3.28.29.29 0 0 0 .3.3l24.04-.04 21.8 74.7c-2.93 0-16.7 0-17.3.1a.3.3 0 0 0-.2.1.3.3 0 0 0-.06.2c0 .09.04.16.1.2a.3.3 0 0 0 .2.08v-.01Zm-33.1.15 18.36-.08a.29.29 0 0 0 .3-.3.3.3 0 0 0-.3-.28l-17.8.08 1.3-55.48a.29.29 0 0 0-.6-.1l-1.35 56.06Z"
        fill="#e0201c"
      />
      <path
        d="M231.82 139.6h.05a4.33 4.33 0 0 0 4.3-4.34l-.03-7.16-8.68.04.03 7.17a4.33 4.33 0 0 0 4.33 4.3Zm.01-.57h-.01a3.75 3.75 0 0 1-3.75-3.72l-.03-6.6 7.53-.03.03 6.6a3.74 3.74 0 0 1-3.73 3.75h-.04Zm-6.8-35.12a.3.3 0 0 0 .24-.13 149.27 149.27 0 0 1 4.06-4.96.3.3 0 0 0-.01-.23.3.3 0 0 0-.18-.15.29.29 0 0 0-.22.03 158.55 158.55 0 0 0-4.13 5 .3.3 0 0 0 .24.45Zm-14.62-6.98a.3.3 0 0 0 .28-.36 18.56 18.56 0 0 1-.5-3.4.29.29 0 0 0-.4-.14.29.29 0 0 0-.16.27 17.9 17.9 0 0 0 .5 3.4.3.3 0 0 0 .28.23Zm56.78 23.62a.3.3 0 0 0 .18-.06l5.5-4.15c.06-.05.1-.11.12-.2a.3.3 0 0 0-.06-.2.29.29 0 0 0-.4-.06l-5.51 4.15a.3.3 0 0 0-.1.14.28.28 0 0 0 0 .18c.02.06.06.1.1.14.05.04.11.06.17.06Zm-72.75-24.48a.3.3 0 0 0 .26-.15l3.63-6.55a.3.3 0 0 0 .03-.23.3.3 0 0 0-.54-.05l-3.63 6.55a.29.29 0 0 0 .25.43Zm57.48 11.8h.06a.29.29 0 0 0 .23-.35c0-.18-3.1-6.69-5.6-12.11a.3.3 0 0 0-.36-.14.29.29 0 0 0-.14.38 1131.78 1131.78 0 0 1 5.74 12.16c.04.03.09.06.16.06Zm-.3-.23v.02-.02Z"
        fill="#e0201c"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M.5 0h293v220H.5z" fill="#fff" />
      </clipPath>
      <clipPath id="b">
        <path d="M29.49 115.23H48.7v19.22H29.5z" fill="#fff" />
      </clipPath>
      <clipPath id="c">
        <path d="M29.49 73.33H48.7v17.46H29.5z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export const Step2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 305 220"
    {...props}
  >
    <path
      d="M182.07 46.77c-6.7-6.47-12.76-14.67-25.98-26.83C142.87 7.78 123.52-3.3 87.87 7.2 52.2 17.7 21.28 48.96 29.27 109.83c5.6 42.6 41.46 83.56 88.67 99.03 47.6 15.6 97.15 3.45 132.11-15.65 34.97-19.1 45.72-58.14 39.1-81.95-6.6-23.8-19.85-37.1-51.55-41.72-31.7-4.62-41.56-9.34-55.53-22.78Z"
      fill="#e0201c"
      opacity={0.8}
    />
    <path
      d="m159.65 45.86.25-.43-.25.43c8.37 4.85 15.26 7.85 24.08 9.25 8.8 1.4 19.48 1.22 35.42-.27 15.88-1.5 27.72.2 37.07 4.85 9.34 4.54 16.24 12.2 22.18 22.82 11.81 21.14 10.45 60.92-18.9 87.3-29.48 26.47-74.66 49.66-124.32 45.82-49.28-3.8-93.4-34.7-108.62-74.1-10.89-28.2-10.63-51.55-3.69-70.13C29.82 52.85 43.47 39 59.5 29.82c16.03-9.17 29.33-12.22 40.55-11.92 11.21.31 20.4 3.96 28.17 8.23a240.7 240.7 0 0 1 18.55 11.32l3.25 2.18c3.47 2.34 6.54 4.4 9.63 6.2Z"
      stroke="#e0201c"
      opacity={0.8}
    />
    <path
      d="M29.5 54.43h234v141.4a3.6 3.6 0 0 1-3.6 3.6H33.1a3.6 3.6 0 0 1-3.6-3.6V54.42Z"
      fill="#FBFBFB"
      stroke="#e0201c"
    />
    <rect
      fill="#F5F5F5"
      width={197.4}
      height={48.13}
      x={48.56}
      y={78.79}
      stroke="e0201c"
      strokeWidth={0.56}
      rx={1.96}
    />
    <path
      d="M173.6 102.76v5.5h-1.19v-6.87h1.12l.06 1.37Zm-.25 1.8-.54-.01c0-.47.06-.9.18-1.3s.3-.75.53-1.05c.23-.3.52-.53.87-.69a2.8 2.8 0 0 1 1.2-.24c.3 0 .6.04.8.14a1.8 1.8 0 0 1 1.16 1.17c.12.3.18.67.18 1.1v4.58h-1.17v-4.52c0-.36-.06-.65-.18-.86a1.06 1.06 0 0 0-.5-.47c-.23-.1-.49-.15-.78-.15-.34 0-.63.06-.86.18-.24.12-.42.3-.56.5a2.3 2.3 0 0 0-.3.75c-.07.28-.1.57-.1.88Zm4.45-.64-.78.24a3.22 3.22 0 0 1 .7-2.01c.24-.27.53-.5.86-.64.34-.16.73-.24 1.17-.24.36 0 .69.04.97.14a1.8 1.8 0 0 1 1.18 1.22c.1.31.15.69.15 1.12v4.51h-1.18v-4.53c0-.38-.06-.68-.2-.9a.96.96 0 0 0-.5-.44 2.03 2.03 0 0 0-1.45 0c-.2.09-.37.21-.5.37a1.6 1.6 0 0 0-.31.52c-.07.2-.1.41-.1.64Zm-13.1.98v-.14c0-.5.08-.96.22-1.38a3.03 3.03 0 0 1 1.61-1.85c.38-.18.81-.26 1.29-.26a3.02 3.02 0 0 1 2.3 1c.27.31.48.68.62 1.1.14.43.22.9.22 1.39v.14c0 .5-.08.96-.22 1.38-.14.42-.35.8-.63 1.11a2.86 2.86 0 0 1-2.28 1 2.94 2.94 0 0 1-2.91-2.1 4.25 4.25 0 0 1-.22-1.39Zm1.18-.14v.14c0 .35.04.67.12.97.08.3.2.57.36.8.16.24.37.42.62.56.24.13.53.2.85.2.32 0 .6-.07.85-.2.24-.14.44-.32.6-.56.17-.23.29-.5.37-.8.08-.3.13-.62.13-.97v-.14c0-.34-.05-.66-.13-.96-.08-.3-.2-.58-.37-.8a1.7 1.7 0 0 0-1.46-.76 1.73 1.73 0 0 0-1.46.75c-.16.22-.28.5-.36.8-.08.3-.12.62-.12.96Zm-4.92 2.66c.28 0 .54-.05.77-.17.24-.11.44-.27.6-.47.14-.2.23-.43.25-.69h1.11c-.1.4-.2.78-.5 1.14a2.82 2.82 0 0 1-2.3 1.16c-.54 0-.99-.1-1.37-.28a2.7 2.7 0 0 1-.96-.74 3.37 3.37 0 0 1-.55-1.1 4.64 4.64 0 0 1-.18-1.3v-.28c0-.46.06-.9.18-1.3.13-.42.32-.78.56-1.1.26-.32.58-.57.96-.75.38-.18.83-.27 1.35-.27.54 0 1 .1 1.4.33a2.52 2.52 0 0 1 1.33 2.15h-1.1c-.03-.28-.1-.54-.25-.76a1.55 1.55 0 0 0-1.38-.76c-.37 0-.67.07-.9.22a1.6 1.6 0 0 0-.6.57c-.14.23-.24.5-.3.8-.04.28-.07.57-.07.87v.27c0 .3.03.6.1.9.05.3.15.55.3.8.13.22.32.41.56.55.25.14.56.21.92.21Zm-6.16.22c0-.2.06-.36.19-.5.12-.14.3-.2.54-.2.24 0 .42.06.54.2.13.14.2.3.2.5a.7.7 0 0 1-.2.5c-.12.13-.3.2-.54.2-.24 0-.42-.07-.54-.2a.71.71 0 0 1-.19-.5Zm-4.06.75a2.95 2.95 0 0 1-2.93-1.99c-.15-.4-.22-.85-.22-1.33v-.27a3.57 3.57 0 0 1 .92-2.6 2.9 2.9 0 0 1 3.35-.68c.36.17.65.4.88.71.23.3.4.66.5 1.07.12.4.17.85.17 1.33v.53h-5.13v-.96h3.96v-.1c-.02-.3-.08-.6-.2-.88a1.6 1.6 0 0 0-.5-.7 1.49 1.49 0 0 0-.95-.29 1.6 1.6 0 0 0-1.32.67c-.16.22-.28.49-.37.8a4.1 4.1 0 0 0-.13 1.1v.27c0 .32.04.63.13.92.1.28.23.53.4.75.18.21.4.38.64.5a2.16 2.16 0 0 0 2.67-.74l.78.56a3 3 0 0 1-1.4 1.14c-.33.12-.73.19-1.18.19ZM146 98.5v9.75h-1.18V98.5H146Zm-7.4 4.2v8.2h-1.18v-9.52h1.08l.1 1.32Zm4.63 2.06v.13c0 .5-.06.97-.18 1.4-.12.42-.3.78-.52 1.1a2.36 2.36 0 0 1-1.97.99 2.9 2.9 0 0 1-1.15-.22 2.27 2.27 0 0 1-.85-.63c-.24-.27-.42-.6-.56-.99a5.71 5.71 0 0 1-.28-1.3v-.7c.05-.52.15-.97.29-1.37.14-.4.32-.75.55-1.03.23-.3.5-.5.84-.66a2.7 2.7 0 0 1 1.14-.23c.44 0 .82.08 1.15.25.34.17.62.4.85.71a4.9 4.9 0 0 1 .69 2.54Zm-1.18.13v-.13c0-.34-.04-.66-.1-.96a2.8 2.8 0 0 0-.34-.8 1.6 1.6 0 0 0-1.4-.75 1.73 1.73 0 0 0-1.3.56 2.59 2.59 0 0 0-.51 1.26v1.64c.07.3.19.58.34.84.15.26.35.47.6.63.26.16.58.23.97.23.3 0 .59-.06.8-.2.25-.13.44-.3.58-.55.15-.23.26-.5.33-.8.07-.3.1-.62.1-.97Zm-14.85-2.14v5.5h-1.18v-6.87h1.1l.08 1.37Zm-.25 1.8-.54-.01c0-.47.06-.9.18-1.3s.3-.75.53-1.05c.23-.3.52-.53.87-.69a2.8 2.8 0 0 1 1.1-.24c.33 0 .62.04.89.14a1.8 1.8 0 0 1 1.17 1.17c.1.3.18.67.18 1.1v4.58h-1.18v-4.52c0-.36-.05-.65-.17-.86a1.05 1.05 0 0 0-.5-.47c-.23-.1-.5-.15-.78-.15-.35 0-.64.06-.87.18-.24.12-.42.3-.56.5-.14.22-.24.47-.3.75s-.11.57-.11.88Zm4.45-.64-.78.24a3.22 3.22 0 0 1 .7-2.01 2.67 2.67 0 0 1 2.03-.88 3 3 0 0 1 .97.14c.28.1.52.25.72.45.2.2.35.46.45.77.1.3.15.69.15 1.12v4.51h-1.18v-4.53c0-.38-.06-.68-.18-.9a.96.96 0 0 0-.51-.44 2.03 2.03 0 0 0-1.46 0c-.2.09-.37.21-.5.37-.14.15-.24.32-.31.52s-.1.41-.1.64Zm-8.4 3.17v-3.54c0-.27-.05-.5-.16-.7a1.1 1.1 0 0 0-.48-.47 1.75 1.75 0 0 0-.8-.17c-.3 0-.56.05-.78.15-.22.1-.4.24-.52.4a.88.88 0 0 0-.2.54h-1.16c0-.25.06-.5.19-.73.13-.24.3-.46.55-.66.24-.2.53-.35.86-.47a3.67 3.67 0 0 1 2.45.08c.38.17.69.42.9.77.22.34.33.76.33 1.27v3.2c0 .23.02.47.06.73.04.25.1.47.18.66v.1h-1.22a4.33 4.33 0 0 1-.2-1.17Zm.2-3 .02.83h-1.18c-.34 0-.64.03-.9.08-.26.06-.48.13-.66.24a1.06 1.06 0 0 0-.55.95c0 .22.05.4.15.6.1.17.24.3.44.42.2.1.44.15.73.15a1.94 1.94 0 0 0 1.6-.79c.17-.22.26-.43.27-.64l.5.57c-.03.17-.1.37-.24.59a2.77 2.77 0 0 1-2.3 1.3c-.47 0-.88-.1-1.23-.28a1.93 1.93 0 0 1-1.1-1.77c0-.36.08-.68.22-.96.14-.28.35-.52.62-.7.27-.2.6-.34.98-.44.38-.1.8-.14 1.28-.14h1.36Zm-9.9-2.7 1.5 2.5 1.53-2.5h1.38l-2.25 3.4 2.32 3.47h-1.36l-1.6-2.57-1.58 2.56h-1.36l2.3-3.48-2.23-3.39h1.35Zm-4.84 7a2.95 2.95 0 0 1-2.93-1.99c-.15-.4-.22-.85-.22-1.33v-.27c0-.56.08-1.05.25-1.49.16-.44.38-.8.67-1.12a2.9 2.9 0 0 1 3.35-.67c.36.17.65.4.88.71.23.3.4.66.5 1.07.12.4.18.85.18 1.33v.53H106v-.96h3.95v-.2c-.02-.3-.08-.6-.19-.88a1.6 1.6 0 0 0-.5-.7 1.48 1.48 0 0 0-.96-.28 1.6 1.6 0 0 0-1.3.67c-.17.22-.3.49-.39.8a4.1 4.1 0 0 0-.13 1.1v.27c0 .33.03.64.12.93.1.28.23.53.4.75a1.92 1.92 0 0 0 1.51.69c.41 0 .76-.1 1.05-.26.3-.16.54-.4.76-.67l.7.56a3.3 3.3 0 0 1-.56.64c-.23.2-.5.37-.84.5-.33.12-.72.19-1.18.19ZM104.33 99l-3.85 10.05h-1.01L103.33 99h1Zm-3.95 0-3.85 10.05h-1.01L99.38 99h1Zm-7.3 8.63c0-.2.08-.37.2-.5.12-.14.3-.21.54-.21.24 0 .42.07.54.2.13.14.2.31.2.51a.7.7 0 0 1-.2.5c-.12.13-.3.2-.54.2-.23 0-.42-.07-.54-.2a.7.7 0 0 1-.2-.5Zm.02-5.6c0-.2.06-.37.18-.5.13-.15.3-.22.55-.22.24 0 .42.07.54.21.13.14.2.3.2.5a.7.7 0 0 1-.2.5c-.12.14-.3.2-.54.2-.24 0-.42-.06-.55-.2a.7.7 0 0 1-.18-.5Zm-2.67 4.4a1 1 0 0 0-.11-.47.97.97 0 0 0-.45-.4 3.73 3.73 0 0 0-1.02-.32 7.98 7.98 0 0 1-1.03-.28 3 3 0 0 1-.78-.4 1.54 1.54 0 0 1-.66-1.3c0-.26.05-.52.17-.76a2.25 2.25 0 0 1 1.32-1.08c.32-.1.67-.15 1.05-.15.55 0 1.02.1 1.4.29a1.99 1.99 0 0 1 1.2 1.85h-1.16a1 1 0 0 0-.17-.55 1.2 1.2 0 0 0-.5-.45 1.58 1.58 0 0 0-.77-.18c-.32 0-.6.05-.8.15a.94.94 0 0 0-.5 1.2c.05.1.13.2.24.28a5.87 5.87 0 0 0 1.28.44c.56.13 1.02.28 1.39.46.36.17.63.4.8.65.19.26.28.57.28.94a1.79 1.79 0 0 1-.73 1.47 2.7 2.7 0 0 1-.84.42c-.32.1-.7.15-1.1.15-.6 0-1.1-.1-1.52-.33-.42-.21-.74-.5-.96-.83a2 2 0 0 1-.32-1.09h1.18c.02.32.1.58.28.77.17.19.38.32.62.4a2.46 2.46 0 0 0 1.54-.01c.22-.09.4-.2.5-.35a.81.81 0 0 0 .17-.51ZM80.3 102.7v8.2h-1.2v-9.52h1.09l.1 1.32Zm4.62 2.06v.13c0 .5-.06.97-.17 1.4-.12.42-.3.78-.53 1.1a2.35 2.35 0 0 1-1.96.99 2.9 2.9 0 0 1-1.16-.22 2.27 2.27 0 0 1-.85-.63c-.23-.27-.42-.6-.56-.99a5.73 5.73 0 0 1-.28-1.3v-.7c.05-.52.15-.97.3-1.37.13-.4.31-.75.54-1.03.23-.3.52-.5.85-.66a2.7 2.7 0 0 1 1.14-.23 2.38 2.38 0 0 1 2 .96c.22.3.4.68.5 1.11.12.43.18.9.18 1.43Zm-1.18.13v-.13c0-.34-.03-.66-.1-.96a2.54 2.54 0 0 0-.34-.8 1.6 1.6 0 0 0-1.4-.75c-.3 0-.56.05-.78.15-.21.1-.4.24-.55.41a2.39 2.39 0 0 0-.58 1.26v1.64c.08.3.2.58.35.84.15.26.36.47.6.63.26.16.58.23.97.23a1.58 1.58 0 0 0 1.39-.75c.16-.23.27-.5.34-.8.08-.3.1-.62.1-.97Zm-6-3.5v.9h-3.71v-.9h3.7Zm-2.45-1.68h1.17v6.84c0 .23.04.4.1.53.08.11.17.2.29.23.1.04.23.06.37.06a2.04 2.04 0 0 0 .55-.08v.96a2.77 2.77 0 0 1-.9.13c-.3 0-.56-.06-.8-.17-.24-.12-.43-.3-.57-.58a2.4 2.4 0 0 1-.21-1.09v-6.83Zm-1.8 1.67v.9h-3.78v-.9h3.7Zm-2.54-1.67h1.17v6.84c0 .23.04.4.1.53.09.11.18.2.3.23.1.04.23.06.37.06a2.04 2.04 0 0 0 .55-.08v.96a2.77 2.77 0 0 1-.9.13c-.3 0-.55-.06-.8-.17-.23-.12-.42-.3-.56-.58a2.4 2.4 0 0 1-.21-1.09v-6.83Zm-6.41-1.2v9.8H63.4v-9.8h1.18Zm-.28 6.1h-.5a3.53 3.53 0 0 1 .79-2.33 2.54 2.54 0 0 1 2-.93c.34 0 .65.05.92.15.27.08.5.22.7.42.2.2.33.45.43.77.1.3.16.7.16 1.15v4.5H67.6v-4.51c0-.35-.06-.64-.16-.85a.98.98 0 0 0-.47-.48c-.2-.1-.45-.15-.75-.15a1.73 1.73 0 0 0-1.41.69 2.56 2.56 0 0 0-.54 1.63Zm-35.3-61.53a4.1 4.1 0 0 1 4.1-4.11h226.8a4.1 4.1 0 0 1 4.1 4.1v11.9H29v-11.9Z"
      fill="#e0201c"
    />
    <ellipse fill="#FBFBFB" cx={37.24} cy={47.48} rx={3.3} ry={3.29} />
    <ellipse fill="#FBFBFB" cx={48.37} cy={47.48} rx={3.3} ry={3.29} />
    <ellipse fill="#FBFBFB" cx={59.49} cy={47.48} rx={3.3} ry={3.29} />
    <rect
      fill="#e0201c"
      width={196.68}
      height={42.28}
      x={48.74}
      y={137.51}
      rx={5}
    />
    <path
      d="M178.67 161.4v1.48h-4.92v-1.48h4.92Zm-4.3-7.76v9.24h-1.9v-9.24h1.9Zm3.66 3.77v1.44h-4.28v-1.44h4.28Zm.63-3.77v1.5h-4.9v-1.5h4.9Zm-10.12 0v9.24h-1.9v-9.24h1.9Zm2.84 0v1.5h-7.54v-1.5h7.54Zm-11.17 1.58-2.5 7.66h-2.03l3.43-9.24h1.29l-.2 1.58Zm2.1 7.66-2.53-7.66-.2-1.58h1.3l3.45 9.24h-2.03Zm-.12-3.44v1.5h-4.88v-1.5h4.88Zm-14.06-5.8h3.45c.7 0 1.3.1 1.82.32.5.2.9.52 1.18.94.27.41.4.92.4 1.53a2.54 2.54 0 0 1-.95 2.16c-.3.23-.65.41-1.06.55l-.6.32h-3v-1.48h2.22c.33 0 .6-.06.83-.18.22-.12.39-.29.5-.5.1-.2.17-.45.17-.73 0-.3-.06-.56-.17-.77a1.1 1.1 0 0 0-.5-.5c-.22-.11-.5-.17-.84-.17h-1.55v7.75h-1.9v-9.24Zm5.17 9.24-2.11-4.12h2l2.14 4.03v.1h-2.03Zm-6.28-1.48v1.48h-4.92v-1.48h4.92Zm-4.3-7.76v9.24h-1.9v-9.24h1.9Zm3.66 3.77v1.44h-4.28v-1.44h4.28Zm.63-3.77v1.5h-4.91v-1.5h4.9Zm-7.85 0v9.24h-1.9l-3.72-6.2v6.2h-1.9v-9.24h1.9l3.72 6.2v-6.2h1.9Zm-8.63 7.76v1.48h-4.92v-1.48h4.92Zm-4.3-7.76v9.24h-1.9v-9.24h1.9Zm3.66 3.77v1.44h-4.4v-1.44h4.3Zm.52-3.77v1.5h-4.9v-1.5h4.9Zm-7.72 4.41v3.66a2.9 2.9 0 0 1-.67.57c-.3.2-.7.37-1.16.51a5.75 5.75 0 0 1-3.35-.08 3.54 3.54 0 0 1-2.08-2.15 5.81 5.81 0 0 1-.3-1.9v-.59c0-.7.1-1.35.29-1.9.17-.55.44-1 .78-1.39.34-.39.75-.68 1.22-.87.48-.2 1-.3 1.58-.3.8 0 1.47.13 1.98.4.5.25.89.6 1.18 1.07.27.46.44.98.5 1.58h-1.84a2.36 2.36 0 0 0-.27-.82 1.37 1.37 0 0 0-.57-.55c-.24-.1-.55-.2-.93-.2a1.69 1.69 0 0 0-1.47.8c-.18.24-.3.55-.4.92-.08.37-.13.8-.13 1.28v.6c0 .48.05.9.14 1.28.1.37.23.68.4.93.19.23.42.42.69.54.27.13.59.2.95.2.3.01.55-.02.74-.07a1.8 1.8 0 0 0 .8-.4v-1.64h-1.74v-1.36h3.64Z"
      fill="#FBFBFB"
    />
  </svg>
);

export const Step3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 293 221"
    {...props}
  >
    <path
      d="M118.54 170.98c6.07 6.99 11.33 15.65 23.33 28.84 12 13.2 30.17 25.83 66.4 18.34 36.21-7.49 69.6-36.04 67.1-97.26-1.76-42.83-33.62-86.56-78.97-105.87-45.73-19.46-95.84-11.48-132.14 4.62-36.3 16.1-50.4 54.05-45.97 78.28 4.4 24.23 16.3 38.56 47.3 45.78 30.9 7.23 40.3 12.74 52.9 27.27Z"
      fill="#e0201c"
      opacity={0.8}
    />
    <path
      d="m129.97 174.67-.32.4.32-.4c-7.55-6.02-13.91-10-22.39-12.65-8.46-2.65-19-3.96-34.89-4.72-15.82-.75-27.24-4.1-35.78-10.08-8.53-5.97-14.24-14.62-18.59-26.08-8.65-22.82-1.7-62.44 30.9-84.7C81.94 14.09 129.64-2.74 177.96 8.1c47.93 10.77 87 47.9 96.4 89.5 6.75 29.78 3.2 53.12-6.24 70.73-9.45 17.62-24.84 29.55-41.88 36.47-17.07 6.93-30.58 8.1-41.57 6.22-10.99-1.88-19.5-6.82-26.55-12.2a237.18 237.18 0 0 1-16.66-13.94l-2.9-2.64c-3.08-2.84-5.8-5.34-8.6-7.57Z"
      stroke="#e0201c"
      opacity={0.8}
    />
    <rect
      fill="#e0201c"
      width={135.24}
      height={159.5}
      x={76.8}
      y={0.4}
      rx={21.1}
    />
    <mask fill="#fff" id="a">
      <path
        d="M98.78 9.5a13.24 13.24 0 0 0-13.23 13.24v90.69c0 7.31 5.92 13.24 13.23 13.24h38.24c.36 0 .72.1 1.02.3l6.64 4.37c.61.4 1.42.4 2.04 0l6.63-4.37c.3-.2.66-.3 1.03-.3h35.2c7.3 0 13.24-5.93 13.24-13.24v-90.7c0-7.3-5.93-13.23-13.24-13.23h-90.8Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </mask>
    <path
      d="M98.78 9.5a13.24 13.24 0 0 0-13.23 13.24v90.69c0 7.31 5.92 13.24 13.23 13.24h38.24c.36 0 .72.1 1.02.3l6.64 4.37c.61.4 1.42.4 2.04 0l6.63-4.37c.3-.2.66-.3 1.03-.3h35.2c7.3 0 13.24-5.93 13.24-13.24v-90.7c0-7.3-5.93-13.23-13.24-13.23h-90.8Z"
      fill="#FBFBFB"
      fillRule="evenodd"
      clipRule="evenodd"
    />
    <path
      d="m153.35 126.97-.54-.83.54.83Zm-8.67 4.37.54-.84-.54.84Zm2.04 0-.55-.84.55.84Zm-8.68-4.37.55-.83-.55.83ZM86.54 22.74c0-6.76 5.49-12.24 12.24-12.24v-2a14.24 14.24 0 0 0-14.23 14.24h2Zm0 90.69v-90.7h-2v90.7h2Zm12.24 12.24a12.24 12.24 0 0 1-12.23-12.24h-2c0 7.86 6.37 14.24 14.23 14.24v-2Zm38.24 0H98.78v2h38.24v-2Zm8.2 4.83-6.63-4.36-1.1 1.67 6.63 4.36 1.1-1.67Zm7.59-4.36-6.64 4.36 1.1 1.67 6.63-4.36-1.1-1.6Zm36.77-.47h-35.2v2h35.2v-2Zm12.24-12.24c0 6.76-5.48 12.24-12.24 12.24v2c7.87 0 14.24-6.38 14.24-14.24h-2Zm0-90.7v90.7h2v-90.7h-2ZM189.58 10.5c6.76 0 12.24 5.48 12.24 12.24h2c0-7.87-6.37-14.24-14.24-14.24v2Zm-90.8 0h90.8v-2h-90.8v2Zm55.12 117.3c.14-.08.3-.13.48-.13v-2c-.56 0-1.1.16-1.57.47l1.1 1.67Zm-9.78 4.37c.96.63 2.2.63 3.15 0l-1.1-1.67a.86.86 0 0 1-.95 0l-1.1 1.67Zm-7.1-4.5c.16 0 .33.05.47.14l1.1-1.67a2.86 2.86 0 0 0-1.57-.47v2Z"
      fill="#e0201c"
      mask="url(#a)"
    />
    <path
      d="M99.17 49.37a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23ZM99 75.16a1.61 1.61 0 1 0 .01-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M102.4 49.4a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M102.37 52.62a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.1 19.34a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.1 12.88a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.4-28.98a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M105.48 71.97a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.36-22.53a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.13 22.56a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M112.03 55.9a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.3Zm-.02 3.3a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.24Z"
      fill="#e0201c"
    />
    <path
      d="M111.9 78.46a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.05 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.38-25.77a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.07 12.9a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 9.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.45-38.65a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.43-35.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M121.67 62.4a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.34Zm-.03 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.6-61.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.1 16.12a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.23a1.61 1.61 0 1 0 0-3.12 1.61 1.61 0 0 0 0 3.22Zm-.04 3.33a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M124.95 52.75a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.2Zm-.05 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.12 19.34a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.12 19.33a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.3 1.61 1.61 0 0 0 0 3.2Zm3.74-87.1a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.2Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.2Zm-.05 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.05 6.45a1.61 1.61 0 1 0 .1-3.24 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M128.2 49.55a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M128.12 62.44a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.46a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.75-87a1.61 1.61 0 1 0 0-3.34 1.61 1.61 0 0 0 0 3.22Zm-.03 3.1a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.23Zm-.03 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M131.46 43.12a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.23 38.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M131.1 104.35a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.7-77.34a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.12 19.34a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.22 35.46a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.65-70.9a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.3Zm-.03 3.3a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M138 30.26a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M137.85 52.82a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.2 35.46a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.09 16.1a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.21Zm3.72-83.77a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.07 12.9a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.2 32.23a1.61 1.61 0 1 0 .01-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0-.1-3.22 1.61 1.61 0 0 0 0 3.22Zm-.13 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.77-90.22a1.61 1.61 0 1 0-.01-3.23 1.61 1.61 0 0 0-.01 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0-.01-3.22 1.61 1.61 0 0 0-.01 3.22Zm-.02 3.23a1.61 1.61 0 1 0-.01-3.23 1.61 1.61 0 0 0-.01 3.2Z"
      fill="#e0201c"
    />
    <path
      d="M144.3 52.86a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.2 35.46a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.08 12.9a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm3.75-87.01a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M147.69 27.1a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.14 22.56a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M147.53 52.88a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.23 38.68a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.22a1.61 1.61 0 1 0-.1-3.22 1.61 1.61 0 0 0 0 3.22Zm-.1 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.07 3.23a1.61 1.61 0 1 0 .01-3.23 1.61 1.61 0 0 0 .02 3.23Zm.01 3.22a1.61 1.61 0 1 0 .02-3.22 1.61 1.61 0 0 0 .01 3.22Zm0 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 3.22a1.61 1.61 0 1 0 .01-3.22 1.61 1.61 0 0 0 .01 3.22Zm3.75-87a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.05 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M150.78 49.68a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.21 35.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.77-90.22a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.22 38.68a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.08 12.89a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M157.38 23.94a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.2 32.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M157 88.4a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.06 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.12 1.61 1.61 0 0 0 0 3.22Zm-.05 9.77a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23ZM160.6 24a1.61 1.61 0 1 0 .04-3.23 1.61 1.61 0 0 0 0 3.23Zm0 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M160.53 36.84a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.08 12.89a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M160.3 75.52a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.05 9.67a1.61 1.61 0 1 0 .1-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M160.19 94.85a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.46a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.3Zm-.05 9.7a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.26Zm3.75-87a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.26Zm-.06 9.7a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.2Zm-.02 3.26a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M163.72 43.31a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M163.4 94.87a1.61 1.61 0 1 0 .01-3.22 1.61 1.61 0 0 0 0 3.22Zm0 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M163.38 101.32a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M163.34 107.76a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.3 1.61 1.61 0 0 0 0 3.21Zm-.02 3.2a1.61 1.61 0 1 0 0-3.3 1.61 1.61 0 0 0 0 3.23Zm3.6-64.5a1.61 1.61 0 1 0 0-3.24 1.61 1.61 0 0 0 0 3.23Zm-.03 6.43a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.1 16.12a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 3.3a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.08 12.9a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M166.56 107.8a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm3.58-58a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.08 12.89a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M169.98 75.58a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.5-48.33a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 12.9a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.05 6.44a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M173.15 85.26a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.3 1.61 1.61 0 0 0 0 3.2Zm-.09 12.8a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.01 3.22a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.24Zm3.6-61.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.2 1.61 1.61 0 0 0 0 3.21Z"
      fill="#e0201c"
    />
    <path
      d="M176.5 65.95a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.01 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.01 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M176.28 101.4a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.5-45.1a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.05 9.67a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M179.58 88.53a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.06 9.67a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.58-58a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.23Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M182.96 62.76a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.06 9.68a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M182.89 75.66a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.03 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.03 3.22a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.01 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M182.71 104.66a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm3.6-61.22a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.02 3.22a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.3 1.61 1.61 0 0 0 0 3.2Zm-.08 12.8a1.61 1.61 0 1 0 .1-3.23 1.61 1.61 0 0 0 0 3.22Zm0 6.43a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm0 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Zm-.1 9.69a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.23Zm0 6.46a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 6.45a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.22Zm-.04 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm3.53-58a1.61 1.61 0 1 0 0-3.21 1.61 1.61 0 0 0 0 3.22Z"
      fill="#e0201c"
    />
    <path
      d="M189.4 62.8a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.44a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.03 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.08 12.88a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.04 6.45a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-.02 3.23a1.61 1.61 0 1 0 0-3.23 1.61 1.61 0 0 0 0 3.23Z"
      fill="#e0201c"
    />
    <path
      d="M189.14 107.92a1.61 1.61 0 1 0 0-3.22 1.61 1.61 0 0 0 0 3.22Zm-91.47-79.5-.04 6.44a8.06 8.06 0 0 0 8.02 8.1l6.43.04a8.07 8.07 0 0 0 8.12-8l.04-6.44a8.05 8.05 0 0 0-8.02-8.1l-6.45-.04a8.07 8.07 0 0 0-8.12 8h.02Zm7.67-5.82 7.28.04a5.46 5.46 0 0 1 5.43 5.5l-.04 7.27a5.44 5.44 0 0 1-5.4 5.43l-7.28-.05a5.47 5.47 0 0 1-5.43-5.5l.04-7.3a5.45 5.45 0 0 1 5.5-5.48Z"
      fill="#e0201c"
    />
    <rect
      fill="#e0201c"
      width={10.93}
      height={10.92}
      x={103.35}
      y={26.23}
      rx={1.76}
    />
    <rect
      fill="#e0201c"
      width={10.93}
      height={10.92}
      x={103.35}
      y={98.88}
      rx={1.76}
    />
    <rect
      fill="#e0201c"
      width={10.93}
      height={10.92}
      x={174.25}
      y={26.23}
      rx={1.76}
    />
    <path
      d="m97.67 101.05-.04 6.45a8.05 8.05 0 0 0 8.02 8.1l6.43.04a8.07 8.07 0 0 0 8.12-8l.04-6.45a8.07 8.07 0 0 0-8.02-8.11l-6.45-.04a8.07 8.07 0 0 0-8.12 8h.02Zm7.67-5.82 7.28.04a5.46 5.46 0 0 1 5.43 5.49l-.04 7.27a5.46 5.46 0 0 1-5.39 5.43l-7.29-.05a5.47 5.47 0 0 1-5.42-5.48l.04-7.28a5.46 5.46 0 0 1 5.5-5.42Zm63.16-66.81-.04 6.44a8.05 8.05 0 0 0 8.02 8.1l6.44.04a8.07 8.07 0 0 0 8.1-8l.05-6.44a8.07 8.07 0 0 0-8.02-8.1l-6.45-.04a8.07 8.07 0 0 0-8.1 8Zm7.67-5.82 7.29.04a5.47 5.47 0 0 1 5.42 5.5l-.04 7.27a5.46 5.46 0 0 1-5.5 5.43l-7.28-.05a5.47 5.47 0 0 1-5.43-5.6l.05-7.26a5.46 5.46 0 0 1 5.5-5.43Z"
      fill="#e0201c"
    />
    <path
      d="M116.42 148.86c-.78 0-1.53-.1-2.27-.31-.72-.22-1.3-.5-1.74-.83l.77-1.72a5.65 5.65 0 0 0 3.25 1.03c.65 0 1.13-.1 1.44-.28.31-.2.46-.46.46-.78a.7.7 0 0 0-.28-.57 1.94 1.94 0 0 0-.7-.38c-.28-.1-.67-.2-1.16-.31a16 16 0 0 1-1.84-.54c-.48-.17-.9-.46-1.24-.85-.34-.4-.5-.92-.5-1.58 0-.57.15-1.09.46-1.55.3-.47.77-.84 1.4-1.1a5.58 5.58 0 0 1 2.29-.42c.63 0 1.24.08 1.84.23.6.15 1.13.36 1.58.64l-.7 1.74a5.5 5.5 0 0 0-2.74-.78c-.63 0-1.1.1-1.42.31-.3.2-.45.48-.45.82 0 .33.17.59.52.76.36.16.9.32 1.62.48.75.17 1.37.35 1.85.53a3 3 0 0 1 1.22.84c.35.39.52.9.52 1.56 0 .57-.16 1.08-.48 1.55-.3.46-.78.83-1.4 1.1-.63.27-1.4.4-2.3.4Zm10.46 0c-1 0-1.92-.22-2.73-.65a5.01 5.01 0 0 1-1.92-1.81 5.07 5.07 0 0 1-.7-2.64 4.88 4.88 0 0 1 2.6-4.43 5.69 5.69 0 0 1 2.76-.66c.86 0 1.63.15 2.3.45.7.3 1.29.73 1.76 1.3l-1.47 1.35a3.15 3.15 0 0 0-2.47-1.16 3.17 3.17 0 0 0-2.7 1.52 3.39 3.39 0 0 0-.4 1.63c0 .62.17 1.16.4 1.64s.68.85 1.16 1.12c.48.26 1.02.4 1.64.4.98 0 1.8-.4 2.47-1.17l1.47 1.35c-.47.57-1.05 1-1.75 1.3-.7.3-1.47.46-2.32.46Zm11.9-2.28h-4.57l-.87 2.1H131l4.4-9.84h2.25l4.4 9.85h-2.39l-.87-2.11Zm-.7-1.73-1.57-3.77-1.57 3.77h3.13Zm14.04-6v9.84h-1.87l-4.92-5.98v5.98h-2.25v-9.85h1.89l4.9 5.98v-5.98h2.25Zm15.3 9.84-.02-5.9-2.9 4.86h-1.03l-2.89-4.74v5.78h-2.14v-9.85h1.9l3.68 6.12 3.63-6.12h1.87l.03 9.85h-2.14Zm12.1-1.83v1.83h-7.63v-9.9h7.4v1.8h-5.2v2.12h4.54v1.78h-4.56v2.28h5.37Z"
      fill="#FBFBFB"
    />
    <path
      d="M144.54 58.4c-2.54 0-2.86.01-3.86.05-1 .05-1.68.2-2.27.44-.63.24-1.2.6-1.66 1.08a4.61 4.61 0 0 0-1.1 1.66c-.22.6-.38 1.28-.42 2.27-.05 1-.06 1.32-.06 3.86a61 61 0 0 0 .06 3.86c.05 1 .2 1.68.43 2.28a4.6 4.6 0 0 0 1.09 1.66c.52.52 1.04.84 1.65 1.08.6.23 1.28.39 2.28.43 1 .05 1.32.06 3.86.06 2.55 0 2.87-.01 3.87-.06 1-.05 1.68-.2 2.28-.43.62-.24 1.2-.6 1.65-1.08a4.6 4.6 0 0 0 1.1-1.66c.22-.6.37-1.28.42-2.28a61 61 0 0 0 .06-3.86c0-2.54 0-2.86-.06-3.86-.05-1-.2-1.68-.43-2.27a4.6 4.6 0 0 0-1.09-1.66 4.58 4.58 0 0 0-1.66-1.08 6.9 6.9 0 0 0-2.27-.44c-1-.04-1.32-.05-3.87-.05Zm-.83 1.69h.9c2.5 0 2.8 0 3.8.05.94.04 1.4.2 1.76.32a3 3 0 0 1 1.78 1.78c.12.33.27.83.3 1.74.06.99.07 1.28.07 3.78s0 2.8-.06 3.78a5.08 5.08 0 0 1-.32 1.74c-.17.4-.42.78-.72 1.08a2.9 2.9 0 0 1-1.08.7c-.31.13-.8.28-1.72.32-1 .05-1.28.06-3.78.06s-2.8-.01-3.8-.06a5.4 5.4 0 0 1-1.73-.32 2.9 2.9 0 0 1-1.08-.7 2.9 2.9 0 0 1-.7-1.08 5.19 5.19 0 0 1-.34-1.74c-.04-.98-.05-1.28-.05-3.78s0-2.8.05-3.78c.05-.92.2-1.41.33-1.74.16-.44.36-.75.69-1.08a2.9 2.9 0 0 1 1.08-.7c.33-.13.82-.28 1.74-.32.85-.04 1.2-.05 2.94-.06Zm5.9 1.55a1.13 1.13 0 0 0-1.1 1.12 1.11 1.11 0 0 0 .7 1.04 1.13 1.13 0 0 0 1.56-1.04 1.12 1.12 0 0 0-1.12-1.12Zm-5 1.3a4.81 4.81 0 1 0-.12 9.64 4.81 4.81 0 0 0 .15-9.63Zm0 1.7a3.12 3.12 0 1 1 0 6.25 3.12 3.12 0 0 1 0-6.25Z"
      fill="#e0201c"
    />
    <rect
      fill="#e0201c"
      width={134.99}
      height={38.7}
      x={76.81}
      y={173.97}
      rx={5}
    />
    <path
      d="M146.4 179.5v11.97l4.37-4.37 2.12 2.12-7 6.92a1.5 1.5 0 0 1-2.15 0l-6.93-6.92 2.12-2.12 4.37 4.36V179.5h3Zm-10.57 14.08v6.2a.85.85 0 0 0 .85.84h16.43a.84.84 0 0 0 .85-.85v-6.19h3v6.2a3.85 3.85 0 0 1-3.85 3.84h-16.43a3.85 3.85 0 0 1-3.85-3.85v-6.19h3Z"
      fill="#FBFBFB"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export const LandingCardImg1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 88 88"
    className="injected-svg"
    data-src="/svg/benefits.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#D1E5FA" cx={44} cy={44} r={44} />
      <g transform="translate(1 12)">
        <rect
          stroke="#e0201c"
          strokeWidth={2}
          fill="#F6FAFE"
          width={64}
          height={64}
          rx={2}
        />
        <g transform="translate(8 8)" fill="#e0201c">
          <rect width={8} height={8} rx={2} />
          <rect x={12} width={8} height={8} rx={2} />
          <rect y={12} width={8} height={8} rx={2} />
          <rect x={12} y={12} width={8} height={8} rx={2} />
          <rect x={6} y={6} width={8} height={8} rx={2} />
        </g>
        <rect fill="#e0201c" x={12} y={40} width={12} height={12} rx={2} />
        <rect fill="#e0201c" x={40} y={12} width={12} height={12} rx={2} />
        <rect
          stroke="#e0201c"
          strokeWidth={2}
          x={8}
          y={36}
          width={20}
          height={20}
          rx={2}
        />
        <rect
          stroke="#e0201c"
          strokeWidth={2}
          x={36}
          y={8}
          width={20}
          height={20}
          rx={2}
        />
        <g fill="#e0201c" fillRule="nonzero">
          <path d="M47.38 46.282c-.745-.742-2.031-.37-2.268.641L42.27 59.571c-.237.978.71 1.855 1.692 1.586l2.979-.877c.27-.068.575.067.643.337l2.166 7.42a1.34 1.34 0 0 0 1.66.91l2.538-.741a1.334 1.334 0 0 0 .914-1.653l-2.167-7.42c-.067-.27.068-.573.339-.64l2.979-.878c.981-.27 1.286-1.518.575-2.226l-9.207-9.107zM43.42 40.324c.169.54.643.877 1.185.877.101 0 .237 0 .338-.034a1.263 1.263 0 0 0 .846-1.517l-.812-2.766a1.27 1.27 0 0 0-1.523-.843 1.263 1.263 0 0 0-.846 1.517l.812 2.766zM41.152 42.146l-2.539-1.383a1.213 1.213 0 0 0-1.658.472c-.305.573-.102 1.349.474 1.653l2.538 1.383a1.253 1.253 0 0 0 1.659-.506 1.147 1.147 0 0 0-.474-1.62zM39.663 47.171l-2.776.81a1.263 1.263 0 0 0-.846 1.517c.17.54.643.877 1.185.877.101 0 .237 0 .338-.033l2.776-.81a1.263 1.263 0 0 0 .846-1.518c-.203-.674-.88-1.045-1.523-.843zM51.814 44.911c.17.54.643.877 1.185.877.101 0 .237 0 .338-.033l2.776-.81a1.263 1.263 0 0 0 .846-1.518 1.27 1.27 0 0 0-1.523-.843l-2.776.81c-.643.168-1.015.843-.846 1.517zM49.174 41.606a1.253 1.253 0 0 0 1.659-.506l1.387-2.53a1.204 1.204 0 0 0-.474-1.652 1.213 1.213 0 0 0-1.658.472L48.7 39.92a1.223 1.223 0 0 0 .474 1.686z" />
        </g>
      </g>
    </g>
  </svg>
);

export const LandingCardImg2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 88 88"
    className="injected-svg"
    data-src="/svg/design.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#D1E5FA" cx={44} cy={44} r={44} />
      <rect
        stroke="#e0201c"
        strokeWidth={2}
        fill="#F6FAFE"
        x={1}
        y={12}
        width={77}
        height={64}
        rx={2}
      />
      <rect fill="#e0201c" x={9} y={58} width={22} height={2} rx={1} />
      <g transform="translate(9 30)">
        <rect stroke="#e0201c" strokeWidth={2} width={22} height={22} rx={2} />
        <g fill="#e0201c">
          <path d="m2.121.707 19.817 19.817a1 1 0 1 1-1.414 1.414L.707 2.12A1 1 0 0 1 2.121.707z" />
          <path d="M.707 20.524 20.524.707a1 1 0 1 1 1.414 1.414L2.12 21.938a1 1 0 0 1-1.414-1.414z" />
        </g>
      </g>
      <rect fill="#e0201c" x={9} y={62} width={22} height={2} rx={1} />
      <rect fill="#e0201c" x={9} y={66} width={14} height={2} rx={1} />
      <rect
        stroke="#e0201c"
        strokeWidth={2}
        x={40}
        y={30}
        width={8}
        height={8}
        rx={2}
      />
      <rect
        stroke="#e0201c"
        strokeWidth={2}
        x={40}
        y={58}
        width={8}
        height={8}
        rx={2}
      />
      <rect
        stroke="#e0201c"
        strokeWidth={2}
        x={62}
        y={30}
        width={8}
        height={8}
        rx={2}
      />
      <rect
        stroke="#e0201c"
        strokeWidth={2}
        x={62}
        y={58}
        width={8}
        height={8}
        rx={2}
      />
      <rect fill="#e0201c" x={48} y={33} width={14} height={2} rx={1} />
      <rect fill="#e0201c" x={48} y={61} width={14} height={2} rx={1} />
      <rect
        fill="#e0201c"
        transform="rotate(90 44 48)"
        x={34}
        y={47}
        width={20}
        height={2}
        rx={1}
      />
      <rect
        fill="#e0201c"
        transform="rotate(90 66 48)"
        x={56}
        y={47}
        width={20}
        height={2}
        rx={1}
      />
      <path
        d="M3 12h73a2 2 0 0 1 2 2v8H1v-8a2 2 0 0 1 2-2z"
        stroke="#e0201c"
        strokeWidth={2}
        fill="#F6FAFE"
      />
      <rect fill="#e0201c" x={7} y={16} width={8} height={2} rx={1} />
      <rect fill="#e0201c" x={19} y={16} width={8} height={2} rx={1} />
      <rect fill="#e0201c" x={62} y={16} width={8} height={2} rx={1} />
      <g fill="#e0201c" fillRule="nonzero">
        <path d="M53.639 48.817h-3.083l-.31.751h.31c.306 0 .523.058.653.172.13.114.195.264.195.448 0 .18-.065.328-.195.442-.13.114-.347.172-.653.172h-1.708c-.305 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.185.068-.335.204-.451.136-.116.361-.17.675-.163l1.993-4.824h-.83c-.305 0-.522-.057-.652-.171a.568.568 0 0 1-.195-.448c0-.185.065-.334.195-.448.13-.115.347-.172.653-.172l2.742.006 2.525 6.057c.297 0 .493.033.588.097a.61.61 0 0 1 .285.523c0 .18-.064.328-.192.442-.128.114-.345.172-.65.172h-1.708c-.306 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.18.065-.328.195-.442.13-.114.347-.172.653-.172h.31l-.304-.751zm-.526-1.234-1.022-2.442-1.027 2.442h2.049z" />
        <path d="M57.937 43v2.767c.31-.197.624-.344.944-.442.32-.098.642-.148.968-.148.88 0 1.624.295 2.235.885.61.59.916 1.3.916 2.135 0 .798-.29 1.465-.873 2-.582.535-1.35.803-2.302.803a3.755 3.755 0 0 1-1.888-.5v.302H56.45c-.305 0-.523-.058-.653-.172a.568.568 0 0 1-.195-.448c0-.18.066-.328.198-.442.132-.114.35-.172.65-.172h.217v-5.335h-.217c-.305 0-.523-.057-.653-.171a.568.568 0 0 1-.195-.448c0-.18.065-.328.195-.443.13-.114.348-.171.653-.171h1.486zm3.794 5.233c0-.51-.184-.94-.55-1.293a1.874 1.874 0 0 0-1.35-.53c-.528 0-.976.177-1.343.53-.368.353-.551.778-.551 1.275 0 .453.165.825.495 1.116.33.29.796.436 1.399.436.602 0 1.07-.145 1.402-.436.332-.29.498-.657.498-1.098z" />
      </g>
    </g>
  </svg>
);

export const LandingCardImg3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 190 190"
    className="injected-svg"
    data-src="/svg/cancel-subscription.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#D1E5FA" cx={95} cy={95} r={95} />
      <rect
        stroke="#e0201c"
        strokeWidth={5.135}
        fill="#F6FAFE"
        x={33.378}
        y={56.486}
        width={123.243}
        height={95}
        rx={3.851}
      />
      <g fill="#e0201c" fillRule="nonzero">
        <path d="M26.993 166.884a2.363 2.363 0 0 0-.229-2.824c-.128-.148-.3-.345-.476-.45-1.105-.68-2.551-.373-3.264.679l-2.974 4.658a2.446 2.446 0 0 0 .705 3.273c1.105.68 2.55.374 3.264-.678l2.974-4.658zM32.492 167.89l1.207 5.428c.282 1.31 1.564 2.095 2.779 1.817 1.214-.278 2.079-1.548 1.791-2.767l-1.207-5.428a2.5 2.5 0 0 0-.532-1.005c-.556-.64-1.41-.933-2.295-.769a2.193 2.193 0 0 0-1.743 2.724zM41.642 163.736l4.678 3.016c1.105.68 2.55.374 3.264-.678a2.363 2.363 0 0 0-.229-2.824c-.128-.148-.3-.345-.476-.45l-4.678-3.016c-1.105-.68-2.55-.374-3.264.678-.719 1.144-.4 2.594.705 3.274zM23.022 148.917a2.363 2.363 0 0 0-.228-2.824c-.129-.147-.3-.344-.477-.45l-4.677-3.016c-1.105-.68-2.551-.373-3.264.679a2.446 2.446 0 0 0 .704 3.273l4.678 3.016c1.057.723 2.503.416 3.264-.678zM21.577 156.91a2.5 2.5 0 0 0-.532-1.006c-.556-.64-1.41-.932-2.295-.768l-5.412 1.163c-1.306.271-2.08 1.549-1.792 2.767.282 1.31 1.564 2.095 2.778 1.817l5.412-1.164c1.306-.272 2.123-1.5 1.841-2.809z" />
      </g>
      <g transform="matrix(-1 0 0 1 44.193 38.747)" fill="#e0201c">
        <rect width={10.324} height={10.27} rx={2.568} />
        <rect x={15.486} width={10.324} height={10.27} rx={2.568} />
        <rect y={15.405} width={10.324} height={10.27} rx={2.568} />
        <rect x={15.486} y={15.405} width={10.324} height={10.27} rx={2.568} />
        <rect x={7.743} y={7.703} width={10.324} height={10.27} rx={2.568} />
      </g>
      <path
        d="M152.09 175.479a2.406 2.406 0 0 0 4.105 1.053 12.491 12.491 0 0 1 7.583-4.486 2.404 2.404 0 0 0 1.053-4.105 12.495 12.495 0 0 1-4.487-7.582 2.402 2.402 0 0 0-4.105-1.052 12.49 12.49 0 0 1-7.583 4.484 2.405 2.405 0 0 0-1.053 4.105 12.495 12.495 0 0 1 4.487 7.583zm4.801-10.189a14.623 14.623 0 0 0 1.953 3.303 14.656 14.656 0 0 0-3.302 1.954 14.634 14.634 0 0 0-1.953-3.302 14.607 14.607 0 0 0 3.302-1.955z"
        fill="#e0201c"
        fillRule="nonzero"
      />
      <path
        d="M72.075 82.904v8.458a2.568 2.568 0 0 1-2.567 2.567h-16.69a2.568 2.568 0 0 1-2.567-2.567v-8.458a2.568 2.568 0 0 1 2.567-2.568h16.69a2.568 2.568 0 0 1 2.567 2.568zM86.625 127.081v8.458a2.568 2.568 0 0 1-2.568 2.568H52.818a2.568 2.568 0 0 1-2.567-2.568v-8.458a2.568 2.568 0 0 1 2.567-2.567h31.24a2.568 2.568 0 0 1 2.567 2.567zM104.266 104.993v8.458a2.568 2.568 0 0 1-2.568 2.567h-48.88a2.568 2.568 0 0 1-2.567-2.567v-8.458a2.568 2.568 0 0 1 2.567-2.568h48.88a2.568 2.568 0 0 1 2.568 2.568z"
        fill="#e0201c"
      />
      <path
        d="M86.625 82.904v8.458a2.568 2.568 0 0 1-2.568 2.567H52.818a2.568 2.568 0 0 1-2.567-2.567v-8.458a2.568 2.568 0 0 1 2.567-2.568h31.24a2.568 2.568 0 0 1 2.567 2.568zM101.174 127.081v8.458a2.568 2.568 0 0 1-2.567 2.568H52.818a2.568 2.568 0 0 1-2.567-2.568v-8.458a2.568 2.568 0 0 1 2.567-2.567h45.789a2.568 2.568 0 0 1 2.567 2.567zM115.724 104.993v8.458a2.568 2.568 0 0 1-2.568 2.567H52.818a2.568 2.568 0 0 1-2.567-2.567v-8.458a2.568 2.568 0 0 1 2.567-2.568h60.338a2.568 2.568 0 0 1 2.568 2.568z"
        stroke="#e0201c"
        strokeWidth={2.568}
      />
      <g fill="#e0201c" fillRule="nonzero">
        <path d="M133.514 142.5c-5.663 0-10.27-4.608-10.27-10.27 0-5.663 4.607-10.27 10.27-10.27v10.27h10.27c0 5.662-4.608 10.27-10.27 10.27z" />
        <path d="M134.797 130.946v-10.27c5.302.758 9.508 4.965 10.27 10.27h-10.27z" />
      </g>
      <g transform="translate(123.243 95)" fill="#e0201c">
        <rect width={23.108} height={3.595} rx={1.797} />
        <rect y={7.189} width={23.108} height={3.595} rx={1.797} />
        <rect y={14.378} width={14.705} height={3.595} rx={1.797} />
      </g>
      <g transform="translate(110.405 25.676)">
        <ellipse
          stroke="#e0201c"
          strokeWidth={5.135}
          fill="#F6FAFE"
          cx={30.972}
          cy={30.811}
          rx={28.405}
          ry={28.243}
        />
        <path
          d="M45.667 16.346a2.327 2.327 0 0 0-3.295 0L30.945 27.749 19.518 16.322a2.327 2.327 0 0 0-3.295 0 2.327 2.327 0 0 0 0 3.295L27.65 31.044 16.223 42.471a2.327 2.327 0 0 0 0 3.295 2.327 2.327 0 0 0 3.295 0L30.945 34.34l11.427 11.427a2.327 2.327 0 0 0 3.295 0 2.327 2.327 0 0 0 0-3.295L34.24 31.044l11.427-11.427c.888-.888.888-2.383 0-3.271z"
          fill="#e0201c"
        />
      </g>
    </g>
  </svg>
);
export const LandingCardImg4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 88 88"
    fill="none"
    className="injected-svg"
    data-src="/svg/download-qr.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <path
      d="M88.0001 44C88.0001 68.3005 68.3006 88 44 88C19.6995 88 0 68.3005 0 44C0 19.6995 19.6995 0 44 0C68.3006 0 88.0001 19.6995 88.0001 44Z"
      fill="#E8F2FC"
    />
    <path
      d="M6 13.9958C6 12.8936 6.89357 12 7.99584 12H80.4378C81.5401 12 82.4337 12.8936 82.4337 13.9958V73.867C82.4337 74.9693 81.5401 75.8629 80.4378 75.8629H7.99584C6.89357 75.8629 6 74.9693 6 73.867V13.9958Z"
      fill="#F6FAFE"
      stroke="#e0201c"
      strokeWidth={1.99584}
    />
    <path
      d="M6 13.9958C6 12.8936 6.89357 12 7.99584 12H80.4378C81.5401 12 82.4337 12.8936 82.4337 13.9958V22.0571H6V13.9958Z"
      fill="#F6FAFE"
      stroke="#e0201c"
      strokeWidth={2.01143}
    />
    <rect
      x={12.0342}
      y={16.0229}
      width={3.01712}
      height={2.01143}
      rx={1.00571}
      fill="#e0201c"
    />
    <rect
      x={16.5598}
      y={16.0229}
      width={3.01712}
      height={2.01143}
      rx={1.00571}
      fill="#e0201c"
    />
    <rect
      x={21.5884}
      y={16.0229}
      width={3.01712}
      height={2.01143}
      rx={1.00571}
      fill="#e0201c"
    />
    <ellipse
      cx={29.8629}
      cy={46.4457}
      rx={19.8629}
      ry={19.8629}
      fill="#FEF8E6"
    />
    <path
      d="M54 32.0987C54 30.9965 54.8936 30.1029 55.9958 30.1029H70.1069C71.2091 30.1029 72.1027 30.9965 72.1027 32.0987V46.2099C72.1027 47.3122 71.2091 48.2058 70.1069 48.2058H55.9958C54.8936 48.2058 54 47.3122 54 46.2099V32.0987Z"
      stroke="#e0201c"
      strokeWidth={1.99584}
      strokeLinejoin="round"
    />
    <path
      d="M56.0114 32.1144L70.5941 46.6972"
      stroke="#e0201c"
      strokeWidth={1.99584}
      strokeLinecap="square"
    />
    <path
      d="M54.7583 46.9602L70.8575 30.861"
      stroke="#e0201c"
      strokeWidth={1.99584}
      strokeLinecap="square"
    />
    <rect
      x={13}
      y={29}
      width={29.6683}
      height={2.01143}
      rx={1.00571}
      fill="#e0201c"
    />
    <rect
      x={13}
      y={34}
      width={29.6683}
      height={2.01143}
      rx={1.00571}
      fill="#e0201c"
    />
    <rect x={13} y={39} width={26} height={2} rx={1} fill="#e0201c" />
    <rect x={13} y={44} width={12} height={2} rx={1} fill="#e0201c" />
    <path
      d="M58 69C58 76.732 51.732 83 44 83C36.268 83 30 76.732 30 69C30 61.268 36.268 55 44 55C51.732 55 58 61.268 58 69Z"
      fill="#E8F2FC"
      stroke="#e0201c"
      strokeWidth={2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 68.6V72.6C50 73.04 49.64 73.4 49.2 73.4H39.6C39.16 73.4 38.8 73.04 38.8 72.6V68.6C38.8 68.16 38.44 67.8 38 67.8C37.56 67.8 37.2 68.16 37.2 68.6V73.4C37.2 74.28 37.92 75 38.8 75H50C50.88 75 51.6 74.28 51.6 73.4V68.6C51.6 68.16 51.24 67.8 50.8 67.8C50.36 67.8 50 68.16 50 68.6ZM45.2 68.336L46.704 66.832C47.016 66.52 47.52 66.52 47.832 66.832C48.144 67.144 48.144 67.648 47.832 67.96L44.96 70.832C44.648 71.144 44.144 71.144 43.832 70.832L40.96 67.96C40.648 67.648 40.648 67.144 40.96 66.832C41.272 66.52 41.776 66.52 42.088 66.832L43.6 68.336V61.4C43.6 60.96 43.96 60.6 44.4 60.6C44.84 60.6 45.2 60.96 45.2 61.4V68.336Z"
      fill="#e0201c"
    />
    <path
      d="M66.9233 57.9384C66.4145 58.1856 66.151 58.704 66.231 59.2397C66.246 59.3401 66.266 59.4742 66.3143 59.5696C66.6094 60.1759 67.3315 60.4445 67.9403 60.1824L70.5558 58.9705C71.1597 58.675 71.4267 57.9507 71.1649 57.3396C70.8698 56.7333 70.1477 56.4647 69.5389 56.7268L66.9233 57.9384Z"
      fill="#e0201c"
    />
    <path
      d="M64.787 55.9644L65.7798 53.2494C66.0236 52.5972 65.68 51.8955 65.0679 51.6787C64.4559 51.4622 63.7187 51.7776 63.5032 52.3915L62.5104 55.1065C62.4403 55.3222 62.437 55.528 62.462 55.6954C62.527 56.1307 62.8206 56.4975 63.2559 56.6722C63.8729 56.9224 64.5768 56.612 64.787 55.9644L64.787 55.9644Z"
      fill="#e0201c"
    />
    <path
      d="M59.5966 55.2335L58.3861 52.6079C58.091 52.0016 57.3689 51.733 56.76 51.9951C56.2513 52.2422 55.9878 52.7607 56.0677 53.2964C56.0827 53.3968 56.1028 53.5308 56.151 53.6263L57.3616 56.2519C57.6567 56.8582 58.3788 57.1268 58.9876 56.8647C59.6249 56.564 59.8919 55.8398 59.5966 55.2336L59.5966 55.2335Z"
      fill="#e0201c"
    />
    <path
      d="M63.626 66.9181C63.1172 67.1652 62.8538 67.6837 62.9337 68.2194C62.9487 68.3198 62.9687 68.4538 63.017 68.5492L64.2276 71.1749C64.5227 71.7811 65.2448 72.0498 65.8536 71.7877C66.4575 71.4922 66.7244 70.7679 66.4626 70.1568L65.2521 67.5311C64.9902 66.9197 64.2681 66.651 63.626 66.9181L63.626 66.9181Z"
      fill="#e0201c"
    />
    <path
      d="M66.5054 63.8188C66.4353 64.0345 66.432 64.2403 66.457 64.4078C66.522 64.843 66.8156 65.2098 67.2509 65.3845L69.9577 66.3835C70.608 66.6288 71.3069 66.2847 71.5223 65.6708C71.7661 65.0185 71.4225 64.3169 70.8104 64.1001L68.1036 63.1011C67.4528 62.8561 66.7489 63.1665 66.5054 63.8188L66.5054 63.8188Z"
      fill="#e0201c"
    />
  </svg>
);
export const LandingCardImg5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 88 88"
    fill="none"
    className="injected-svg"
    data-src="/svg/metrics.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <circle cx={44} cy={44} r={44} fill="#E8F2FC" />
    <path
      d="M24 20.7838C24 19.7986 24.7986 19 25.7838 19H62.2162C63.2014 19 64 19.7986 64 20.7838V65.2162C64 66.2014 63.2014 67 62.2162 67H25.7838C24.7986 67 24 66.2014 24 65.2162V20.7838Z"
      fill="#F6FAFE"
      stroke="#e0201c"
      strokeWidth={2.37838}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77 24C78.1046 24 79 24.8954 79 26V32C79 33.1046 78.1046 34 77 34L34 34C32.8954 34 32 33.1046 32 32V26C32 24.8954 32.8954 24 34 24L77 24Z"
      fill="#A3CCF5"
    />
    <rect x={36} y={27.5} width={20} height={3} rx={1.5} fill="#e0201c" />
    <rect x={60} y={27.5} width={14} height={3} rx={1.5} fill="#e0201c" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41 43.4V47H37.4V43.4H41ZM42.8 41.6H35.6V48.8H42.8V41.6ZM41 53V56.6H37.4V53H41ZM42.8 51.2001H35.6V58.4001H42.8V51.2001ZM50.6 43.4V47H47V43.4H50.6ZM52.4 41.6H45.2V48.8H52.4V41.6ZM45.2 51.2001H47V53.0001H45.2V51.2001ZM47 53H48.8V54.8H47V53ZM48.8 51.2001H50.6V53.0001H48.8V51.2001ZM45.2 54.7999H47V56.5999H45.2V54.7999ZM47 56.6H48.8V58.4H47V56.6ZM48.8 54.7999H50.6V56.5999H48.8V54.7999ZM50.6 53H52.4V54.8H50.6V53ZM50.6 56.6H52.4V58.4H50.6V56.6ZM54.8 44C54.14 44 53.6 43.46 53.6 42.8V40.4H51.2C50.54 40.4 50 39.86 50 39.2C50 38.54 50.54 38 51.2 38H54.8C55.46 38 56 38.54 56 39.2V42.8C56 43.46 55.46 44 54.8 44ZM56 60.8V57.2C56 56.54 55.46 56 54.8 56C54.14 56 53.6 56.54 53.6 57.2V59.6H51.2C50.54 59.6 50 60.14 50 60.8C50 61.46 50.54 62 51.2 62H54.8C55.46 62 56 61.46 56 60.8ZM33.2 62H36.8C37.46 62 38 61.46 38 60.8C38 60.14 37.46 59.6 36.8 59.6H34.4V57.2C34.4 56.54 33.86 56 33.2 56C32.54 56 32 56.54 32 57.2V60.8C32 61.46 32.54 62 33.2 62ZM32 39.2V42.8C32 43.46 32.54 44 33.2 44C33.86 44 34.4 43.46 34.4 42.8V40.4H36.8C37.46 40.4 38 39.86 38 39.2C38 38.54 37.46 38 36.8 38H33.2C32.54 38 32 38.54 32 39.2Z"
      fill="#e0201c"
    />
    <path
      d="M20.6014 74.9887C20.931 74.6096 20.9653 74.0929 20.7128 73.681C20.6655 73.6038 20.6024 73.5008 20.5296 73.4392C20.0767 73.0439 19.3927 73.0736 18.9867 73.4996L17.2722 75.4002C16.8818 75.8518 16.9165 76.5387 17.3439 76.9495C17.7968 77.3447 18.4808 77.315 18.8869 76.889L20.6014 74.9887Z"
      fill="#F9C120"
    />
    <path
      d="M23.0368 75.8685L23.1734 78.4403C23.202 79.06 23.7278 79.5167 24.3037 79.4826C24.8795 79.4483 25.3719 78.9341 25.3336 78.3557L25.197 75.7838C25.1789 75.5825 25.1098 75.4125 25.0309 75.2838C24.8258 74.9491 24.4577 74.7499 24.041 74.7573C23.4493 74.7657 22.9824 75.2643 23.0367 75.8685L23.0368 75.8685Z"
      fill="#e0201c"
    />
    <path
      d="M27.534 74.6702L29.4402 76.4054C29.8931 76.8006 30.5771 76.7709 30.9832 76.345C31.3127 75.9659 31.347 75.4492 31.0946 75.0373C31.0473 74.9601 30.9841 74.857 30.9113 74.7954L29.0051 73.0602C28.5522 72.6649 27.8682 72.6947 27.4622 73.1206C27.0463 73.5882 27.081 74.275 27.534 74.6701L27.534 74.6702Z"
      fill="#e0201c"
    />
    <path
      d="M20.1607 66.4778C20.4903 66.0988 20.5246 65.5821 20.2721 65.1702C20.2248 65.093 20.1617 64.9899 20.0889 64.9283L18.1827 63.1931C17.7298 62.7978 17.0458 62.8276 16.6397 63.2535C16.2494 63.7052 16.2841 64.392 16.7115 64.8028L18.6177 66.5381C19.0452 66.9491 19.7292 66.9194 20.1607 66.4778L20.1607 66.4778Z"
      fill="#e0201c"
    />
    <path
      d="M18.8898 70.0185C18.8717 69.8172 18.8025 69.6472 18.7236 69.5185C18.5185 69.1838 18.1505 68.9845 17.7338 68.992L15.1727 69.1099C14.5555 69.1339 14.1045 69.6583 14.1428 70.2367C14.1714 70.8564 14.6972 71.3131 15.2731 71.279L17.8342 71.1611C18.4516 71.1367 18.9185 70.6381 18.8898 70.0185L18.8898 70.0185Z"
      fill="#e0201c"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.8813 75.4972C66.6602 75.3424 66.5026 75.1128 66.4382 74.8506V74.8507C66.1948 73.4666 65.4562 72.2184 64.36 71.3389C64.1614 71.1563 64.0357 70.9079 64.0065 70.6395C63.9775 70.3713 64.0466 70.1015 64.2013 69.8804C64.3561 69.6593 64.5858 69.502 64.8479 69.4376C66.232 69.1947 67.4803 68.4565 68.3598 67.3606C68.5423 67.1618 68.7908 67.036 69.0589 67.0066C69.3273 66.9773 69.5971 67.0465 69.8182 67.2012C70.0393 67.3559 70.1968 67.5856 70.2611 67.8478C70.5044 69.2318 71.2431 70.4801 72.3392 71.3596C72.5378 71.5421 72.6635 71.7908 72.6928 72.059C72.722 72.3271 72.6529 72.5969 72.4981 72.818C72.3434 73.0391 72.1135 73.1966 71.8516 73.2609C70.4673 73.504 69.219 74.2424 68.3395 75.3385C68.1569 75.5371 67.9085 75.6626 67.6401 75.6918C67.3719 75.7211 67.1023 75.652 66.8813 75.4972ZM69.5667 71.6613C69.1993 71.1934 68.8951 70.6793 68.662 70.1318C68.1941 70.4995 67.68 70.8039 67.1325 71.037C67.4999 71.5049 67.8041 72.0193 68.0372 72.5665C68.5051 72.1991 69.0194 71.8947 69.5667 71.6613Z"
      fill="#e0201c"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.8813 16.4972C45.6602 16.3424 45.5026 16.1128 45.4382 15.8506V15.8507C45.1948 14.4666 44.4562 13.2184 43.36 12.3389C43.1614 12.1563 43.0357 11.9079 43.0065 11.6395C42.9775 11.3713 43.0466 11.1015 43.2013 10.8804C43.3561 10.6593 43.5858 10.502 43.8479 10.4376C45.232 10.1947 46.4803 9.45646 47.3598 8.36057C47.5423 8.16176 47.7908 8.03602 48.0589 8.00656C48.3273 7.97733 48.5971 8.04645 48.8182 8.20119C49.0393 8.35595 49.1968 8.58561 49.2611 8.84775C49.5044 10.2318 50.2431 11.4801 51.3392 12.3596C51.5378 12.5421 51.6635 12.7908 51.6928 13.059C51.722 13.3271 51.6529 13.5969 51.4981 13.818C51.3434 14.0391 51.1135 14.1966 50.8516 14.2609C49.4673 14.504 48.219 15.2424 47.3395 16.3385C47.1569 16.5371 46.9085 16.6626 46.6401 16.6918C46.3719 16.7211 46.1023 16.652 45.8813 16.4972ZM48.5667 12.6613C48.1993 12.1934 47.8951 11.6793 47.662 11.1318C47.1941 11.4995 46.68 11.8039 46.1325 12.037C46.4999 12.5049 46.8041 13.0193 47.0372 13.5665C47.5051 13.1991 48.0194 12.8947 48.5667 12.6613Z"
      fill="#e0201c"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.88125 40.4972C9.66017 40.3424 9.50265 40.1128 9.43816 39.8506V39.8507C9.19484 38.4666 8.45616 37.2184 7.36002 36.3389C7.16144 36.1563 7.0357 35.9079 7.00647 35.6395C6.97747 35.3713 7.0466 35.1015 7.20134 34.8804C7.35609 34.6593 7.58575 34.502 7.8479 34.4376C9.23196 34.1947 10.4803 33.4565 11.3598 32.3606C11.5423 32.1618 11.7908 32.036 12.0589 32.0066C12.3273 31.9773 12.5971 32.0465 12.8182 32.2012C13.0393 32.3559 13.1968 32.5856 13.2611 32.8478C13.5044 34.2318 14.2431 35.4801 15.3392 36.3596C15.5378 36.5421 15.6635 36.7908 15.6928 37.059C15.722 37.3271 15.6529 37.5969 15.4981 37.818C15.3434 38.0391 15.1135 38.1966 14.8516 38.2609C13.4673 38.504 12.219 39.2424 11.3395 40.3385C11.1569 40.5371 10.9085 40.6626 10.6401 40.6918C10.3719 40.7211 10.1023 40.652 9.88125 40.4972ZM12.5667 36.6613C12.1993 36.1934 11.8951 35.6793 11.662 35.1318C11.1941 35.4995 10.68 35.8039 10.1325 36.037C10.4999 36.5049 10.8041 37.0193 11.0372 37.5665C11.5051 37.1991 12.0194 36.8947 12.5667 36.6613Z"
      fill="#e0201c"
    />
  </svg>
);
export const LandingCardImg6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={88}
    height={88}
    viewBox="0 0 88 88"
    fill="none"
    className="injected-svg"
    data-src="/svg/edit.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <circle cx={44} cy={44} r={44} fill="#E8F2FC" />
    <rect x={1} y={12} width={77} height={64} fill="white" />
    <path
      d="M60 72C60 71.4477 60.4477 71 61 71H69C69.5523 71 70 71.4477 70 72C70 72.5523 69.5523 73 69 73H61C60.4477 73 60 72.5523 60 72Z"
      fill="#e0201c"
    />
    <path
      d="M43 72C43 71.4477 43.4477 71 44 71H47C47.5523 71 48 71.4477 48 72C48 72.5523 47.5523 73 47 73H44C43.4477 73 43 72.5523 43 72Z"
      fill="#e0201c"
    />
    <path
      d="M27 72C27 71.4477 27.4477 71 28 71H31C31.5523 71 32 71.4477 32 72C32 72.5523 31.5523 73 31 73H28C27.4477 73 27 72.5523 27 72Z"
      fill="#e0201c"
    />
    <path
      d="M35 72C35 71.4477 35.4477 71 36 71H39C39.5523 71 40 71.4477 40 72C40 72.5523 39.5523 73 39 73H36C35.4477 73 35 72.5523 35 72Z"
      fill="#e0201c"
    />
    <path
      d="M8 72C8 71.4477 8.44772 71 9 71H15C15.5523 71 16 71.4477 16 72C16 72.5523 15.5523 73 15 73H9C8.44772 73 8 72.5523 8 72Z"
      fill="#e0201c"
    />
    <rect x={54} y={57} width={18} height={2} rx={1} fill="#e0201c" />
    <rect x={54} y={53} width={18} height={2} rx={1} fill="#e0201c" />
    <rect x={54} y={61} width={9} height={2} rx={1} fill="#e0201c" />
    <rect x={7} y={16} width={8} height={2} rx={1} fill="#e0201c" />
    <rect x={65} y={16} width={5} height={2} rx={1} fill="#e0201c" />
    <path
      d="M1 14C1 12.8954 1.89543 12 3 12H76C77.1046 12 78 12.8954 78 14M1 14V74M1 14V22H78V14M78 14V74M78 74C78 75.1046 77.1046 76 76 76H3C1.89543 76 1 75.1046 1 74M78 74V70C78 68.8954 77.1046 68 76 68H3C1.89543 68 1 68.8954 1 70V74"
      stroke="#e0201c"
      strokeWidth={2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1563 47.9113H26.2387L26.542 48.6631H26.2326C25.9272 48.6631 25.7095 48.7203 25.5795 48.8346C25.4496 48.9488 25.3846 49.0962 25.3846 49.2767C25.3846 49.4611 25.4496 49.6105 25.5795 49.7248C25.7095 49.8391 25.9272 49.8962 26.2326 49.8962H27.9409C28.2463 49.8962 28.4629 49.8391 28.5908 49.7248C28.7187 49.6105 28.7827 49.4631 28.7827 49.2827C28.7827 49.0661 28.6878 48.8917 28.498 48.7594C28.4031 48.6952 28.2071 48.6631 27.91 48.6631L25.3846 42.606L22.6426 42.6C22.3372 42.6 22.1195 42.6571 21.9896 42.7714C21.8596 42.8857 21.7946 43.0351 21.7946 43.2195C21.7946 43.404 21.8596 43.5534 21.9896 43.6676C22.1195 43.7819 22.3372 43.8391 22.6426 43.8391H23.472L21.4789 48.6631C21.1653 48.6551 20.9404 48.7092 20.8042 48.8255C20.6681 48.9418 20.6 49.0922 20.6 49.2767C20.6 49.4611 20.665 49.6105 20.7949 49.7248C20.9249 49.8391 21.1426 49.8962 21.448 49.8962H23.1563C23.4617 49.8962 23.6793 49.8391 23.8093 49.7248C23.9393 49.6105 24.0043 49.4631 24.0043 49.2827C24.0043 49.0982 23.9393 48.9488 23.8093 48.8346C23.6793 48.7203 23.4617 48.6631 23.1563 48.6631H22.8468L23.1563 47.9113ZM24.6913 44.2361L25.7126 46.6782H23.6639L24.6913 44.2361Z"
      fill="#e0201c"
    />
    <rect x={11} y={60} width={27} height={2} rx={1} fill="#e0201c" />
    <rect x={11} y={27} width={27} height={2} rx={1} fill="#e0201c" />
    <rect x={11} y={31} width={13} height={2} rx={1} fill="#e0201c" />
    <rect x={17} y={54.6} width={16} height={1.6} rx={0.8} fill="#e0201c" />
    <rect x={17} y={37} width={16} height={1.6} rx={0.8} fill="#e0201c" />
    <rect
      x={16.6}
      y={39}
      width={16}
      height={1.6}
      rx={0.8}
      transform="rotate(90 16.6 39)"
      fill="#e0201c"
    />
    <rect
      x={34.2}
      y={39}
      width={16}
      height={1.6}
      rx={0.8}
      transform="rotate(90 34.2 39)"
      fill="#e0201c"
    />
    <path
      d="M66.5 28H58.5C57.12 28 56 29.12 56 30.5V47.5C56 48.88 57.12 50 58.5 50H66.5C67.88 50 69 48.88 69 47.5V30.5C69 29.12 67.88 28 66.5 28ZM62.5 49C61.67 49 61 48.33 61 47.5C61 46.67 61.67 46 62.5 46C63.33 46 64 46.67 64 47.5C64 48.33 63.33 49 62.5 49ZM67 45H58V31H67V45Z"
      fill="#e0201c"
    />
    <path d="M47 22L47 69" stroke="#e0201c" strokeWidth={2} />
  </svg>
);
